import lodash from "lodash";

type CommunityObject = {
  name: string,
  districtCode: string,
  regionCode: string,
}

export const DistrictCodeCommunityMap: Record<string, CommunityObject[]> = {
  "01-01":[
    { "name": "37 Military Hospital", regionCode: "01", districtCode: "01",  },
    { "name": "Accra Central", regionCode: "01", districtCode: "01" },
    { "name": "Cantonment", regionCode: "01", districtCode: "01" },
    { "name": "El Wak Stadium", regionCode: "01", districtCode: "01" },
    { "name": "Jubilee House", regionCode: "01", districtCode: "01" },
    { "name": "La", regionCode: "01", districtCode: "01" },
    { "name": "Labone", regionCode: "01", districtCode: "01" },
    { "name": "Ministries And Environs", regionCode: "01", districtCode: "01" },
    { "name": "Osu Clottey", regionCode: "01", districtCode: "01" },
    { "name": "Salaga Market", regionCode: "01", districtCode: "01" },
    { "name": "Usher Forte", regionCode: "01", districtCode: "01" },
    { "name": "WAEC", regionCode: "01", districtCode: "01" }
  ],
  "01-02": [
    {
      name: "3rd Gate",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Abedi Pele",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Ability Square",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Abofu",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Abotsiman",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Acheampong Junction",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Achimota Forest",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Achimota New Station",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Achimota School",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Adasa Royal",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Adjringanor Village",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Akosombo",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Alogboshie",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Ambassadorial Enclave",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "American House",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "ANC Mall",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Anumle",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "ARS",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "AS Villa",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Asafo Adjei",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Asafoatse",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Asanka Local",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Atima",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Atomic Junction",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Ayigbe Town",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Babayara",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Baiden Avenue",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Banku Junction",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Bawaleshie",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Behind Forestry",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Beigin",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Catapilar Junction",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Christian Centre",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Christian Village",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Doku",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Dome Freshers",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Dome Oko",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Dzen Ayor",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Echoing Hills",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Emmanuel Eye",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Emmanuel Villa",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Estates",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Fan Milk",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Fasemkye",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "French School",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Gethesemane",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Ghana Canada",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Gimpa",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Golf Hills",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Golf Park",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Haatso",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Haatso Papao",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Haatso Supermarket",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Hannah School",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Highways Junction",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "J'famco",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Kings Cottage",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Kyeremantin Estate",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Labone",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Lighthouse",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Mama Liit",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Mannet Estate",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Mannet Estates",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Manu Avenue",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Market",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Maye Hot",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "MDS Estates",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Mempasem Alth",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Mempasem Dell",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Mempasem Meteo",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Mempasem Trinity",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Mempeasem Blue Gate",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Mempeasem Chief Palace",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Morocco Spot Junction",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "National Service Farms",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "New Road",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "New Town Park",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "North Dzorwulu",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "NTHC",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Nungue Farms",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Obudankade",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Ogbojo New Market",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Ogbojo Village",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Oheneba Kissie",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Old Road",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Old Town Park",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Omanye Villa",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Otanor",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Otinishie",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Paraku Estates",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Point 5",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Post Office",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Rawlings Circle",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Ritz",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Safo Adu",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Salem Estate",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "School Junction",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Shiashie Gulf House",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Social Welfare",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "South Legon",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Sraha",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "St. Peters Primary",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "St. Peters Secondary",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "St. Thomas Guesthouse",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Star Bites",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Sunfruit",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Sychar",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Taxi Rank",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Trassaco",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Trassaco West",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Twumasiwaa",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Under Bridge",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "University Of Ghana",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "UPSA",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Vilac Int'l School",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Warehouse",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Zion House",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Zongo Junction",
      regionCode: "01",
      districtCode: "02",
    },
    {
      name: "Zoomlion Head Office",
      regionCode: "01",
      districtCode: "02",
    },
  ],
  "01-03": [
    {
      name: "Abiriw",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Aburi",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Adenkrebi",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Adukurom",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Agyementi",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Ahwerease",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Akropong",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Amanokrom",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Apirede",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Asesseso",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Awukugwa",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Berekusu",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Dawu",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Gyankama",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Kitase",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Konkonuru",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Larteh",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Mamfe",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Mampong",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Obosomase",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Peduase",
      regionCode: "01",
      districtCode: "03",
    },
    {
      name: "Tutu",
      regionCode: "01",
      districtCode: "03",
    },
  ],
  "01-04": [
    { name: "Abavana Down", regionCode: "01", districtCode: "04" },
    { name: "Abavana Junction", regionCode: "01", districtCode: "04" },
    { name: "Abavana School", regionCode: "01", districtCode: "04" },
    { name: "Pigfarm Abedi Pele", regionCode: "01", districtCode: "04" },
    { name: "Abelemkpe", regionCode: "01", districtCode: "04" },
    { name: "Abelemkpe Lincoln School", regionCode: "01", districtCode: "04" },
    { name: "Abelemkpe/ARS", regionCode: "01", districtCode: "04" },
    { name: "Abelemkpe/Kasapa", regionCode: "01", districtCode: "04" },
    { name: "Abelemkpe/Marwako", regionCode: "01", districtCode: "04" },
    { name: "Abelemkpe/P.W.D", regionCode: "01", districtCode: "04" },
    { name: "Aiport West Res.", regionCode: "01", districtCode: "04" },
    { name: "Airport Ghana Airways", regionCode: "01", districtCode: "04" },
    { name: "Airport Koala Shopping Mall", regionCode: "01", districtCode: "04" },
    { name: "Airport Res Opeibea.", regionCode: "01", districtCode: "04" },
    { name: "Airport Res. Area/Diplomatic Shop", regionCode: "01", districtCode: "04" },
    { name: "Airport Res. Gold Key Properties", regionCode: "01", districtCode: "04" },
    { name: "Airport Res. Meridian Apartment", regionCode: "01", districtCode: "04" },
    { name: "Airport Res. Net Africa", regionCode: "01", districtCode: "04" },
    { name: "Airport Res. Sam Jonah", regionCode: "01", districtCode: "04" },
    { name: "Airport West Res.", regionCode: "01", districtCode: "04" },
    { name: "Airport West Res. / Japan Motors", regionCode: "01", districtCode: "04" },
    { name: "Airport West Res. Villagio", regionCode: "01", districtCode: "04" },
    { name: "Airport Women's Clinic", regionCode: "01", districtCode: "04" },
    { name: "Airport/Airside Hotel", regionCode: "01", districtCode: "04" },
    { name: "Airport/Alliance Francaise", regionCode: "01", districtCode: "04" },
    { name: "Airport Dhl", regionCode: "01", districtCode: "04" },
    { name: "Airpot Gateway Africa", regionCode: "01", districtCode: "04" },
    { name: "Airprt Res. Millenium Height", regionCode: "01", districtCode: "04" },
    { name: "Alajo/ Sem Cinema", regionCode: "01", districtCode: "04" },
    { name: "Aladjo/Clay Product", regionCode: "01", districtCode: "04" },
    { name: "Alajo", regionCode: "01", districtCode: "04" },
    { name: "Alajo Ayidiki", regionCode: "01", districtCode: "04" },
    { name: "Alajo/Railway", regionCode: "01", districtCode: "04" },
    { name: "Avenor", regionCode: "01", districtCode: "04" },
    { name: "Avenor/M Plaza", regionCode: "01", districtCode: "04" },
    { name: "Dzorwulu", regionCode: "01", districtCode: "04" },
    { name: "Dzorwulu Codemm", regionCode: "01", districtCode: "04" },
    { name: "Dzorwulu Special School", regionCode: "01", districtCode: "04" },
    { name: "Dzorwulu T-Junction", regionCode: "01", districtCode: "04" },
    { name: "Dzorwulu/Dimples Junction", regionCode: "01", districtCode: "04" },
    { name: "Dzorwulu/Earl Beam Hotel", regionCode: "01", districtCode: "04" },
    { name: "Dzorwulu/Fitting Shop", regionCode: "01", districtCode: "04" },
    { name: "Dzorwulu/GSMF", regionCode: "01", districtCode: "04" },
    { name: "Dzorwulu/Urban Taste", regionCode: "01", districtCode: "04" },
    { name: "Dzorwulu/Yam Junction", regionCode: "01", districtCode: "04" },
    { name: "Kanda", regionCode: "01", districtCode: "04" },
    { name: "Kanda Booster Station", regionCode: "01", districtCode: "04" },
    { name: "Kanda Fulgrip", regionCode: "01", districtCode: "04" },
    { name: "Kanda Gbc Power House", regionCode: "01", districtCode: "04" },
    { name: "Kanda Netherland Emb", regionCode: "01", districtCode: "04" },
    { name: "Kanda Prudential Bank", regionCode: "01", districtCode: "04" },
    { name: "Kanda Tv3", regionCode: "01", districtCode: "04" },
    { name: "Kanda/37 Military Hospital", regionCode: "01", districtCode: "04" },
    { name: "Kanda/Post Office", regionCode: "01", districtCode: "04" },
    { name: "Kokomlemle/ Sadisco", regionCode: "01", districtCode: "04" },
    { name: "Kokomlemle Asantewaa", regionCode: "01", districtCode: "04" },
    { name: "Kokomlemle Equip", regionCode: "01", districtCode: "04" },
    { name: "Kokomlemle Havad", regionCode: "01", districtCode: "04" },
    { name: "Kokomlemle Odo Rice", regionCode: "01", districtCode: "04" },
    { name: "Kokomlemle Procredit", regionCode: "01", districtCode: "04" },
    { name: "Kokomlemle/Association Consult", regionCode: "01", districtCode: "04" },
    { name: "Kokomlemle/Ghana Telecom", regionCode: "01", districtCode: "04" },
    { name: "Kokomlemle/Multi Tv", regionCode: "01", districtCode: "04" },
    { name: "Kokomlemle/Paloma", regionCode: "01", districtCode: "04" },
    { name: "Kokomlemle/Unibank", regionCode: "01", districtCode: "04" },
    { name: "Kokomlemle/Vat", regionCode: "01", districtCode: "04" },
    { name: "Kotobabi Police Station", regionCode: "01", districtCode: "04" },
    { name: "Kotobabi Down", regionCode: "01", districtCode: "04" },
    { name: "Kotobabi/Modex", regionCode: "01", districtCode: "04" },
    { name: "Kpehe", regionCode: "01", districtCode: "04" },
    { name: "Kpehe Caprice", regionCode: "01", districtCode: "04" },
    { name: "Maamobi Fifteen Bulb", regionCode: "01", districtCode: "04" },
    { name: "Maamobi Mosque", regionCode: "01", districtCode: "04" },
    { name: "Maamobi Police Station Down", regionCode: "01", districtCode: "04" },
    { name: "Maamobi Polyclinic", regionCode: "01", districtCode: "04" },
    { name: "Newtown Gbc", regionCode: "01", districtCode: "04" },
    { name: "Newtown Bankok", regionCode: "01", districtCode: "04" },
    { name: "Newtown Agbazena", regionCode: "01", districtCode: "04" },
    { name: "Newtown Malam Atta", regionCode: "01", districtCode: "04" },
    { name: "Newtown Obuntu Road", regionCode: "01", districtCode: "04" },
    { name: "Newtown Commandos", regionCode: "01", districtCode: "04" },
    { name: "Newtown Nkansa Djan", regionCode: "01", districtCode: "04" },
    { name: "Newtown Timber Market", regionCode: "01", districtCode: "04" },
    { name: "Newtown Tobinko", regionCode: "01", districtCode: "04" },
    { name: "Newtown 37 Station", regionCode: "01", districtCode: "04" },
    { name: "Nima Market", regionCode: "01", districtCode: "04" },
    { name: "Nima Round About", regionCode: "01", districtCode: "04" },
    { name: "Nima Alaska", regionCode: "01", districtCode: "04" },
    { name: "Nima Post Office", regionCode: "01", districtCode: "04" },
    { name: "Nima Ashaiman Station", regionCode: "01", districtCode: "04" },
    { name: "Nima Pride Of The East", regionCode: "01", districtCode: "04" },
    { name: "Nima Gutter", regionCode: "01", districtCode: "04" },
    { name: "Nima Gorillas", regionCode: "01", districtCode: "04" },
    { name: "Nima 441", regionCode: "01", districtCode: "04" },
    { name: "Nima Hot Coffee", regionCode: "01", districtCode: "04" },
    { name: "Nima St Kizito", regionCode: "01", districtCode: "04" },
    { name: "Nima/Lop Est.", regionCode: "01", districtCode: "04" },
    { name: "Pigfarm Club 1000", regionCode: "01", districtCode: "04" },
    { name: "Pigfarm Presby", regionCode: "01", districtCode: "04" },
    { name: "Pigfarm Station", regionCode: "01", districtCode: "04" },
    { name: "Pigfarm Expo67", regionCode: "01", districtCode: "04" },
    { name: "Pigfarm Ebony", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge Banking College", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge Cedar Court", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge Chinese Embassy", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge M Plaza", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge Med Lab", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge Min. Works And Housing", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge Narcotics Control Board", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge Nigerian High Com.", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge Paladio", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge Primrose Place", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge Royal Plaza", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge Shopping Arcade", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge/Chinese Embassy", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge/Csir", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge/Engineers Centre", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge/Jack And Jill", regionCode: "01", districtCode: "04" },
    { name: "Roman Ridge/Prisons Yard", regionCode: "01", districtCode: "04" }
  ],
  "01-05": [
    { name: "Ablorh-Adjei Methodist", regionCode: "01", districtCode: "05" },
    { name: "Accra Mall", regionCode: "01", districtCode: "05" },
    { name: "Adjei Lotto", regionCode: "01", districtCode: "05" },
    { name: "Adenkpo", regionCode: "01", districtCode: "05" },
    { name: "Adu Memorial School", regionCode: "01", districtCode: "05" },
    { name: "Adumli", regionCode: "01", districtCode: "05" },
    { name: "Afariwa Style ( Fashion St.)", regionCode: "01", districtCode: "05" },
    { name: "Agenda Mission Assembly", regionCode: "01", districtCode: "05" },
    { name: "Ahenfie Drinking Water", regionCode: "01", districtCode: "05" },
    { name: "Airport Hills", regionCode: "01", districtCode: "05" },
    { name: "Airport Hills", regionCode: "01", districtCode: "05" },
    { name: "Airport Hills Int. School", regionCode: "01", districtCode: "05" },
    { name: "Air Force Base", regionCode: "01", districtCode: "05" },
    { name: "Airport City Area", regionCode: "01", districtCode: "05" },
    { name: "Airport Police Sch Prim", regionCode: "01", districtCode: "05" },
    { name: "Airport Police Station", regionCode: "01", districtCode: "05" },
    { name: "Airport Shell F Station", regionCode: "01", districtCode: "05" },
    { name: "Aj's Royal Guest House", regionCode: "01", districtCode: "05" },
    { name: "Aku Sika Cold Store", regionCode: "01", districtCode: "05" },
    { name: "Alfiko Day Care Home", regionCode: "01", districtCode: "05" },
    { name: "A-Life Supermarket", regionCode: "01", districtCode: "05" },
    { name: "All Bemevers Inter Pow.", regionCode: "01", districtCode: "05" },
    { name: "Alloway Park", regionCode: "01", districtCode: "05" },
    { name: "Almond Road", regionCode: "01", districtCode: "05" },
    { name: "Anbert Garden School", regionCode: "01", districtCode: "05" },
    { name: "Annemarie Inter School", regionCode: "01", districtCode: "05" },
    { name: "Apostle Salvation Church", regionCode: "01", districtCode: "05" },
    { name: "Apostolic Church", regionCode: "01", districtCode: "05" },
    { name: "Apostolic Senior High Sch", regionCode: "01", districtCode: "05" },
    { name: "Apricot Street", regionCode: "01", districtCode: "05" },
    { name: "As-Bea Enterprise", regionCode: "01", districtCode: "05" },
    { name: "Assemblies Of God", regionCode: "01", districtCode: "05" },
    { name: "Ataa Kyea", regionCode: "01", districtCode: "05" },
    { name: "Baptist Int Prof School", regionCode: "01", districtCode: "05" },
    { name: "Batter Guest House", regionCode: "01", districtCode: "05" },
    { name: "Bethage School Complex", regionCode: "01", districtCode: "05" },
    { name: "Bethesda Red. Prayer Min", regionCode: "01", districtCode: "05" },
    { name: "Bank Of Ghana", regionCode: "01", districtCode: "05" },
    { name: "Block Factory", regionCode: "01", districtCode: "05" },
    { name: "Blue Lagoon Bar & Grill", regionCode: "01", districtCode: "05" },
    { name: "Bright Starint School", regionCode: "01", districtCode: "05" },
    { name: "Bukoeshie", regionCode: "01", districtCode: "05" },
    { name: "Burma Camp", regionCode: "01", districtCode: "05" },
    { name: "Busy Mouth", regionCode: "01", districtCode: "05" },
    { name: "C Of P At Nartey District", regionCode: "01", districtCode: "05" },
    { name: "C Of P Central Assembly", regionCode: "01", districtCode: "05" },
    { name: "C4 Area", regionCode: "01", districtCode: "05" },
    { name: "C4 House", regionCode: "01", districtCode: "05" },
    { name: "Cafacayo Charity Organization", regionCode: "01", districtCode: "05" },
    { name: "Camp Road Pharmacy", regionCode: "01", districtCode: "05" },
    { name: "Campbell Hotel", regionCode: "01", districtCode: "05" },
    { name: "Cattle Ranch 275", regionCode: "01", districtCode: "05" },
    { name: "Centre", regionCode: "01", districtCode: "05" },
    { name: "Chains Home", regionCode: "01", districtCode: "05" },
    { name: "China Machine Market", regionCode: "01", districtCode: "05" },
    { name: "Civil Aviation Authority", regionCode: "01", districtCode: "05" },
    { name: "Christ Apostolic Church", regionCode: "01", districtCode: "05" },
    { name: "Christ Church Of Faith", regionCode: "01", districtCode: "05" },
    { name: "Christ Our Savior Refor. Ac", regionCode: "01", districtCode: "05" },
    { name: "Christ Power Ev & Prayer", regionCode: "01", districtCode: "05" },
    { name: "Christ Star Int. School", regionCode: "01", districtCode: "05" },
    { name: "Christian Pharmacy", regionCode: "01", districtCode: "05" },
    { name: "Christian Praise Academy", regionCode: "01", districtCode: "05" },
    { name: "Christian Hotel Teshie", regionCode: "01", districtCode: "05" },
    { name: "Christ-Servant Ministry", regionCode: "01", districtCode: "05" },
    { name: "Church Of Pent Victory Ass.", regionCode: "01", districtCode: "05" },
    { name: "Church Of Pentecost", regionCode: "01", districtCode: "05" },
    { name: "Chydan Int School", regionCode: "01", districtCode: "05" },
    { name: "Club Deport", regionCode: "01", districtCode: "05" },
    { name: "Club Road", regionCode: "01", districtCode: "05" },
    { name: "Coca Cola Company Ltd Area", regionCode: "01", districtCode: "05" },
    { name: "Community Baptist Church", regionCode: "01", districtCode: "05" },
    { name: "Continer", regionCode: "01", districtCode: "05" },
    { name: "Curve", regionCode: "01", districtCode: "05" },
    { name: "D Street", regionCode: "01", districtCode: "05" },
    { name: "Dallars House", regionCode: "01", districtCode: "05" },
    { name: "Dampong Pharmacy Tes", regionCode: "01", districtCode: "05" },
    { name: "Daras Salem Islamic Sch", regionCode: "01", districtCode: "05" },
    { name: "Daras School Ltd", regionCode: "01", districtCode: "05" },
    { name: "Dares- Salem Jhs", regionCode: "01", districtCode: "05" },
    { name: "Day Sping School", regionCode: "01", districtCode: "05" },
    { name: "Dbs Production Hall", regionCode: "01", districtCode: "05" },
    { name: "De-9ntis Grooming", regionCode: "01", districtCode: "05" },
    { name: "Demo Taxi Station", regionCode: "01", districtCode: "05" },
    { name: "Diligent Seekers Haven", regionCode: "01", districtCode: "05" },
    { name: "Divine Alpha & Omega Chu.", regionCode: "01", districtCode: "05" },
    { name: "Downsview Inter School", regionCode: "01", districtCode: "05" },
    { name: "Dream Africa Care Found.", regionCode: "01", districtCode: "05" },
    { name: "Dunamis Action Church", regionCode: "01", districtCode: "05" },
    { name: "DVLA Area", regionCode: "01", districtCode: "05" },
    { name: "Ebenezer House", regionCode: "01", districtCode: "05" },
    { name: "Eckankar Church", regionCode: "01", districtCode: "05" },
    { name: "Elohim Temple", regionCode: "01", districtCode: "05" },
    { name: "Elorhim Praise Chapel Int", regionCode: "01", districtCode: "05" },
    { name: "El-Shaddai", regionCode: "01", districtCode: "05" },
    { name: "Emmanuel Methodist Chu", regionCode: "01", districtCode: "05" },
    { name: "Ev Oil Company Ltd", regionCode: "01", districtCode: "05" },
    { name: "Faith Academy Prim/Jhs", regionCode: "01", districtCode: "05" },
    { name: "Fanny Crosby Day Care", regionCode: "01", districtCode: "05" },
    { name: "Fedek Water Prod. House", regionCode: "01", districtCode: "05" },
    { name: "First Avenue", regionCode: "01", districtCode: "05" },
    { name: "First Floor Keeo Fit Club", regionCode: "01", districtCode: "05" },
    { name: "First Step Infant Sch", regionCode: "01", districtCode: "05" },
    { name: "Florredan School", regionCode: "01", districtCode: "05" },
    { name: "Ford School Ltd", regionCode: "01", districtCode: "05" },
    { name: "Fortune Child Int Sch.", regionCode: "01", districtCode: "05" },
    { name: "Foster Care School", regionCode: "01", districtCode: "05" },
    { name: "Francis Road", regionCode: "01", districtCode: "05" },
    { name: "Gaint Education Consult", regionCode: "01", districtCode: "05" },
    { name: "Gams Guest House", regionCode: "01", districtCode: "05" },
    { name: "Garges", regionCode: "01", districtCode: "05" },
    { name: "Gilead Pre-School", regionCode: "01", districtCode: "05" },
    { name: "Gilgal Fire Prayer Ministry", regionCode: "01", districtCode: "05" },
    { name: "Glee Oil", regionCode: "01", districtCode: "05" },
    { name: "Global Evangelistic Church", regionCode: "01", districtCode: "05" },
    { name: "Global Miracle Church", regionCode: "01", districtCode: "05" },
    { name: "Gnat Hostel", regionCode: "01", districtCode: "05" },
    { name: "Gogo Montessori School", regionCode: "01", districtCode: "05" },
    { name: "Goil Filling Station Kpeshie", regionCode: "01", districtCode: "05" },
    { name: "Golden Gate", regionCode: "01", districtCode: "05" },
    { name: "Golden Gate Cad Inter Sch", regionCode: "01", districtCode: "05" },
    { name: "Good News Assembly Pente.", regionCode: "01", districtCode: "05" },
    { name: "Good News Miracle Chap.", regionCode: "01", districtCode: "05" },
    { name: "Gospel Highway Int. Sch", regionCode: "01", districtCode: "05" },
    { name: "Gold Coast Refinery", regionCode: "01", districtCode: "05" },
    { name: "Grace Jones Guest House", regionCode: "01", districtCode: "05" },
    { name: "Great Harvest Ministries", regionCode: "01", districtCode: "05" },
    { name: "Greda Estate", regionCode: "01", districtCode: "05" },
    { name: "Grey Hill Road", regionCode: "01", districtCode: "05" },
    { name: "Guest Inn Market", regionCode: "01", districtCode: "05" },
    { name: "Harley Williams", regionCode: "01", districtCode: "05" },
    { name: "Heemas Learning & Care Ce", regionCode: "01", districtCode: "05" },
    { name: "High Tension Lines", regionCode: "01", districtCode: "05" },
    { name: "Holy Apostolic Reformed C", regionCode: "01", districtCode: "05" },
    { name: "Holy Apostolic Reformed C", regionCode: "01", districtCode: "05" },
    { name: "Holy Bethlehem Ministry", regionCode: "01", districtCode: "05" },
    { name: "Holy Grace Church", regionCode: "01", districtCode: "05" },
    { name: "Holy Land School", regionCode: "01", districtCode: "05" },
    { name: "Hydrofone Estate", regionCode: "01", districtCode: "05" },
    { name: "Hydrofone Estate", regionCode: "01", districtCode: "05" },
    { name: "I.C.G.C", regionCode: "01", districtCode: "05" },
    { name: "Inter.Central Gospel Chu.", regionCode: "01", districtCode: "05" },
    { name: "International Mall", regionCode: "01", districtCode: "05" },
    { name: "Interplast", regionCode: "01", districtCode: "05" },
    { name: "Jamborie,Eddie Polo'S Hot", regionCode: "01", districtCode: "05" },
    { name: "Jamers Satellite Solution", regionCode: "01", districtCode: "05" },
    { name: "Jelecem Ghana Limited", regionCode: "01", districtCode: "05" },
    { name: "Kalvary School", regionCode: "01", districtCode: "05" },
    { name: "Kiddicare School", regionCode: "01", districtCode: "05" },
    { name: "Kingsand Queen Int School", regionCode: "01", districtCode: "05" },
    { name: "Korbor Bukom", regionCode: "01", districtCode: "05" },
    { name: "KRTI Enterprises", regionCode: "01", districtCode: "05" },
    { name: "La Dade Kontonpon Mu", regionCode: "01", districtCode: "05" },
    { name: "Lascala Market", regionCode: "01", districtCode: "05" },
    { name: "Lascala Now Light House", regionCode: "01", districtCode: "05" },
    { name: "Later-Day Saints", regionCode: "01", districtCode: "05" },
    { name: "Lekma Hospital", regionCode: "01", districtCode: "05" },
    { name: "Lexton Motors", regionCode: "01", districtCode: "05" },
    { name: "Life Style Gallery Ltd", regionCode: "01", districtCode: "05" },
    { name: "Light House Chapel", regionCode: "01", districtCode: "05" },
    { name: "Living Christ Disciples Ass", regionCode: "01", districtCode: "05" },
    { name: "Lock Hotel", regionCode: "01", districtCode: "05" },
    { name: "Love Kingdom Sanctuary", regionCode: "01", districtCode: "05" },
    { name: "Loves School", regionCode: "01", districtCode: "05" },
    { name: "Lucky Child Int. Sch", regionCode: "01", districtCode: "05" },
    { name: "Manet Estate", regionCode: "01", districtCode: "05" },
    { name: "Mangose", regionCode: "01", districtCode: "05" },
    { name: "Manna Mission Sch & Hosp", regionCode: "01", districtCode: "05" },
    { name: "Maple Crescent", regionCode: "01", districtCode: "05" },
    { name: "Maria All Care School", regionCode: "01", districtCode: "05" },
    { name: "Mariville Homes", regionCode: "01", districtCode: "05" },
    { name: "Martey Tsuru", regionCode: "01", districtCode: "05" },
    { name: "Martey Tsuru Presby Sch", regionCode: "01", districtCode: "05" },
    { name: "Martins Bakery", regionCode: "01", districtCode: "05" },
    { name: "Maxxow Filling Station", regionCode: "01", districtCode: "05" },
    { name: "Mazzola Construct Work", regionCode: "01", districtCode: "05" },
    { name: "Mega Star Academy", regionCode: "01", districtCode: "05" },
    { name: "Melcom", regionCode: "01", districtCode: "05" },
    { name: "Mensah Sarbah Int Sch", regionCode: "01", districtCode: "05" },
    { name: "MG Contruction", regionCode: "01", districtCode: "05" },
    { name: "Ministry Of Defence", regionCode: "01", districtCode: "05" },
    { name: "Moral Academy", regionCode: "01", districtCode: "05" },
    { name: "Mount Oliver School", regionCode: "01", districtCode: "05" },
    { name: "Mount Horeb Vict. Church Int.", regionCode: "01", districtCode: "05" },
    { name: "Naa Mootsoo Memorial", regionCode: "01", districtCode: "05" },
    { name: "Ndc New Office Lascala", regionCode: "01", districtCode: "05" },
    { name: "Near Ocansey Plaza", regionCode: "01", districtCode: "05" },
    { name: "Neuro Consult", regionCode: "01", districtCode: "05" },
    { name: "New England", regionCode: "01", districtCode: "05" },
    { name: "New Generation Family", regionCode: "01", districtCode: "05" },
    { name: "Next Door Beach Resort", regionCode: "01", districtCode: "05" },
    { name: "Nibso Hotel", regionCode: "01", districtCode: "05" },
    { name: "Nii Odotei Place", regionCode: "01", districtCode: "05" },
    { name: "No 1 Zion Avenue", regionCode: "01", districtCode: "05" },
    { name: "Nobel Prof Institute", regionCode: "01", districtCode: "05" },
    { name: "North Presby Church", regionCode: "01", districtCode: "05" },
    { name: "Ofori Mart Abglizaa 120", regionCode: "01", districtCode: "05" },
    { name: "Ogyampa Herbal Clinic", regionCode: "01", districtCode: "05" },
    { name: "OHRT Close", regionCode: "01", districtCode: "05" },
    { name: "Okpoi Gonno", regionCode: "01", districtCode: "05" },
    { name: "Old Saps School", regionCode: "01", districtCode: "05" },
    { name: "Opp. One Stone Movie Hse", regionCode: "01", districtCode: "05" },
    { name: "Opposite Golden Star Inter", regionCode: "01", districtCode: "05" },
    { name: "Opposite St John School An", regionCode: "01", districtCode: "05" },
    { name: "Opposite Keta Salts Indust.", regionCode: "01", districtCode: "05" },
    { name: "Opposite Roosevelt School", regionCode: "01", districtCode: "05" },
    { name: "Opposite Sun Hotel", regionCode: "01", districtCode: "05" },
    { name: "Opposite Trinity Senior High", regionCode: "01", districtCode: "05" },
    { name: "Opposite Ultimate", regionCode: "01", districtCode: "05" },
    { name: "Opposite Telephone Pole", regionCode: "01", districtCode: "05" },
    { name: "O'Reilly Senior High Sch.", regionCode: "01", districtCode: "05" },
    { name: "Pallet Lounge", regionCode: "01", districtCode: "05" },
    { name: "Pannel Last Stop", regionCode: "01", districtCode: "05" },
    { name: "Pearly Kids School", regionCode: "01", districtCode: "05" },
    { name: "Perez Int. School", regionCode: "01", districtCode: "05" },
    { name: "Pipe Ekpaa Naa", regionCode: "01", districtCode: "05" },
    { name: "Praise Worship Center", regionCode: "01", districtCode: "05" },
    { name: "Precious Child Academy", regionCode: "01", districtCode: "05" },
    { name: "Presby Church Of Ghana-Teshie", regionCode: "01", districtCode: "05" },
    { name: "Presby Chu. Grace", regionCode: "01", districtCode: "05" },
    { name: "Presby Church & School", regionCode: "01", districtCode: "05" },
    { name: "Presbyterian Cemetery", regionCode: "01", districtCode: "05" },
    { name: "Printex Gh Ltd", regionCode: "01", districtCode: "05" },
    { name: "Pure Revival Ministries", regionCode: "01", districtCode: "05" },
    { name: "Quacation Pharmacy", regionCode: "01", districtCode: "05" },
    { name: "Rabbies Empire", regionCode: "01", districtCode: "05" },
    { name: "Rapture Sch", regionCode: "01", districtCode: "05" },
    { name: "Raster Police Post", regionCode: "01", districtCode: "05" },
    { name: "Real Life Guest House", regionCode: "01", districtCode: "05" },
    { name: "Regina Crescent", regionCode: "01", districtCode: "05" },
    { name: "Restoration Power Ministry", regionCode: "01", districtCode: "05" },
    { name: "Restoration Revival Church", regionCode: "01", districtCode: "05" },
    { name: "Rice & Sugar Shopping Ent", regionCode: "01", districtCode: "05" },
    { name: "Rising Star Prep School", regionCode: "01", districtCode: "05" },
    { name: "Robinhood Hotel", regionCode: "01", districtCode: "05" },
    { name: "Roosevelt Prep. School", regionCode: "01", districtCode: "05" },
    { name: "Royal Heritage Academy", regionCode: "01", districtCode: "05" },
    { name: "Rydas Pub", regionCode: "01", districtCode: "05" },
    { name: "Saloon Approved", regionCode: "01", districtCode: "05" },
    { name: "Sami Adjei Park", regionCode: "01", districtCode: "05" },
    { name: "Saps Int School", regionCode: "01", districtCode: "05" },
    { name: "Shield Micro Finance", regionCode: "01", districtCode: "05" },
    { name: "Shell Filling Station", regionCode: "01", districtCode: "05" },
    { name: "Silver Bells Gate1", regionCode: "01", districtCode: "05" },
    { name: "Songo Naa", regionCode: "01", districtCode: "05" },
    { name: "Southland College (Debb)", regionCode: "01", districtCode: "05" },
    { name: "Speedy", regionCode: "01", districtCode: "05" },
    { name: "Speedy Down", regionCode: "01", districtCode: "05" },
    { name: "Spot", regionCode: "01", districtCode: "05" },
    { name: "St. Barnabas' Int School", regionCode: "01", districtCode: "05" },
    { name: "Star Gas Filling Station", regionCode: "01", districtCode: "05" },
    { name: "Station Q", regionCode: "01", districtCode: "05" },
    { name: "Sun Hotel", regionCode: "01", districtCode: "05" },
    { name: "Sunrise Prep School.", regionCode: "01", districtCode: "05" },
    { name: "Survival Basic School", regionCode: "01", districtCode: "05" },
    { name: "Swiss Palm Lodge", regionCode: "01", districtCode: "05" },
    { name: "T10", regionCode: "01", districtCode: "05" },
    { name: "T4d", regionCode: "01", districtCode: "05" },
    { name: "Tebibiano Mosque", regionCode: "01", districtCode: "05" },
    { name: "Telephone Pole", regionCode: "01", districtCode: "05" },
    { name: "Teshie Camp", regionCode: "01", districtCode: "05" },
    { name: "Teshie Camp 2 School", regionCode: "01", districtCode: "05" },
    { name: "Teshie Central Kingdom", regionCode: "01", districtCode: "05" },
    { name: "Teshie Fire Service", regionCode: "01", districtCode: "05" },
    { name: "Teshie Fish House", regionCode: "01", districtCode: "05" },
    { name: "Teshie Krobo 1/2 School", regionCode: "01", districtCode: "05" },
    { name: "Teshie Mantse Palace", regionCode: "01", districtCode: "05" },
    { name: "Teshie Market Accra Tso", regionCode: "01", districtCode: "05" },
    { name: "Teshie North Clusters Of Sc", regionCode: "01", districtCode: "05" },
    { name: "Teshie Nungua Estate", regionCode: "01", districtCode: "05" },
    { name: "Teshie Orphanage", regionCode: "01", districtCode: "05" },
    { name: "Teshie Police Station", regionCode: "01", districtCode: "05" },
    { name: "Teshie St.John School", regionCode: "01", districtCode: "05" },
    { name: "Teshie Total(Former Mobile)", regionCode: "01", districtCode: "05" },
    { name: "Teshie-Aboma", regionCode: "01", districtCode: "05" },
    { name: "The Baah's Gladiwel", regionCode: "01", districtCode: "05" },
    { name: "The Devine Healers Chu", regionCode: "01", districtCode: "05" },
    { name: "The Star Inter Church", regionCode: "01", districtCode: "05" },
    { name: "Three Ace Pharmacy", regionCode: "01", districtCode: "05" },
    { name: "Total Life Christian Centre", regionCode: "01", districtCode: "05" },
    { name: "Tower Sea Foods Ltd", regionCode: "01", districtCode: "05" },
    { name: "Train Station", regionCode: "01", districtCode: "05" },
    { name: "Transformer", regionCode: "01", districtCode: "05" },
    { name: "Trinity Snr High School", regionCode: "01", districtCode: "05" },
    { name: "Tse Addo", regionCode: "01", districtCode: "05" },
    { name: "Tsuibleoo Last Stop", regionCode: "01", districtCode: "05" },
    { name: "Tsuibleoo Total Station", regionCode: "01", districtCode: "05" },
    { name: "Unique Child Int. School", regionCode: "01", districtCode: "05" },
    { name: "United Christian Mission", regionCode: "01", districtCode: "05" },
    { name: "Ultimate Hotel", regionCode: "01", districtCode: "05" },
    { name: "Victory Assemblies Of God", regionCode: "01", districtCode: "05" },
    { name: "Walnut Road", regionCode: "01", districtCode: "05" },
    { name: "Wora Of Life Outreach Min.", regionCode: "01", districtCode: "05" },
    { name: "Yogama Int School", regionCode: "01", districtCode: "05" },
    { name: "Zoompark", regionCode: "01", districtCode: "05" },
    { name: "37 Lorry Station", regionCode: "01", districtCode: "05" },
    { name: "205 Corner Bar & Grill", regionCode: "01", districtCode: "05" },
    { name: "31st Women Mov. Sch", regionCode: "01", districtCode: "05" }
  ],
  "01-06": [
    {
      name: "Ablorgyei",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Abokobi",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Abokobi Boi",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Abokobi Seseme",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Agbogba",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Ashogman",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Comet",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Dome",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Dome Crossing",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Dome Pillar II",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Franko Estate",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Haatso",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Kissieman (Christian  Village)",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Kwabenya",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Madina Libya Quarters",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Madina Zongo",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "North Legon",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "Taifa",
      regionCode: "01",
      districtCode: "06",
    },
    {
      name: "West Legon (West Land)",
      regionCode: "01",
      districtCode: "06",
    },
  ],
  "01-07": [
    { name: "Abenampa", regionCode: "01", districtCode: "07" },
    { name: "Abokobi", regionCode: "01", districtCode: "07" },
    { name: "Abonse", regionCode: "01", districtCode: "07" },
    { name: "Abonya", regionCode: "01", districtCode: "07" },
    { name: "Adamrobe", regionCode: "01", districtCode: "07" },
    { name: "Adoteiman", regionCode: "01", districtCode: "07" },
    { name: "Adzumadzan", regionCode: "01", districtCode: "07" },
    { name: "Agormeda", regionCode: "01", districtCode: "07" },
    { name: "Akatamanso", regionCode: "01", districtCode: "07" },
    { name: "Akuaba", regionCode: "01", districtCode: "07" },
    { name: "Amanor", regionCode: "01", districtCode: "07" },
    { name: "Amrahia", regionCode: "01", districtCode: "07" },
    { name: "Apase", regionCode: "01", districtCode: "07" },
    { name: "Apolonia", regionCode: "01", districtCode: "07" },
    { name: "Asebi", regionCode: "01", districtCode: "07" },
    { name: "Ashiyie", regionCode: "01", districtCode: "07" },
    { name: "Ayenye", regionCode: "01", districtCode: "07" },
    { name: "Ayikuma", regionCode: "01", districtCode: "07" },
    { name: "Ayimensah", regionCode: "01", districtCode: "07" },
    { name: "Damfa", regionCode: "01", districtCode: "07" },
    { name: "Dodowa Oscar Down", regionCode: "01", districtCode: "07" },
    { name: "Dodowa Township", regionCode: "01", districtCode: "07" },
    { name: "Dodowa Wodokum", regionCode: "01", districtCode: "07" },
    { name: "Doryimu", regionCode: "01", districtCode: "07" },
    { name: "Dzokpanya", regionCode: "01", districtCode: "07" },
    { name: "Frafraha", regionCode: "01", districtCode: "07" },
    { name: "Gblokotonya", regionCode: "01", districtCode: "07" },
    { name: "Gigedokum", regionCode: "01", districtCode: "07" },
    { name: "Gyan Kwakye", regionCode: "01", districtCode: "07" },
    { name: "Kordiabe", regionCode: "01", districtCode: "07" },
    { name: "Kpone Baweleshi", regionCode: "01", districtCode: "07" },
    { name: "Kubekrom I & II", regionCode: "01", districtCode: "07" },
    { name: "Malejor", regionCode: "01", districtCode: "07" },
    { name: "Mensah Bar", regionCode: "01", districtCode: "07" },
    { name: "Mobole", regionCode: "01", districtCode: "07" },
    { name: "Nanoman", regionCode: "01", districtCode: "07" },
    { name: "Odumse", regionCode: "01", districtCode: "07" },
    { name: "Otchebleku", regionCode: "01", districtCode: "07" },
    { name: "Otinibi", regionCode: "01", districtCode: "07" },
    { name: "Oyarifa", regionCode: "01", districtCode: "07" },
    { name: "Oyibi", regionCode: "01", districtCode: "07" },
    { name: "Sasaabi", regionCode: "01", districtCode: "07" },
    { name: "Seduase", regionCode: "01", districtCode: "07" },
    { name: "Shai Hills", regionCode: "01", districtCode: "07" },
    { name: "Sota", regionCode: "01", districtCode: "07" },
    { name: "Teiman", regionCode: "01", districtCode: "07" }
  ],
  "01-08": [
    { name: "Adenta Area", regionCode: "01", districtCode: "08" },
    { name: "Adenta Barrier", regionCode: "01", districtCode: "08" },
    { name: "Agbogba", regionCode: "01", districtCode: "08" },
    { name: "Animal Research Institute", regionCode: "01", districtCode: "08" },
    { name: "Ashaley Botwe", regionCode: "01", districtCode: "08" },
    { name: "Ashieyie", regionCode: "01", districtCode: "08" },
    { name: "Assemblies Of God", regionCode: "01", districtCode: "08" },
    { name: "Borteyman", regionCode: "01", districtCode: "08" },
    { name: "East Legon Hills", regionCode: "01", districtCode: "08" },
    { name: "Frafraha", regionCode: "01", districtCode: "08" },
    { name: "Fulani", regionCode: "01", districtCode: "08" },
    { name: "Lakeside Estates", regionCode: "01", districtCode: "08" },
    { name: "Nanakrom", regionCode: "01", districtCode: "08" },
    { name: "New Legon", regionCode: "01", districtCode: "08" },
    { name: "New Nation School", regionCode: "01", districtCode: "08" },
    { name: "Nmai Dzor", regionCode: "01", districtCode: "08" },
    { name: "Owusu Ansah", regionCode: "01", districtCode: "08" },
    { name: "Pantang", regionCode: "01", districtCode: "08" }
  ],

  "02-01": [
    { name: "Agbogbloshie", regionCode: "02", districtCode: "01" },
    { name: "Abossey Okai", regionCode: "02", districtCode: "01" },
    { name: "Adabraka", regionCode: "02", districtCode: "01" },
    { name: "Accra Central", regionCode: "02", districtCode: "01" },
    { name: "Chorkor", regionCode: "02", districtCode: "01" },
    { name: "James Town", regionCode: "02", districtCode: "01" },
    { name: "Korle Gonno", regionCode: "02", districtCode: "01" },
    { name: "Korle Bu", regionCode: "02", districtCode: "01" },
    { name: "Mamprobi", regionCode: "02", districtCode: "01" }
  ],
  "02-02": [
    { name: "Ablekuma", regionCode: "02", districtCode: "02" },
    { name: "Achimota", regionCode: "02", districtCode: "02" },
    { name: "ACP Estate(Pokusa)", regionCode: "02", districtCode: "02" },
    { name: "Akweteman", regionCode: "02", districtCode: "02" },
    { name: "A-Lang", regionCode: "02", districtCode: "02" },
    { name: "Alhaji Paa Dan", regionCode: "02", districtCode: "02" },
    { name: "Alobgoshie", regionCode: "02", districtCode: "02" },
    { name: "Amalia", regionCode: "02", districtCode: "02" },
    { name: "Amamoley", regionCode: "02", districtCode: "02" },
    { name: "Antic Aku Last", regionCode: "02", districtCode: "02" },
    { name: "Anya", regionCode: "02", districtCode: "02" },
    { name: "Anyaa Cemetary", regionCode: "02", districtCode: "02" },
    { name: "Anyaa Mic", regionCode: "02", districtCode: "02" },
    { name: "Anyaa Nsufa", regionCode: "02", districtCode: "02" },
    { name: "Asofa Market", regionCode: "02", districtCode: "02" },
    { name: "Asofa Nursing", regionCode: "02", districtCode: "02" },
    { name: "Asofa Township", regionCode: "02", districtCode: "02" },
    { name: "Awoshie", regionCode: "02", districtCode: "02" },
    { name: "Ayawaso Holy Hill", regionCode: "02", districtCode: "02" },
    { name: "Ayawaso Ofori Amponsah", regionCode: "02", districtCode: "02" },
    { name: "Ayawaso Town", regionCode: "02", districtCode: "02" },
    { name: "Best Point Mile 7", regionCode: "02", districtCode: "02" },
    { name: "Champion Divine", regionCode: "02", districtCode: "02" },
    { name: "Chantan", regionCode: "02", districtCode: "02" },
    { name: "Dome CFC", regionCode: "02", districtCode: "02" },
    { name: "Dome Market", regionCode: "02", districtCode: "02" },
    { name: "Fan Milk Last Stop", regionCode: "02", districtCode: "02" },
    { name: "Iran Clinic", regionCode: "02", districtCode: "02" },
    { name: "Israel", regionCode: "02", districtCode: "02" },
    { name: "Kingsby", regionCode: "02", districtCode: "02" },
    { name: "Kwashiebu", regionCode: "02", districtCode: "02" },
    { name: "Kwashieman", regionCode: "02", districtCode: "02" },
    { name: "Lapaz", regionCode: "02", districtCode: "02" },
    { name: "Lapaz New Market", regionCode: "02", districtCode: "02" },
    { name: "Lomnava", regionCode: "02", districtCode: "02" },
    { name: "Mile 7", regionCode: "02", districtCode: "02" },
    { name: "Nii Boye", regionCode: "02", districtCode: "02" },
    { name: "Nyameste", regionCode: "02", districtCode: "02" },
    { name: "Odorgoron", regionCode: "02", districtCode: "02" },
    { name: "Ofankor 7 Days", regionCode: "02", districtCode: "02" },
    { name: "Ofankor Atta Mills", regionCode: "02", districtCode: "02" },
    { name: "Ofankor Cemetary", regionCode: "02", districtCode: "02" },
    { name: "Ofankor Muss", regionCode: "02", districtCode: "02" },
    { name: "Ofankor Post Office", regionCode: "02", districtCode: "02" },
    { name: "Ofankor Saw Mill", regionCode: "02", districtCode: "02" },
    { name: "Ofankor Township", regionCode: "02", districtCode: "02" },
    { name: "Ofankor White House", regionCode: "02", districtCode: "02" },
    { name: "Olebu", regionCode: "02", districtCode: "02" },
    { name: "Omanjor", regionCode: "02", districtCode: "02" },
    { name: "Pentecost University", regionCode: "02", districtCode: "02" },
    { name: "Petroleum", regionCode: "02", districtCode: "02" },
    { name: "Race Course", regionCode: "02", districtCode: "02" },
    { name: "Santa Maria", regionCode: "02", districtCode: "02" },
    { name: "South Ofankor", regionCode: "02", districtCode: "02" },
    { name: "Sowutuom", regionCode: "02", districtCode: "02" },
    { name: "Sowutuom Chop Bar", regionCode: "02", districtCode: "02" },
    { name: "St Johns", regionCode: "02", districtCode: "02" },
    { name: "Tabora No.2", regionCode: "02", districtCode: "02" },
    { name: "Tabora No.5", regionCode: "02", districtCode: "02" },
    { name: "Taifa Junction", regionCode: "02", districtCode: "02" },
    { name: "Tantra Hills", regionCode: "02", districtCode: "02" },
    { name: "Yellow House", regionCode: "02", districtCode: "02" }
  ],
  "02-03": [
    { name: "Abetima", regionCode: "02", districtCode: "03" },
    { name: "Aburi Amanfrom", regionCode: "02", districtCode: "03" },
    { name: "Adieso/Alafia", regionCode: "02", districtCode: "03" },
    { name: "Adieso/Roman Sch.", regionCode: "02", districtCode: "03" },
    { name: "Adjenkiti", regionCode: "02", districtCode: "03" },
    { name: "Adoagyiri", regionCode: "02", districtCode: "03" },
    { name: "Adukofi", regionCode: "02", districtCode: "03" },
    { name: "Adukrom", regionCode: "02", districtCode: "03" },
    { name: "Afabein-Kpanikrom", regionCode: "02", districtCode: "03" },
    { name: "Ahodwo", regionCode: "02", districtCode: "03" },
    { name: "Ahodwo Kitewa", regionCode: "02", districtCode: "03" },
    { name: "Ahwerease Darmang", regionCode: "02", districtCode: "03" },
    { name: "Ajanoa", regionCode: "02", districtCode: "03" },
    { name: "Akraman", regionCode: "02", districtCode: "03" },
    { name: "Akufokrom", regionCode: "02", districtCode: "03" },
    { name: "Akwakupome", regionCode: "02", districtCode: "03" },
    { name: "Akwamu", regionCode: "02", districtCode: "03" },
    { name: "Akwane Dobro-Adipa", regionCode: "02", districtCode: "03" },
    { name: "Akweiman", regionCode: "02", districtCode: "03" },
    { name: "Alafia", regionCode: "02", districtCode: "03" },
    { name: "Alema", regionCode: "02", districtCode: "03" },
    { name: "Amfetifi", regionCode: "02", districtCode: "03" },
    { name: "Amoyaw", regionCode: "02", districtCode: "03" },
    { name: "Anoff", regionCode: "02", districtCode: "03" },
    { name: "Apantem", regionCode: "02", districtCode: "03" },
    { name: "Armaaman", regionCode: "02", districtCode: "03" },
    { name: "Asuaba/SDA Church", regionCode: "02", districtCode: "03" },
    { name: "Asuotwene", regionCode: "02", districtCode: "03" },
    { name: "Atokrom/Rainbow Academy", regionCode: "02", districtCode: "03" },
    { name: "Attakrom Amanfro", regionCode: "02", districtCode: "03" },
    { name: "Atwakan", regionCode: "02", districtCode: "03" },
    { name: "Avaga", regionCode: "02", districtCode: "03" },
    { name: "Aworoeso", regionCode: "02", districtCode: "03" },
    { name: "Awoyekrow", regionCode: "02", districtCode: "03" },
    { name: "Ayibontey", regionCode: "02", districtCode: "03" },
    { name: "Besiasi Amanfrom", regionCode: "02", districtCode: "03" },
    { name: "Boahenekrom", regionCode: "02", districtCode: "03" },
    { name: "Botokra", regionCode: "02", districtCode: "03" },
    { name: "Danso", regionCode: "02", districtCode: "03" },
    { name: "Djankrom", regionCode: "02", districtCode: "03" },
    { name: "Djankrom Wangara/Atsikope", regionCode: "02", districtCode: "03" },
    { name: "Doblo Royal Triangle", regionCode: "02", districtCode: "03" },
    { name: "Docrochiwa", regionCode: "02", districtCode: "03" },
    { name: "Dome Faase", regionCode: "02", districtCode: "03" },
    { name: "Duayeden", regionCode: "02", districtCode: "03" },
    { name: "Dumpong", regionCode: "02", districtCode: "03" },
    { name: "Dzatsui", regionCode: "02", districtCode: "03" },
    { name: "Esikabew", regionCode: "02", districtCode: "03" },
    { name: "Fankyeneko", regionCode: "02", districtCode: "03" },
    { name: "Fotobi", regionCode: "02", districtCode: "03" },
    { name: "Gbogblan", regionCode: "02", districtCode: "03" },
    { name: "Kofi Donkor", regionCode: "02", districtCode: "03" },
    { name: "Kofi Kura/Ansakwaw", regionCode: "02", districtCode: "03" },
    { name: "Kofiman", regionCode: "02", districtCode: "03" },
    { name: "Kofisah", regionCode: "02", districtCode: "03" },
    { name: "Kraboa Coaltar", regionCode: "02", districtCode: "03" },
    { name: "Krabokese", regionCode: "02", districtCode: "03" },
    { name: "Kwabena Larbi", regionCode: "02", districtCode: "03" },
    { name: "Kwablafio/Kwame Adu/Willson", regionCode: "02", districtCode: "03" },
    { name: "Kwadjokrom", regionCode: "02", districtCode: "03" },
    { name: "Kwame Krom", regionCode: "02", districtCode: "03" },
    { name: "Kwame Ntow", regionCode: "02", districtCode: "03" },
    { name: "Kwasikrow", regionCode: "02", districtCode: "03" },
    { name: "Kwesi Nyarko", regionCode: "02", districtCode: "03" },
    { name: "Kyekyewree", regionCode: "02", districtCode: "03" },
    { name: "Lamangoase", regionCode: "02", districtCode: "03" },
    { name: "Lanteiman", regionCode: "02", districtCode: "03" },
    { name: "Maamakrom", regionCode: "02", districtCode: "03" },
    { name: "Maame Dede Junction", regionCode: "02", districtCode: "03" },
    { name: "Maame Dede/Methodist Church", regionCode: "02", districtCode: "03" },
    { name: "Mamakrom-Boadeso", regionCode: "02", districtCode: "03" },
    { name: "Marfo", regionCode: "02", districtCode: "03" },
    { name: "Mariakow", regionCode: "02", districtCode: "03" },
    { name: "Medium Security Prison", regionCode: "02", districtCode: "03" },
    { name: "Mensahman", regionCode: "02", districtCode: "03" },
    { name: "Nkumkrom", regionCode: "02", districtCode: "03" },
    { name: "Nkyenenkyene", regionCode: "02", districtCode: "03" },
    { name: "Nkyenenkyene", regionCode: "02", districtCode: "03" },
    { name: "Noka", regionCode: "02", districtCode: "03" },
    { name: "Nsawam Bungalow Martha", regionCode: "02", districtCode: "03" },
    { name: "Nsumia", regionCode: "02", districtCode: "03" },
    { name: "Ntoaso", regionCode: "02", districtCode: "03" },
    { name: "Obenyaw", regionCode: "02", districtCode: "03" },
    { name: "Oboadaka", regionCode: "02", districtCode: "03" },
    { name: "Obotweri", regionCode: "02", districtCode: "03" },
    { name: "Obuonso/New", regionCode: "02", districtCode: "03" },
    { name: "Odeikrom", regionCode: "02", districtCode: "03" },
    { name: "Oduntokrom/New", regionCode: "02", districtCode: "03" },
    { name: "Okinjaman", regionCode: "02", districtCode: "03" },
    { name: "Okoe Nkwanta-Marfi", regionCode: "02", districtCode: "03" },
    { name: "Okotuom", regionCode: "02", districtCode: "03" },
    { name: "Okubeyeyie", regionCode: "02", districtCode: "03" },
    { name: "Okurase", regionCode: "02", districtCode: "03" },
    { name: "Oparekrom", regionCode: "02", districtCode: "03" },
    { name: "Otiakrom", regionCode: "02", districtCode: "03" },
    { name: "Otoase", regionCode: "02", districtCode: "03" },
    { name: "Otsirikomfo", regionCode: "02", districtCode: "03" },
    { name: "Ottopayaw", regionCode: "02", districtCode: "03" },
    { name: "Ottukwadwo", regionCode: "02", districtCode: "03" },
    { name: "Owusukrom", regionCode: "02", districtCode: "03" },
    { name: "Pakro", regionCode: "02", districtCode: "03" },
    { name: "Pokrom", regionCode: "02", districtCode: "03" },
    { name: "Pokrom", regionCode: "02", districtCode: "03" },
    { name: "Prince", regionCode: "02", districtCode: "03" },
    { name: "Sakyikro/Adoagyiri", regionCode: "02", districtCode: "03" },
    { name: "Sakyikrom", regionCode: "02", districtCode: "03" },
    { name: "Samsam Odumase/Mpehuseme", regionCode: "02", districtCode: "03" },
    { name: "Sekyikrom", regionCode: "02", districtCode: "03" },
    { name: "Takyikrom", regionCode: "02", districtCode: "03" },
    { name: "Tarankro", regionCode: "02", districtCode: "03" },
    { name: "Teshie Town Akwadum", regionCode: "02", districtCode: "03" },
    { name: "Toikrom/Success Pre Sch", regionCode: "02", districtCode: "03" },
    { name: "Twerebo/Anglican Sch", regionCode: "02", districtCode: "03" },
    { name: "Wuruduwurudu", regionCode: "02", districtCode: "03" },
    { name: "Yaw Donko-Aboakrom", regionCode: "02", districtCode: "03" },
    { name: "Yaw Kwesi", regionCode: "02", districtCode: "03" },
    { name: "Yaw Larbi", regionCode: "02", districtCode: "03" },
    { name: "Yawduodu", regionCode: "02", districtCode: "03" },
    { name: "Yawkrom", regionCode: "02", districtCode: "03" },
    { name: "Yawkwra", regionCode: "02", districtCode: "03" }
  ],
  "02-04": [
    { name: "Aplaku", regionCode: "02", districtCode: "04" },
    { name: "Ayigbe Town", regionCode: "02", districtCode: "04" },
    { name: "Azumah", regionCode: "02", districtCode: "04" },
    { name: "Barrier", regionCode: "02", districtCode: "04" },
    { name: "Block Factory", regionCode: "02", districtCode: "04" },
    { name: "Broadcasting", regionCode: "02", districtCode: "04" },
    { name: "Bulemi", regionCode: "02", districtCode: "04" },
    { name: "Choice", regionCode: "02", districtCode: "04" },
    { name: "Darkuman", regionCode: "02", districtCode: "04" },
    { name: "Gbawe", regionCode: "02", districtCode: "04" },
    { name: "Jama", regionCode: "02", districtCode: "04" },
    { name: "Kokompe", regionCode: "02", districtCode: "04" },
    { name: "Kokrobite", regionCode: "02", districtCode: "04" },
    { name: "Kwashieman", regionCode: "02", districtCode: "04" },
    { name: "Langba", regionCode: "02", districtCode: "04" },
    { name: "MacCarthy Hill", regionCode: "02", districtCode: "04" },
    { name: "Mallam", regionCode: "02", districtCode: "04" },
    { name: "Menskrom", regionCode: "02", districtCode: "04" },
    { name: "Mile 11", regionCode: "02", districtCode: "04" },
    { name: "New Bortianor", regionCode: "02", districtCode: "04" },
    { name: "Nyamekye", regionCode: "02", districtCode: "04" },
    { name: "Oblogo", regionCode: "02", districtCode: "04" },
    { name: "Odorkor", regionCode: "02", districtCode: "04" },
    { name: "Old Bortianor", regionCode: "02", districtCode: "04" },
    { name: "Oshie", regionCode: "02", districtCode: "04" },
    { name: "Red top", regionCode: "02", districtCode: "04" },
    { name: "S.C.C", regionCode: "02", districtCode: "04" },
    { name: "Sampa Valley", regionCode: "02", districtCode: "04" },
    { name: "Taptop", regionCode: "02", districtCode: "04" },
    { name: "Tetegu", regionCode: "02", districtCode: "04" },
    { name: "Top Base", regionCode: "02", districtCode: "04" },
    { name: "Weija", regionCode: "02", districtCode: "04" },
    { name: "White Cross", regionCode: "02", districtCode: "04" },
    { name: "Wiaborman", regionCode: "02", districtCode: "04" }
  ],
  "02-05": [
    { name: "Accountant General", regionCode: "02", districtCode: "05" },
    { name: "Agege", regionCode: "02", districtCode: "05" },
    { name: "Agege 205", regionCode: "02", districtCode: "05" },
    { name: "Akoko Foto", regionCode: "02", districtCode: "05" },
    { name: "Akweibu", regionCode: "02", districtCode: "05" },
    { name: "Aliu Mahama", regionCode: "02", districtCode: "05" },
    { name: "Appiah Dankwah", regionCode: "02", districtCode: "05" },
    { name: "Asoredanho", regionCode: "02", districtCode: "05" },
    { name: "Atomic", regionCode: "02", districtCode: "05" },
    { name: "B' Opoku", regionCode: "02", districtCode: "05" },
    { name: "Banana Inn", regionCode: "02", districtCode: "05" },
    { name: "Beach Road Gbegbeyisei", regionCode: "02", districtCode: "05" },
    { name: "Beechem", regionCode: "02", districtCode: "05" },
    { name: "Busia", regionCode: "02", districtCode: "05" },
    { name: "Camara", regionCode: "02", districtCode: "05" },
    { name: "Central University", regionCode: "02", districtCode: "05" },
    { name: "Control", regionCode: "02", districtCode: "05" },
    { name: "Danwright", regionCode: "02", districtCode: "05" },
    { name: "Dr Rose", regionCode: "02", districtCode: "05" },
    { name: "Ebenezer", regionCode: "02", districtCode: "05" },
    { name: "Exhibition", regionCode: "02", districtCode: "05" },
    { name: "First Light", regionCode: "02", districtCode: "05" },
    { name: "First Stop", regionCode: "02", districtCode: "05" },
    { name: "Flamingo", regionCode: "02", districtCode: "05" },
    { name: "Glefe & Environs", regionCode: "02", districtCode: "05" },
    { name: "Gloryland", regionCode: "02", districtCode: "05" },
    { name: "Hansonic", regionCode: "02", districtCode: "05" },
    { name: "I.B.E", regionCode: "02", districtCode: "05" },
    { name: "Item 13", regionCode: "02", districtCode: "05" },
    { name: "Kaneshie", regionCode: "02", districtCode: "05" },
    { name: "Karikari", regionCode: "02", districtCode: "05" },
    { name: "Keepfit", regionCode: "02", districtCode: "05" },
    { name: "King Solomon", regionCode: "02", districtCode: "05" },
    { name: "Kofi Ne Ama", regionCode: "02", districtCode: "05" },
    { name: "Kumchacha", regionCode: "02", districtCode: "05" },
    { name: "Last Stop", regionCode: "02", districtCode: "05" },
    { name: "Mabruk Park", regionCode: "02", districtCode: "05" },
    { name: "Mama's Inn", regionCode: "02", districtCode: "05" },
    { name: "Mamponse", regionCode: "02", districtCode: "05" },
    { name: "Mataheko", regionCode: "02", districtCode: "05" },
    { name: "Most Holy Heart", regionCode: "02", districtCode: "05" },
    { name: "Mpoase", regionCode: "02", districtCode: "05" },
    { name: "Mr. Mensah", regionCode: "02", districtCode: "05" },
    { name: "Opetekwei", regionCode: "02", districtCode: "05" },
    { name: "Osofo Dadzie", regionCode: "02", districtCode: "05" },
    { name: "Otojor", regionCode: "02", districtCode: "05" },
    { name: "Petroleum", regionCode: "02", districtCode: "05" },
    { name: "Radio Gold", regionCode: "02", districtCode: "05" },
    { name: "Russia", regionCode: "02", districtCode: "05" },
    { name: "Sahara", regionCode: "02", districtCode: "05" },
    { name: "Sakaman", regionCode: "02", districtCode: "05" },
    { name: "Salvation", regionCode: "02", districtCode: "05" },
    { name: "Sharp Curve", regionCode: "02", districtCode: "05" },
    { name: "Shiabu", regionCode: "02", districtCode: "05" },
    { name: "Soko", regionCode: "02", districtCode: "05" },
    { name: "South Odorkor", regionCode: "02", districtCode: "05" },
    { name: "SSNIT Flats", regionCode: "02", districtCode: "05" },
    { name: "St. Anthony", regionCode: "02", districtCode: "05" },
    { name: "Sukura", regionCode: "02", districtCode: "05" },
    { name: "Town Council Line", regionCode: "02", districtCode: "05" },
    { name: "Tunga", regionCode: "02", districtCode: "05" },
    { name: "Wesley Grammar", regionCode: "02", districtCode: "05" },
    { name: "Zamanam Line", regionCode: "02", districtCode: "05" },
    { name: "Zodiac", regionCode: "02", districtCode: "05" },
    { name: "Zone 6", regionCode: "02", districtCode: "05" },
    { name: "Zongo Junction", regionCode: "02", districtCode: "05" }
  ],
  "02-06": [
    { name: "Abeka", regionCode: "02", districtCode: "06" },
    { name: "Abeka Lapaz", regionCode: "02", districtCode: "06" },
    { name: "Abeka Point 4 Junction", regionCode: "02", districtCode: "06" },
    { name: "Accra City Campus", regionCode: "02", districtCode: "06" },
    { name: "Accra High Sch", regionCode: "02", districtCode: "06" },
    { name: "Accra Polytechnic", regionCode: "02", districtCode: "06" },
    { name: "Adabraka", regionCode: "02", districtCode: "06" },
    { name: "Adabraka Cathedral", regionCode: "02", districtCode: "06" },
    { name: "Apenkwa", regionCode: "02", districtCode: "06" },
    { name: "Asylum Down", regionCode: "02", districtCode: "06" },
    { name: "Atico", regionCode: "02", districtCode: "06" },
    { name: "Awudome Estates", regionCode: "02", districtCode: "06" },
    { name: "Bubiashie", regionCode: "02", districtCode: "06" },
    { name: "Cedis House", regionCode: "02", districtCode: "06" },
    { name: "Darkuman", regionCode: "02", districtCode: "06" },
    { name: "De-Mod Spot", regionCode: "02", districtCode: "06" },
    { name: "Electoral Commission", regionCode: "02", districtCode: "06" },
    { name: "Fadama", regionCode: "02", districtCode: "06" },
    { name: "Good Shepherd", regionCode: "02", districtCode: "06" },
    { name: "Kaneshie", regionCode: "02", districtCode: "06" },
    { name: "Kaneshie Market", regionCode: "02", districtCode: "06" },
    { name: "Mitsubish Motors", regionCode: "02", districtCode: "06" },
    { name: "MTTU", regionCode: "02", districtCode: "06" },
    { name: "North Industrial Area", regionCode: "02", districtCode: "06" },
    { name: "North Kaneshie", regionCode: "02", districtCode: "06" },
    { name: "Peace FM St.", regionCode: "02", districtCode: "06" },
    { name: "Police Depot Tesano", regionCode: "02", districtCode: "06" },
    { name: "Ridge", regionCode: "02", districtCode: "06" },
    { name: "Santana Market", regionCode: "02", districtCode: "06" },
    { name: "St Theresa Sch.", regionCode: "02", districtCode: "06" },
    { name: "Tesano", regionCode: "02", districtCode: "06" },
    { name: "Tesano Karldof Area", regionCode: "02", districtCode: "06" },
    { name: "Tudu", regionCode: "02", districtCode: "06" },
    { name: "Vienna City Circle", regionCode: "02", districtCode: "06" }
  ],
  "02-07": [
    { name: "Abehenase", regionCode: "02", districtCode: "07" },
    { name: "Abeyman", regionCode: "02", districtCode: "07" },
    { name: "Ablekuma Abase", regionCode: "02", districtCode: "07" },
    { name: "Ablekuma Curve", regionCode: "02", districtCode: "07" },
    { name: "Ablekuma Fanmilk", regionCode: "02", districtCode: "07" },
    { name: "Ablekuma New Town", regionCode: "02", districtCode: "07" },
    { name: "Afuaman", regionCode: "02", districtCode: "07" },
    { name: "Agape", regionCode: "02", districtCode: "07" },
    { name: "Agape Down", regionCode: "02", districtCode: "07" },
    { name: "Agbozome", regionCode: "02", districtCode: "07" },
    { name: "Amamorley", regionCode: "02", districtCode: "07" },
    { name: "Anyaa", regionCode: "02", districtCode: "07" },
    { name: "Awoshies", regionCode: "02", districtCode: "07" },
    { name: "Ayikai Doblo", regionCode: "02", districtCode: "07" },
    { name: "Borkorborkor", regionCode: "02", districtCode: "07" },
    { name: "Gbawe", regionCode: "02", districtCode: "07" },
    { name: "Gbawe Bulemi", regionCode: "02", districtCode: "07" },
    { name: "Gbawe CP", regionCode: "02", districtCode: "07" },
    { name: "Gbawe Gonse", regionCode: "02", districtCode: "07" },
    { name: "Gbawe Zero", regionCode: "02", districtCode: "07" },
    { name: "Jida", regionCode: "02", districtCode: "07" },
    { name: "Joma", regionCode: "02", districtCode: "07" },
    { name: "Joma Paradise", regionCode: "02", districtCode: "07" },
    { name: "Mallam", regionCode: "02", districtCode: "07" },
    { name: "Mame Nkran", regionCode: "02", districtCode: "07" },
    { name: "Manhea", regionCode: "02", districtCode: "07" },
    { name: "NIC", regionCode: "02", districtCode: "07" },
    { name: "Nsakina", regionCode: "02", districtCode: "07" },
    { name: "Obeyeyie", regionCode: "02", districtCode: "07" },
    { name: "Oduman", regionCode: "02", districtCode: "07" },
    { name: "Odumase", regionCode: "02", districtCode: "07" },
    { name: "Olebu", regionCode: "02", districtCode: "07" },
    { name: "Oshuman", regionCode: "02", districtCode: "07" },
    { name: "Palace Town", regionCode: "02", districtCode: "07" },
    { name: "Peace Village", regionCode: "02", districtCode: "07" },
    { name: "Sonitra", regionCode: "02", districtCode: "07" }
  ],
  "02-08": [
    { name: "Achiaman", regionCode: "02", districtCode: "08" },
    { name: "Ademan", regionCode: "02", districtCode: "08" },
    { name: "Akotoshie", regionCode: "02", districtCode: "08" },
    { name: "Akramaman", regionCode: "02", districtCode: "08" },
    { name: "Amasaman Abehenase", regionCode: "02", districtCode: "08" },
    { name: "Amasaman COCOBOD", regionCode: "02", districtCode: "08" },
    { name: "Amasaman Darasalam", regionCode: "02", districtCode: "08" },
    { name: "Amasaman Fise", regionCode: "02", districtCode: "08" },
    { name: "Amasaman Shipontele", regionCode: "02", districtCode: "08" },
    { name: "Amasaman Tooman", regionCode: "02", districtCode: "08" },
    { name: "Ayikaidoblo", regionCode: "02", districtCode: "08" },
    { name: "Doblogono", regionCode: "02", districtCode: "08" },
    { name: "Kotoku", regionCode: "02", districtCode: "08" },
    { name: "Kwasiekuma", regionCode: "02", districtCode: "08" },
    { name: "Manchi", regionCode: "02", districtCode: "08" },
    { name: "Medie", regionCode: "02", districtCode: "08" },
    { name: "Obeyeyie", regionCode: "02", districtCode: "08" },
    { name: "Odumase", regionCode: "02", districtCode: "08" },
    { name: "Okushiebeade", regionCode: "02", districtCode: "08" },
    { name: "Onyansah", regionCode: "02", districtCode: "08" },
    { name: "Opah", regionCode: "02", districtCode: "08" },
    { name: "Otuapre", regionCode: "02", districtCode: "08" },
    { name: "Pokuase Dunyo", regionCode: "02", districtCode: "08" },
    { name: "Pokuase Abensu", regionCode: "02", districtCode: "08" },
    { name: "Pokuase Acp Estate /Knust", regionCode: "02", districtCode: "08" },
    { name: "Pokuase Adusah", regionCode: "02", districtCode: "08" },
    { name: "Pokuase Afiaman", regionCode: "02", districtCode: "08" },
    { name: "Pokuase Amfrum", regionCode: "02", districtCode: "08" },
    { name: "Pokuase Amomole", regionCode: "02", districtCode: "08" },
    { name: "Pokuase Katapor", regionCode: "02", districtCode: "08" },
    { name: "Pokuase Mayira", regionCode: "02", districtCode: "08" },
    { name: "Pokuase Osofoman", regionCode: "02", districtCode: "08" },
    { name: "Samsam", regionCode: "02", districtCode: "08" },
    { name: "Sapeman", regionCode: "02", districtCode: "08" },
    { name: "Satelite Abloman", regionCode: "02", districtCode: "08" },
    { name: "Satelite Damax 1 & 2", regionCode: "02", districtCode: "08" },
    { name: "Satelite Hans Lodge Area", regionCode: "02", districtCode: "08" },
    { name: "Satelite Koans Estate", regionCode: "02", districtCode: "08" },
    { name: "Satelite Kpobiman", regionCode: "02", districtCode: "08" },
    { name: "Satelite Mercidonia", regionCode: "02", districtCode: "08" },
    { name: "Satelite Opah", regionCode: "02", districtCode: "08" },
    { name: "Satelite Treba", regionCode: "02", districtCode: "08" },
    { name: "Yahoman", regionCode: "02", districtCode: "08" }
  ],

  "04-01": [
    { name: "Ablodokope", regionCode: "04", districtCode: "01" },
    { name: "Abor Agbolete", regionCode: "04", districtCode: "01" },
    { name: "Abor Allied Filling Station", regionCode: "04", districtCode: "01" },
    { name: "Abor Ars Church", regionCode: "04", districtCode: "01" },
    { name: "Abor Dzovatame", regionCode: "04", districtCode: "01" },
    { name: "Abor Handicap", regionCode: "04", districtCode: "01" },
    { name: "Abor Market", regionCode: "04", districtCode: "01" },
    { name: "Abor Shs", regionCode: "04", districtCode: "01" },
    { name: "Abor Town", regionCode: "04", districtCode: "01" },
    { name: "Abor Tsiame Road", regionCode: "04", districtCode: "01" },
    { name: "Abor Weme", regionCode: "04", districtCode: "01" },
    { name: "Abor Weme Agbenukope", regionCode: "04", districtCode: "01" },
    { name: "Aborlove", regionCode: "04", districtCode: "01" },
    { name: "Abrokope Zalikpo", regionCode: "04", districtCode: "01" },
    { name: "Adave", regionCode: "04", districtCode: "01" },
    { name: "Adetsewui", regionCode: "04", districtCode: "01" },
    { name: "Adidome No. 1", regionCode: "04", districtCode: "01" },
    { name: "Adidome No. 2", regionCode: "04", districtCode: "01" },
    { name: "Adogokope /Humadzikope", regionCode: "04", districtCode: "01" },
    { name: "Adrakpo", regionCode: "04", districtCode: "01" },
    { name: "Adzikame Rc", regionCode: "04", districtCode: "01" },
    { name: "Adzikame Township", regionCode: "04", districtCode: "01" },
    { name: "Afatsagbleve", regionCode: "04", districtCode: "01" },
    { name: "Afeyime Glidzakope", regionCode: "04", districtCode: "01" },
    { name: "Afeyime Lakpakope", regionCode: "04", districtCode: "01" },
    { name: "Afife Area Council", regionCode: "04", districtCode: "01" },
    { name: "Afife Assemblies Of God", regionCode: "04", districtCode: "01" },
    { name: "Afife Havorkope", regionCode: "04", districtCode: "01" },
    { name: "Afife Health Centre", regionCode: "04", districtCode: "01" },
    { name: "Afife New Market", regionCode: "04", districtCode: "01" },
    { name: "Afife Norlopi No. 1", regionCode: "04", districtCode: "01" },
    { name: "Afife Norlopi No. 2", regionCode: "04", districtCode: "01" },
    { name: "Afife Police Barrier", regionCode: "04", districtCode: "01" },
    { name: "Afife Street Light", regionCode: "04", districtCode: "01" },
    { name: "Afife Township", regionCode: "04", districtCode: "01" },
    { name: "Afriyie Ankrah's House", regionCode: "04", districtCode: "01" },
    { name: "Agbaflome", regionCode: "04", districtCode: "01" },
    { name: "Agbagblakope", regionCode: "04", districtCode: "01" },
    { name: "Agbalihome", regionCode: "04", districtCode: "01" },
    { name: "Agbalihome Agblega", regionCode: "04", districtCode: "01" },
    { name: "Agbanukope", regionCode: "04", districtCode: "01" },
    { name: "Agbanyokope", regionCode: "04", districtCode: "01" },
    { name: "Agbedrafor", regionCode: "04", districtCode: "01" },
    { name: "Agbledome No. 1", regionCode: "04", districtCode: "01" },
    { name: "Agbledome No. 2", regionCode: "04", districtCode: "01" },
    { name: "Agblekpuime", regionCode: "04", districtCode: "01" },
    { name: "Agboglikope", regionCode: "04", districtCode: "01" },
    { name: "Agbotsukope", regionCode: "04", districtCode: "01" },
    { name: "Agordeke", regionCode: "04", districtCode: "01" },
    { name: "Agordza", regionCode: "04", districtCode: "01" },
    { name: "Agorme", regionCode: "04", districtCode: "01" },
    { name: "Agormor Agado", regionCode: "04", districtCode: "01" },
    { name: "Agormor Basic School", regionCode: "04", districtCode: "01" },
    { name: "Agornu Kporkplorte", regionCode: "04", districtCode: "01" },
    { name: "Agortorgbeve", regionCode: "04", districtCode: "01" },
    { name: "Agorve", regionCode: "04", districtCode: "01" },
    { name: "Agorve Newtown", regionCode: "04", districtCode: "01" },
    { name: "Agorvega", regionCode: "04", districtCode: "01" },
    { name: "Agorvenugoe", regionCode: "04", districtCode: "01" },
    { name: "Agorweme", regionCode: "04", districtCode: "01" },
    { name: "Ahiagbekope", regionCode: "04", districtCode: "01" },
    { name: "Ahiakpo", regionCode: "04", districtCode: "01" },
    { name: "Ahiayiborkope", regionCode: "04", districtCode: "01" },
    { name: "Ahlihadzi", regionCode: "04", districtCode: "01" },
    { name: "Ahugakope", regionCode: "04", districtCode: "01" },
    { name: "Akaglakope", regionCode: "04", districtCode: "01" },
    { name: "Akatsi Agorve", regionCode: "04", districtCode: "01" },
    { name: "Akatsi Bishop Village", regionCode: "04", districtCode: "01" },
    { name: "Akatsi District Hospital", regionCode: "04", districtCode: "01" },
    { name: "Akatsi Ecg Office", regionCode: "04", districtCode: "01" },
    { name: "Akatsi Gbc", regionCode: "04", districtCode: "01" },
    { name: "Akatsi Live Road", regionCode: "04", districtCode: "01" },
    { name: "Akatsi Market", regionCode: "04", districtCode: "01" },
    { name: "Akatsi Motuary Road", regionCode: "04", districtCode: "01" },
    { name: "Akatsi Sec. Tech", regionCode: "04", districtCode: "01" },
    { name: "Akatsi Shell Filling Station", regionCode: "04", districtCode: "01" },
    { name: "Akatsi Training College No. 1", regionCode: "04", districtCode: "01" },
    { name: "Akatsi Training College No. 2", regionCode: "04", districtCode: "01" },
    { name: "Akatsi Tv Station", regionCode: "04", districtCode: "01" },
    { name: "Akatsi Zongo", regionCode: "04", districtCode: "01" },
    { name: "Akave Gui", regionCode: "04", districtCode: "01" },
    { name: "Akave Gui Jhs", regionCode: "04", districtCode: "01" },
    { name: "Akave Gui Klokope", regionCode: "04", districtCode: "01" },
    { name: "Akonkope Heheme", regionCode: "04", districtCode: "01" },
    { name: "Akuave", regionCode: "04", districtCode: "01" },
    { name: "Akukorme", regionCode: "04", districtCode: "01" },
    { name: "Alavanyo Dzinyuiadzi", regionCode: "04", districtCode: "01" },
    { name: "Alavanyo Kpoyikope", regionCode: "04", districtCode: "01" },
    { name: "Anyako Aborme Cemetry", regionCode: "04", districtCode: "01" },
    { name: "Anyako Kpota", regionCode: "04", districtCode: "01" },
    { name: "Anyako Kpota Ars Mission", regionCode: "04", districtCode: "01" },
    { name: "Anyako Police Station", regionCode: "04", districtCode: "01" },
    { name: "Anyako Sports Complex", regionCode: "04", districtCode: "01" },
    { name: "Anyidzime", regionCode: "04", districtCode: "01" },
    { name: "Anyiyeme", regionCode: "04", districtCode: "01" }
  ],
  "04-02": [
    { "name": "Aborigine Beach Resort", "regionCode": "04", "districtCode": "02" },
    { "name": "Adakordzi", "regionCode": "04", "districtCode": "02" },
    { "name": "Adzato", "regionCode": "04", "districtCode": "02" },
    { "name": "Adzido", "regionCode": "04", "districtCode": "02" },
    { "name": "Aflornuto", "regionCode": "04", "districtCode": "02" },
    { "name": "Agbatsivi", "regionCode": "04", "districtCode": "02" },
    { "name": "Agbedrafor", "regionCode": "04", "districtCode": "02" },
    { "name": "Agbledome", "regionCode": "04", "districtCode": "02" },
    { "name": "Agbledome Area Council", "regionCode": "04", "districtCode": "02" },
    { "name": "Agorbledokui", "regionCode": "04", "districtCode": "02" },
    { "name": "Agorbledokuikope", "regionCode": "04", "districtCode": "02" },
    { "name": "Agortoe", "regionCode": "04", "districtCode": "02" },
    { "name": "Agortoe Boosting Station", "regionCode": "04", "districtCode": "02" },
    { "name": "Agortoe Jhs", "regionCode": "04", "districtCode": "02" },
    { "name": "Agorvinu", "regionCode": "04", "districtCode": "02" },
    { "name": "Aklorbordzi Morkporkpor", "regionCode": "04", "districtCode": "02" },
    { "name": "Aklorbordzi Rc Mission", "regionCode": "04", "districtCode": "02" },
    { "name": "Akplorfudzi", "regionCode": "04", "districtCode": "02" },
    { "name": "Akplorwotorkor Basic School", "regionCode": "04", "districtCode": "02" },
    { "name": "Alakple", "regionCode": "04", "districtCode": "02" },
    { "name": "Anlo Rural Bank", "regionCode": "04", "districtCode": "02" },
    { "name": "Anloga Switching Station", "regionCode": "04", "districtCode": "02" },
    { "name": "Anloga Township", "regionCode": "04", "districtCode": "02" },
    { "name": "Anloga Water Works", "regionCode": "04", "districtCode": "02" },
    { "name": "Anseco", "regionCode": "04", "districtCode": "02" },
    { "name": "Antech", "regionCode": "04", "districtCode": "02" },
    { "name": "Anyanui", "regionCode": "04", "districtCode": "02" },
    { "name": "Anyanui No. 2", "regionCode": "04", "districtCode": "02" },
    { "name": "Atiteti Anyanui", "regionCode": "04", "districtCode": "02" },
    { "name": "Atito", "regionCode": "04", "districtCode": "02" },
    { "name": "Atorkor", "regionCode": "04", "districtCode": "02" },
    { "name": "Atorkor School Mission", "regionCode": "04", "districtCode": "02" },
    { "name": "Atravenu", "regionCode": "04", "districtCode": "02" },
    { "name": "Atsugbor No. 1", "regionCode": "04", "districtCode": "02" },
    { "name": "Atsugbor No. 2", "regionCode": "04", "districtCode": "02" },
    { "name": "Avadada", "regionCode": "04", "districtCode": "02" },
    { "name": "Awaflakpota", "regionCode": "04", "districtCode": "02" },
    { "name": "Azanu", "regionCode": "04", "districtCode": "02" },
    { "name": "Azumagbor", "regionCode": "04", "districtCode": "02" },
    { "name": "Benadzi", "regionCode": "04", "districtCode": "02" },
    { "name": "Biwater Anloga", "regionCode": "04", "districtCode": "02" },
    { "name": "Blamezado", "regionCode": "04", "districtCode": "02" },
    { "name": "Brazil Agro, Kpenu", "regionCode": "04", "districtCode": "02" },
    { "name": "Cape Coast Road No. 1", "regionCode": "04", "districtCode": "02" },
    { "name": "Cape Coast Road No. 2", "regionCode": "04", "districtCode": "02" },
    { "name": "Dekugbor", "regionCode": "04", "districtCode": "02" },
    { "name": "Deta", "regionCode": "04", "districtCode": "02" },
    { "name": "Devegodo No. 1", "regionCode": "04", "districtCode": "02" },
    { "name": "Devegodo No. 2", "regionCode": "04", "districtCode": "02" },
    { "name": "Dornorgbor", "regionCode": "04", "districtCode": "02" },
    { "name": "Dornorgbor Quarters No. 1", "regionCode": "04", "districtCode": "02" },
    { "name": "Dornorgbor Quarters No. 2", "regionCode": "04", "districtCode": "02" },
    { "name": "Dzadekope", "regionCode": "04", "districtCode": "02" },
    { "name": "Dzidzorve Clinic", "regionCode": "04", "districtCode": "02" },
    { "name": "Dzita", "regionCode": "04", "districtCode": "02" },
    { "name": "Dzita Agbledome", "regionCode": "04", "districtCode": "02" },
    { "name": "Dzita Morgadzi", "regionCode": "04", "districtCode": "02" },
    { "name": "Fascom", "regionCode": "04", "districtCode": "02" },
    { "name": "Fiaxor", "regionCode": "04", "districtCode": "02" },
    { "name": "Galosota", "regionCode": "04", "districtCode": "02" },
    { "name": "Gavivina", "regionCode": "04", "districtCode": "02" },
    { "name": "Genui", "regionCode": "04", "districtCode": "02" },
    { "name": "Glorkpovia", "regionCode": "04", "districtCode": "02" },
    { "name": "Hadota", "regionCode": "04", "districtCode": "02" },
    { "name": "Hekpa", "regionCode": "04", "districtCode": "02" },
    { "name": "Katta Road", "regionCode": "04", "districtCode": "02" },
    { "name": "Kedzi No. 1", "regionCode": "04", "districtCode": "02" },
    { "name": "Kedzi No. 2", "regionCode": "04", "districtCode": "02" },
    { "name": "Kedzikope", "regionCode": "04", "districtCode": "02" },
    { "name": "Keta Beach Hotel", "regionCode": "04", "districtCode": "02" },
    { "name": "Keta Ecg Yard", "regionCode": "04", "districtCode": "02" },
    { "name": "Keta Gbc", "regionCode": "04", "districtCode": "02" },
    { "name": "Keta Hospital No. 1", "regionCode": "04", "districtCode": "02" },
    { "name": "Keta Hospital No. 2", "regionCode": "04", "districtCode": "02" },
    { "name": "Keta Lorry Station", "regionCode": "04", "districtCode": "02" },
    { "name": "Keta Magazine", "regionCode": "04", "districtCode": "02" },
    { "name": "Keta New Resettlement", "regionCode": "04", "districtCode": "02" },
    { "name": "Keta Shs", "regionCode": "04", "districtCode": "02" },
    { "name": "Klomikpota", "regionCode": "04", "districtCode": "02" },
    { "name": "Klonu", "regionCode": "04", "districtCode": "02" },
    { "name": "Kodzi", "regionCode": "04", "districtCode": "02" },
    { "name": "Kpordui", "regionCode": "04", "districtCode": "02" },
    { "name": "Kportorgbi", "regionCode": "04", "districtCode": "02" },
    { "name": "Kpota (Nyamebekyre)", "regionCode": "04", "districtCode": "02" },
    { "name": "Latame", "regionCode": "04", "districtCode": "02" },
    { "name": "Lighthouse Junction", "regionCode": "04", "districtCode": "02" },
    { "name": "Lividzi", "regionCode": "04", "districtCode": "02" },
    { "name": "Nyikutor", "regionCode": "04", "districtCode": "02" },
    { "name": "Salo", "regionCode": "04", "districtCode": "02" },
    { "name": "Salvation Army", "regionCode": "04", "districtCode": "02" },
    { "name": "Savietula", "regionCode": "04", "districtCode": "02" },
    { "name": "Savietula Barrier", "regionCode": "04", "districtCode": "02" },
    { "name": "Savietula Fish Pond", "regionCode": "04", "districtCode": "02" },
    { "name": "Semenagbor", "regionCode": "04", "districtCode": "02" },
    { "name": "Setsinu Anloga", "regionCode": "04", "districtCode": "02" },
    { "name": "Sodzi", "regionCode": "04", "districtCode": "02" },
    { "name": "Sokutsime", "regionCode": "04", "districtCode": "02" },
    { "name": "Srogbe", "regionCode": "04", "districtCode": "02" },
    { "name": "Srogbe Gbedegbor", "regionCode": "04", "districtCode": "02" },
    { "name": "Suipe", "regionCode": "04", "districtCode": "02" },
    { "name": "Tegbi Ashiata", "regionCode": "04", "districtCode": "02" },
    { "name": "Tegbi Ashiata 2", "regionCode": "04", "districtCode": "02" },
    { "name": "Tegbi Clinic", "regionCode": "04", "districtCode": "02" },
    { "name": "Tegbi Kpota", "regionCode": "04", "districtCode": "02" },
    { "name": "Tegbi Vakpormida", "regionCode": "04", "districtCode": "02" },
    { "name": "Tetevikope", "regionCode": "04", "districtCode": "02" },
    { "name": "Tregui", "regionCode": "04", "districtCode": "02" },
    { "name": "Trekume No. 1", "regionCode": "04", "districtCode": "02" },
    { "name": "Trekume No. 2", "regionCode": "04", "districtCode": "02" },
    { "name": "Trekume No. 3", "regionCode": "04", "districtCode": "02" },
    { "name": "Tunu", "regionCode": "04", "districtCode": "02" },
    { "name": "Vodafone Yard", "regionCode": "04", "districtCode": "02" },
    { "name": "Vodza", "regionCode": "04", "districtCode": "02" },
    { "name": "Vorvornukope", "regionCode": "04", "districtCode": "02" },
    { "name": "Vui Cemetry", "regionCode": "04", "districtCode": "02" },
    { "name": "Vui Chraj", "regionCode": "04", "districtCode": "02" },
    { "name": "Vui Town", "regionCode": "04", "districtCode": "02" },
    { "name": "Whuti No. 1", "regionCode": "04", "districtCode": "02" },
    { "name": "Whuti Atiefe", "regionCode": "04", "districtCode": "02" },
    { "name": "Whuti No. 2", "regionCode": "04", "districtCode": "02" },
    { "name": "Whuti Srogbe Ep Church", "regionCode": "04", "districtCode": "02" },
    { "name": "Woe Abutia", "regionCode": "04", "districtCode": "02" },
    { "name": "Woe Dzidzorve", "regionCode": "04", "districtCode": "02" },
    { "name": "Woe Kaklokope", "regionCode": "04", "districtCode": "02" },
    { "name": "Woe Lighthouse", "regionCode": "04", "districtCode": "02" },
    { "name": "Woe Town", "regionCode": "04", "districtCode": "02" },
    { "name": "Zion College", "regionCode": "04", "districtCode": "02" },
    { "name": "Zortorglo Cemetry", "regionCode": "04", "districtCode": "02" }
  ],
  "04-03": [
    { name: "Adafianu", regionCode: "04", districtCode: "03" },
    { name: "Adafianu Babanawokope", regionCode: "04", districtCode: "03" },
    { name: "Adafianu Tetekope No. 1", regionCode: "04", districtCode: "03" },
    { name: "Adafianu Tetekope No. 2", regionCode: "04", districtCode: "03" },
    { name: "Adafianu Tetekope No. 3", regionCode: "04", districtCode: "03" },
    { name: "Adafianu Tetekope No. 4", regionCode: "04", districtCode: "03" },
    { name: "Adelakoekope", regionCode: "04", districtCode: "03" },
    { name: "Adewukope", regionCode: "04", districtCode: "03" },
    { name: "Adina Adukope", regionCode: "04", districtCode: "03" },
    { name: "Adina Gbagbakope", regionCode: "04", districtCode: "03" },
    { name: "Adina Hiatorkope", regionCode: "04", districtCode: "03" },
    { name: "Adina Salt Factory N0. 2", regionCode: "04", districtCode: "03" },
    { name: "Adina Salt Factory N0. 3", regionCode: "04", districtCode: "03" },
    { name: "Adina Salt Factory No. 1", regionCode: "04", districtCode: "03" },
    { name: "Adrume", regionCode: "04", districtCode: "03" },
    { name: "Adzablikope", regionCode: "04", districtCode: "03" },
    { name: "Adzinukope", regionCode: "04", districtCode: "03" },
    { name: "Adzoatsi", regionCode: "04", districtCode: "03" },
    { name: "Afiadenyigba Town", regionCode: "04", districtCode: "03" },
    { name: "Aflao Akussah Park", regionCode: "04", districtCode: "03" },
    { name: "Aflao Border No. 1", regionCode: "04", districtCode: "03" },
    { name: "Aflao Border No. 2", regionCode: "04", districtCode: "03" },
    { name: "Aflao Border Yard", regionCode: "04", districtCode: "03" },
    { name: "Aflao Duta No. 1", regionCode: "04", districtCode: "03" },
    { name: "Aflao Duta No. 2", regionCode: "04", districtCode: "03" },
    { name: "Aflao Duta No. 3", regionCode: "04", districtCode: "03" },
    { name: "Aflao Hospital", regionCode: "04", districtCode: "03" },
    { name: "Aflao Hospital No. 2", regionCode: "04", districtCode: "03" },
    { name: "Aflao Police Station", regionCode: "04", districtCode: "03" },
    { name: "Aflao Tokor Jhs", regionCode: "04", districtCode: "03" },
    { name: "Aflao Tokor Mtn", regionCode: "04", districtCode: "03" },
    { name: "Afuta", regionCode: "04", districtCode: "03" },
    { name: "Afuta Ganukope", regionCode: "04", districtCode: "03" },
    { name: "Agavedzi", regionCode: "04", districtCode: "03" },
    { name: "Agbagblakope No. 1", regionCode: "04", districtCode: "03" },
    { name: "Agbagblakope No. 2", regionCode: "04", districtCode: "03" },
    { name: "Agblafedo", regionCode: "04", districtCode: "03" },
    { name: "Agblazume", regionCode: "04", districtCode: "03" },
    { name: "Agblekpui Comm. Day Shs", regionCode: "04", districtCode: "03" },
    { name: "Agbogbome", regionCode: "04", districtCode: "03" },
    { name: "Agbokope", regionCode: "04", districtCode: "03" },
    { name: "Agbondo / Adidokpui", regionCode: "04", districtCode: "03" },
    { name: "Agortorme No.1", regionCode: "04", districtCode: "03" },
    { name: "Agortorme No.2", regionCode: "04", districtCode: "03" },
    { name: "Agorvie No. 1", regionCode: "04", districtCode: "03" },
    { name: "Agorvie No. 2", regionCode: "04", districtCode: "03" },
    { name: "Agoyivikope", regionCode: "04", districtCode: "03" },
    { name: "Akaglakope No. 1", regionCode: "04", districtCode: "03" },
    { name: "Akaglakope No. 2", regionCode: "04", districtCode: "03" },
    { name: "Akame Kpota", regionCode: "04", districtCode: "03" },
    { name: "Akame Mission", regionCode: "04", districtCode: "03" },
    { name: "Akame Newtown", regionCode: "04", districtCode: "03" },
    { name: "Akame Torgodo", regionCode: "04", districtCode: "03" },
    { name: "Akame Vetekope", regionCode: "04", districtCode: "03" },
    { name: "Akame Vudome", regionCode: "04", districtCode: "03" },
    { name: "Akanu Border", regionCode: "04", districtCode: "03" },
    { name: "Akanu Star Oil", regionCode: "04", districtCode: "03" },
    { name: "Akanu Superior Filling Station", regionCode: "04", districtCode: "03" },
    { name: "Akpablikope", regionCode: "04", districtCode: "03" },
    { name: "Akpatoeme", regionCode: "04", districtCode: "03" },
    { name: "Akporkploe", regionCode: "04", districtCode: "03" },
    { name: "Alentame No. 1", regionCode: "04", districtCode: "03" },
    { name: "Alentame No. 2", regionCode: "04", districtCode: "03" },
    { name: "Alorgui Totame", regionCode: "04", districtCode: "03" },
    { name: "Amandi Quarry", regionCode: "04", districtCode: "03" },
    { name: "Amedoda", regionCode: "04", districtCode: "03" },
    { name: "Amedzikope", regionCode: "04", districtCode: "03" },
    { name: "Amefinukope", regionCode: "04", districtCode: "03" },
    { name: "Amule", regionCode: "04", districtCode: "03" },
    { name: "Amutinu", regionCode: "04", districtCode: "03" },
    { name: "Anites Hotel Junction", regionCode: "04", districtCode: "03" },
    { name: "Anlo Afiadenyigba Langbati", regionCode: "04", districtCode: "03" },
    { name: "Anlo Afiadenyigba Shs", regionCode: "04", districtCode: "03" },
    { name: "Anoenu Afedidi No. 1", regionCode: "04", districtCode: "03" },
    { name: "Anoenu Afedidi No. 2", regionCode: "04", districtCode: "03" },
    { name: "Anoenu Semenukope", regionCode: "04", districtCode: "03" },
    { name: "Asorgor", regionCode: "04", districtCode: "03" },
    { name: "Atanve", regionCode: "04", districtCode: "03" },
    { name: "Atiglime", regionCode: "04", districtCode: "03" },
    { name: "Atiteti", regionCode: "04", districtCode: "03" },
    { name: "Ativuta No. 1", regionCode: "04", districtCode: "03" },
    { name: "Ativuta No. 2", regionCode: "04", districtCode: "03" },
    { name: "Atorkukope", regionCode: "04", districtCode: "03" },
    { name: "Atsiaklorbor", regionCode: "04", districtCode: "03" },
    { name: "Atsukope", regionCode: "04", districtCode: "03" },
    { name: "Ave Afiadenyigba", regionCode: "04", districtCode: "03" },
    { name: "Ave Ahorkpor", regionCode: "04", districtCode: "03" },
    { name: "Ave Dakpa No. 2", regionCode: "04", districtCode: "03" },
    { name: "Ave Dakpa Shs Junction", regionCode: "04", districtCode: "03" },
    { name: "Ave Dakpa Township", regionCode: "04", districtCode: "03" },
    { name: "Ave Dzalele", regionCode: "04", districtCode: "03" },
    { name: "Ave Havi Filling Station", regionCode: "04", districtCode: "03" },
    { name: "Ave Havi No. 1", regionCode: "04", districtCode: "03" },
    { name: "Ave Havi No. 2", regionCode: "04", districtCode: "03" },
    { name: "Ave Kpedome", regionCode: "04", districtCode: "03" },
    { name: "Ave Kpotsa", regionCode: "04", districtCode: "03" },
    { name: "Ave Nyive", regionCode: "04", districtCode: "03" },
    { name: "Ave Posumono", regionCode: "04", districtCode: "03" },
    { name: "Ave Wukpe", regionCode: "04", districtCode: "03" },
    { name: "Ave Xevi", regionCode: "04", districtCode: "03" },
    { name: "Ave Zomayi", regionCode: "04", districtCode: "03" },
    { name: "Avekordome No. 1", regionCode: "04", districtCode: "03" },
    { name: "Avekordome No. 2", regionCode: "04", districtCode: "03" },
    { name: "Aveyiborme", regionCode: "04", districtCode: "03" },
    { name: "Avoeme", regionCode: "04", districtCode: "03" },
    { name: "Avoeme Junction", regionCode: "04", districtCode: "03" },
    { name: "Awakorme", regionCode: "04", districtCode: "03" },
    { name: "Awakorme Newtown", regionCode: "04", districtCode: "03" },
    { name: "Awakorme No. 2", regionCode: "04", districtCode: "03" },
    { name: "Awlekope", regionCode: "04", districtCode: "03" },
    { name: "Azilakope", regionCode: "04", districtCode: "03" },
    { name: "Azumahkope", regionCode: "04", districtCode: "03" },
    { name: "Babanawokope", regionCode: "04", districtCode: "03" },
    { name: "Bator", regionCode: "04", districtCode: "03" },
    { name: "Bayikope", regionCode: "04", districtCode: "03" },
    { name: "Benab Filling Station, Dzodze", regionCode: "04", districtCode: "03" },
    { name: "Bit 9", regionCode: "04", districtCode: "03" },
    { name: "Bit 9 Border", regionCode: "04", districtCode: "03" },
    { name: "Bit 9 Sitsofe", regionCode: "04", districtCode: "03" },
    { name: "Blamezado", regionCode: "04", districtCode: "03" },
    { name: "Blekpui", regionCode: "04", districtCode: "03" },
    { name: "Blekusu No. 1", regionCode: "04", districtCode: "03" },
    { name: "Blekusu No. 2", regionCode: "04", districtCode: "03" },
    { name: "Blewuadakope", regionCode: "04", districtCode: "03" },
    { name: "Bodzakope", regionCode: "04", districtCode: "03" },
    { name: "Cgc Camp", regionCode: "04", districtCode: "03" },
    { name: "Dakpa District Assembly Area", regionCode: "04", districtCode: "03" },
    { name: "Dakpa Elinam International", regionCode: "04", districtCode: "03" },
    { name: "Dakpa Newtown", regionCode: "04", districtCode: "03" },
    { name: "Daletekope", regionCode: "04", districtCode: "03" },
    { name: "Datsime", regionCode: "04", districtCode: "03" },
    { name: "Dekpor Dome", regionCode: "04", districtCode: "03" },
    { name: "Dekpor Horme", regionCode: "04", districtCode: "03" },
    { name: "Dekpor Yia", regionCode: "04", districtCode: "03" },
    { name: "Denu Ecg Office", regionCode: "04", districtCode: "03" },
    { name: "Denu Sda", regionCode: "04", districtCode: "03" },
    { name: "Diamond Cement", regionCode: "04", districtCode: "03" },
    { name: "District Assembly, Tokor", regionCode: "04", districtCode: "03" },
    { name: "District Works Department", regionCode: "04", districtCode: "03" },
    { name: "Dodorkope", regionCode: "04", districtCode: "03" },
    { name: "Dogbekope", regionCode: "04", districtCode: "03" },
    { name: "Dohia No. 1", regionCode: "04", districtCode: "03" },
    { name: "Dohia No. 2", regionCode: "04", districtCode: "03" },
    { name: "Dohia Tsavanye", regionCode: "04", districtCode: "03" },
    { name: "Dornormadi", regionCode: "04", districtCode: "03" },
    { name: "Duta Basic School", regionCode: "04", districtCode: "03" },
    { name: "Duta Clinic", regionCode: "04", districtCode: "03" },
    { name: "Duta Dzadakope", regionCode: "04", districtCode: "03" },
    { name: "Duta Makarantha Mosque", regionCode: "04", districtCode: "03" },
    { name: "Dzaglame", regionCode: "04", districtCode: "03" },
    { name: "Dzakpasukope", regionCode: "04", districtCode: "03" },
    { name: "Dzikunukope", regionCode: "04", districtCode: "03" },
    { name: "Dzisakope", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Ablorme", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Bedzame", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Bedzame No.2", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Begome", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Children Res. Center", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Court", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Dagbledu", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Dzogbefuime", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Fiagbedu", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Filling Station", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Global Down", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Hospital", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Hospital View", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Kave Jhs", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Kuli", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Lagbavi", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Lowcost No.1", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Lowcost No.2", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Market", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Mite", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Penyi Shs", regionCode: "04", districtCode: "03" },
    { name: "Dzodze Rc Mission", regionCode: "04", districtCode: "03" },
    { name: "Dzodze White Dove Hotel", regionCode: "04", districtCode: "03" },
    { name: "Dzogbekope", regionCode: "04", districtCode: "03" },
    { name: "Dzogbenu Nugozekope", regionCode: "04", districtCode: "03" },
    { name: "Dzogbetsikope", regionCode: "04", districtCode: "03" },
    { name: "Dzove Agbokorpe", regionCode: "04", districtCode: "03" },
    { name: "Ehi Biese", regionCode: "04", districtCode: "03" },
    { name: "Ehi Biese Kpota", regionCode: "04", districtCode: "03" },
    { name: "Ehi Horme Amegakope", regionCode: "04", districtCode: "03" },
    { name: "Ehi Police Station", regionCode: "04", districtCode: "03" },
    { name: "Ehi Tadzi", regionCode: "04", districtCode: "03" },
    { name: "Eleme Sovi", regionCode: "04", districtCode: "03" },
    { name: "Etekorpe Worta", regionCode: "04", districtCode: "03" },
    { name: "Fanoue Palace", regionCode: "04", districtCode: "03" },
    { name: "Fiave", regionCode: "04", districtCode: "03" },
    { name: "Gagodope", regionCode: "04", districtCode: "03" },
    { name: "Gakli", regionCode: "04", districtCode: "03" },
    { name: "Gakli Market", regionCode: "04", districtCode: "03" },
    { name: "Gamadzra", regionCode: "04", districtCode: "03" },
    { name: "Ganukope New", regionCode: "04", districtCode: "03" },
    { name: "Gbadzame No. 1", regionCode: "04", districtCode: "03" },
    { name: "Gbadzame No. 2", regionCode: "04", districtCode: "03" },
    { name: "Gbawueme Nukunukope", regionCode: "04", districtCode: "03" },
    { name: "Gbegbekorpe", regionCode: "04", districtCode: "03" },
    { name: "Gbonorme", regionCode: "04", districtCode: "03" },
    { name: "Gborglakope", regionCode: "04", districtCode: "03" },
    { name: "Gborxoxome", regionCode: "04", districtCode: "03" },
    { name: "Gedekope", regionCode: "04", districtCode: "03" },
    { name: "Glakpakope", regionCode: "04", districtCode: "03" },
    { name: "Glidzi", regionCode: "04", districtCode: "03" },
    { name: "Glidzi Glo", regionCode: "04", districtCode: "03" },
    { name: "Glitame", regionCode: "04", districtCode: "03" },
    { name: "Govinakope", regionCode: "04", districtCode: "03" },
    { name: "Havedzi", regionCode: "04", districtCode: "03" },
    { name: "Hawutoe", regionCode: "04", districtCode: "03" },
    { name: "Hedzranawo", regionCode: "04", districtCode: "03" },
    { name: "Hormegobo", regionCode: "04", districtCode: "03" },
    { name: "Horvi", regionCode: "04", districtCode: "03" },
    { name: "Huive", regionCode: "04", districtCode: "03" },
    { name: "Int. Mission Hospital", regionCode: "04", districtCode: "03" },
    { name: "Jehovah Witness Camp", regionCode: "04", districtCode: "03" },
    { name: "Kasu", regionCode: "04", districtCode: "03" },
    { name: "Kedzi Havedzi No. 1", regionCode: "04", districtCode: "03" },
    { name: "Kedzi Havedzi No. 2", regionCode: "04", districtCode: "03" },
    { name: "Klehorme No. 1", regionCode: "04", districtCode: "03" },
    { name: "Klehorme No. 2", regionCode: "04", districtCode: "03" },
    { name: "Klikor Central", regionCode: "04", districtCode: "03" },
    { name: "Klikor Kpota", regionCode: "04", districtCode: "03" },
    { name: "Klikor Lowcost", regionCode: "04", districtCode: "03" },
    { name: "Klinogokope", regionCode: "04", districtCode: "03" },
    { name: "Kopeyia", regionCode: "04", districtCode: "03" },
    { name: "Kopeyia Dzogbedzi", regionCode: "04", districtCode: "03" },
    { name: "Kopeyia Woegakope", regionCode: "04", districtCode: "03" },
    { name: "Kopeyia Wukope", regionCode: "04", districtCode: "03" },
    { name: "Korkuvi Adedzikope", regionCode: "04", districtCode: "03" },
    { name: "Kornuklopui", regionCode: "04", districtCode: "03" },
    { name: "Kpakakope", regionCode: "04", districtCode: "03" },
    { name: "Kpegbadza", regionCode: "04", districtCode: "03" },
    { name: "Kpekorwoe", regionCode: "04", districtCode: "03" },
    { name: "Kpelikope", regionCode: "04", districtCode: "03" },
    { name: "Kpodzi", regionCode: "04", districtCode: "03" },
    { name: "Kpogedi No. 1", regionCode: "04", districtCode: "03" },
    { name: "Kpogedi No. 2", regionCode: "04", districtCode: "03" },
    { name: "Kpoglu", regionCode: "04", districtCode: "03" },
    { name: "Kpoglu Barrier", regionCode: "04", districtCode: "03" },
    { name: "Kpohi Avoryikope", regionCode: "04", districtCode: "03" },
    { name: "Kpohi Kpeta", regionCode: "04", districtCode: "03" },
    { name: "Kpohi Yorkuvi", regionCode: "04", districtCode: "03" },
    { name: "Kpordoave No. 1", regionCode: "04", districtCode: "03" },
    { name: "Kpordoave No. 2", regionCode: "04", districtCode: "03" },
    { name: "Kubakope", regionCode: "04", districtCode: "03" },
    { name: "Kuve Bokorgakope", regionCode: "04", districtCode: "03" },
    { name: "Kuve Deve", regionCode: "04", districtCode: "03" },
    { name: "Laklevikope No. 1", regionCode: "04", districtCode: "03" },
    { name: "Laklevikope No. 2", regionCode: "04", districtCode: "03" },
    { name: "Lave", regionCode: "04", districtCode: "03" },
    { name: "Lavoekope", regionCode: "04", districtCode: "03" },
    { name: "Legbatime", regionCode: "04", districtCode: "03" },
    { name: "Lente Wute", regionCode: "04", districtCode: "03" },
    { name: "Lente Yame", regionCode: "04", districtCode: "03" },
    { name: "Logove", regionCode: "04", districtCode: "03" },
    { name: "Lormnava", regionCode: "04", districtCode: "03" },
    { name: "Lotakor", regionCode: "04", districtCode: "03" },
    { name: "Lotakor Horme", regionCode: "04", districtCode: "03" },
    { name: "Lowcost Beach", regionCode: "04", districtCode: "03" },
    { name: "Lowcost No. 1", regionCode: "04", districtCode: "03" },
    { name: "Lowcost No. 2", regionCode: "04", districtCode: "03" },
    { name: "Mark G Hotel", regionCode: "04", districtCode: "03" },
    { name: "Metsrikasa", regionCode: "04", districtCode: "03" },
    { name: "Nogokpo", regionCode: "04", districtCode: "03" },
    { name: "Nogokpo Gbevekope No. 1", regionCode: "04", districtCode: "03" },
    { name: "Nogokpo Gbevekope No. 2", regionCode: "04", districtCode: "03" },
    { name: "Nogokpo Tokorte", regionCode: "04", districtCode: "03" },
    { name: "Nurses Flat Tokor", regionCode: "04", districtCode: "03" },
    { name: "Nyekornakpoe Ayitikope", regionCode: "04", districtCode: "03" },
    { name: "Nyravase", regionCode: "04", districtCode: "03" },
    { name: "Omega Complex Hotel", regionCode: "04", districtCode: "03" },
    { name: "P/T (Vodafone)", regionCode: "04", districtCode: "03" },
    { name: "Penyi Anglican Basic School", regionCode: "04", districtCode: "03" },
    { name: "Penyi Hata", regionCode: "04", districtCode: "03" },
    { name: "Penyi Yorkoe", regionCode: "04", districtCode: "03" },
    { name: "Penyi Yorkpe", regionCode: "04", districtCode: "03" },
    { name: "Penyi Yorkpe New", regionCode: "04", districtCode: "03" },
    { name: "Pwd", regionCode: "04", districtCode: "03" },
    { name: "Rainbow", regionCode: "04", districtCode: "03" },
    { name: "Rainbow No. 2", regionCode: "04", districtCode: "03" },
    { name: "Rc Mission", regionCode: "04", districtCode: "03" },
    { name: "Sakani", regionCode: "04", districtCode: "03" },
    { name: "Sanyi", regionCode: "04", districtCode: "03" },
    { name: "Satsimadza", regionCode: "04", districtCode: "03" },
    { name: "Segbe Junction No. 1", regionCode: "04", districtCode: "03" },
    { name: "Segbe Junction No. 2", regionCode: "04", districtCode: "03" },
    { name: "Seklekope", regionCode: "04", districtCode: "03" },
    { name: "Semawukope", regionCode: "04", districtCode: "03" },
    { name: "Seva", regionCode: "04", districtCode: "03" },
    { name: "Shitorkope", regionCode: "04", districtCode: "03" },
    { name: "Sikakope No.1", regionCode: "04", districtCode: "03" },
    { name: "Sikakope No.2", regionCode: "04", districtCode: "03" },
    { name: "Sonuto No. 1", regionCode: "04", districtCode: "03" },
    { name: "Sonuto No. 2", regionCode: "04", districtCode: "03" },
    { name: "Sorkporkope", regionCode: "04", districtCode: "03" },
    { name: "Srohume", regionCode: "04", districtCode: "03" },
    { name: "Ssnit Denu", regionCode: "04", districtCode: "03" },
    { name: "St Pauls Shs", regionCode: "04", districtCode: "03" },
    { name: "Sterling Salt Factory", regionCode: "04", districtCode: "03" },
    { name: "Sterling Salt Industries", regionCode: "04", districtCode: "03" },
    { name: "Sugladzi 1", regionCode: "04", districtCode: "03" },
    { name: "Sugladzi 2", regionCode: "04", districtCode: "03" },
    { name: "Sugladzi Shs", regionCode: "04", districtCode: "03" },
    { name: "Tamekope", regionCode: "04", districtCode: "03" },
    { name: "Task Corner No. 1", regionCode: "04", districtCode: "03" },
    { name: "Task Corner No. 2", regionCode: "04", districtCode: "03" },
    { name: "Task Corner No. 3", regionCode: "04", districtCode: "03" },
    { name: "Tekpekope", regionCode: "04", districtCode: "03" },
    { name: "Tengekope Mornu", regionCode: "04", districtCode: "03" },
    { name: "Tengekope No. 1", regionCode: "04", districtCode: "03" },
    { name: "Tengekope No. 2", regionCode: "04", districtCode: "03" },
    { name: "Timber Market", regionCode: "04", districtCode: "03" },
    { name: "Tokor Street Lights", regionCode: "04", districtCode: "03" },
    { name: "Torgbe", regionCode: "04", districtCode: "03" },
    { name: "Tornorgbekope", regionCode: "04", districtCode: "03" },
    { name: "Tornu", regionCode: "04", districtCode: "03" },
    { name: "Toyo Junction", regionCode: "04", districtCode: "03" },
    { name: "Trovito", regionCode: "04", districtCode: "03" },
    { name: "Tsanpui", regionCode: "04", districtCode: "03" },
    { name: "Tsata Bame", regionCode: "04", districtCode: "03" },
    { name: "Tsiaveme", regionCode: "04", districtCode: "03" },
    { name: "Tsiaveme Dagbalekope", regionCode: "04", districtCode: "03" },
    { name: "Tsivorli", regionCode: "04", districtCode: "03" },
    { name: "Tukpuikope", regionCode: "04", districtCode: "03" },
    { name: "Viepe", regionCode: "04", districtCode: "03" },
    { name: "Viepe Cemetry", regionCode: "04", districtCode: "03" },
    { name: "Viepe Glory Gas", regionCode: "04", districtCode: "03" },
    { name: "Vume Agordome", regionCode: "04", districtCode: "03" },
    { name: "Weta", regionCode: "04", districtCode: "03" },
    { name: "Weta Dzakpatakope", regionCode: "04", districtCode: "03" },
    { name: "Weta Hospital", regionCode: "04", districtCode: "03" },
    { name: "Weta Hospital View", regionCode: "04", districtCode: "03" },
    { name: "Weta Junction", regionCode: "04", districtCode: "03" },
    { name: "Weta New", regionCode: "04", districtCode: "03" },
    { name: "Weta Sea Defence Camp", regionCode: "04", districtCode: "03" },
    { name: "Workpato", regionCode: "04", districtCode: "03" },
    { name: "Wudoaba Mission", regionCode: "04", districtCode: "03" },
    { name: "Wudoaba No. 1", regionCode: "04", districtCode: "03" },
    { name: "Wudoaba No. 2", regionCode: "04", districtCode: "03" },
    { name: "Wute", regionCode: "04", districtCode: "03" },
    { name: "Wyco", regionCode: "04", districtCode: "03" },
    { name: "Xesumalikope", regionCode: "04", districtCode: "03" },
    { name: "Yalibato Netsime", regionCode: "04", districtCode: "03" },
    { name: "Yalibato No. 1", regionCode: "04", districtCode: "03" },
    { name: "Yalibato No. 2", regionCode: "04", districtCode: "03" },
    { name: "Yawuni", regionCode: "04", districtCode: "03" },
    { name: "Yegbekope", regionCode: "04", districtCode: "03" },
    { name: "Yevi", regionCode: "04", districtCode: "03" },
    { name: "Zigakope", regionCode: "04", districtCode: "03" },
    { name: "Ziome", regionCode: "04", districtCode: "03" },
    { name: "Zuime", regionCode: "04", districtCode: "03" },
    { name: "Zukpe", regionCode: "04", districtCode: "03" },
    { name: "Zukpe Junction", regionCode: "04", districtCode: "03" }
  ],
  "04-04": [
    { name: "Abordahe", regionCode: "04", districtCode: "04" },
    { name: "66 Artillery Officers Akoefe", regionCode: "04", districtCode: "04" },
    { name: "66 Artillery Workshop Akoefe", regionCode: "04", districtCode: "04" },
    { name: "Abenyenase 1 Kpetoe", regionCode: "04", districtCode: "04" },
    { name: "Abenyenase Kpetoe", regionCode: "04", districtCode: "04" },
    { name: "Abutia Agorve", regionCode: "04", districtCode: "04" },
    { name: "Abutia Kloe", regionCode: "04", districtCode: "04" },
    { name: "Abutia Kloe Kalakpa", regionCode: "04", districtCode: "04" },
    { name: "Abutia Tegblevi", regionCode: "04", districtCode: "04" },
    { name: "Abutia Teti", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Ablidokope", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Ablornu", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Abuadi 1", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Abuadi 2", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Abuadi Day Shs", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Abuadi Quarry", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Adekpe", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Agblefe", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Akatsihoe", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Alavanyo", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Alawukope", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Amedzivie", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Anfoe No.1", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Anfoe No.2", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Avanyaviwofe", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Avedzi", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Dawanu", regionCode: "04", districtCode: "04" },
    { name: "Adaklu District Assembly", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Dorkpo", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Dzakpo", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Gavorkope", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Gbleve", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Goefe", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Have No. 1", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Have No. 2", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Hehekpe", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Helekpe", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Helekpe- Kpetoe", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Kordiabe", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Kpatove No. 1", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Kpatove No. 2", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Kpeleho", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Kpetsu", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Kpodzi", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Kpogadzi", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Kpordoave New", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Okanyi", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Segbale", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Seva", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Shs, Waya", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Sikama", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Sofa", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Tevikpo", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Tokor", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Torda No.1", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Torda No.2", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Tsrefe", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Tsrefe Pumping St.", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Vodze", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Waya", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Waya No. 2", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Wayanu", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Wumenu", regionCode: "04", districtCode: "04" },
    { name: "Adaklu Xinekope", regionCode: "04", districtCode: "04" },
    { name: "Adedome", regionCode: "04", districtCode: "04" },
    { name: "Adokpakope", regionCode: "04", districtCode: "04" },
    { name: "Adzonkor", regionCode: "04", districtCode: "04" },
    { name: "Adzonkor Agbedorkope", regionCode: "04", districtCode: "04" },
    { name: "Adzorve Kpota", regionCode: "04", districtCode: "04" },
    { name: "Adzorvime", regionCode: "04", districtCode: "04" },
    { name: "Aflakope", regionCode: "04", districtCode: "04" },
    { name: "Agbagodo", regionCode: "04", districtCode: "04" },
    { name: "Agbalavi", regionCode: "04", districtCode: "04" },
    { name: "Agbasiape", regionCode: "04", districtCode: "04" },
    { name: "Agbokope", regionCode: "04", districtCode: "04" },
    { name: "Agordeke", regionCode: "04", districtCode: "04" },
    { name: "Agorhokpo", regionCode: "04", districtCode: "04" },
    { name: "Agorhome", regionCode: "04", districtCode: "04" },
    { name: "Agorkpo", regionCode: "04", districtCode: "04" },
    { name: "Agornu No. 1", regionCode: "04", districtCode: "04" },
    { name: "Agornu No. 2", regionCode: "04", districtCode: "04" },
    { name: "Agornu No. 3", regionCode: "04", districtCode: "04" },
    { name: "Agotime Afegame", regionCode: "04", districtCode: "04" },
    { name: "Agotime Agbesia", regionCode: "04", districtCode: "04" },
    { name: "Agotime Amedikpui", regionCode: "04", districtCode: "04" },
    { name: "Agotime Ars", regionCode: "04", districtCode: "04" },
    { name: "Agotime Beh", regionCode: "04", districtCode: "04" },
    { name: "Agotime Kpatakope", regionCode: "04", districtCode: "04" },
    { name: "Agotime Vakpo", regionCode: "04", districtCode: "04" },
    { name: "Agotime Vedome", regionCode: "04", districtCode: "04" },
    { name: "Agotime Wodome No. 1", regionCode: "04", districtCode: "04" },
    { name: "Agotime Wodome No. 2", regionCode: "04", districtCode: "04" },
    { name: "Agotime-Ziope Ass. Qtrs", regionCode: "04", districtCode: "04" },
    { name: "Ahiadormekope", regionCode: "04", districtCode: "04" },
    { name: "Ahlihata", regionCode: "04", districtCode: "04" },
    { name: "Ahoe Public Toilet", regionCode: "04", districtCode: "04" },
    { name: "Akisokope Pumping St.", regionCode: "04", districtCode: "04" },
    { name: "Akoefe Avenui", regionCode: "04", districtCode: "04" },
    { name: "Akoefe Avenui Ep Village", regionCode: "04", districtCode: "04" },
    { name: "Akoefe Gadza", regionCode: "04", districtCode: "04" },
    { name: "Akoefe Tokor", regionCode: "04", districtCode: "04" },
    { name: "Akpagodo", regionCode: "04", districtCode: "04" },
    { name: "Akpokope No. 1", regionCode: "04", districtCode: "04" },
    { name: "Akpokope No. 2", regionCode: "04", districtCode: "04" },
    { name: "Akpokope Quantum Filling Station", regionCode: "04", districtCode: "04" },
    { name: "Akrofu Agorve", regionCode: "04", districtCode: "04" },
    { name: "Akrofu Agorve 2", regionCode: "04", districtCode: "04" },
    { name: "Akrofu Xeviwofe", regionCode: "04", districtCode: "04" },
    { name: "Akrofu Xeviwofe 2", regionCode: "04", districtCode: "04" },
    { name: "Akrofu Xeviwofe Jhs", regionCode: "04", districtCode: "04" },
    { name: "Akuetteh", regionCode: "04", districtCode: "04" },
    { name: "Alayi Down No. 1", regionCode: "04", districtCode: "04" },
    { name: "Alayi Down No. 2", regionCode: "04", districtCode: "04" },
    { name: "Alayi Junction", regionCode: "04", districtCode: "04" },
    { name: "Alorkpui", regionCode: "04", districtCode: "04" },
    { name: "Ame Zion", regionCode: "04", districtCode: "04" },
    { name: "Ame Zion Junction", regionCode: "04", districtCode: "04" },
    { name: "Amezakope", regionCode: "04", districtCode: "04" },
    { name: "Amuzudeve", regionCode: "04", districtCode: "04" },
    { name: "Anagokodzi", regionCode: "04", districtCode: "04" },
    { name: "Anatikope", regionCode: "04", districtCode: "04" },
    { name: "Andokope", regionCode: "04", districtCode: "04" },
    { name: "Anlokodzi", regionCode: "04", districtCode: "04" },
    { name: "Anyame", regionCode: "04", districtCode: "04" },
    { name: "Area 52", regionCode: "04", districtCode: "04" },
    { name: "Area 52 No. 2", regionCode: "04", districtCode: "04" },
    { name: "Area 53", regionCode: "04", districtCode: "04" },
    { name: "Asafokope", regionCode: "04", districtCode: "04" },
    { name: "Atiave", regionCode: "04", districtCode: "04" },
    { name: "Atikpui", regionCode: "04", districtCode: "04" },
    { name: "Ativorkope", regionCode: "04", districtCode: "04" },
    { name: "Atiyinu No. 1", regionCode: "04", districtCode: "04" },
    { name: "Atsrulume", regionCode: "04", districtCode: "04" },
    { name: "Avee Gbogame", regionCode: "04", districtCode: "04" },
    { name: "Avee Tokor", regionCode: "04", districtCode: "04" },
    { name: "Avele", regionCode: "04", districtCode: "04" },
    { name: "Avelebe", regionCode: "04", districtCode: "04" },
    { name: "Avevo Wuga", regionCode: "04", districtCode: "04" },
    { name: "Azametikope", regionCode: "04", districtCode: "04" },
    { name: "Barracks Administration", regionCode: "04", districtCode: "04" },
    { name: "Barracks Determination", regionCode: "04", districtCode: "04" },
    { name: "Barracks Newtown", regionCode: "04", districtCode: "04" },
    { name: "Barracks Newtown Down", regionCode: "04", districtCode: "04" },
    { name: "Barracks Newtown Top", regionCode: "04", districtCode: "04" },
    { name: "Barracks Officers Qtrs", regionCode: "04", districtCode: "04" },
    { name: "Barracks Opposite", regionCode: "04", districtCode: "04" },
    { name: "Barracks Pentecost", regionCode: "04", districtCode: "04" },
    { name: "Batume Junction", regionCode: "04", districtCode: "04" },
    { name: "Bedzame", regionCode: "04", districtCode: "04" },
    { name: "Ben-Total Junction", regionCode: "04", districtCode: "04" },
    { name: "Big Market", regionCode: "04", districtCode: "04" },
    { name: "Big Market 2", regionCode: "04", districtCode: "04" },
    { name: "Bishop House", regionCode: "04", districtCode: "04" },
    { name: "Cagd", regionCode: "04", districtCode: "04" },
    { name: "Cemetery Down", regionCode: "04", districtCode: "04" },
    { name: "Ceps Academy No. 1", regionCode: "04", districtCode: "04" },
    { name: "Ceps Academy No. 2", regionCode: "04", districtCode: "04" },
    { name: "Chances Hotel 1", regionCode: "04", districtCode: "04" },
    { name: "Chances Hotel 2", regionCode: "04", districtCode: "04" },
    { name: "Dadikpodo", regionCode: "04", districtCode: "04" },
    { name: "Dakui", regionCode: "04", districtCode: "04" },
    { name: "Data Link", regionCode: "04", districtCode: "04" },
    { name: "Datsiedu", regionCode: "04", districtCode: "04" },
    { name: "Dave Junction", regionCode: "04", districtCode: "04" },
    { name: "Dave No. 1", regionCode: "04", districtCode: "04" },
    { name: "Dave No. 2", regionCode: "04", districtCode: "04" },
    { name: "Dodome Awuiasu", regionCode: "04", districtCode: "04" },
    { name: "Dodome Dogblome", regionCode: "04", districtCode: "04" },
    { name: "Dorglobo", regionCode: "04", districtCode: "04" },
    { name: "Dorkope", regionCode: "04", districtCode: "04" },
    { name: "D-Quarters", regionCode: "04", districtCode: "04" },
    { name: "Dvla Office", regionCode: "04", districtCode: "04" },
    { name: "Dzadogbi", regionCode: "04", districtCode: "04" },
    { name: "Dzikeli Farms, Sokode Etoe", regionCode: "04", districtCode: "04" },
    { name: "Dzremave", regionCode: "04", districtCode: "04" },
    { name: "Ecg Office", regionCode: "04", districtCode: "04" },
    { name: "Ecg Plot", regionCode: "04", districtCode: "04" },
    { name: "Executive Gardens", regionCode: "04", districtCode: "04" },
    { name: "Fiakope", regionCode: "04", districtCode: "04" },
    { name: "Fiave Gec", regionCode: "04", districtCode: "04" },
    { name: "Fiave Newtown", regionCode: "04", districtCode: "04" },
    { name: "Food Distribution", regionCode: "04", districtCode: "04" },
    { name: "Forestry", regionCode: "04", districtCode: "04" },
    { name: "Forkpakope", regionCode: "04", districtCode: "04" },
    { name: "Gateway Guest Hse", regionCode: "04", districtCode: "04" },
    { name: "Gbc Volta Star", regionCode: "04", districtCode: "04" },
    { name: "Gbogame Afe Lotto Farms", regionCode: "04", districtCode: "04" },
    { name: "Getfund Hostel", regionCode: "04", districtCode: "04" },
    { name: "Ghana Registered N. Office", regionCode: "04", districtCode: "04" },
    { name: "Glade, Medical Village", regionCode: "04", districtCode: "04" },
    { name: "Global University", regionCode: "04", districtCode: "04" },
    { name: "Gntc", regionCode: "04", districtCode: "04" },
    { name: "Godokpe 1", regionCode: "04", districtCode: "04" },
    { name: "Godokpe 2", regionCode: "04", districtCode: "04" },
    { name: "Goshen City", regionCode: "04", districtCode: "04" },
    { name: "Gra Kpetoe Patrol Base", regionCode: "04", districtCode: "04" },
    { name: "Green Valley", regionCode: "04", districtCode: "04" },
    { name: "Green Valley 1", regionCode: "04", districtCode: "04" },
    { name: "Green Valley 2", regionCode: "04", districtCode: "04" },
    { name: "Hatekakope", regionCode: "04", districtCode: "04" },
    { name: "Henry Int. School", regionCode: "04", districtCode: "04" },
    { name: "Ho 17", regionCode: "04", districtCode: "04" },
    { name: "Ho Airfield Basic Sch.", regionCode: "04", districtCode: "04" },
    { name: "Ho Airport", regionCode: "04", districtCode: "04" },
    { name: "Ho Airport Area", regionCode: "04", districtCode: "04" },
    { name: "Ho Barracks", regionCode: "04", districtCode: "04" },
    { name: "Ho Bible College", regionCode: "04", districtCode: "04" },
    { name: "Ho Dome", regionCode: "04", districtCode: "04" },
    { name: "Ho Kpodzi", regionCode: "04", districtCode: "04" },
    { name: "Ho Kpodzi Ep Basic School", regionCode: "04", districtCode: "04" },
    { name: "Ho Polyclinic", regionCode: "04", districtCode: "04" },
    { name: "Ho Public Cemetry", regionCode: "04", districtCode: "04" },
    { name: "Ho Technical University", regionCode: "04", districtCode: "04" },
    { name: "Hodzo Achianse", regionCode: "04", districtCode: "04" },
    { name: "Hodzo Alavanyo", regionCode: "04", districtCode: "04" },
    { name: "Hodzo Anyiboboe", regionCode: "04", districtCode: "04" },
    { name: "Hodzo Aviefe", regionCode: "04", districtCode: "04" },
    { name: "Hodzo Cassava Farm", regionCode: "04", districtCode: "04" },
    { name: "Hodzo Ve", regionCode: "04", districtCode: "04" },
    { name: "Hodzoga", regionCode: "04", districtCode: "04" },
    { name: "Hoe", regionCode: "04", districtCode: "04" },
    { name: "Holy Spirit Cathedral", regionCode: "04", districtCode: "04" },
    { name: "Honugo No. 1", regionCode: "04", districtCode: "04" },
    { name: "Honugo No. 2", regionCode: "04", districtCode: "04" },
    { name: "Hopedo Comm 2", regionCode: "04", districtCode: "04" },
    { name: "Hoviefe", regionCode: "04", districtCode: "04" },
    { name: "Hoviefe Ep School", regionCode: "04", districtCode: "04" },
    { name: "Htu Bungalow", regionCode: "04", districtCode: "04" },
    { name: "Ipalco", regionCode: "04", districtCode: "04" },
    { name: "Ittu / Rttc", regionCode: "04", districtCode: "04" },
    { name: "J Star Plastic Waste Factory", regionCode: "04", districtCode: "04" },
    { name: "Jehovah's Witness, Waya", regionCode: "04", districtCode: "04" },
    { name: "Kabore Down", regionCode: "04", districtCode: "04" },
    { name: "Kabore School Complex", regionCode: "04", districtCode: "04" },
    { name: "Kakadedzi", regionCode: "04", districtCode: "04" },
    { name: "Keklebesi", regionCode: "04", districtCode: "04" },
    { name: "Kesenyemito (Unity Town)", regionCode: "04", districtCode: "04" },
    { name: "Keyime", regionCode: "04", districtCode: "04" },
    { name: "Kings Filling Station", regionCode: "04", districtCode: "04" },
    { name: "Klave Catholic Church", regionCode: "04", districtCode: "04" },
    { name: "Klave Pumping Station", regionCode: "04", districtCode: "04" },
    { name: "Klefe Atsatime", regionCode: "04", districtCode: "04" },
    { name: "Klefe Atsatime Newtown", regionCode: "04", districtCode: "04" },
    { name: "Klefe Demete", regionCode: "04", districtCode: "04" },
    { name: "Klefe Dome 1", regionCode: "04", districtCode: "04" },
    { name: "Klefe Dome 2", regionCode: "04", districtCode: "04" },
    { name: "Kodzobi", regionCode: "04", districtCode: "04" },
    { name: "Kodzobi Ando No. 1", regionCode: "04", districtCode: "04" },
    { name: "Kodzobi Ando No. 2", regionCode: "04", districtCode: "04" },
    { name: "Kodzobi New Site", regionCode: "04", districtCode: "04" },
    { name: "Kodzobi Uhas Junction", regionCode: "04", districtCode: "04" },
    { name: "Kortsrala", regionCode: "04", districtCode: "04" },
    { name: "Kpedzi", regionCode: "04", districtCode: "04" },
    { name: "Kpehadzi", regionCode: "04", districtCode: "04" },
    { name: "Kpeleme", regionCode: "04", districtCode: "04" },
    { name: "Kpelikope", regionCode: "04", districtCode: "04" },
    { name: "Kpenoe Barrier", regionCode: "04", districtCode: "04" },
    { name: "Kpenoe Batique", regionCode: "04", districtCode: "04" },
    { name: "Kpenoe C200", regionCode: "04", districtCode: "04" },
    { name: "Kpenoe Jhs", regionCode: "04", districtCode: "04" },
    { name: "Kpenoe Township", regionCode: "04", districtCode: "04" },
    { name: "Kpenukor", regionCode: "04", districtCode: "04" },
    { name: "Kpetoe", regionCode: "04", districtCode: "04" },
    { name: "Kpetoe Anloto", regionCode: "04", districtCode: "04" },
    { name: "Kpetoe Ceps Office", regionCode: "04", districtCode: "04" },
    { name: "Kpetoe Ep Church", regionCode: "04", districtCode: "04" },
    { name: "Kpetoe Kpekuita", regionCode: "04", districtCode: "04" },
    { name: "Kpetoe Kpogedi", regionCode: "04", districtCode: "04" },
    { name: "Kpetoe Market", regionCode: "04", districtCode: "04" },
    { name: "Kpetoe Mp House", regionCode: "04", districtCode: "04" },
    { name: "Kpexor", regionCode: "04", districtCode: "04" },
    { name: "Kporta", regionCode: "04", districtCode: "04" },
    { name: "Kporta Aforkpui", regionCode: "04", districtCode: "04" },
    { name: "Kyirebone", regionCode: "04", districtCode: "04" },
    { name: "Lepers Village", regionCode: "04", districtCode: "04" },
    { name: "Leproserium", regionCode: "04", districtCode: "04" },
    { name: "Logovi", regionCode: "04", districtCode: "04" },
    { name: "Lokoe Diamond Avenue", regionCode: "04", districtCode: "04" },
    { name: "Lokoe Ecg Site", regionCode: "04", districtCode: "04" },
    { name: "Lokoe Nima", regionCode: "04", districtCode: "04" },
    { name: "Lume Atsiame", regionCode: "04", districtCode: "04" },
    { name: "Lume Ge", regionCode: "04", districtCode: "04" },
    { name: "Lume Kpodoave", regionCode: "04", districtCode: "04" },
    { name: "Mangoase", regionCode: "04", districtCode: "04" },
    { name: "Mangotideke", regionCode: "04", districtCode: "04" },
    { name: "Mangotidekekope", regionCode: "04", districtCode: "04" },
    { name: "Matse Ando", regionCode: "04", districtCode: "04" },
    { name: "Matse Dzeve", regionCode: "04", districtCode: "04" },
    { name: "Matse Dzorkpe", regionCode: "04", districtCode: "04" },
    { name: "Matse Have", regionCode: "04", districtCode: "04" },
    { name: "Matse Lowcost", regionCode: "04", districtCode: "04" },
    { name: "Matse Tsife", regionCode: "04", districtCode: "04" },
    { name: "Mawuli Estate", regionCode: "04", districtCode: "04" },
    { name: "Mawuli School", regionCode: "04", districtCode: "04" },
    { name: "Mc Collins Junction", regionCode: "04", districtCode: "04" },
    { name: "Mc Collins Junction 2", regionCode: "04", districtCode: "04" },
    { name: "Mc Collins New", regionCode: "04", districtCode: "04" },
    { name: "Medical Village", regionCode: "04", districtCode: "04" },
    { name: "Microwave 1", regionCode: "04", districtCode: "04" },
    { name: "Microwave 2", regionCode: "04", districtCode: "04" },
    { name: "Microwave Airtel Cell Site", regionCode: "04", districtCode: "04" },
    { name: "Ministries", regionCode: "04", districtCode: "04" },
    { name: "Mri Trafalgar", regionCode: "04", districtCode: "04" },
    { name: "Municipal Hospital", regionCode: "04", districtCode: "04" },
    { name: "Nca Yard", regionCode: "04", districtCode: "04" },
    { name: "New Agortorme", regionCode: "04", districtCode: "04" },
    { name: "New Housing", regionCode: "04", districtCode: "04" },
    { name: "New York City", regionCode: "04", districtCode: "04" },
    { name: "Nkuabiakope", regionCode: "04", districtCode: "04" },
    { name: "Noanyikpo Tsati", regionCode: "04", districtCode: "04" },
    { name: "Nurses Training College", regionCode: "04", districtCode: "04" },
    { name: "Nyive", regionCode: "04", districtCode: "04" },
    { name: "Obemla", regionCode: "04", districtCode: "04" },
    { name: "Ola Shs", regionCode: "04", districtCode: "04" },
    { name: "Pavilion", regionCode: "04", districtCode: "04" },
    { name: "Pleasure Gardens", regionCode: "04", districtCode: "04" },
    { name: "Police Barrier", regionCode: "04", districtCode: "04" },
    { name: "Police Depot Jhs", regionCode: "04", districtCode: "04" },
    { name: "Police Depot View", regionCode: "04", districtCode: "04" },
    { name: "Power House", regionCode: "04", districtCode: "04" },
    { name: "Power House Newtown", regionCode: "04", districtCode: "04" },
    { name: "Power House Newtown 2", regionCode: "04", districtCode: "04" },
    { name: "Princefield University", regionCode: "04", districtCode: "04" },
    { name: "Reg. Police Hq", regionCode: "04", districtCode: "04" },
    { name: "Residency", regionCode: "04", districtCode: "04" },
    { name: "Rtc", regionCode: "04", districtCode: "04" },
    { name: "Rtc Park", regionCode: "04", districtCode: "04" },
    { name: "Salem House", regionCode: "04", districtCode: "04" },
    { name: "Sarakope", regionCode: "04", districtCode: "04" },
    { name: "School Of Hygiene", regionCode: "04", districtCode: "04" },
    { name: "Scrap Akpenamawu", regionCode: "04", districtCode: "04" },
    { name: "Sda Down", regionCode: "04", districtCode: "04" },
    { name: "Shavime", regionCode: "04", districtCode: "04" },
    { name: "Shia Community Library", regionCode: "04", districtCode: "04" },
    { name: "Shia Health Centre", regionCode: "04", districtCode: "04" },
    { name: "Sikama Pumping Station", regionCode: "04", districtCode: "04" },
    { name: "Sileandre", regionCode: "04", districtCode: "04" },
    { name: "Sky Plus Hotel", regionCode: "04", districtCode: "04" },
    { name: "Sodzikope", regionCode: "04", districtCode: "04" },
    { name: "Sokode Ando 1", regionCode: "04", districtCode: "04" },
    { name: "Sokode Ando 2", regionCode: "04", districtCode: "04" },
    { name: "Sokode Bagble 2", regionCode: "04", districtCode: "04" },
    { name: "Sokode Bagble Gosple Revivals", regionCode: "04", districtCode: "04" },
    { name: "Sokode Cemetery Junction", regionCode: "04", districtCode: "04" },
    { name: "Sokode Etoe", regionCode: "04", districtCode: "04" },
    { name: "Sokode Etoe 2", regionCode: "04", districtCode: "04" },
    { name: "Sokode Etoe New Site", regionCode: "04", districtCode: "04" },
    { name: "Sokode Gbogame", regionCode: "04", districtCode: "04" },
    { name: "Sokode Gbogame 2", regionCode: "04", districtCode: "04" },
    { name: "Sokode Gbogame 3", regionCode: "04", districtCode: "04" },
    { name: "Sokode Lokoe", regionCode: "04", districtCode: "04" },
    { name: "Sokode Lowcost", regionCode: "04", districtCode: "04" },
    { name: "Sokode Machine Shop", regionCode: "04", districtCode: "04" },
    { name: "Sokode Mater Ecclesiae", regionCode: "04", districtCode: "04" },
    { name: "Sokode Sec. Tech", regionCode: "04", districtCode: "04" },
    { name: "Somey Down", regionCode: "04", districtCode: "04" },
    { name: "Special Branch, Ho", regionCode: "04", districtCode: "04" },
    { name: "Ssnit Flats 1", regionCode: "04", districtCode: "04" },
    { name: "Ssnit Flats 2", regionCode: "04", districtCode: "04" },
    { name: "Ssnit Office", regionCode: "04", districtCode: "04" },
    { name: "St Marks Anglican B. Sch.", regionCode: "04", districtCode: "04" },
    { name: "Sunrise Shs", regionCode: "04", districtCode: "04" },
    { name: "Takla Gbogame 1", regionCode: "04", districtCode: "04" },
    { name: "Takla Gbogame 2", regionCode: "04", districtCode: "04" },
    { name: "Takla Nyekornakpoe", regionCode: "04", districtCode: "04" },
    { name: "Takla Tokor", regionCode: "04", districtCode: "04" },
    { name: "Takla Tokor New", regionCode: "04", districtCode: "04" },
    { name: "Takuve", regionCode: "04", districtCode: "04" },
    { name: "Takuvega", regionCode: "04", districtCode: "04" },
    { name: "Tanyigbe Anyigbe", regionCode: "04", districtCode: "04" },
    { name: "Tanyigbe Anyigbe Clinic", regionCode: "04", districtCode: "04" },
    { name: "Tanyigbe Atidze", regionCode: "04", districtCode: "04" },
    { name: "Tanyigbe Dzafe", regionCode: "04", districtCode: "04" },
    { name: "Tanyigbe Etoe New", regionCode: "04", districtCode: "04" },
    { name: "Taviefe Avenya 1", regionCode: "04", districtCode: "04" },
    { name: "Taviefe Aviefe", regionCode: "04", districtCode: "04" },
    { name: "Taviefe Dzefe", regionCode: "04", districtCode: "04" },
    { name: "Taviefe Dzefe Toilet", regionCode: "04", districtCode: "04" },
    { name: "Taviefe Pumping Station", regionCode: "04", districtCode: "04" },
    { name: "Taviefe Sreme Down", regionCode: "04", districtCode: "04" },
    { name: "Taviefe Sreme Junction", regionCode: "04", districtCode: "04" },
    { name: "Taviefe Sreme Top", regionCode: "04", districtCode: "04" },
    { name: "Ter Quarry Ltd 1, Abutia", regionCode: "04", districtCode: "04" },
    { name: "Ter Quarry Ltd 2, Abutia", regionCode: "04", districtCode: "04" },
    { name: "Titrinu No. 1", regionCode: "04", districtCode: "04" },
    { name: "Titrinu No. 2", regionCode: "04", districtCode: "04" },
    { name: "Titrinu St. Lights", regionCode: "04", districtCode: "04" },
    { name: "Tokokoe Abudi", regionCode: "04", districtCode: "04" },
    { name: "Tokokoe Mottey", regionCode: "04", districtCode: "04" },
    { name: "Total Filling Station Bagble", regionCode: "04", districtCode: "04" },
    { name: "Trafalgar 1", regionCode: "04", districtCode: "04" },
    { name: "Trafalgar 2", regionCode: "04", districtCode: "04" },
    { name: "Trafalgar Gate", regionCode: "04", districtCode: "04" },
    { name: "Trafalgar View", regionCode: "04", districtCode: "04" },
    { name: "Tsavanye", regionCode: "04", districtCode: "04" },
    { name: "Tsidenkor", regionCode: "04", districtCode: "04" },
    { name: "Tsiyikpota", regionCode: "04", districtCode: "04" },
    { name: "Tsiyikpota Last Stop", regionCode: "04", districtCode: "04" },
    { name: "Tsovey City", regionCode: "04", districtCode: "04" },
    { name: "Tumor", regionCode: "04", districtCode: "04" },
    { name: "Uhas Administration", regionCode: "04", districtCode: "04" },
    { name: "Uhas Basic School", regionCode: "04", districtCode: "04" },
    { name: "Uhas Bungalow", regionCode: "04", districtCode: "04" },
    { name: "Uhas Campus", regionCode: "04", districtCode: "04" },
    { name: "Uhas Hostel", regionCode: "04", districtCode: "04" },
    { name: "Uhas Phase Ii No.1", regionCode: "04", districtCode: "04" },
    { name: "Uhas Phase Ii No.2", regionCode: "04", districtCode: "04" },
    { name: "Uhas Tigo Mast", regionCode: "04", districtCode: "04" },
    { name: "Uhas Trafalgar", regionCode: "04", districtCode: "04" },
    { name: "Vag Hall", regionCode: "04", districtCode: "04" },
    { name: "Vag Hall No. 2", regionCode: "04", districtCode: "04" },
    { name: "Vedome", regionCode: "04", districtCode: "04" },
    { name: "Veterinary Office Opposite", regionCode: "04", districtCode: "04" },
    { name: "Vodafone Yard", regionCode: "04", districtCode: "04" },
    { name: "Vodzakpo", regionCode: "04", districtCode: "04" },
    { name: "Volta Serene Hotel", regionCode: "04", districtCode: "04" },
    { name: "Volta Trigger Project", regionCode: "04", districtCode: "04" },
    { name: "Voradep Village", regionCode: "04", districtCode: "04" },
    { name: "Voradep Workshop", regionCode: "04", districtCode: "04" },
    { name: "Water Works", regionCode: "04", districtCode: "04" },
    { name: "Wekor", regionCode: "04", districtCode: "04" },
    { name: "Wortikpo", regionCode: "04", districtCode: "04" },
    { name: "Wortoe", regionCode: "04", districtCode: "04" },
    { name: "Wudesi", regionCode: "04", districtCode: "04" },
    { name: "Wudzedeke", regionCode: "04", districtCode: "04" },
    { name: "Wumenu Mtn Cell Site", regionCode: "04", districtCode: "04" },
    { name: "Wuvevia", regionCode: "04", districtCode: "04" },
    { name: "Wuvi", regionCode: "04", districtCode: "04" },
    { name: "Xakope", regionCode: "04", districtCode: "04" },
    { name: "Yesukope Kpetoe", regionCode: "04", districtCode: "04" },
    { name: "Yevukope", regionCode: "04", districtCode: "04" },
    { name: "Youth Resource Centre", regionCode: "04", districtCode: "04" },
    { name: "Ziavi Adukofe 1", regionCode: "04", districtCode: "04" },
    { name: "Ziavi Adukofe 2", regionCode: "04", districtCode: "04" },
    { name: "Ziavi Bamefedo", regionCode: "04", districtCode: "04" },
    { name: "Ziavi Dzogbe 1", regionCode: "04", districtCode: "04" },
    { name: "Ziavi Dzogbe 2", regionCode: "04", districtCode: "04" },
    { name: "Ziavi Dzogbe Basic School", regionCode: "04", districtCode: "04" },
    { name: "Ziavi Dzogbe No. 3", regionCode: "04", districtCode: "04" },
    { name: "Ziavi Gbegbe", regionCode: "04", districtCode: "04" },
    { name: "Ziavi Lume", regionCode: "04", districtCode: "04" },
    { name: "Ziavi Rice Factory", regionCode: "04", districtCode: "04" },
    { name: "Ziavi Woenanyo", regionCode: "04", districtCode: "04" },
    { name: "Ziope Barrier", regionCode: "04", districtCode: "04" },
    { name: "Ziope Logokor", regionCode: "04", districtCode: "04" },
    { name: "Ziope Nyekornakpoe", regionCode: "04", districtCode: "04" },
    { name: "Ziope Shs", regionCode: "04", districtCode: "04" }
  ],
  "04-05": [
    { "name": "Abanse Gas Filling Station", "regionCode": "04", "districtCode": "05" },
    { "name": "Adigbokope", "regionCode": "04", "districtCode": "05" },
    { "name": "Adult Education Campus", "regionCode": "04", "districtCode": "05" },
    { "name": "Adult Education Junc.", "regionCode": "04", "districtCode": "05" },
    { "name": "Aflakpe", "regionCode": "04", "districtCode": "05" },
    { "name": "Agate Amenuveve Junction", "regionCode": "04", "districtCode": "05" },
    { "name": "Agate Shs Junction", "regionCode": "04", "districtCode": "05" },
    { "name": "Agate Township", "regionCode": "04", "districtCode": "05" },
    { "name": "Agate Truth Chapel", "regionCode": "04", "districtCode": "05" },
    { "name": "Agordeke", "regionCode": "04", "districtCode": "05" },
    { "name": "Agorkpo Cocoaboard", "regionCode": "04", "districtCode": "05" },
    { "name": "Akome Agate", "regionCode": "04", "districtCode": "05" },
    { "name": "Akome Gbogame", "regionCode": "04", "districtCode": "05" },
    { "name": "Akome Gbota", "regionCode": "04", "districtCode": "05" },
    { "name": "Akoviefe", "regionCode": "04", "districtCode": "05" },
    { "name": "Alinko Filling Station", "regionCode": "04", "districtCode": "05" },
    { "name": "Ameco", "regionCode": "04", "districtCode": "05" },
    { "name": "Amedzofe Cell Site", "regionCode": "04", "districtCode": "05" },
    { "name": "Amedzofe Health Centre", "regionCode": "04", "districtCode": "05" },
    { "name": "Amedzofe Tourist Centre", "regionCode": "04", "districtCode": "05" },
    { "name": "Amedzofe Transmitter", "regionCode": "04", "districtCode": "05" },
    { "name": "Anfoeta Gbogame", "regionCode": "04", "districtCode": "05" },
    { "name": "Anfoeta Tsebi", "regionCode": "04", "districtCode": "05" },
    { "name": "Anfoeta Wordemaxe", "regionCode": "04", "districtCode": "05" },
    { "name": "Anfoeta Zongo", "regionCode": "04", "districtCode": "05" },
    { "name": "Anyirawase", "regionCode": "04", "districtCode": "05" },
    { "name": "Anyirawase Pent. Church", "regionCode": "04", "districtCode": "05" },
    { "name": "Avatime Gbadzeme", "regionCode": "04", "districtCode": "05" },
    { "name": "Avatime Gbadzeme New", "regionCode": "04", "districtCode": "05" },
    { "name": "Awudome Avenui", "regionCode": "04", "districtCode": "05" },
    { "name": "Awudome Avenui Camp", "regionCode": "04", "districtCode": "05" },
    { "name": "Awudome Kwanta", "regionCode": "04", "districtCode": "05" },
    { "name": "Awudome Shs", "regionCode": "04", "districtCode": "05" },
    { "name": "Badzikope", "regionCode": "04", "districtCode": "05" },
    { "name": "Bakpe No. 1", "regionCode": "04", "districtCode": "05" },
    { "name": "Bakpe No. 2", "regionCode": "04", "districtCode": "05" },
    { "name": "Bame", "regionCode": "04", "districtCode": "05" },
    { "name": "Bame Quarters", "regionCode": "04", "districtCode": "05" },
    { "name": "Bame T. Junction", "regionCode": "04", "districtCode": "05" },
    { "name": "Besmod Hotel Peki", "regionCode": "04", "districtCode": "05" },
    { "name": "Biakpa Basic School", "regionCode": "04", "districtCode": "05" },
    { "name": "Biakpa Township", "regionCode": "04", "districtCode": "05" },
    { "name": "Bokorvikope", "regionCode": "04", "districtCode": "05" },
    { "name": "Bomats Mango Farms", "regionCode": "04", "districtCode": "05" },
    { "name": "Dededo No. 1", "regionCode": "04", "districtCode": "05" },
    { "name": "Dededo No. 2", "regionCode": "04", "districtCode": "05" },
    { "name": "Dodome Aveha", "regionCode": "04", "districtCode": "05" },
    { "name": "Dodome Tedeafenu", "regionCode": "04", "districtCode": "05" },
    { "name": "Dodome Tsikor", "regionCode": "04", "districtCode": "05" },
    { "name": "Dodzi Academy", "regionCode": "04", "districtCode": "05" },
    { "name": "Dominion Paint Factory", "regionCode": "04", "districtCode": "05" },
    { "name": "Dzake Ep Kpodzi", "regionCode": "04", "districtCode": "05" },
    { "name": "Dzakiti", "regionCode": "04", "districtCode": "05" },
    { "name": "Dzakiti Junc. Dzemeni", "regionCode": "04", "districtCode": "05" },
    { "name": "Dzemeni Clinic", "regionCode": "04", "districtCode": "05" },
    { "name": "Dzogbefeme", "regionCode": "04", "districtCode": "05" },
    { "name": "Dzolo Gbogame Ep Church", "regionCode": "04", "districtCode": "05" },
    { "name": "Dzolo Gbogame New", "regionCode": "04", "districtCode": "05" },
    { "name": "Dzolo Gbogame Rc School", "regionCode": "04", "districtCode": "05" },
    { "name": "Dzolokpuita", "regionCode": "04", "districtCode": "05" },
    { "name": "Dzolokpuita Mortuary", "regionCode": "04", "districtCode": "05" },
    { "name": "Dzolokpuita Mtn Cell Site", "regionCode": "04", "districtCode": "05" },
    { "name": "Ep Church, Dzemeni", "regionCode": "04", "districtCode": "05" },
    { "name": "Etordome", "regionCode": "04", "districtCode": "05" },
    { "name": "Fantikope", "regionCode": "04", "districtCode": "05" },
    { "name": "Gblorkporkope", "regionCode": "04", "districtCode": "05" },
    { "name": "Global Church, Dzemeni", "regionCode": "04", "districtCode": "05" },
    { "name": "Govco, Peki", "regionCode": "04", "districtCode": "05" },
    { "name": "Goviefe Agordome", "regionCode": "04", "districtCode": "05" },
    { "name": "Goviefe Agordome 2", "regionCode": "04", "districtCode": "05" },
    { "name": "Goviefe Dudome", "regionCode": "04", "districtCode": "05" },
    { "name": "Goviefe Kowu", "regionCode": "04", "districtCode": "05" },
    { "name": "Goviefe Kowu 2", "regionCode": "04", "districtCode": "05" },
    { "name": "Goviefe Todzi", "regionCode": "04", "districtCode": "05" },
    { "name": "Goviefe Todzi Park", "regionCode": "04", "districtCode": "05" },
    { "name": "Have Adzekope", "regionCode": "04", "districtCode": "05" },
    { "name": "Have Agorme", "regionCode": "04", "districtCode": "05" },
    { "name": "Have Aveyoryoe", "regionCode": "04", "districtCode": "05" },
    { "name": "Have Domefe", "regionCode": "04", "districtCode": "05" },
    { "name": "Have Police Barrier", "regionCode": "04", "districtCode": "05" },
    { "name": "Have Town", "regionCode": "04", "districtCode": "05" },
    { "name": "Have Zongo", "regionCode": "04", "districtCode": "05" },
    { "name": "Hlefi", "regionCode": "04", "districtCode": "05" },
    { "name": "Hlefi Ndc Zonal Office", "regionCode": "04", "districtCode": "05" },
    { "name": "Hlefi Rc Basic School", "regionCode": "04", "districtCode": "05" },
    { "name": "Ho West District Assembly", "regionCode": "04", "districtCode": "05" },
    { "name": "Holuta Border", "regionCode": "04", "districtCode": "05" },
    { "name": "Holuta Gbogame", "regionCode": "04", "districtCode": "05" },
    { "name": "Holuta Luvudo", "regionCode": "04", "districtCode": "05" },
    { "name": "Holuta Torgome", "regionCode": "04", "districtCode": "05" },
    { "name": "Holy Rosary Rc Todome", "regionCode": "04", "districtCode": "05" },
    { "name": "Kayira Kpalime", "regionCode": "04", "districtCode": "05" },
    { "name": "Kingdom Fruits", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpale-Xorse", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpalime Duga", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpalime Duga No. 2", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpedze Anoe", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpedze Chief House", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpedze Lowcost", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpedze Shs", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpedze Sreme", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpedze Todze", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpeve Dzudome", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpeve Ecg Office", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpeve Global Church", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpeve Herbal Clinic", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpeve Junction", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpeve Newtown", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpeve Shs", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpeve Tornu", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpeve Water Plant 1", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpeve Water Plant 2", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpeve Water Plant 3", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpeyiborme", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpoeta Achem", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpoeta Ashanti", "regionCode": "04", "districtCode": "05" },
    { "name": "Kpoeta Kpodzi", "regionCode": "04", "districtCode": "05" },
    { "name": "New Kayira", "regionCode": "04", "districtCode": "05" },
    { "name": "Nunya Todzi, Dzolokpuita", "regionCode": "04", "districtCode": "05" },
    { "name": "Nyagbo Akorfafanami", "regionCode": "04", "districtCode": "05" },
    { "name": "Nyagbo Anyigbe", "regionCode": "04", "districtCode": "05" },
    { "name": "Nyagbo Fiape", "regionCode": "04", "districtCode": "05" },
    { "name": "Nyagbo Gagbefe", "regionCode": "04", "districtCode": "05" },
    { "name": "Nyagbo Konda", "regionCode": "04", "districtCode": "05" },
    { "name": "Nyagbo Kume", "regionCode": "04", "districtCode": "05" },
    { "name": "Nyagbo Odumase", "regionCode": "04", "districtCode": "05" },
    { "name": "Nyagbo Sroe", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Adzokoe No. 1", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Adzokoe No. 2", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Agbate", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Agbate Farms", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Avetile", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Avetile Police Station", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Blengo", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Dzake No. 1", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Dzake No. 2", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Dzogbati", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Hospital", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Shs", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Shs 2", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Tsame", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Tsame Assemblies Of God", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Tsame Ecg Office", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Tsiyinu", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Tsiyinu Junction", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Wliti", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Wudome", "regionCode": "04", "districtCode": "05" },
    { "name": "Peki Wudome Dodota Avenue", "regionCode": "04", "districtCode": "05" },
    { "name": "Rc School Park, Dzakiti", "regionCode": "04", "districtCode": "05" },
    { "name": "Rolider", "regionCode": "04", "districtCode": "05" },
    { "name": "Sanga", "regionCode": "04", "districtCode": "05" },
    { "name": "Saviefe Agorkpo", "regionCode": "04", "districtCode": "05" },
    { "name": "Saviefe Deme", "regionCode": "04", "districtCode": "05" },
    { "name": "Saviefe Gbedome", "regionCode": "04", "districtCode": "05" },
    { "name": "Saviefe Gbogame", "regionCode": "04", "districtCode": "05" },
    { "name": "Segbedome", "regionCode": "04", "districtCode": "05" },
    { "name": "South Dayi Dist. Assembly", "regionCode": "04", "districtCode": "05" },
    { "name": "Soyakodzi", "regionCode": "04", "districtCode": "05" },
    { "name": "Tafi Abuife", "regionCode": "04", "districtCode": "05" },
    { "name": "Tafi Agorme", "regionCode": "04", "districtCode": "05" },
    { "name": "Tafi Mador", "regionCode": "04", "districtCode": "05" },
    { "name": "Talax, Tsanakpe", "regionCode": "04", "districtCode": "05" },
    { "name": "Todome Kpalime", "regionCode": "04", "districtCode": "05" },
    { "name": "Toh Kpalime", "regionCode": "04", "districtCode": "05" },
    { "name": "Tongor Abui", "regionCode": "04", "districtCode": "05" },
    { "name": "Tongor Abui Tornu", "regionCode": "04", "districtCode": "05" },
    { "name": "Tongor Ahor", "regionCode": "04", "districtCode": "05" },
    { "name": "Tongor Attorkrokpo", "regionCode": "04", "districtCode": "05" },
    { "name": "Tongor Royal Hotel", "regionCode": "04", "districtCode": "05" },
    { "name": "Tongor Tsanakpe No. 1", "regionCode": "04", "districtCode": "05" },
    { "name": "Tongor Tsanakpe No. 2", "regionCode": "04", "districtCode": "05" },
    { "name": "Tongor Tsita", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsame Mawutor Guest House", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsatee", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsawenu", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsibu Awudome", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsibu Bethel", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsibu Gs Int. Limited", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsibu Health Centre", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsito Awudome", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsito Brave Palace", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsito Doveme", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsito Ep Jhs", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsito Prim. Station", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsito Shts No. 1", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsito Shts No. 2", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsokpokope", "regionCode": "04", "districtCode": "05" },
    { "name": "Tsyome Afedo", "regionCode": "04", "districtCode": "05" },
    { "name": "Vakpo Fu", "regionCode": "04", "districtCode": "05" },
    { "name": "Vakpo Konda", "regionCode": "04", "districtCode": "05" },
    { "name": "Vane Nazareth Clinic", "regionCode": "04", "districtCode": "05" },
    { "name": "Vane Sikakrom", "regionCode": "04", "districtCode": "05" },
    { "name": "Vane Y. Junction", "regionCode": "04", "districtCode": "05" },
    { "name": "Wegbe Kpalime", "regionCode": "04", "districtCode": "05" },
    { "name": "Wegbe Wawase", "regionCode": "04", "districtCode": "05" },
    { "name": "Wordze", "regionCode": "04", "districtCode": "05" },
    { "name": "Wordze Tornu Junction", "regionCode": "04", "districtCode": "05" },
    { "name": "Wordze Tsatoe Fish Farm", "regionCode": "04",  "districtCode": "05" },
    { "name": "Wordzetsatoe", "regionCode": "04", "districtCode": "05" }
  ],
  "04-06": [
    { "name": "Ababio Mango Farms", "regionCode": "04", "districtCode": "06" },
    { "name": "Abanu", "regionCode": "04", "districtCode": "06" },
    { "name": "Abanu Fitting Shop", "regionCode": "04", "districtCode": "06" },
    { "name": "Ablorga", "regionCode": "04", "districtCode": "06" },
    { "name": "Ablorga Farms", "regionCode": "04", "districtCode": "06" },
    { "name": "Agbite 1", "regionCode": "04", "districtCode": "06" },
    { "name": "Agbite 2", "regionCode": "04", "districtCode": "06" },
    { "name": "Ahinkro Police Station", "regionCode": "04", "districtCode": "06" },
    { "name": "Akukorme Ep Church", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Abehenease", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Abehenease 2", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Agorme", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Agorme St. Light", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Agorxoe", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Agorxoe St. Light", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Deme", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Deme St. Light", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Dzogbedze No.1", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Dzogbedze No.2", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Kpeme", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Wudidi No.1", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Wudidi No.2", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Wudidi No.3", "regionCode": "04", "districtCode": "06" },
    { "name": "Alavanyo Wudidi St. Light", "regionCode": "04", "districtCode": "06" },
    { "name": "Aloyi", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Agatanyigbe", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Akukorme", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Akukorme 2", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Ando", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Aveti", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Bume", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Denui", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Dzana", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Gblenkor 1", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Gblenkor 2", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Hospital", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Shs", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Wademaxe 1", "regionCode": "04", "districtCode": "06" },
    { "name": "Anfoega Wademaxe 2", "regionCode": "04", "districtCode": "06" },
    { "name": "Anglican", "regionCode": "04", "districtCode": "06" },
    { "name": "Anglican Village", "regionCode": "04", "districtCode": "06" },
    { "name": "Angola", "regionCode": "04", "districtCode": "06" },
    { "name": "Angola Tnt", "regionCode": "04", "districtCode": "06" },
    { "name": "Aqua Smile", "regionCode": "04", "districtCode": "06" },
    { "name": "Assemblies", "regionCode": "04", "districtCode": "06" },
    { "name": "Aveme Beme No.1", "regionCode": "04", "districtCode": "06" },
    { "name": "Aveme Beme No.2", "regionCode": "04", "districtCode": "06" },
    { "name": "Aveme Danyigba", "regionCode": "04", "districtCode": "06" },
    { "name": "Aveme Dra", "regionCode": "04", "districtCode": "06" },
    { "name": "Aveme Dzeme", "regionCode": "04", "districtCode": "06" },
    { "name": "Aveme Gborxome", "regionCode": "04", "districtCode": "06" },
    { "name": "Awate Agame", "regionCode": "04", "districtCode": "06" },
    { "name": "Awate Todzi", "regionCode": "04", "districtCode": "06" },
    { "name": "Awate Tornu", "regionCode": "04", "districtCode": "06" },
    { "name": "Azikope", "regionCode": "04", "districtCode": "06" },
    { "name": "Bishop Herman", "regionCode": "04", "districtCode": "06" },
    { "name": "Bishop Herman 2", "regionCode": "04", "districtCode": "06" },
    { "name": "Botoku Quarters", "regionCode": "04", "districtCode": "06" },
    { "name": "Botoku Township", "regionCode": "04", "districtCode": "06" },
    { "name": "Bui Mini Dam", "regionCode": "04", "districtCode": "06" },
    { "name": "Com Hospital", "regionCode": "04", "districtCode": "06" },
    { "name": "Danyigba Quarters", "regionCode": "04", "districtCode": "06" },
    { "name": "Darfor", "regionCode": "04", "districtCode": "06" },
    { "name": "Darfor Tornu", "regionCode": "04", "districtCode": "06" },
    { "name": "District Fire Office", "regionCode": "04", "districtCode": "06" },
    { "name": "District Water Company", "regionCode": "04", "districtCode": "06" },
    { "name": "Ecg Office", "regionCode": "04", "districtCode": "06" },
    { "name": "Ep Kpodzi", "regionCode": "04", "districtCode": "06" },
    { "name": "Epttc", "regionCode": "04", "districtCode": "06" },
    { "name": "Foyer", "regionCode": "04", "districtCode": "06" },
    { "name": "Gabi La Jhs", "regionCode": "04", "districtCode": "06" },
    { "name": "Gayidzi", "regionCode": "04", "districtCode": "06" },
    { "name": "Gbefi Tornu", "regionCode": "04", "districtCode": "06" },
    { "name": "Gbefi Town", "regionCode": "04", "districtCode": "06" },
    { "name": "Gbi Akplamafu", "regionCode": "04", "districtCode": "06" },
    { "name": "Have Ando No. 1", "regionCode": "04", "districtCode": "06" },
    { "name": "Have Ando No. 2", "regionCode": "04", "districtCode": "06" },
    { "name": "Hope Home Orphanage", "regionCode": "04", "districtCode": "06" },
    { "name": "Jerusalem", "regionCode": "04", "districtCode": "06" },
    { "name": "Konda", "regionCode": "04", "districtCode": "06" },
    { "name": "Konda Old Cemetry 1", "regionCode": "04", "districtCode": "06" },
    { "name": "Konda Old Cemetry 2", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Adorfe No.1", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Adorfe No.2", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Agbenorxoe", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Agudzi", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Bame", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Bsp", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Cemetry Junction", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Dzewe", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Dzewe Junction", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Dzigbe", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Dzoanti", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Dzoanti 2", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Dzoanti Cemetery", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Fesi", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Fesi Quarters", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Gadza", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Gbofe", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Market", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpando Residency", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpantech", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpantech New Block", "regionCode": "04", "districtCode": "06" },
    { "name": "Kpokope", "regionCode": "04", "districtCode": "06" },
    { "name": "Kudzra Quarters", "regionCode": "04", "districtCode": "06" },
    { "name": "Kudzra Town", "regionCode": "04", "districtCode": "06" },
    { "name": "Kwamekrom Abornorkope", "regionCode": "04", "districtCode": "06" },
    { "name": "Kwamekrom Abudu Park", "regionCode": "04", "districtCode": "06" },
    { "name": "Kwamekrom Canaan", "regionCode": "04", "districtCode": "06" },
    { "name": "Kwamekrom Church Of Christ", "regionCode": "04", "districtCode": "06" },
    { "name": "Kwamekrom Cmb", "regionCode": "04", "districtCode": "06" },
    { "name": "Kwamekrom Concert House", "regionCode": "04", "districtCode": "06" },
    { "name": "Kwamekrom Market", "regionCode": "04", "districtCode": "06" },
    { "name": "Kwamekrom Newtown", "regionCode": "04", "districtCode": "06" },
    { "name": "Kwamekrom Pumping Station", "regionCode": "04", "districtCode": "06" },
    { "name": "Kwamekrom Pumping Station No.2", "regionCode": "04", "districtCode": "06" },
    { "name": "Lowcost", "regionCode": "04", "districtCode": "06" },
    { "name": "Ministry Of Agric", "regionCode": "04", "districtCode": "06" },
    { "name": "Nhis Junction", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Adenkesu", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Ahenkro Town", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Ahenkro Zongo", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Ahundzo", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Asakyire", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Bamboo Eng. Site", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Bumbula", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Kadjebi", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Ntumda Rc Church", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Shs", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Sibbiso", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Tayi", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Tepo", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Tepo Quarters No.1", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Tepo Quarters No.2", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Worupong Clinic", "regionCode": "04", "districtCode": "06" },
    { "name": "Nkonya Worupong Town", "regionCode": "04", "districtCode": "06" },
    { "name": "North Dayi Dist. Assemly", "regionCode": "04", "districtCode": "06" },
    { "name": "Ntumda Vodafone", "regionCode": "04", "districtCode": "06" },
    { "name": "Prisons Farms", "regionCode": "04", "districtCode": "06" },
    { "name": "Rolider", "regionCode": "04", "districtCode": "06" },
    { "name": "Sabadu", "regionCode": "04", "districtCode": "06" },
    { "name": "Sadzikope", "regionCode": "04", "districtCode": "06" },
    { "name": "Sadzikope Quarters", "regionCode": "04", "districtCode": "06" },
    { "name": "Sovie Newtown No.1", "regionCode": "04", "districtCode": "06" },
    { "name": "Sovie Newtown No.2", "regionCode": "04", "districtCode": "06" },
    { "name": "Sovie Town", "regionCode": "04", "districtCode": "06" },
    { "name": "Sovie Voc. Tech. Inst.", "regionCode": "04", "districtCode": "06" },
    { "name": "Togorme", "regionCode": "04", "districtCode": "06" },
    { "name": "Torkor Aglama", "regionCode": "04", "districtCode": "06" },
    { "name": "Torkor Market", "regionCode": "04", "districtCode": "06" },
    { "name": "Torkor Narrow Gate", "regionCode": "04", "districtCode": "06" },
    { "name": "Torkor Tsitekope", "regionCode": "04", "districtCode": "06" },
    { "name": "Torkor Water Pum. Station", "regionCode": "04", "districtCode": "06" },
    { "name": "Torkor Water Station", "regionCode": "04", "districtCode": "06" },
    { "name": "Tsoxor", "regionCode": "04", "districtCode": "06" },
    { "name": "Tsoxor Quarters", "regionCode": "04", "districtCode": "06" },
    { "name": "Tsrukpe Dukuma", "regionCode": "04", "districtCode": "06" },
    { "name": "Tsrukpe Tota", "regionCode": "04", "districtCode": "06" },
    { "name": "Tsrukpe Tsranu", "regionCode": "04", "districtCode": "06" },
    { "name": "Vakpo New Adomi No.1", "regionCode": "04", "districtCode": "06" },
    { "name": "Vakpo New Adomi No.2", "regionCode": "04", "districtCode": "06" },
    { "name": "Vakpo Old Adomi", "regionCode": "04", "districtCode": "06" },
    { "name": "Vakpo Quarters", "regionCode": "04", "districtCode": "06" },
    { "name": "Vakpo Snr. High", "regionCode": "04", "districtCode": "06" },
    { "name": "Vakpo Todzi", "regionCode": "04", "districtCode": "06" },
    { "name": "Vakpo Township", "regionCode": "04", "districtCode": "06" },
    { "name": "Vol Farms", "regionCode": "04", "districtCode": "06" },
    { "name": "Worupong Quarters", "regionCode": "04", "districtCode": "06" },
    { "name": "Worupong Rc Church", "regionCode": "04", "districtCode": "06" },
    { "name": "Worupong Zongo", "regionCode": "04", "districtCode": "06" },
    { "name": "Wusuta Anyafo", "regionCode": "04", "districtCode": "06" },
    { "name": "Wusuta Gborxome", "regionCode": "04", "districtCode": "06" },
    { "name": "Wusuta Hotor", "regionCode": "04", "districtCode": "06" },
    { "name": "Wusuta Kpebe", "regionCode": "04", "districtCode": "06" },
    { "name": "Wusuta Market", "regionCode": "04", "districtCode": "06" },
    { "name": "Wusuta Quarters", "regionCode": "04", "districtCode": "06" },
    { "name": "Xakope", "regionCode": "04", "districtCode": "06" },
    { "name": "Yordanu", "regionCode": "04", "districtCode": "06" }
  ],
  "04-07": [
    { "name": "Abledzie", "regionCode": "04", "districtCode": "07" },
    { "name": "Adobaye 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Adobaye 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Adzorgekope", "regionCode": "04", "districtCode": "07" },
    { "name": "Afadjato Shts", "regionCode": "04", "districtCode": "07" },
    { "name": "Akpafu Adorkor", "regionCode": "04", "districtCode": "07" },
    { "name": "Akpafu Mangoase", "regionCode": "04", "districtCode": "07" },
    { "name": "Akpafu Mempeasem Clinic", "regionCode": "04", "districtCode": "07" },
    { "name": "Akpafu Mempeasem Global", "regionCode": "04", "districtCode": "07" },
    { "name": "Akpafu Mempeasem Rc Church", "regionCode": "04", "districtCode": "07" },
    { "name": "Akpafu Mirekukrom", "regionCode": "04", "districtCode": "07" },
    { "name": "Akpafu Odomi Clinic", "regionCode": "04", "districtCode": "07" },
    { "name": "Akpafu Odomi Town", "regionCode": "04", "districtCode": "07" },
    { "name": "Akpafu Shts", "regionCode": "04", "districtCode": "07" },
    { "name": "Akpafu Sokpo", "regionCode": "04", "districtCode": "07" },
    { "name": "Akpafu Todzi", "regionCode": "04", "districtCode": "07" },
    { "name": "Anago Estate", "regionCode": "04", "districtCode": "07" },
    { "name": "Ando Kpuitive", "regionCode": "04", "districtCode": "07" },
    { "name": "Apatanu", "regionCode": "04", "districtCode": "07" },
    { "name": "Avekpo", "regionCode": "04", "districtCode": "07" },
    { "name": "Awoma", "regionCode": "04", "districtCode": "07" },
    { "name": "Baglo Boader", "regionCode": "04", "districtCode": "07" },
    { "name": "Baglo Shs", "regionCode": "04", "districtCode": "07" },
    { "name": "Baglo Town", "regionCode": "04", "districtCode": "07" },
    { "name": "Banazokope", "regionCode": "04", "districtCode": "07" },
    { "name": "Bank Of Ghana", "regionCode": "04", "districtCode": "07" },
    { "name": "Beghap Company Ltd", "regionCode": "04", "districtCode": "07" },
    { "name": "Bla Tordome", "regionCode": "04", "districtCode": "07" },
    { "name": "Buckingham Palace Hotel, Hloma", "regionCode": "04", "districtCode": "07" },
    { "name": "Bungalow Down No. 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Bungalow Down No. 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Bungalow St. Lights", "regionCode": "04", "districtCode": "07" },
    { "name": "By Fire", "regionCode": "04", "districtCode": "07" },
    { "name": "By Fire Down", "regionCode": "04", "districtCode": "07" },
    { "name": "By Fire St.Lights", "regionCode": "04", "districtCode": "07" },
    { "name": "By Plan", "regionCode": "04", "districtCode": "07" },
    { "name": "By Plan No. 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Cash Oil", "regionCode": "04", "districtCode": "07" },
    { "name": "Chinese Road Construction Co.", "regionCode": "04", "districtCode": "07" },
    { "name": "Dzenana", "regionCode": "04", "districtCode": "07" },
    { "name": "Dzogbeme", "regionCode": "04", "districtCode": "07" },
    { "name": "Dzoku", "regionCode": "04", "districtCode": "07" },
    { "name": "Dzolu", "regionCode": "04", "districtCode": "07" },
    { "name": "Dzorkpe Newtown", "regionCode": "04", "districtCode": "07" },
    { "name": "Dzorkpe Oldtown", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Ahor", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Ahor 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Amele", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Amele St. Light", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Amele Tonu", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Ando", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Dzogbega", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Dzogbekope", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Dzorkpe/Lormnava", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Helu", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Helu St. Light", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Hloma", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Kodzeto", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Torgbadza", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Tormegbe", "regionCode": "04", "districtCode": "07" },
    { "name": "Fodome Woe", "regionCode": "04", "districtCode": "07" },
    { "name": "Fr Dogli Voc. Institute", "regionCode": "04", "districtCode": "07" },
    { "name": "Fume", "regionCode": "04", "districtCode": "07" },
    { "name": "Galikope No. 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Galikope No. 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Atabu", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Avega No.2", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Bla No.2 / Kaleve", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Godenu", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Godenu Rice Factory", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Kledzo", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Kledzo 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Kledzo Newtown", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Kodzope", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Special School", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Wegbe", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Wegbe Danorkpedzi", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Wegbe Rc", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi Wegbe Street Light", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbi-Avega", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbledi Chebi", "regionCode": "04", "districtCode": "07" },
    { "name": "Gbledi Gborgame", "regionCode": "04", "districtCode": "07" },
    { "name": "Gborxome", "regionCode": "04", "districtCode": "07" },
    { "name": "Gboxome No. 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Geduld Junction", "regionCode": "04", "districtCode": "07" },
    { "name": "Ghana Telecom", "regionCode": "04", "districtCode": "07" },
    { "name": "Golokuati D/A", "regionCode": "04", "districtCode": "07" },
    { "name": "Goodwill Lodge", "regionCode": "04", "districtCode": "07" },
    { "name": "Hampton Resort", "regionCode": "04", "districtCode": "07" },
    { "name": "Hepps No. 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Hepps No. 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Highways", "regionCode": "04", "districtCode": "07" },
    { "name": "Hohoe Ecg Office", "regionCode": "04", "districtCode": "07" },
    { "name": "Hohoe Gcb", "regionCode": "04", "districtCode": "07" },
    { "name": "Hohoe High Court", "regionCode": "04", "districtCode": "07" },
    { "name": "Hohoe Hospital No. 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Hohoe Hospital No. 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Hohoe Stadium", "regionCode": "04", "districtCode": "07" },
    { "name": "Hohoe Zongo", "regionCode": "04", "districtCode": "07" },
    { "name": "Hotel De Mork", "regionCode": "04", "districtCode": "07" },
    { "name": "Hove Farms Area", "regionCode": "04", "districtCode": "07" },
    { "name": "Hove Lomnava", "regionCode": "04", "districtCode": "07" },
    { "name": "Hove Nyive", "regionCode": "04", "districtCode": "07" },
    { "name": "Kitikpa", "regionCode": "04", "districtCode": "07" },
    { "name": "Kitikpa Cemetery", "regionCode": "04", "districtCode": "07" },
    { "name": "Kitikpa Lukpo", "regionCode": "04", "districtCode": "07" },
    { "name": "Kitikpa St. Lights", "regionCode": "04", "districtCode": "07" },
    { "name": "Klokpo", "regionCode": "04", "districtCode": "07" },
    { "name": "Kotokakope 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Kotokakope 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpelezo", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpeme", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpoeta Global 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpoeta Global 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpoeta Jehova Witness", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpoeta Rice Farm", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpoeta Street Light", "regionCode": "04", "districtCode": "07" },
    { "name": "Kukukope", "regionCode": "04", "districtCode": "07" },
    { "name": "Kute Market", "regionCode": "04", "districtCode": "07" },
    { "name": "Kute Town", "regionCode": "04", "districtCode": "07" },
    { "name": "Lekanti", "regionCode": "04", "districtCode": "07" },
    { "name": "Leklebi Agbesia", "regionCode": "04", "districtCode": "07" },
    { "name": "Leklebi Agbesia Town", "regionCode": "04", "districtCode": "07" },
    { "name": "Leklebi Dafor", "regionCode": "04", "districtCode": "07" },
    { "name": "Leklebi Duga", "regionCode": "04", "districtCode": "07" },
    { "name": "Leklebi Fiapé", "regionCode": "04", "districtCode": "07" },
    { "name": "Leklebi Kame", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Agbonyra", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Dafornu", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Datem", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Mango Farm", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Peterkope", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Soba", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Teikrom", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Torganu", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Tove 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Tove 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Wote", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Abrani", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Agbozume Farm", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Alavanyo", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Bakua 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Bakua 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Bakua Clinic", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Bala No. 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Bala No. 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Ep Jhs", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Koforidua", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Kpeve", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Kukurantumi", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Kukurantumi Church", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Mate Church", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Nkwanta", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Shs", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Temkporkope", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Totame", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Water Works", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Akusame 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Adzokoe", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Adzokoe 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Akusame", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Alakpeti", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Alakpeti 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Ando", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Horglikope", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Klikpo", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Tota", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Vuinta", "regionCode": "04", "districtCode": "07" },
    { "name": "Lolobi Kumasi Market", "regionCode": "04", "districtCode": "07" },
    { "name": "Lolobi Ashambi", "regionCode": "04", "districtCode": "07" },
    { "name": "Lolobi Hunyasem", "regionCode": "04", "districtCode": "07" },
    { "name": "Lolobi Kumase", "regionCode": "04", "districtCode": "07" },
    { "name": "Lolobi Serminary", "regionCode": "04", "districtCode": "07" },
    { "name": "Lorve Tornu Ando", "regionCode": "04", "districtCode": "07" },
    { "name": "Lowcost Down 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Lowcost Down 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Majestic Villa", "regionCode": "04", "districtCode": "07" },
    { "name": "Maname", "regionCode": "04", "districtCode": "07" },
    { "name": "Matvin", "regionCode": "04", "districtCode": "07" },
    { "name": "Mchill", "regionCode": "04", "districtCode": "07" },
    { "name": "Michel Camp", "regionCode": "04", "districtCode": "07" },
    { "name": "New Atabu", "regionCode": "04", "districtCode": "07" },
    { "name": "New Atabu 2", "regionCode": "04", "districtCode": "07" },
    { "name": "New Ayoma Town", "regionCode": "04", "districtCode": "07" },
    { "name": "New Ayoma Zongo", "regionCode": "04", "districtCode": "07" },
    { "name": "New Baika", "regionCode": "04", "districtCode": "07" },
    { "name": "Odumase Buem", "regionCode": "04", "districtCode": "07" },
    { "name": "Ogidigidi", "regionCode": "04", "districtCode": "07" },
    { "name": "Oklahoma", "regionCode": "04", "districtCode": "07" },
    { "name": "Oklahoma Sobokope", "regionCode": "04", "districtCode": "07" },
    { "name": "Old Ayoma", "regionCode": "04", "districtCode": "07" },
    { "name": "Old Baika", "regionCode": "04", "districtCode": "07" },
    { "name": "Old Baika New", "regionCode": "04", "districtCode": "07" },
    { "name": "Palm Groove", "regionCode": "04", "districtCode": "07" },
    { "name": "Paloma", "regionCode": "04", "districtCode": "07" },
    { "name": "Paloma St. Lights", "regionCode": "04", "districtCode": "07" },
    { "name": "Peggy Good Int. School", "regionCode": "04", "districtCode": "07" },
    { "name": "Picnic", "regionCode": "04", "districtCode": "07" },
    { "name": "Picnic St. Lights", "regionCode": "04", "districtCode": "07" },
    { "name": "Rekiti", "regionCode": "04", "districtCode": "07" },
    { "name": "Kitikpa", "regionCode": "04", "districtCode": "07" },
    { "name": "Kitikpa Cemetery", "regionCode": "04", "districtCode": "07" },
    { "name": "Kitikpa Lukpo", "regionCode": "04", "districtCode": "07" },
    { "name": "Kitikpa St. Lights", "regionCode": "04", "districtCode": "07" },
    { "name": "Klokpo", "regionCode": "04", "districtCode": "07" },
    { "name": "Kotokakope 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Kotokakope 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpelezo", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpeme", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpoeta Global 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpoeta Global 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpoeta Jehova Witness", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpoeta Rice Farm", "regionCode": "04", "districtCode": "07" },
    { "name": "Kpoeta Street Light", "regionCode": "04", "districtCode": "07" },
    { "name": "Kukukope", "regionCode": "04", "districtCode": "07" },
    { "name": "Kute Market", "regionCode": "04", "districtCode": "07" },
    { "name": "Kute Town", "regionCode": "04", "districtCode": "07" },
    { "name": "Lekanti", "regionCode": "04", "districtCode": "07" },
    { "name": "Leklebi Agbesia", "regionCode": "04", "districtCode": "07" },
    { "name": "Leklebi Agbesia Town", "regionCode": "04", "districtCode": "07" },
    { "name": "Leklebi Dafor", "regionCode": "04", "districtCode": "07" },
    { "name": "Leklebi Duga", "regionCode": "04", "districtCode": "07" },
    { "name": "Leklebi Fiapé", "regionCode": "04", "districtCode": "07" },
    { "name": "Leklebi Kame", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Agbonyra", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Dafornu", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Datem", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Mango Farm", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Peterkope", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Soba", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Teikrom", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Torganu", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Tove 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Tove 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Liati Wote", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Abrani", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Agbozume Farm", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Alavanyo", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Bakua 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Bakua 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Bakua Clinic", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Bala No. 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Bala No. 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Ep Jhs", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Koforidua", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Kpeve", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Kukurantumi", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Kukurantumi Church", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Mate Church", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Nkwanta", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Shs", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Temkporkope", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Totame", "regionCode": "04", "districtCode": "07" },
    { "name": "Likpe Water Works", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Akusame 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Adzokoe", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Adzokoe 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Akusame", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Alakpeti", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Alakpeti 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Ando", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Horglikope", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Klikpo", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Tota", "regionCode": "04", "districtCode": "07" },
    { "name": "Logba Vuinta", "regionCode": "04", "districtCode": "07" },
    { "name": "Lolobi Kumasi Market", "regionCode": "04", "districtCode": "07" },
    { "name": "Lolobi Ashambi", "regionCode": "04", "districtCode": "07" },
    { "name": "Lolobi Hunyasem", "regionCode": "04", "districtCode": "07" },
    { "name": "Lolobi Kumase", "regionCode": "04", "districtCode": "07" },
    { "name": "Lolobi Serminary", "regionCode": "04", "districtCode": "07" },
    { "name": "Lorve Tornu Ando", "regionCode": "04", "districtCode": "07" },
    { "name": "Lowcost Down 1", "regionCode": "04", "districtCode": "07" },
    { "name": "Lowcost Down 2", "regionCode": "04", "districtCode": "07" },
    { "name": "Majestic Villa", "regionCode": "04", "districtCode": "07" },
    { "name": "Maname", "regionCode": "04", "districtCode": "07" },
    { "name": "Matvin", "regionCode": "04", "districtCode": "07" },
    { "name": "Mchill", "regionCode": "04", "districtCode": "07" },
    { "name": "Michel Camp", "regionCode": "04", "districtCode": "07" },
    { "name": "New Atabu", "regionCode": "04", "districtCode": "07" },
    { "name": "New Atabu 2", "regionCode": "04", "districtCode": "07" },
    { "name": "New Ayoma Town", "regionCode": "04", "districtCode": "07" },
    { "name": "New Ayoma Zongo", "regionCode": "04", "districtCode": "07" },
    { "name": "New Baika", "regionCode": "04", "districtCode": "07" },
    { "name": "Odumase Buem", "regionCode": "04", "districtCode": "07" },
    { "name": "Ogidigidi", "regionCode": "04", "districtCode": "07" },
    { "name": "Oklahoma", "regionCode": "04", "districtCode": "07" },
    { "name": "Oklahoma Sobokope", "regionCode": "04", "districtCode": "07" },
    { "name": "Old Ayoma", "regionCode": "04", "districtCode": "07" },
    { "name": "Old Baika", "regionCode": "04", "districtCode": "07" },
    { "name": "Old Baika New", "regionCode": "04", "districtCode": "07" },
    { "name": "Palm Groove", "regionCode": "04", "districtCode": "07" },
    { "name": "Paloma", "regionCode": "04", "districtCode": "07" },
    { "name": "Paloma St. Lights", "regionCode": "04", "districtCode": "07" },
    { "name": "Peggy Good Int. School", "regionCode": "04", "districtCode": "07" },
    { "name": "Picnic", "regionCode": "04", "districtCode": "07" },
    { "name": "Picnic St. Lights", "regionCode": "04", "districtCode": "07" },
    { "name": "Rekiti", "regionCode": "04", "districtCode": "07" }
  ],
  "04-08": [
    { "name": "Abornorkope", "regionCode": "04", "districtCode": "08" },
    { "name": "Abotoase E.P School", "regionCode": "04", "districtCode": "08" },
    { "name": "Abotoase Mtn", "regionCode": "04", "districtCode": "08" },
    { "name": "Adekyee", "regionCode": "04", "districtCode": "08" },
    { "name": "Agormayor", "regionCode": "04", "districtCode": "08" },
    { "name": "Ahamansu", "regionCode": "04", "districtCode": "08" },
    { "name": "Ahamansu Junction", "regionCode": "04", "districtCode": "08" },
    { "name": "Ahamansu Pumping Station", "regionCode": "04", "districtCode": "08" },
    { "name": "Akaa Bompa", "regionCode": "04", "districtCode": "08" },
    { "name": "Akaa Buem", "regionCode": "04", "districtCode": "08" },
    { "name": "Akaa Quarters", "regionCode": "04", "districtCode": "08" },
    { "name": "Akaa Quarters New", "regionCode": "04", "districtCode": "08" },
    { "name": "Akaa Tanki", "regionCode": "04", "districtCode": "08" },
    { "name": "Akaa Yaw Farms", "regionCode": "04", "districtCode": "08" },
    { "name": "Akaa Yaw No.1", "regionCode": "04", "districtCode": "08" },
    { "name": "Akaa Yaw No.2", "regionCode": "04", "districtCode": "08" },
    { "name": "Akposo Kabo", "regionCode": "04", "districtCode": "08" },
    { "name": "Ampayo", "regionCode": "04", "districtCode": "08" },
    { "name": "Ananikope", "regionCode": "04", "districtCode": "08" },
    { "name": "Apenkwa", "regionCode": "04", "districtCode": "08" },
    { "name": "Apesokubi Akyenase", "regionCode": "04", "districtCode": "08" },
    { "name": "Apesokubi No.1", "regionCode": "04", "districtCode": "08" },
    { "name": "Apesokubi No.2", "regionCode": "04", "districtCode": "08" },
    { "name": "Apesokubi Township", "regionCode": "04", "districtCode": "08" },
    { "name": "Asato", "regionCode": "04", "districtCode": "08" },
    { "name": "Atakrom", "regionCode": "04", "districtCode": "08" },
    { "name": "Atonkor", "regionCode": "04", "districtCode": "08" },
    { "name": "Attakofi", "regionCode": "04", "districtCode": "08" },
    { "name": "Bodada Pumping Station", "regionCode": "04", "districtCode": "08" },
    { "name": "Bodada Roundabout", "regionCode": "04", "districtCode": "08" },
    { "name": "Bodada Town", "regionCode": "04", "districtCode": "08" },
    { "name": "Bowiri Abetenase", "regionCode": "04", "districtCode": "08" },
    { "name": "Bowiri Aboabo", "regionCode": "04", "districtCode": "08" },
    { "name": "Bowiri Abohere", "regionCode": "04", "districtCode": "08" },
    { "name": "Bowiri Amanfrom", "regionCode": "04", "districtCode": "08" },
    { "name": "Bowiri Anyinase No. 1", "regionCode": "04", "districtCode": "08" },
    { "name": "Bowiri Anyinase No. 2", "regionCode": "04", "districtCode": "08" },
    { "name": "Bowiri Kubease", "regionCode": "04", "districtCode": "08" },
    { "name": "Bowiri Kyirahene", "regionCode": "04", "districtCode": "08" },
    { "name": "Bowiri Kyirahene 2", "regionCode": "04", "districtCode": "08" },
    { "name": "Bowiri Odumase", "regionCode": "04", "districtCode": "08" },
    { "name": "Bowiri Takrabe", "regionCode": "04", "districtCode": "08" },
    { "name": "Bueman Shs", "regionCode": "04", "districtCode": "08" },
    { "name": "Dodi Mempeasem Central Mosque", "regionCode": "04", "districtCode": "08" },
    { "name": "Dodi Mempeasem 1", "regionCode": "04", "districtCode": "08" },
    { "name": "Dodi Mempeasem 2", "regionCode": "04", "districtCode": "08" },
    { "name": "Dodi Papase Hospital", "regionCode": "04", "districtCode": "08" },
    { "name": "Dodi Papase Pumping Station", "regionCode": "04", "districtCode": "08" },
    { "name": "Dodi Papase Township", "regionCode": "04", "districtCode": "08" },
    { "name": "Dodi Papase Zongo No.1", "regionCode": "04", "districtCode": "08" },
    { "name": "Dodi Papase Zongo No.2", "regionCode": "04", "districtCode": "08" },
    { "name": "Dzindzinsu 1", "regionCode": "04", "districtCode": "08" },
    { "name": "Dzindzinsu 2", "regionCode": "04", "districtCode": "08" },
    { "name": "Dzindzinsu 3", "regionCode": "04", "districtCode": "08" },
    { "name": "Edwin Woods No. 1", "regionCode": "04", "districtCode": "08" },
    { "name": "Edwin Woods No. 2", "regionCode": "04", "districtCode": "08" },
    { "name": "Fahiekorbor", "regionCode": "04", "districtCode": "08" },
    { "name": "Gadaka", "regionCode": "04", "districtCode": "08" },
    { "name": "Gruma Akura", "regionCode": "04", "districtCode": "08" },
    { "name": "Guaman", "regionCode": "04", "districtCode": "08" },
    { "name": "Guaman Bethel", "regionCode": "04", "districtCode": "08" },
    { "name": "Gyamonome", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasico", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasikan District Assembly", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasikan Ep Church", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasikan Filling Station", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasikan Gcb", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasikan Hospital No. 1", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasikan Hospital No. 2", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasikan Nestella", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasikan Rc Secretariat", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasikan Recidency", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasikan Rollider", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasikan Roundabout", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasikan Sharp Corner", "regionCode": "04", "districtCode": "08" },
    { "name": "Jasikan T. Junction", "regionCode": "04", "districtCode": "08" },
    { "name": "Kadjebi", "regionCode": "04", "districtCode": "08" },
    { "name": "Kadjebi Asato Shs", "regionCode": "04", "districtCode": "08" },
    { "name": "Kadjebi Clinic", "regionCode": "04", "districtCode": "08" },
    { "name": "Kadjebi Cmb", "regionCode": "04", "districtCode": "08" },
    { "name": "Kadjebi District Assembly", "regionCode": "04", "districtCode": "08" },
    { "name": "Kadjebi Junction", "regionCode": "04", "districtCode": "08" },
    { "name": "Kadjebi Zongo", "regionCode": "04", "districtCode": "08" },
    { "name": "Kasajah", "regionCode": "04", "districtCode": "08" },
    { "name": "Ketepi", "regionCode": "04", "districtCode": "08" },
    { "name": "Ketsi Nkwanta", "regionCode": "04", "districtCode": "08" },
    { "name": "Koesem", "regionCode": "04", "districtCode": "08" },
    { "name": "Kordibenum", "regionCode": "04", "districtCode": "08" },
    { "name": "Kordibenum Nyako", "regionCode": "04", "districtCode": "08" },
    { "name": "Kosanba", "regionCode": "04", "districtCode": "08" },
    { "name": "Koto Nkwanta", "regionCode": "04", "districtCode": "08" },
    { "name": "Koto Nkwanta Road Cons. Co. Ltd", "regionCode": "04", "districtCode": "08" },
    { "name": "Kotokoli Zongo", "regionCode": "04", "districtCode": "08" },
    { "name": "Kotokoli Zongo New", "regionCode": "04", "districtCode": "08" },
    { "name": "Kudze", "regionCode": "04", "districtCode": "08" },
    { "name": "Mangoase", "regionCode": "04", "districtCode": "08" },
    { "name": "Manida", "regionCode": "04", "districtCode": "08" },
    { "name": "Menuso", "regionCode": "04", "districtCode": "08" },
    { "name": "Menuso New", "regionCode": "04", "districtCode": "08" },
    { "name": "Menuso No. 1", "regionCode": "04", "districtCode": "08" },
    { "name": "Menuso No. 2", "regionCode": "04", "districtCode": "08" },
    { "name": "Nsuta", "regionCode": "04", "districtCode": "08" },
    { "name": "Nsuta Rc Secretariat", "regionCode": "04", "districtCode": "08" },
    { "name": "Oboasi", "regionCode": "04", "districtCode": "08" },
    { "name": "Odomeabra", "regionCode": "04", "districtCode": "08" },
    { "name": "Okagyeakrom James Town", "regionCode": "04", "districtCode": "08" },
    { "name": "Okagyeakrom Shts", "regionCode": "04", "districtCode": "08" },
    { "name": "Okagyeakrom Town", "regionCode": "04", "districtCode": "08" },
    { "name": "Okanta", "regionCode": "04", "districtCode": "08" },
    { "name": "Omankradukrom", "regionCode": "04", "districtCode": "08" },
    { "name": "Poase Cement Cmb", "regionCode": "04", "districtCode": "08" },
    { "name": "Poase Cement La Jhs", "regionCode": "04", "districtCode": "08" },
    { "name": "Poase Cement Township", "regionCode": "04", "districtCode": "08" },
    { "name": "Rc Bishop'S Recidence", "regionCode": "04", "districtCode": "08" },
    { "name": "Sabram", "regionCode": "04", "districtCode": "08" },
    { "name": "Tapa Abotoase", "regionCode": "04", "districtCode": "08" },
    { "name": "Tapa Abotoase Market", "regionCode": "04", "districtCode": "08" },
    { "name": "Tapa Amanfrom Ressetlement", "regionCode": "04", "districtCode": "08" },
    { "name": "Tapa Amanfrom Zongo", "regionCode": "04", "districtCode": "08" },
    { "name": "Tapa Amanya", "regionCode": "04", "districtCode": "08" },
    { "name": "Tapa Apiakrom", "regionCode": "04", "districtCode": "08" },
    { "name": "Tapa Kortokope", "regionCode": "04", "districtCode": "08" },
    { "name": "Tapa Roundabout", "regionCode": "04", "districtCode": "08" },
    { "name": "Tapaman Shts", "regionCode": "04", "districtCode": "08" },
    { "name": "Titiaka", "regionCode": "04", "districtCode": "08" },
    { "name": "Titiaka Saw Mill", "regionCode": "04", "districtCode": "08" },
    { "name": "Twengena", "regionCode": "04", "districtCode": "08" },
    { "name": "Vodafone", "regionCode": "04", "districtCode": "08" },
    { "name": "Volta Red", "regionCode": "04", "districtCode": "08" },
    { "name": "Wawaso", "regionCode": "04", "districtCode": "08" },
    { "name": "Worawora", "regionCode": "04", "districtCode": "08" },
    { "name": "Worawora Afariwa Farm", "regionCode": "04", "districtCode": "08" },
    { "name": "Worawora Glory Oil", "regionCode": "04", "districtCode": "08" },
    { "name": "Worawora Hospital", "regionCode": "04", "districtCode": "08" },
    { "name": "Worawora Kotomase", "regionCode": "04", "districtCode": "08" },
    { "name": "Worawora Pumping Station", "regionCode": "04", "districtCode": "08" },
    { "name": "Worawora Rice Mill", "regionCode": "04", "districtCode": "08" },
    { "name": "Yadzo", "regionCode": "04", "districtCode": "08" }
  ],
  "04-09": [
    { "name": "31St Day Care", "regionCode": "04", "districtCode": "09" },
    { "name": "Abrewankor", "regionCode": "04", "districtCode": "09" },
    { "name": "Abrewankor Junction", "regionCode": "04", "districtCode": "09" },
    { "name": "Abrubruwa", "regionCode": "04", "districtCode": "09" },
    { "name": "Agou Junction", "regionCode": "04", "districtCode": "09" },
    { "name": "Agou Konji", "regionCode": "04", "districtCode": "09" },
    { "name": "Agoufie", "regionCode": "04", "districtCode": "09" },
    { "name": "Agric Office", "regionCode": "04", "districtCode": "09" },
    { "name": "Agric Quarters", "regionCode": "04", "districtCode": "09" },
    { "name": "Agyekumkura (Hill Top)", "regionCode": "04", "districtCode": "09" },
    { "name": "Ahondwo", "regionCode": "04", "districtCode": "09" },
    { "name": "Akum", "regionCode": "04", "districtCode": "09" },
    { "name": "Anikado Farms", "regionCode": "04", "districtCode": "09" },
    { "name": "Animal Husbandry", "regionCode": "04", "districtCode": "09" },
    { "name": "Ashiabre", "regionCode": "04", "districtCode": "09" },
    { "name": "Asuogya", "regionCode": "04", "districtCode": "09" },
    { "name": "Basare Akura", "regionCode": "04", "districtCode": "09" },
    { "name": "Beyond Fm", "regionCode": "04", "districtCode": "09" },
    { "name": "Big Zongo", "regionCode": "04", "districtCode": "09" },
    { "name": "Bontibor", "regionCode": "04", "districtCode": "09" },
    { "name": "Brewaniase Market", "regionCode": "04", "districtCode": "09" },
    { "name": "Brewaniase Pampa", "regionCode": "04", "districtCode": "09" },
    { "name": "Brewaniase Rc", "regionCode": "04", "districtCode": "09" },
    { "name": "Brewaniase Shs", "regionCode": "04", "districtCode": "09" },
    { "name": "Brewanise Civil Aviation", "regionCode": "04", "districtCode": "09" },
    { "name": "Chaiso", "regionCode": "04", "districtCode": "09" },
    { "name": "Chaiso Old Road", "regionCode": "04", "districtCode": "09" },
    { "name": "Dadiase", "regionCode": "04", "districtCode": "09" },
    { "name": "Dapa Amanta No. 1", "regionCode": "04", "districtCode": "09" },
    { "name": "Dapa Amanta No. 2", "regionCode": "04", "districtCode": "09" },
    { "name": "Dapa Junction 1", "regionCode": "04", "districtCode": "09" },
    { "name": "Dapa Junction 2", "regionCode": "04", "districtCode": "09" },
    { "name": "Dawakura", "regionCode": "04", "districtCode": "09" },
    { "name": "District Assembly Junction", "regionCode": "04", "districtCode": "09" },
    { "name": "Dodo Amanfrom Market", "regionCode": "04", "districtCode": "09" },
    { "name": "Dodo Amanfrom Zongo", "regionCode": "04", "districtCode": "09" },
    { "name": "Dodo Dompa", "regionCode": "04", "districtCode": "09" },
    { "name": "Dodo Pepesu", "regionCode": "04", "districtCode": "09" },
    { "name": "Dodo Tamale", "regionCode": "04", "districtCode": "09" },
    { "name": "Dodofie", "regionCode": "04", "districtCode": "09" },
    { "name": "Ecg Office Lowcost", "regionCode": "04", "districtCode": "09" },
    { "name": "English Arabic Junction", "regionCode": "04", "districtCode": "09" },
    { "name": "Full Gospel", "regionCode": "04", "districtCode": "09" },
    { "name": "Gateway", "regionCode": "04", "districtCode": "09" },
    { "name": "Gateway Top", "regionCode": "04", "districtCode": "09" },
    { "name": "Gekorong", "regionCode": "04", "districtCode": "09" },
    { "name": "Global Evangelical Church", "regionCode": "04", "districtCode": "09" },
    { "name": "Green Wood", "regionCode": "04", "districtCode": "09" },
    { "name": "Gyankra Saw Mill", "regionCode": "04", "districtCode": "09" },
    { "name": "Health Insurance Office", "regionCode": "04", "districtCode": "09" },
    { "name": "Jabari Akura", "regionCode": "04", "districtCode": "09" },
    { "name": "Kabiti No. 1", "regionCode": "04", "districtCode": "09" },
    { "name": "Kabiti No. 2", "regionCode": "04", "districtCode": "09" },
    { "name": "Kakraka Vodafone Cell Site", "regionCode": "04", "districtCode": "09" },
    { "name": "Katai Junction", "regionCode": "04", "districtCode": "09" },
    { "name": "Kecheibi No. 1", "regionCode": "04", "districtCode": "09" },
    { "name": "Kecheibi No. 2", "regionCode": "04", "districtCode": "09" },
    { "name": "Kente", "regionCode": "04", "districtCode": "09" },
    { "name": "Keri", "regionCode": "04", "districtCode": "09" },
    { "name": "Kilimanjaro E/A", "regionCode": "04", "districtCode": "09" },
    { "name": "Kotokoli Zongo", "regionCode": "04", "districtCode": "09" },
    { "name": "Kpekpu Akura", "regionCode": "04", "districtCode": "09" },
    { "name": "Kpeve", "regionCode": "04", "districtCode": "09" },
    { "name": "Kromase", "regionCode": "04", "districtCode": "09" },
    { "name": "Krontang", "regionCode": "04", "districtCode": "09" },
    { "name": "Kue", "regionCode": "04", "districtCode": "09" },
    { "name": "Kukurantumi No. 1", "regionCode": "04", "districtCode": "09" },
    { "name": "Kukurantumi No. 2", "regionCode": "04", "districtCode": "09" },
    { "name": "Kyabobo Nat. Park", "regionCode": "04", "districtCode": "09" },
    { "name": "Kyabobo Park Qtrs Odomi", "regionCode": "04", "districtCode": "09" },
    { "name": "Mangoase", "regionCode": "04", "districtCode": "09" },
    { "name": "Mount Sinai", "regionCode": "04", "districtCode": "09" },
    { "name": "Nanzeni", "regionCode": "04", "districtCode": "09" },
    { "name": "Njare", "regionCode": "04", "districtCode": "09" },
    { "name": "Njare Kucha", "regionCode": "04", "districtCode": "09" },
    { "name": "Nkwanta Comm. Day Shs", "regionCode": "04", "districtCode": "09" },
    { "name": "Nkwanta District Hospital", "regionCode": "04", "districtCode": "09" },
    { "name": "Nkwanta Highways", "regionCode": "04", "districtCode": "09" },
    { "name": "Nkwanta Kablikura 1", "regionCode": "04", "districtCode": "09" },
    { "name": "Nkwanta Kablikura 2", "regionCode": "04", "districtCode": "09" },
    { "name": "Nkwanta Madina", "regionCode": "04", "districtCode": "09" },
    { "name": "Nkwanta Market", "regionCode": "04", "districtCode": "09" },
    { "name": "Nkwanta Medical Village", "regionCode": "04", "districtCode": "09" },
    { "name": "Nkwanta Shs", "regionCode": "04", "districtCode": "09" },
    { "name": "Nsana Zongo", "regionCode": "04", "districtCode": "09" },
    { "name": "Nyakomah", "regionCode": "04", "districtCode": "09" },
    { "name": "Nyambong", "regionCode": "04", "districtCode": "09" },
    { "name": "Nyambong Junction", "regionCode": "04", "districtCode": "09" },
    { "name": "Nyame Bekyere", "regionCode": "04", "districtCode": "09" },
    { "name": "Obanda", "regionCode": "04", "districtCode": "09" },
    { "name": "Obanda Ando", "regionCode": "04", "districtCode": "09" },
    { "name": "Odomi", "regionCode": "04", "districtCode": "09" },
    { "name": "Odumase No. 1", "regionCode": "04", "districtCode": "09" },
    { "name": "Odumase No. 2", "regionCode": "04", "districtCode": "09" },
    { "name": "Pampawie", "regionCode": "04", "districtCode": "09" },
    { "name": "Pampawie Clinic", "regionCode": "04", "districtCode": "09" },
    { "name": "Papaye", "regionCode": "04", "districtCode": "09" },
    { "name": "Pawa No. 1", "regionCode": "04", "districtCode": "09" },
    { "name": "Pawa No. 2", "regionCode": "04", "districtCode": "09" },
    { "name": "Pusupu Clinic", "regionCode": "04", "districtCode": "09" },
    { "name": "Pusupu Market", "regionCode": "04", "districtCode": "09" },
    { "name": "Pusupu Zongo", "regionCode": "04", "districtCode": "09" },
    { "name": "Safiano", "regionCode": "04", "districtCode": "09" },
    { "name": "Salifukrom", "regionCode": "04", "districtCode": "09" },
    { "name": "Shairi", "regionCode": "04", "districtCode": "09" },
    { "name": "St Josep'S Hospital", "regionCode": "04", "districtCode": "09" },
    { "name": "St Josep'S Hospital Top", "regionCode": "04", "districtCode": "09" },
    { "name": "Volta Wood", "regionCode": "04", "districtCode": "09" },
    { "name": "Water Works", "regionCode": "04", "districtCode": "09" }
  ],
  "04-11": [
    { "name": "Abletorkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Abusakope", "regionCode": "04", "districtCode": "11" },
    { "name": "Accra Station", "regionCode": "04", "districtCode": "11" },
    { "name": "Accra Town", "regionCode": "04", "districtCode": "11" },
    { "name": "Adaklu Ahunda Boso", "regionCode": "04", "districtCode": "11" },
    { "name": "Adaklu Ahunda Kpodzi", "regionCode": "04", "districtCode": "11" },
    { "name": "Adaklu Ahunda Quarry", "regionCode": "04", "districtCode": "11" },
    { "name": "Adaklu Aziedukope", "regionCode": "04", "districtCode": "11" },
    { "name": "Adaklu Hlihave", "regionCode": "04", "districtCode": "11" },
    { "name": "Adegblikope/Yedzokope", "regionCode": "04", "districtCode": "11" },
    { "name": "Adexor", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidikpo / Gadekope", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidokpoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidokpoi", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome Ceramics", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome District Assembly", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome Hospital", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome Hunorkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome Int. Needs Vtc", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome Junction", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome Lowcost", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome P&T", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome Police Station", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome Pumping Station 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome Pumping Station 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome Shs", "regionCode": "04", "districtCode": "11" },
    { "name": "Adidome Zongo", "regionCode": "04", "districtCode": "11" },
    { "name": "Adusukope", "regionCode": "04", "districtCode": "11" },
    { "name": "Adutor", "regionCode": "04", "districtCode": "11" },
    { "name": "Adutor Bekpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Adutor Korzunyi", "regionCode": "04", "districtCode": "11" },
    { "name": "Adutor Sonukpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Adutor Sonume", "regionCode": "04", "districtCode": "11" },
    { "name": "Aflavenu Vokpoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Agave Agortakpo No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Agave Agortakpo No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Agbagorme", "regionCode": "04", "districtCode": "11" },
    { "name": "Agbakope Comboni Rc Church", "regionCode": "04", "districtCode": "11" },
    { "name": "Agbakope No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Agbakope No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Agbletorkoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Agbogbla", "regionCode": "04", "districtCode": "11" },
    { "name": "Agborlikpota", "regionCode": "04", "districtCode": "11" },
    { "name": "Aglobakpo No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Aglobakpo No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Aglobakpo No. 3", "regionCode": "04", "districtCode": "11" },
    { "name": "Agordome", "regionCode": "04", "districtCode": "11" },
    { "name": "Agordome Junction", "regionCode": "04", "districtCode": "11" },
    { "name": "Agordome Pumping Station", "regionCode": "04", "districtCode": "11" },
    { "name": "Agorhome", "regionCode": "04", "districtCode": "11" },
    { "name": "Agorhome Road", "regionCode": "04", "districtCode": "11" },
    { "name": "Agorkpenu", "regionCode": "04", "districtCode": "11" },
    { "name": "Agorkpo No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Agorkpo No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Agorkpoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Agorta Dodokope", "regionCode": "04", "districtCode": "11" },
    { "name": "Agorta Zewukope", "regionCode": "04", "districtCode": "11" },
    { "name": "Agortaga", "regionCode": "04", "districtCode": "11" },
    { "name": "Ahiatrogakope", "regionCode": "04", "districtCode": "11" },
    { "name": "Ahlihakpe No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Ahlihakpe No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Ahorlukope", "regionCode": "04", "districtCode": "11" },
    { "name": "Akakpokope", "regionCode": "04", "districtCode": "11" },
    { "name": "Akalove", "regionCode": "04", "districtCode": "11" },
    { "name": "Akato", "regionCode": "04", "districtCode": "11" },
    { "name": "Akorlikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Akuta", "regionCode": "04", "districtCode": "11" },
    { "name": "Alavanyo", "regionCode": "04", "districtCode": "11" },
    { "name": "Alesikpe No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Alesikpe No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Alordukope", "regionCode": "04", "districtCode": "11" },
    { "name": "Amedormekope", "regionCode": "04", "districtCode": "11" },
    { "name": "Amelorkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Amelorkope - Agbaglakope", "regionCode": "04", "districtCode": "11" },
    { "name": "Amelorkope Quarters", "regionCode": "04", "districtCode": "11" },
    { "name": "Ampadu", "regionCode": "04", "districtCode": "11" },
    { "name": "Anator Quarry", "regionCode": "04", "districtCode": "11" },
    { "name": "Ashiagborkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Asiekpe", "regionCode": "04", "districtCode": "11" },
    { "name": "Atiglinyikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Atitekpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Atitekpo / Hekope", "regionCode": "04", "districtCode": "11" },
    { "name": "Atorkplakpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Atsieve", "regionCode": "04", "districtCode": "11" },
    { "name": "Avafiya", "regionCode": "04", "districtCode": "11" },
    { "name": "Avegorme", "regionCode": "04", "districtCode": "11" },
    { "name": "Avorvi", "regionCode": "04", "districtCode": "11" },
    { "name": "Avuto", "regionCode": "04", "districtCode": "11" },
    { "name": "Awadiwoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Awuyakope Da Basic School", "regionCode": "04", "districtCode": "11" },
    { "name": "Ayitovinu", "regionCode": "04", "districtCode": "11" },
    { "name": "Aywata No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Aywata No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Azikpo Agave", "regionCode": "04", "districtCode": "11" },
    { "name": "Bakpa Adzani", "regionCode": "04", "districtCode": "11" },
    { "name": "Bakpa Ankpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Bakpa Avedo", "regionCode": "04", "districtCode": "11" },
    { "name": "Bakpa Avedo Market", "regionCode": "04", "districtCode": "11" },
    { "name": "Bakpa Dzavie", "regionCode": "04", "districtCode": "11" },
    { "name": "Bakpa Kpokope", "regionCode": "04", "districtCode": "11" },
    { "name": "Bakpa Pumping Station", "regionCode": "04", "districtCode": "11" },
    { "name": "Bakpa Todze", "regionCode": "04", "districtCode": "11" },
    { "name": "Bakpa Torsukope", "regionCode": "04", "districtCode": "11" },
    { "name": "Bakpa Yevuyiborkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Bakpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Battor Adidokpavu", "regionCode": "04", "districtCode": "11" },
    { "name": "Battor Atigonu", "regionCode": "04", "districtCode": "11" },
    { "name": "Battor Depe No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Battor Depe No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Battor Dotorkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Battor Gbagbavuinu", "regionCode": "04", "districtCode": "11" },
    { "name": "Battor Ngorlekpoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Battor Nyatikpo No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Battor Nyatikpo No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Battor Nyatikpo No. 3", "regionCode": "04", "districtCode": "11" },
    { "name": "Battor Torgodo", "regionCode": "04", "districtCode": "11" },
    { "name": "Besahkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Bokokope", "regionCode": "04", "districtCode": "11" },
    { "name": "Botoakoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Brazil Agro Business", "regionCode": "04", "districtCode": "11" },
    { "name": "Brukotorve", "regionCode": "04", "districtCode": "11" },
    { "name": "Camp Daniel Junction", "regionCode": "04", "districtCode": "11" },
    { "name": "Cisneros Hotel", "regionCode": "04", "districtCode": "11" },
    { "name": "Comboni Clinic", "regionCode": "04", "districtCode": "11" },
    { "name": "Dabala Ict", "regionCode": "04", "districtCode": "11" },
    { "name": "Dabala J. No. 2 / Nyikpogbor", "regionCode": "04", "districtCode": "11" },
    { "name": "Dabala J. No. 3 / Fatherkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Dabala Junction No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Dabala Kpotame", "regionCode": "04", "districtCode": "11" },
    { "name": "Dabala Newtown", "regionCode": "04", "districtCode": "11" },
    { "name": "Dabala Sec. Tech", "regionCode": "04", "districtCode": "11" },
    { "name": "Dabala St. John Rc Church", "regionCode": "04", "districtCode": "11" },
    { "name": "Dabala Zingakope", "regionCode": "04", "districtCode": "11" },
    { "name": "Dalive", "regionCode": "04", "districtCode": "11" },
    { "name": "Dedenu", "regionCode": "04", "districtCode": "11" },
    { "name": "Dekpevie", "regionCode": "04", "districtCode": "11" },
    { "name": "Deme", "regionCode": "04", "districtCode": "11" },
    { "name": "Dendo", "regionCode": "04", "districtCode": "11" },
    { "name": "Detsawome No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Detsawome No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Detsawome Rasta Hotel", "regionCode": "04", "districtCode": "11" },
    { "name": "Dorgbetorkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Dorkploame", "regionCode": "04", "districtCode": "11" },
    { "name": "Dzefekope", "regionCode": "04", "districtCode": "11" },
    { "name": "Dzodome", "regionCode": "04", "districtCode": "11" },
    { "name": "Dzogborve Apimkpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Dzogborve Korsikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Dzogborve Kumakope", "regionCode": "04", "districtCode": "11" },
    { "name": "Dzogborve No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Dzogborve No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Dzokplenu", "regionCode": "04", "districtCode": "11" },
    { "name": "Egbedzikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Fakpoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Fievie Dugame No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Fievie Dugame No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Fievie Kpodzi", "regionCode": "04", "districtCode": "11" },
    { "name": "Fish And Feed", "regionCode": "04", "districtCode": "11" },
    { "name": "Friends Of Ghana", "regionCode": "04", "districtCode": "11" },
    { "name": "Gadco Rice Mill", "regionCode": "04", "districtCode": "11" },
    { "name": "Gafatsikope Vudzakpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Gafatsikope Wegodo", "regionCode": "04", "districtCode": "11" },
    { "name": "Galekope", "regionCode": "04", "districtCode": "11" },
    { "name": "Galotse", "regionCode": "04", "districtCode": "11" },
    { "name": "Gamenu", "regionCode": "04", "districtCode": "11" },
    { "name": "Gamenu Hafui", "regionCode": "04", "districtCode": "11" },
    { "name": "Gamenu Kedzi", "regionCode": "04", "districtCode": "11" },
    { "name": "Gbenuakope", "regionCode": "04", "districtCode": "11" },
    { "name": "Gbetelekpo No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Gbetelekpo No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Gbetelekpo No. 3", "regionCode": "04", "districtCode": "11" },
    { "name": "Gblorkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Gborgblenukpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Glover Estate", "regionCode": "04", "districtCode": "11" },
    { "name": "Goil Filling Station", "regionCode": "04", "districtCode": "11" },
    { "name": "Gonu Adadzikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Gonu Agbokope", "regionCode": "04", "districtCode": "11" },
    { "name": "Gonu Dakope", "regionCode": "04", "districtCode": "11" },
    { "name": "Gonu Gatikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Gonu Korkuvikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Gonu Negbenu", "regionCode": "04", "districtCode": "11" },
    { "name": "Gonu Sukladzi", "regionCode": "04", "districtCode": "11" },
    { "name": "Gordorkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Gowenu", "regionCode": "04", "districtCode": "11" },
    { "name": "Hausakpe", "regionCode": "04", "districtCode": "11" },
    { "name": "Hausakpe Junction", "regionCode": "04", "districtCode": "11" },
    { "name": "Havenu", "regionCode": "04", "districtCode": "11" },
    { "name": "Hikpo No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Hikpo No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Hlevi No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Hlevi No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Hlortorto", "regionCode": "04", "districtCode": "11" },
    { "name": "Horlortsukope", "regionCode": "04", "districtCode": "11" },
    { "name": "Hospital Area / Kpogede", "regionCode": "04", "districtCode": "11" },
    { "name": "Kadeve", "regionCode": "04", "districtCode": "11" },
    { "name": "Klotekpo No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Klotekpo No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Kofi Horserperkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Korpedeke", "regionCode": "04", "districtCode": "11" },
    { "name": "Kotoshikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Kpedzeglo Pumping Station", "regionCode": "04", "districtCode": "11" },
    { "name": "Kpelebe", "regionCode": "04", "districtCode": "11" },
    { "name": "Kpenu", "regionCode": "04", "districtCode": "11" },
    { "name": "Kpewu Sodzikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Kpodzadzi No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Kpodzadzi No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Kpontey", "regionCode": "04", "districtCode": "11" },
    { "name": "Kpoviedzi", "regionCode": "04", "districtCode": "11" },
    { "name": "Krepo No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Krepo No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Kudzekope No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Kudzekope No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Kwao Adadekope No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Kwao Adadekope No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Lakpo Dugame", "regionCode": "04", "districtCode": "11" },
    { "name": "Lakpo Tukpatakope", "regionCode": "04", "districtCode": "11" },
    { "name": "Larve", "regionCode": "04", "districtCode": "11" },
    { "name": "Lolito", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Adafe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Adakpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Adalekpoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Adanu", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Adiekpe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Adzasika", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Adzorkoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Adzorkpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Aflavenu", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Aformanukope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Agbakpame", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Agbedrafor", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Agoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Agortorkpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Agorve", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Ahorkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Akyemfo No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Akyemfo No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Alavanyo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Amegakope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Anfoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Asiegborkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Avakpedome No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Avakpedome No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Avikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Avukope No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Avukope No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Dadoboe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi De", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Dekpoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Deveme", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Doviekope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Dzabukpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Dzoglokope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Feda", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Fiekpe No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Fiekpe No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Gagorme", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Gborkope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Gidikpoe No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Gidikpoe No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Kanikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Klukpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Kodogolikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Kosakope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Kpediwlor", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Kpedzeglo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Kpevekor", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Kpokukope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Kumasi", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Kumasi Market", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Kumasi Shts", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Kusrunu", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Kutime", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Liskope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Lokokope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Mangoase", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Mankukope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Mawoekpor", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Mayikpor", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Mediage Junction", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Nkawkaw", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Norgbedzikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Nukpotoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Sasekpe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Seva", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Somekpe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Srekpe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Tedeafenu", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Tordorkpoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Tove", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Tsakpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Tsakpodzi", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Tsati", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Tsawla", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Tsetsekpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Tsrinyikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Vodza", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Waya", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Wudukpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Wudzrolo No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Wudzrolo No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Wukpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Wute", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Yorkutikpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Zakope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Zongo No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Mafi Zongo No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Manklalokope No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Manklalokope No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Mepe Adehorkpodzi", "regionCode": "04", "districtCode": "11" },
    { "name": "Mepe Adidokpoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mepe Adidovenu", "regionCode": "04", "districtCode": "11" },
    { "name": "Mepe Adudornu", "regionCode": "04", "districtCode": "11" },
    { "name": "Mepe Atitete / Godzakope", "regionCode": "04", "districtCode": "11" },
    { "name": "Mepe Dadome", "regionCode": "04", "districtCode": "11" },
    { "name": "Mepe Dagorme", "regionCode": "04", "districtCode": "11" },
    { "name": "Mepe Degorme", "regionCode": "04", "districtCode": "11" },
    { "name": "Mepe Dudevi", "regionCode": "04", "districtCode": "11" },
    { "name": "Mepe Hekpoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mepe Horkpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mepe Workpoe", "regionCode": "04", "districtCode": "11" },
    { "name": "Mepe Zortikpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Mordzekpo", "regionCode": "04", "districtCode": "11" },
    { "name": "My Choice", "regionCode": "04", "districtCode": "11" },
    { "name": "Naval Training Command", "regionCode": "04", "districtCode": "11" },
    { "name": "Naval Training Command No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Naval Training Command No. 3", "regionCode": "04", "districtCode": "11" },
    { "name": "New Bakpa No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "New Bakpa No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "New Kpekpo No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "New Kpekpo No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Nutekpor", "regionCode": "04", "districtCode": "11" },
    { "name": "Nyinuto", "regionCode": "04", "districtCode": "11" },
    { "name": "Okudzeto Farms", "regionCode": "04", "districtCode": "11" },
    { "name": "Rollider", "regionCode": "04", "districtCode": "11" },
    { "name": "Rural Enterprise Program", "regionCode": "04", "districtCode": "11" },
    { "name": "Sahokope", "regionCode": "04", "districtCode": "11" },
    { "name": "Sasekope", "regionCode": "04", "districtCode": "11" },
    { "name": "Sayikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Sbw", "regionCode": "04", "districtCode": "11" },
    { "name": "Sedzikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Selasie Water", "regionCode": "04", "districtCode": "11" },
    { "name": "Sell Farms, Agorhome", "regionCode": "04", "districtCode": "11" },
    { "name": "Sogakope Adb", "regionCode": "04", "districtCode": "11" },
    { "name": "Sogakope District Hospital", "regionCode": "04", "districtCode": "11" },
    { "name": "Sogakope G.C Area / Nafac", "regionCode": "04", "districtCode": "11" },
    { "name": "Sogakope Health Centre", "regionCode": "04", "districtCode": "11" },
    { "name": "Sogakope Newtown", "regionCode": "04", "districtCode": "11" },
    { "name": "Sogakope Stadium", "regionCode": "04", "districtCode": "11" },
    { "name": "Sogakope Toll Booth", "regionCode": "04", "districtCode": "11" },
    { "name": "Sogakope Toyace", "regionCode": "04", "districtCode": "11" },
    { "name": "Sogasco", "regionCode": "04", "districtCode": "11" },
    { "name": "Sokutime", "regionCode": "04", "districtCode": "11" },
    { "name": "Sosukope", "regionCode": "04", "districtCode": "11" },
    { "name": "Soyigbe", "regionCode": "04", "districtCode": "11" },
    { "name": "Spa No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Spa No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "St Catherine Shs", "regionCode": "04", "districtCode": "11" },
    { "name": "Stonekope", "regionCode": "04", "districtCode": "11" },
    { "name": "Suncity Gardens", "regionCode": "04", "districtCode": "11" },
    { "name": "Tadorakope", "regionCode": "04", "districtCode": "11" },
    { "name": "Tedeafenu - Dekpoe Pumping St.", "regionCode": "04", "districtCode": "11" },
    { "name": "Titikope / Husikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Toklokpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Tordzinu", "regionCode": "04", "districtCode": "11" },
    { "name": "Tordzinu Korpedzi", "regionCode": "04", "districtCode": "11" },
    { "name": "Torlesem", "regionCode": "04", "districtCode": "11" },
    { "name": "Torsukpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Torzikpota", "regionCode": "04", "districtCode": "11" },
    { "name": "Total Child International", "regionCode": "04", "districtCode": "11" },
    { "name": "Total Filling Station", "regionCode": "04", "districtCode": "11" },
    { "name": "Totsyoanyi", "regionCode": "04", "districtCode": "11" },
    { "name": "Tove Glime", "regionCode": "04", "districtCode": "11" },
    { "name": "Tsatsukope", "regionCode": "04", "districtCode": "11" },
    { "name": "Tsavanya", "regionCode": "04", "districtCode": "11" },
    { "name": "Tsavanya Newtown", "regionCode": "04", "districtCode": "11" },
    { "name": "Tsawodzikope", "regionCode": "04", "districtCode": "11" },
    { "name": "Tsawoeme", "regionCode": "04", "districtCode": "11" },
    { "name": "Tsinuto", "regionCode": "04", "districtCode": "11" },
    { "name": "Tsivanyokope", "regionCode": "04", "districtCode": "11" },
    { "name": "Tsiveto", "regionCode": "04", "districtCode": "11" },
    { "name": "Unity Gardens", "regionCode": "04", "districtCode": "11" },
    { "name": "Wafa No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Wafa No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Wetor", "regionCode": "04", "districtCode": "11" },
    { "name": "Wlita Kpekpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Wlorto", "regionCode": "04", "districtCode": "11" },
    { "name": "Woyome House", "regionCode": "04", "districtCode": "11" },
    { "name": "Wuxor No. 1", "regionCode": "04", "districtCode": "11" },
    { "name": "Wuxor No. 2", "regionCode": "04", "districtCode": "11" },
    { "name": "Yorkutikpo", "regionCode": "04", "districtCode": "11" },
    { "name": "Yorve", "regionCode": "04", "districtCode": "11" },
    { "name": "Zomayi", "regionCode": "04", "districtCode": "11" },
    { "name": "Zorotodzi", "regionCode": "04", "districtCode": "11" }
  ],
  "04-12": [
    { name: "Abompa Kodjo", regionCode: "04", districtCode: "12" },
    { name: "Abongo Akura", regionCode: "04", districtCode: "12" },
    { name: "Abotareye", regionCode: "04", districtCode: "12" },
    { name: "Abrewankor", regionCode: "04", districtCode: "12" },
    { name: "Adakponu", regionCode: "04", districtCode: "12" },
    { name: "Adiembra No. 1", regionCode: "04", districtCode: "12" },
    { name: "Adiembra No. 2", regionCode: "04", districtCode: "12" },
    { name: "Adokwanta No.2", regionCode: "04", districtCode: "12" },
    { name: "Adumadum", regionCode: "04", districtCode: "12" },
    { name: "Akomapaye", regionCode: "04", districtCode: "12" },
    { name: "Anyabor No. 1", regionCode: "04", districtCode: "12" },
    { name: "Anyabor No.2 No. 1", regionCode: "04", districtCode: "12" },
    { name: "Anyabor No.2 No. 2", regionCode: "04", districtCode: "12" },
    { name: "Anyakapui", regionCode: "04", districtCode: "12" },
    { name: "Asukawkaw", regionCode: "04", districtCode: "12" },
    { name: "Asukawkaw Shs", regionCode: "04", districtCode: "12" },
    { name: "Atigore", regionCode: "04", districtCode: "12" },
    { name: "Ayirafie Battor", regionCode: "04", districtCode: "12" },
    { name: "Ayrimu", regionCode: "04", districtCode: "12" },
    { name: "Azizakpe", regionCode: "04", districtCode: "12" },
    { name: "Bawa Akura", regionCode: "04", districtCode: "12" },
    { name: "Bidi No. 2", regionCode: "04", districtCode: "12" },
    { name: "Bidi No.1", regionCode: "04", districtCode: "12" },
    { name: "Blaki Junction", regionCode: "04", districtCode: "12" },
    { name: "Brabu", regionCode: "04", districtCode: "12" },
    { name: "Cement", regionCode: "04", districtCode: "12" },
    { name: "Chamba Akura", regionCode: "04", districtCode: "12" },
    { name: "City Construction Ltd 1", regionCode: "04", districtCode: "12" },
    { name: "City Construction Ltd 2", regionCode: "04", districtCode: "12" },
    { name: "City Construction Ltd 3", regionCode: "04", districtCode: "12" },
    { name: "Dadeto No. 1", regionCode: "04", districtCode: "12" },
    { name: "Dadeto No. 2", regionCode: "04", districtCode: "12" },
    { name: "Dambai Ecg Office", regionCode: "04", districtCode: "12" },
    { name: "Dambai Police Station", regionCode: "04", districtCode: "12" },
    { name: "Datco", regionCode: "04", districtCode: "12" },
    { name: "Datco Junction", regionCode: "04", districtCode: "12" },
    { name: "Dce's Residence", regionCode: "04", districtCode: "12" },
    { name: "Dorbisu Junction", regionCode: "04", districtCode: "12" },
    { name: "Dormabin", regionCode: "04", districtCode: "12" },
    { name: "Gh Global", regionCode: "04", districtCode: "12" },
    { name: "Graceland, Dambai", regionCode: "04", districtCode: "12" },
    { name: "Health Centre Down", regionCode: "04", districtCode: "12" },
    { name: "Holy Rosary, Tokurano", regionCode: "04", districtCode: "12" },
    { name: "Israel", regionCode: "04", districtCode: "12" },
    { name: "Kanyita Junction", regionCode: "04", districtCode: "12" },
    { name: "Katanga Primary", regionCode: "04", districtCode: "12" },
    { name: "Katanga Quarters", regionCode: "04", districtCode: "12" },
    { name: "Katanga Tornu", regionCode: "04", districtCode: "12" },
    { name: "Katanga Zongo", regionCode: "04", districtCode: "12" },
    { name: "Kelinti", regionCode: "04", districtCode: "12" },
    { name: "Kotokugyane", regionCode: "04", districtCode: "12" },
    { name: "Kpachrie", regionCode: "04", districtCode: "12" },
    { name: "Kpandokope", regionCode: "04", districtCode: "12" },
    { name: "Kparekpare", regionCode: "04", districtCode: "12" },
    { name: "Kparekpare Market", regionCode: "04", districtCode: "12" },
    { name: "Kpelema Da Jhs", regionCode: "04", districtCode: "12" },
    { name: "Kpelema Health Centre", regionCode: "04", districtCode: "12" },
    { name: "Kpelema Town", regionCode: "04", districtCode: "12" },
    { name: "Kplesu", regionCode: "04", districtCode: "12" },
    { name: "Kunda", regionCode: "04", districtCode: "12" },
    { name: "Kunda Junction", regionCode: "04", districtCode: "12" },
    { name: "Kwame Akura", regionCode: "04", districtCode: "12" },
    { name: "Lake Side", regionCode: "04", districtCode: "12" },
    { name: "Madina", regionCode: "04", districtCode: "12" },
    { name: "Matamanu", regionCode: "04", districtCode: "12" },
    { name: "Matamanu Junction", regionCode: "04", districtCode: "12" },
    { name: "Mepekope", regionCode: "04", districtCode: "12" },
    { name: "Monkrate", regionCode: "04", districtCode: "12" },
    { name: "Motorway No.1", regionCode: "04", districtCode: "12" },
    { name: "Motorway No.2", regionCode: "04", districtCode: "12" },
    { name: "Motorway No.3", regionCode: "04", districtCode: "12" },
    { name: "Nantwi Akura", regionCode: "04", districtCode: "12" },
    { name: "New Jerusalem", regionCode: "04", districtCode: "12" },
    { name: "New Junction", regionCode: "04", districtCode: "12" },
    { name: "New Kwame Akura", regionCode: "04", districtCode: "12" },
    { name: "Nwane", regionCode: "04", districtCode: "12" },
    { name: "Ofosu No. 1", regionCode: "04", districtCode: "12" },
    { name: "Ofosu No. 2", regionCode: "04", districtCode: "12" },
    { name: "Okaniase", regionCode: "04", districtCode: "12" },
    { name: "Okumakura", regionCode: "04", districtCode: "12" },
    { name: "Old Town No. 1", regionCode: "04", districtCode: "12" },
    { name: "Old Town No. 2", regionCode: "04", districtCode: "12" },
    { name: "Papaye", regionCode: "04", districtCode: "12" },
    { name: "Peace City 1", regionCode: "04", districtCode: "12" },
    { name: "Peace City 2", regionCode: "04", districtCode: "12" },
    { name: "Pentecost", regionCode: "04", districtCode: "12" },
    { name: "Prince Mark", regionCode: "04", districtCode: "12" },
    { name: "Rc Church", regionCode: "04", districtCode: "12" },
    { name: "Rc Jhs", regionCode: "04", districtCode: "12" },
    { name: "Tapon", regionCode: "04", districtCode: "12" },
    { name: "Tokurano No. 1", regionCode: "04", districtCode: "12" },
    { name: "Tokurano No. 2", regionCode: "04", districtCode: "12" },
    { name: "Tokurano Police Station", regionCode: "04", districtCode: "12" },
    { name: "Tutukpene", regionCode: "04", districtCode: "12" },
    { name: "Wanka Yaw", regionCode: "04", districtCode: "12" },
    { name: "Yabram", regionCode: "04", districtCode: "12" },
    { name: "Yabram Shs", regionCode: "04", districtCode: "12" },
    { name: "Yarega No. 1", regionCode: "04", districtCode: "12" },
    { name: "Yarega No. 2", regionCode: "04", districtCode: "12" },
    { name: "Yeborae", regionCode: "04", districtCode: "12" },
    { name: "Zongo", regionCode: "04", districtCode: "12" },
    { name: "Zongo No.2", regionCode: "04", districtCode: "12" }
  ],

  "06-01": [
    { name: "Aboabo", regionCode: "06", districtCode: "01" },
    { name: "Aboduabo", regionCode: "06", districtCode: "01" },
    { name: "Adiembra", regionCode: "06", districtCode: "01" },
    { name: "Adukroboni", regionCode: "06", districtCode: "01" },
    { name: "Adupri", regionCode: "06", districtCode: "01" },
    { name: "Afipaye No. 2", regionCode: "06", districtCode: "01" },
    { name: "Afipaye No1", regionCode: "06", districtCode: "01" },
    { name: "Afriyiekrom", regionCode: "06", districtCode: "01" },
    { name: "Afume", regionCode: "06", districtCode: "01" },
    { name: "Ahodzo", regionCode: "06", districtCode: "01" },
    { name: "Akantasu", regionCode: "06", districtCode: "01" },
    { name: "Akentensu Nkwanta", regionCode: "06", districtCode: "01" },
    { name: "Amukrom", regionCode: "06", districtCode: "01" },
    { name: "Ananso", regionCode: "06", districtCode: "01" },
    { name: "Apenkrom", regionCode: "06", districtCode: "01" },
    { name: "Appiahkrom", regionCode: "06", districtCode: "01" },
    { name: "Ataaso", regionCode: "06", districtCode: "01" },
    { name: "Attakrom", regionCode: "06", districtCode: "01" },
    { name: "Bayerebon No. 5", regionCode: "06", districtCode: "01" },
    { name: "Bayerebon No.1", regionCode: "06", districtCode: "01" },
    { name: "Bethlehem", regionCode: "06", districtCode: "01" },
    { name: "Bibiani", regionCode: "06", districtCode: "01" },
    { name: "Bibiani Estate", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Abesinsuom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Aboabogya", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Adiembra", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Adienkyen", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Adobewura", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Adu Kroboni", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Adupri", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Afamu", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Agogoso", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Agyeinia", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Akaaso", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Akonkye", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Akota", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Akrabuo Krom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Amangoase", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Anhwiaso", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Aniamoah", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Ankra Muano", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Antwi Agyei Nkwanta", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Anyinamso No.1", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Anyinamso No.2", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Asibe Nkwanta", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Bani Krom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Barimayena", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Basingele", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Bayerebon No. 3", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Besie Krom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Betinko", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Bontumbruso", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Breman", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Califonia", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Chirano", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Chraso Nkwanta", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Compound Bibinai", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Debiso", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Debra", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Debra Krom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Domeabra", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Dominibo", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Donkoto Lineso", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Hwenampori", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Jerusalem", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Kantinkyere", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Kensa Krom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Kensah Krom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Kofihia Krom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Kramokrom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Kuffuor Camp", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Kunkumso", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Kwame Krom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Lineso", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Lineso Junction", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Mampong", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Manukrom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Mmoframfadwen", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Nambro", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, New Compound", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Nframanyo", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Nkrumah", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Nsuontem", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Ntakam", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Nyameyehene", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Nyinahin", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Nyinahin Police Station", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Nyinahin Salem", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Nyinahin Zongo", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Nzema Nkwanta", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Okyeame Krom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Okyere Krom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Otaa Krom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Pataboso", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Saa Krom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Sereso Temponu", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Srebuoso", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Subri", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Subri Nkwanta", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Surano", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Takoradi", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Tanoso", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Tenewohoye", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Wenchi", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Yaw Barima Krom", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Dominibo No. 1", regionCode: "06", districtCode: "01" },
    { name: "Bibiani, Dominibo No. 2", regionCode: "06", districtCode: "01" },
    { name: "Bobiekrom", regionCode: "06", districtCode: "01" },
    { name: "Dodowa Bayerebon", regionCode: "06", districtCode: "01" },
    { name: "Dodwa Beposo", regionCode: "06", districtCode: "01" },
    { name: "Dommebo 1", regionCode: "06", districtCode: "01" },
    { name: "Dzedi", regionCode: "06", districtCode: "01" },
    { name: "Estate", regionCode: "06", districtCode: "01" },
    { name: "Gyebi", regionCode: "06", districtCode: "01" },
    { name: "Hemang", regionCode: "06", districtCode: "01" },
    { name: "Kaktire-Nyamebekye", regionCode: "06", districtCode: "01" },
    { name: "Kantin Kyereng", regionCode: "06", districtCode: "01" },
    { name: "Kofinyamekrom", regionCode: "06", districtCode: "01" },
    { name: "Kokobiriko", regionCode: "06", districtCode: "01" },
    { name: "Kwadwo Fordjourkrom", regionCode: "06", districtCode: "01" },
    { name: "Kwakuadai", regionCode: "06", districtCode: "01" },
    { name: "Kwantifi", regionCode: "06", districtCode: "01" },
    { name: "Kwaso", regionCode: "06", districtCode: "01" },
    { name: "Kyikyiwere", regionCode: "06", districtCode: "01" },
    { name: "Kyiribaa", regionCode: "06", districtCode: "01" },
    { name: "Mantukwa", regionCode: "06", districtCode: "01" },
    { name: "Mframakrom", regionCode: "06", districtCode: "01" },
    { name: "Morta", regionCode: "06", districtCode: "01" },
    { name: "Mpandwe", regionCode: "06", districtCode: "01" },
    { name: "Nagole Owusukrom", regionCode: "06", districtCode: "01" },
    { name: "Nam Buro", regionCode: "06", districtCode: "01" },
    { name: "Nantwikumye", regionCode: "06", districtCode: "01" },
    { name: "New Town", regionCode: "06", districtCode: "01" },
    { name: "Nkwaseatang-Bentekrom", regionCode: "06", districtCode: "01" },
    { name: "Nkyemkyemso", regionCode: "06", districtCode: "01" },
    { name: "Ntobroso", regionCode: "06", districtCode: "01" },
    { name: "Nwirem", regionCode: "06", districtCode: "01" },
    { name: "Nyamebekyere", regionCode: "06", districtCode: "01" },
    { name: "Nzimankwanta", regionCode: "06", districtCode: "01" },
    { name: "Obuasikrom", regionCode: "06", districtCode: "01" },
    { name: "Oforikrom", regionCode: "06", districtCode: "01" },
    { name: "Ohiampenika", regionCode: "06", districtCode: "01" }
  ],
  "06-04": [
    { name: "Abotanso", regionCode: "06", districtCode: "04" },
    { name: "Abrepo", regionCode: "06", districtCode: "04" },
    { name: "Abrepo, Equator", regionCode: "06", districtCode: "04" },
    { name: "Abrepo, Nana Aboagye Dacosta", regionCode: "06", districtCode: "04" },
    { name: "Abrepo, Pentecost Sch", regionCode: "06", districtCode: "04" },
    { name: "Abuohia", regionCode: "06", districtCode: "04" },
    { name: "Abuohia, Otumfuo", regionCode: "06", districtCode: "04" },
    { name: "Abusua", regionCode: "06", districtCode: "04" },
    { name: "Achiase", regionCode: "06", districtCode: "04" },
    { name: "Achiase, Nketia", regionCode: "06", districtCode: "04" },
    { name: "Adankwame", regionCode: "06", districtCode: "04" },
    { name: "Adomanu", regionCode: "06", districtCode: "04" },
    { name: "Afrancho Bronkong", regionCode: "06", districtCode: "04" },
    { name: "Akrofo Korkoben", regionCode: "06", districtCode: "04" },
    { name: "Akusu", regionCode: "06", districtCode: "04" },
    { name: "Amanfrom", regionCode: "06", districtCode: "04" },
    { name: "Amoaman", regionCode: "06", districtCode: "04" },
    { name: "Ampabame", regionCode: "06", districtCode: "04" },
    { name: "Anomangye", regionCode: "06", districtCode: "04" },
    { name: "Anomangye, Pentecost Ch", regionCode: "06", districtCode: "04" },
    { name: "Anomangye, Pole Ase", regionCode: "06", districtCode: "04" },
    { name: "Anomangye, Sda Church", regionCode: "06", districtCode: "04" },
    { name: "Anoo", regionCode: "06", districtCode: "04" },
    { name: "Anwomaso", regionCode: "06", districtCode: "04" },
    { name: "Asamang", regionCode: "06", districtCode: "04" },
    { name: "Asubonteng", regionCode: "06", districtCode: "04" },
    { name: "Asuofia", regionCode: "06", districtCode: "04" },
    { name: "Asuofia-Hwidiem", regionCode: "06", districtCode: "04" },
    { name: "Asuoyeboa", regionCode: "06", districtCode: "04" },
    { name: "Atafoa", regionCode: "06", districtCode: "04" },
    { name: "Atasomanso", regionCode: "06", districtCode: "04" },
    { name: "Atonsu, Kuwait", regionCode: "06", districtCode: "04" },
    { name: "Bantama", regionCode: "06", districtCode: "04" },
    { name: "Bantama, Bonsam Gyamu", regionCode: "06", districtCode: "04" },
    { name: "Bantama, Race Course", regionCode: "06", districtCode: "04" },
    { name: "Bohyen", regionCode: "06", districtCode: "04" },
    { name: "Bohyen, Ampabame", regionCode: "06", districtCode: "04" },
    { name: "Bohyen, Ampabame Jhs", regionCode: "06", districtCode: "04" },
    { name: "Bohyen, Anomangye", regionCode: "06", districtCode: "04" },
    { name: "Bohyen, Asuogya", regionCode: "06", districtCode: "04" },
    { name: "Bohyen, Pentecost Church", regionCode: "06", districtCode: "04" },
    { name: "Bohyen, Pole \"Ase\"", regionCode: "06", districtCode: "04" },
    { name: "Bohyen, St. George's Sch", regionCode: "06", districtCode: "04" },
    { name: "Bosie", regionCode: "06", districtCode: "04" },
    { name: "Botantia", regionCode: "06", districtCode: "04" },
    { name: "Bremang", regionCode: "06", districtCode: "04" },
    { name: "Bremang New York", regionCode: "06", districtCode: "04" },
    { name: "Bremang, Bethel Sch", regionCode: "06", districtCode: "04" },
    { name: "Bremang, Cath. Church", regionCode: "06", districtCode: "04" },
    { name: "Bremang, I. R. S.", regionCode: "06", districtCode: "04" },
    { name: "Bremang, Kingdom Hall", regionCode: "06", districtCode: "04" },
    { name: "Bremang, Kwasi Oppong Shs", regionCode: "06", districtCode: "04" },
    { name: "Bremang, M/A Basic Sch", regionCode: "06", districtCode: "04" },
    { name: "Bremang, Nana Owusu Ansah", regionCode: "06", districtCode: "04" },
    { name: "Bremang, New Road", regionCode: "06", districtCode: "04" },
    { name: "Bremang, Old Town", regionCode: "06", districtCode: "04" },
    { name: "Bremang, Opp. Okess Shs", regionCode: "06", districtCode: "04" },
    { name: "Bremang, Sda Sch", regionCode: "06", districtCode: "04" },
    { name: "Bremang, Ugc", regionCode: "06", districtCode: "04" },
    { name: "Bronkong", regionCode: "06", districtCode: "04" },
    { name: "Bronkong, New Site", regionCode: "06", districtCode: "04" },
    { name: "Buoho", regionCode: "06", districtCode: "04" },
    { name: "Esaso", regionCode: "06", districtCode: "04" },
    { name: "Hemang N.V.T.I", regionCode: "06", districtCode: "04" },
    { name: "Hemang, Buoho", regionCode: "06", districtCode: "04" },
    { name: "Hwidiem", regionCode: "06", districtCode: "04" },
    { name: "Kokoben", regionCode: "06", districtCode: "04" },
    { name: "Kokoso", regionCode: "06", districtCode: "04" },
    { name: "Kronum", regionCode: "06", districtCode: "04" },
    { name: "Kwapra", regionCode: "06", districtCode: "04" },
    { name: "Kwapra New Site No. 1", regionCode: "06", districtCode: "04" },
    { name: "Kwapra New Site No. 2", regionCode: "06", districtCode: "04" },
    { name: "Kwapra New Site No. 3", regionCode: "06", districtCode: "04" },
    { name: "Kwapra New Site No. 6", regionCode: "06", districtCode: "04" },
    { name: "Kwapra New Site No. 7", regionCode: "06", districtCode: "04" },
    { name: "Kwapra New Site No. 8", regionCode: "06", districtCode: "04" },
    { name: "Kwapra New Site No. 9", regionCode: "06", districtCode: "04" },
    { name: "Kyerase", regionCode: "06", districtCode: "04" },
    { name: "Kyerase, Gina Spot", regionCode: "06", districtCode: "04" },
    { name: "Maakro", regionCode: "06", districtCode: "04" },
    { name: "Maakro, Break Down", regionCode: "06", districtCode: "04" },
    { name: "Maakro, Chopi Chopi", regionCode: "06", districtCode: "04" },
    { name: "Maakro, Gh. Comm. Bank", regionCode: "06", districtCode: "04" },
    { name: "Maakro, Islamic School", regionCode: "06", districtCode: "04" },
    { name: "Maakro, Market", regionCode: "06", districtCode: "04" },
    { name: "Maakro, Opp. Division Sch", regionCode: "06", districtCode: "04" },
    { name: "Maakro, Post Office", regionCode: "06", districtCode: "04" },
    { name: "Maakro, Presby Church", regionCode: "06", districtCode: "04" },
    { name: "Maakro, Top Hill Hotel", regionCode: "06", districtCode: "04" },
    { name: "Maakro, Truck Welders", regionCode: "06", districtCode: "04" },
    { name: "Magazine Garages", regionCode: "06", districtCode: "04" },
    { name: "Magazine Garages, Zone 13", regionCode: "06", districtCode: "04" },
    { name: "New Kyekyere", regionCode: "06", districtCode: "04" },
    { name: "New Suame", regionCode: "06", districtCode: "04" },
    { name: "Nketia New Site", regionCode: "06", districtCode: "04" },
    { name: "North Suntreso", regionCode: "06", districtCode: "04" },
    { name: "Ntiri Buoho", regionCode: "06", districtCode: "04" },
    { name: "Nyakyerenase", regionCode: "06", districtCode: "04" },
    { name: "Ohwim", regionCode: "06", districtCode: "04" },
    { name: "Ohwim Hweideim", regionCode: "06", districtCode: "04" },
    { name: "Old Suame, Angel Fm", regionCode: "06", districtCode: "04" },
    { name: "Old Suame, Islamic School", regionCode: "06", districtCode: "04" },
    { name: "Old Suame, Kotoko", regionCode: "06", districtCode: "04" },
    { name: "Old Suame, Opp. Comm. Bank", regionCode: "06", districtCode: "04" },
    { name: "Old Suame, Police Station", regionCode: "06", districtCode: "04" },
    { name: "Old Suame, Shell Filling Station", regionCode: "06", districtCode: "04" },
    { name: "Old Suame, Ship House", regionCode: "06", districtCode: "04" },
    { name: "Old Suame, State Girls Jhs", regionCode: "06", districtCode: "04" },
    { name: "Prempeh Basic Sch", regionCode: "06", districtCode: "04" },
    { name: "Prempeh College", regionCode: "06", districtCode: "04" },
    { name: "Race Course", regionCode: "06", districtCode: "04" },
    { name: "Santasi", regionCode: "06", districtCode: "04" },
    { name: "Sokoban", regionCode: "06", districtCode: "04" },
    { name: "Suame", regionCode: "06", districtCode: "04" },
    { name: "Suame Magazine", regionCode: "06", districtCode: "04" },
    { name: "Suame, Farm Yard Hotel", regionCode: "06", districtCode: "04" },
    { name: "Suame, Sub Metro", regionCode: "06", districtCode: "04" },
    { name: "Tarkwa", regionCode: "06", districtCode: "04" },
    { name: "Tijira", regionCode: "06", districtCode: "04" }
  ],
  "06-05": [
    { name: "Abinkyi Market", regionCode: "06", districtCode: "05" },
    { name: "Aboabokese", regionCode: "06", districtCode: "05" },
    { name: "Aburaso", regionCode: "06", districtCode: "05" },
    { name: "Adambrobe", regionCode: "06", districtCode: "05" },
    { name: "Adiebeba", regionCode: "06", districtCode: "05" },
    { name: "Adiebeba, Adiembra", regionCode: "06", districtCode: "05" },
    { name: "Adum", regionCode: "06", districtCode: "05" },
    { name: "Adum Railways", regionCode: "06", districtCode: "05" },
    { name: "Adum/Kejetia", regionCode: "06", districtCode: "05" },
    { name: "Adum/Ridge", regionCode: "06", districtCode: "05" },
    { name: "Adumasa", regionCode: "06", districtCode: "05" },
    { name: "Adumase", regionCode: "06", districtCode: "05" },
    { name: "Adwaase", regionCode: "06", districtCode: "05" },
    { name: "Afrancho, Odumasi", regionCode: "06", districtCode: "05" },
    { name: "Afratia", regionCode: "06", districtCode: "05" },
    { name: "Agogo", regionCode: "06", districtCode: "05" },
    { name: "Ahinsan, Angola", regionCode: "06", districtCode: "05" },
    { name: "Ahodwo", regionCode: "06", districtCode: "05" },
    { name: "Ahodwo, Adiembra", regionCode: "06", districtCode: "05" },
    { name: "Akyeremade", regionCode: "06", districtCode: "05" },
    { name: "Ampabame #1, New Site", regionCode: "06", districtCode: "05" },
    { name: "Ampabame #1, Old Town", regionCode: "06", districtCode: "05" },
    { name: "Ampabame #2", regionCode: "06", districtCode: "05" },
    { name: "Ampabame No 1", regionCode: "06", districtCode: "05" },
    { name: "Ampatia", regionCode: "06", districtCode: "05" },
    { name: "Ampatia /Kokoben", regionCode: "06", districtCode: "05" },
    { name: "Ampayoo", regionCode: "06", districtCode: "05" },
    { name: "Anyinam, New Site", regionCode: "06", districtCode: "05" },
    { name: "Apaaso", regionCode: "06", districtCode: "05" },
    { name: "Apampatia", regionCode: "06", districtCode: "05" },
    { name: "Apire", regionCode: "06", districtCode: "05" },
    { name: "Apramang, New Site", regionCode: "06", districtCode: "05" },
    { name: "Asaago", regionCode: "06", districtCode: "05" },
    { name: "Asafo", regionCode: "06", districtCode: "05" },
    { name: "Asuoyeboah", regionCode: "06", districtCode: "05" },
    { name: "Atasomanso", regionCode: "06", districtCode: "05" },
    { name: "Atonsu", regionCode: "06", districtCode: "05" },
    { name: "Atonsu, Aprabo", regionCode: "06", districtCode: "05" },
    { name: "Atonsu, Dompoase", regionCode: "06", districtCode: "05" },
    { name: "Atonsu, Fabi", regionCode: "06", districtCode: "05" },
    { name: "Atonsu, Kuwait", regionCode: "06", districtCode: "05" },
    { name: "Atonsu, S-Line", regionCode: "06", districtCode: "05" },
    { name: "Bantama", regionCode: "06", districtCode: "05" },
    { name: "Bebu", regionCode: "06", districtCode: "05" },
    { name: "Bekwame", regionCode: "06", districtCode: "05" },
    { name: "Brofoyedu", regionCode: "06", districtCode: "05" },
    { name: "Daban", regionCode: "06", districtCode: "05" },
    { name: "Daban, New Site", regionCode: "06", districtCode: "05" },
    { name: "Daban, Patuda", regionCode: "06", districtCode: "05" },
    { name: "Dakodwom", regionCode: "06", districtCode: "05" },
    { name: "Danyame Business Centre", regionCode: "06", districtCode: "05" },
    { name: "Darko", regionCode: "06", districtCode: "05" },
    { name: "Fankenebra", regionCode: "06", districtCode: "05" },
    { name: "Heman New Site", regionCode: "06", districtCode: "05" },
    { name: "Hemang", regionCode: "06", districtCode: "05" },
    { name: "Kaase", regionCode: "06", districtCode: "05" },
    { name: "Kaase, Stp", regionCode: "06", districtCode: "05" },
    { name: "Kegyase", regionCode: "06", districtCode: "05" },
    { name: "Kokoben", regionCode: "06", districtCode: "05" },
    { name: "Konkromoase", regionCode: "06", districtCode: "05" },
    { name: "Konkromoase, New Site", regionCode: "06", districtCode: "05" },
    { name: "Krofrom", regionCode: "06", districtCode: "05" },
    { name: "Kromoase", regionCode: "06", districtCode: "05" },
    { name: "Kwadaso Agric", regionCode: "06", districtCode: "05" },
    { name: "Kwadaso Edwenase", regionCode: "06", districtCode: "05" },
    { name: "Kwadaso Estate", regionCode: "06", districtCode: "05" },
    { name: "Kwadaso Estate,Sofoline", regionCode: "06", districtCode: "05" },
    { name: "Kwadaso Market", regionCode: "06", districtCode: "05" },
    { name: "Kwadaso Peters", regionCode: "06", districtCode: "05" },
    { name: "Kwanwoma", regionCode: "06", districtCode: "05" },
    { name: "Manso-Nkwanta", regionCode: "06", districtCode: "05" },
    { name: "Nhiaeso", regionCode: "06", districtCode: "05" },
    { name: "Nwamase", regionCode: "06", districtCode: "05" },
    { name: "Odeneho Kwadaso", regionCode: "06", districtCode: "05" },
    { name: "Odeneho Kwadaso, Owass", regionCode: "06", districtCode: "05" },
    { name: "Old Asokwa", regionCode: "06", districtCode: "05" },
    { name: "Pakyi #1", regionCode: "06", districtCode: "05" },
    { name: "Pakyi #2", regionCode: "06", districtCode: "05" },
    { name: "Patasi", regionCode: "06", districtCode: "05" },
    { name: "Sabin Kroffrom", regionCode: "06", districtCode: "05" },
    { name: "Santasi", regionCode: "06", districtCode: "05" },
    { name: "Santasi, Aboaso", regionCode: "06", districtCode: "05" },
    { name: "Santasi, Kegyase", regionCode: "06", districtCode: "05" },
    { name: "Santasi, New Site", regionCode: "06", districtCode: "05" },
    { name: "Santasi, St. Hubert", regionCode: "06", districtCode: "05" },
    { name: "Sogakope", regionCode: "06", districtCode: "05" },
    { name: "Sokoban", regionCode: "06", districtCode: "05" },
    { name: "Sokoban, Ahodwo", regionCode: "06", districtCode: "05" },
    { name: "Sokoban, Near Wood Village", regionCode: "06", districtCode: "05" },
    { name: "Sokoban, Wood Village", regionCode: "06", districtCode: "05" },
    { name: "South Suntreso", regionCode: "06", districtCode: "05" },
    { name: "Trede", regionCode: "06", districtCode: "05" },
    { name: "TUC", regionCode: "06", districtCode: "05" }
  ],
  "06-06": [
    { name: "Abakomade", regionCode: "06", districtCode: "06" },
    { name: "Abease", regionCode: "06", districtCode: "06" },
    { name: "Abk Bapt Seminar", regionCode: "06", districtCode: "06" },
    { name: "Aboaboso", regionCode: "06", districtCode: "06" },
    { name: "Abodom-Dome", regionCode: "06", districtCode: "06" },
    { name: "Abore", regionCode: "06", districtCode: "06" },
    { name: "Abuakwa", regionCode: "06", districtCode: "06" },
    { name: "Abuakwa Mkt", regionCode: "06", districtCode: "06" },
    { name: "Abuakwa/Podass", regionCode: "06", districtCode: "06" },
    { name: "Abuoso", regionCode: "06", districtCode: "06" },
    { name: "Adankwame", regionCode: "06", districtCode: "06" },
    { name: "Adugyama", regionCode: "06", districtCode: "06" },
    { name: "Adwaase", regionCode: "06", districtCode: "06" },
    { name: "Afasiebon New Site", regionCode: "06", districtCode: "06" },
    { name: "Afrancho, Odumasi", regionCode: "06", districtCode: "06" },
    { name: "Afraso", regionCode: "06", districtCode: "06" },
    { name: "Agogo", regionCode: "06", districtCode: "06" },
    { name: "Agric", regionCode: "06", districtCode: "06" },
    { name: "Akrofrom", regionCode: "06", districtCode: "06" },
    { name: "Akurufoforom", regionCode: "06", districtCode: "06" },
    { name: "Akye Agogo", regionCode: "06", districtCode: "06" },
    { name: "Akyeiso", regionCode: "06", districtCode: "06" },
    { name: "Akyeremade", regionCode: "06", districtCode: "06" },
    { name: "Akyeremase", regionCode: "06", districtCode: "06" },
    { name: "Amoaben", regionCode: "06", districtCode: "06" },
    { name: "Antoakrom", regionCode: "06", districtCode: "06" },
    { name: "Anyinam, New Site", regionCode: "06", districtCode: "06" },
    { name: "Anyinasosu", regionCode: "06", districtCode: "06" },
    { name: "Apaasi", regionCode: "06", districtCode: "06" },
    { name: "Apatrapa", regionCode: "06", districtCode: "06" },
    { name: "Apemanim", regionCode: "06", districtCode: "06" },
    { name: "Asakraka", regionCode: "06", districtCode: "06" },
    { name: "Asaman", regionCode: "06", districtCode: "06" },
    { name: "Asenemaso", regionCode: "06", districtCode: "06" },
    { name: "Asuoyeboa North", regionCode: "06", districtCode: "06" },
    { name: "Asuoyeboh", regionCode: "06", districtCode: "06" },
    { name: "Atasomanso", regionCode: "06", districtCode: "06" },
    { name: "Atobrakrom", regionCode: "06", districtCode: "06" },
    { name: "Atonsu, Kuwait", regionCode: "06", districtCode: "06" },
    { name: "Atuntuma", regionCode: "06", districtCode: "06" },
    { name: "Atwere", regionCode: "06", districtCode: "06" },
    { name: "Atwima", regionCode: "06", districtCode: "06" },
    { name: "Atwima Agogo", regionCode: "06", districtCode: "06" },
    { name: "Atwima Yabi", regionCode: "06", districtCode: "06" },
    { name: "Atwima-Mim", regionCode: "06", districtCode: "06" },
    { name: "Ayerebikrom", regionCode: "06", districtCode: "06" },
    { name: "Bebuabowu", regionCode: "06", districtCode: "06" },
    { name: "Behenase", regionCode: "06", districtCode: "06" },
    { name: "Besease Kaniago", regionCode: "06", districtCode: "06" },
    { name: "Bodwesango", regionCode: "06", districtCode: "06" },
    { name: "Bokankye", regionCode: "06", districtCode: "06" },
    { name: "Boko", regionCode: "06", districtCode: "06" },
    { name: "Boko Topreso", regionCode: "06", districtCode: "06" },
    { name: "Bonteso", regionCode: "06", districtCode: "06" },
    { name: "Dabaa", regionCode: "06", districtCode: "06" },
    { name: "Dadease", regionCode: "06", districtCode: "06" },
    { name: "Denkyemuoso", regionCode: "06", districtCode: "06" },
    { name: "Dida", regionCode: "06", districtCode: "06" },
    { name: "Dome", regionCode: "06", districtCode: "06" },
    { name: "Ehwimase", regionCode: "06", districtCode: "06" },
    { name: "Esaase", regionCode: "06", districtCode: "06" },
    { name: "Fankenebra", regionCode: "06", districtCode: "06" },
    { name: "Foase", regionCode: "06", districtCode: "06" },
    { name: "Gyaduako", regionCode: "06", districtCode: "06" },
    { name: "Gyekye", regionCode: "06", districtCode: "06" },
    { name: "Gyenanso", regionCode: "06", districtCode: "06" },
    { name: "Hemang Buoho", regionCode: "06", districtCode: "06" },
    { name: "Hiawu Besease", regionCode: "06", districtCode: "06" },
    { name: "I P T", regionCode: "06", districtCode: "06" },
    { name: "Kapro", regionCode: "06", districtCode: "06" },
    { name: "Kegyase Estate", regionCode: "06", districtCode: "06" },
    { name: "Keniago", regionCode: "06", districtCode: "06" },
    { name: "Kobeng Nkonteng", regionCode: "06", districtCode: "06" },
    { name: "Kodadwene", regionCode: "06", districtCode: "06" },
    { name: "Koforidua", regionCode: "06", districtCode: "06" },
    { name: "Kokoben", regionCode: "06", districtCode: "06" },
    { name: "Kokobeng", regionCode: "06", districtCode: "06" },
    { name: "Koniesi Nkran", regionCode: "06", districtCode: "06" },
    { name: "Koninase", regionCode: "06", districtCode: "06" },
    { name: "Kromoase", regionCode: "06", districtCode: "06" },
    { name: "Kumpese", regionCode: "06", districtCode: "06" },
    { name: "Kunsu", regionCode: "06", districtCode: "06" },
    { name: "Kwabenaso", regionCode: "06", districtCode: "06" },
    { name: "Kwabenya Abowum Junction", regionCode: "06", districtCode: "06" },
    { name: "Kwadaso", regionCode: "06", districtCode: "06" },
    { name: "Kwadaso Agric", regionCode: "06", districtCode: "06" },
    { name: "Kwadaso Edwenase", regionCode: "06", districtCode: "06" },
    { name: "Kwadaso Market", regionCode: "06", districtCode: "06" },
    { name: "Kwadaso North", regionCode: "06", districtCode: "06" },
    { name: "Kwadaso Nsuom", regionCode: "06", districtCode: "06" },
    { name: "Kwadaso Peters", regionCode: "06", districtCode: "06" },
    { name: "Kwadaso Sda", regionCode: "06", districtCode: "06" },
    { name: "Kwakukrom", regionCode: "06", districtCode: "06" },
    { name: "Kwanwoma", regionCode: "06", districtCode: "06" },
    { name: "Kwapra", regionCode: "06", districtCode: "06" },
    { name: "Kwawoma", regionCode: "06", districtCode: "06" },
    { name: "Maakro", regionCode: "06", districtCode: "06" },
    { name: "Manhyia", regionCode: "06", districtCode: "06" },
    { name: "Mankranso", regionCode: "06", districtCode: "06" },
    { name: "Manso", regionCode: "06", districtCode: "06" },
    { name: "Manso Abodam", regionCode: "06", districtCode: "06" },
    { name: "Manso Abodam Dome", regionCode: "06", districtCode: "06" },
    { name: "Manso Abore", regionCode: "06", districtCode: "06" },
    { name: "Manso Area", regionCode: "06", districtCode: "06" },
    { name: "Manso Atwere", regionCode: "06", districtCode: "06" },
    { name: "Manso Krofrom", regionCode: "06", districtCode: "06" },
    { name: "Manso Mim", regionCode: "06", districtCode: "06" },
    { name: "Manso Odaso", regionCode: "06", districtCode: "06" },
    { name: "Manso Yawkrom", regionCode: "06", districtCode: "06" },
    { name: "Manso-Asuadei", regionCode: "06", districtCode: "06" },
    { name: "Manso-Edubia", regionCode: "06", districtCode: "06" },
    { name: "Manso-Nkwanta", regionCode: "06", districtCode: "06" },
    { name: "Mfensi", regionCode: "06", districtCode: "06" },
    { name: "Mpasatia", regionCode: "06", districtCode: "06" },
    { name: "Mpatuam", regionCode: "06", districtCode: "06" },
    { name: "Mpraniase", regionCode: "06", districtCode: "06" },
    { name: "Mwineso", regionCode: "06", districtCode: "06" },
    { name: "Nhyiaeso", regionCode: "06", districtCode: "06" },
    { name: "Nkakom", regionCode: "06", districtCode: "06" },
    { name: "Nkawie", regionCode: "06", districtCode: "06" },
    { name: "Nketia", regionCode: "06", districtCode: "06" },
    { name: "Nkontine", regionCode: "06", districtCode: "06" },
    { name: "Nkran Kaniase", regionCode: "06", districtCode: "06" },
    { name: "Nkrontomire", regionCode: "06", districtCode: "06" },
    { name: "Ntensere", regionCode: "06", districtCode: "06" },
    { name: "Nweneso(Odaho)", regionCode: "06", districtCode: "06" },
    { name: "Nyadieya", regionCode: "06", districtCode: "06" },
    { name: "Nyakumase", regionCode: "06", districtCode: "06" },
    { name: "Nyankyrernese", regionCode: "06", districtCode: "06" },
    { name: "Nzima", regionCode: "06", districtCode: "06" },
    { name: "Odaho", regionCode: "06", districtCode: "06" },
    { name: "Ohwimase", regionCode: "06", districtCode: "06" },
    { name: "Pasoro", regionCode: "06", districtCode: "06" },
    { name: "Pokukrom", regionCode: "06", districtCode: "06" },
    { name: "Potrikrom", regionCode: "06", districtCode: "06" },
    { name: "Sarfokrom", regionCode: "06", districtCode: "06" },
    { name: "Seidi", regionCode: "06", districtCode: "06" },
    { name: "Sepaase", regionCode: "06", districtCode: "06" },
    { name: "Sepaase Adwafo", regionCode: "06", districtCode: "06" },
    { name: "Snnit Flat", regionCode: "06", districtCode: "06" },
    { name: "Sofoline", regionCode: "06", districtCode: "06" },
    { name: "Sokoban", regionCode: "06", districtCode: "06" },
    { name: "Suntreso", regionCode: "06", districtCode: "06" },
    { name: "Tabere", regionCode: "06", districtCode: "06" },
    { name: "Takorase", regionCode: "06", districtCode: "06" },
    { name: "Takyiman", regionCode: "06", districtCode: "06" },
    { name: "Tanoso", regionCode: "06", districtCode: "06" },
    { name: "Tanoso Apatrapa", regionCode: "06", districtCode: "06" },
    { name: "Tetrem", regionCode: "06", districtCode: "06" },
    { name: "Tewdie", regionCode: "06", districtCode: "06" },
    { name: "Toase", regionCode: "06", districtCode: "06" },
    { name: "Topreso", regionCode: "06", districtCode: "06" },
    { name: "Trabuom", regionCode: "06", districtCode: "06" },
    { name: "U- EWK", regionCode: "06", districtCode: "06" },
    { name: "Undefined Area Abuakwa", regionCode: "06", districtCode: "06" },
    { name: "Wahaso", regionCode: "06", districtCode: "06" },
    { name: "Wiaso", regionCode: "06", districtCode: "06" },
    { name: "Wonipaniadue", regionCode: "06", districtCode: "06" },
    { name: "Wonipanimadue", regionCode: "06", districtCode: "06" },
    { name: "Yabi", regionCode: "06", districtCode: "06" }
  ],
  "06-07": [
    { name: "Abira", regionCode: "06", districtCode: "07" },
    { name: "Aduamoa", regionCode: "06", districtCode: "07" },
    { name: "Aduman", regionCode: "06", districtCode: "07" },
    { name: "Agyaako Buohu", regionCode: "06", districtCode: "07" },
    { name: "Agyeimprah", regionCode: "06", districtCode: "07" },
    { name: "Ahenkro", regionCode: "06", districtCode: "07" },
    { name: "Akom", regionCode: "06", districtCode: "07" },
    { name: "Akrofrom", regionCode: "06", districtCode: "07" },
    { name: "Akrowa", regionCode: "06", districtCode: "07" },
    { name: "Amowie", regionCode: "06", districtCode: "07" },
    { name: "Ampabame", regionCode: "06", districtCode: "07" },
    { name: "Anninkroma", regionCode: "06", districtCode: "07" },
    { name: "Antoa", regionCode: "06", districtCode: "07" },
    { name: "Anyankaso", regionCode: "06", districtCode: "07" },
    { name: "Anyankaso/Boasi", regionCode: "06", districtCode: "07" },
    { name: "Anyinasuso", regionCode: "06", districtCode: "07" },
    { name: "Apegya", regionCode: "06", districtCode: "07" },
    { name: "Asmankama", regionCode: "06", districtCode: "07" },
    { name: "Atrama", regionCode: "06", districtCode: "07" },
    { name: "Ayensua", regionCode: "06", districtCode: "07" },
    { name: "Ayensua Kokor", regionCode: "06", districtCode: "07" },
    { name: "Barekese", regionCode: "06", districtCode: "07" },
    { name: "Barekuma", regionCode: "06", districtCode: "07" },
    { name: "Boaman", regionCode: "06", districtCode: "07" },
    { name: "Boamang Kyerekrom", regionCode: "06", districtCode: "07" },
    { name: "Boamang, Abroma", regionCode: "06", districtCode: "07" },
    { name: "Boamang, Adukro", regionCode: "06", districtCode: "07" },
    { name: "Boamang, Soko", regionCode: "06", districtCode: "07" },
    { name: "Bodwesango", regionCode: "06", districtCode: "07" },
    { name: "Bomso", regionCode: "06", districtCode: "07" },
    { name: "Bonsu", regionCode: "06", districtCode: "07" },
    { name: "Brofoyedru", regionCode: "06", districtCode: "07" },
    { name: "Buohu", regionCode: "06", districtCode: "07" },
    { name: "Buohu Atrama", regionCode: "06", districtCode: "07" },
    { name: "Buohu Bomso", regionCode: "06", districtCode: "07" },
    { name: "Buohu Sasa", regionCode: "06", districtCode: "07" },
    { name: "Denase", regionCode: "06", districtCode: "07" },
    { name: "Dentin", regionCode: "06", districtCode: "07" },
    { name: "Dome", regionCode: "06", districtCode: "07" },
    { name: "Esaase", regionCode: "06", districtCode: "07" },
    { name: "Fufuo", regionCode: "06", districtCode: "07" },
    { name: "Kayira", regionCode: "06", districtCode: "07" },
    { name: "Kodie", regionCode: "06", districtCode: "07" },
    { name: "Kodie Akrofrom", regionCode: "06", districtCode: "07" },
    { name: "Kodie/Akrowa", regionCode: "06", districtCode: "07" },
    { name: "Kokote", regionCode: "06", districtCode: "07" },
    { name: "Kumi", regionCode: "06", districtCode: "07" },
    { name: "Kwamang", regionCode: "06", districtCode: "07" },
    { name: "Maaban", regionCode: "06", districtCode: "07" },
    { name: "Maasi", regionCode: "06", districtCode: "07" },
    { name: "Mowire", regionCode: "06", districtCode: "07" },
    { name: "Mowire Habitat", regionCode: "06", districtCode: "07" },
    { name: "Mpehim", regionCode: "06", districtCode: "07" },
    { name: "New Offinso", regionCode: "06", districtCode: "07" },
    { name: "New Town", regionCode: "06", districtCode: "07" },
    { name: "Nkwantakese", regionCode: "06", districtCode: "07" },
    { name: "Wawase", regionCode: "06", districtCode: "07" },
    { name: "Undefined Area Suame", regionCode: "06", districtCode: "07" },
    { name: "Undefined Area Offinso", regionCode: "06", districtCode: "07" },
    { name: "Twemasen", regionCode: "06", districtCode: "07" },
    { name: "Tetrem", regionCode: "06", districtCode: "07" },
    { name: "Soko", regionCode: "06", districtCode: "07" },
    { name: "Sasa-Bomso", regionCode: "06", districtCode: "07" },
    { name: "Sasa", regionCode: "06", districtCode: "07" },
    { name: "Sakamukrom", regionCode: "06", districtCode: "07" },
    { name: "Saaboa", regionCode: "06", districtCode: "07" },
    { name: "Penteng", regionCode: "06", districtCode: "07" },
    { name: "Patase", regionCode: "06", districtCode: "07" },
    { name: "Pampata", regionCode: "06", districtCode: "07" },
    { name: "Old Town", regionCode: "06", districtCode: "07" },
    { name: "Old Offinso", regionCode: "06", districtCode: "07" },
    { name: "Offinso-Ampabame", regionCode: "06", districtCode: "07" },
    { name: "Offinso,Kayera", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Samproso", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Sakam", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Namong", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Mpehin", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Koforidua", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Dome", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Dentin", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Bonsua", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Boasi Habitat", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Boasi", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Awisem", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Anyenasuso", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Amoawi", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Adukro", regionCode: "06", districtCode: "07" },
    { name: "Offinso, Aboasu", regionCode: "06", districtCode: "07" },
    { name: "Offinso", regionCode: "06", districtCode: "07" },
    { name: "Offfinso, Abrokyire", regionCode: "06", districtCode: "07" },
    { name: "Nyankaso", regionCode: "06", districtCode: "07" },
    { name: "Nsuontem", regionCode: "06", districtCode: "07" }
  ],
  "06-09": [
    { name: "Abidyan Nkwanta", regionCode: "06", districtCode: "09" },
    { name: "Abinkyi Market", regionCode: "06", districtCode: "09" },
    { name: "Aboabokese", regionCode: "06", districtCode: "09" },
    { name: "Abodom", regionCode: "06", districtCode: "09" },
    { name: "Abonu", regionCode: "06", districtCode: "09" },
    { name: "Abountem New Rd", regionCode: "06", districtCode: "09" },
    { name: "Abountem Old Rd", regionCode: "06", districtCode: "09" },
    { name: "Abuontem", regionCode: "06", districtCode: "09" },
    { name: "Aburaso", regionCode: "06", districtCode: "09" },
    { name: "Adagya", regionCode: "06", districtCode: "09" },
    { name: "Adiebeba", regionCode: "06", districtCode: "09" },
    { name: "Adiebeba, Adiembra", regionCode: "06", districtCode: "09" },
    { name: "Aduaden", regionCode: "06", districtCode: "09" },
    { name: "Adum", regionCode: "06", districtCode: "09" },
    { name: "Adum/Kejetia", regionCode: "06", districtCode: "09" },
    { name: "Adum/Ridge", regionCode: "06", districtCode: "09" },
    { name: "Adumasa", regionCode: "06", districtCode: "09" },
    { name: "Adwaase", regionCode: "06", districtCode: "09" },
    { name: "Adwumamu", regionCode: "06", districtCode: "09" },
    { name: "Afrancho, Odumasi", regionCode: "06", districtCode: "09" },
    { name: "Ahinsan, Angola", regionCode: "06", districtCode: "09" },
    { name: "Ahodwo", regionCode: "06", districtCode: "09" },
    { name: "Ahodwo, Adiembra", regionCode: "06", districtCode: "09" },
    { name: "Akokofe", regionCode: "06", districtCode: "09" },
    { name: "Amakrom", regionCode: "06", districtCode: "09" },
    { name: "Ampabame", regionCode: "06", districtCode: "09" },
    { name: "Ampabame #1, New Site", regionCode: "06", districtCode: "09" },
    { name: "Ampabame #1, Old Town", regionCode: "06", districtCode: "09" },
    { name: "Ampabame #2", regionCode: "06", districtCode: "09" },
    { name: "Ampabame No 1", regionCode: "06", districtCode: "09" },
    { name: "Ampatia", regionCode: "06", districtCode: "09" },
    { name: "Ampayoo", regionCode: "06", districtCode: "09" },
    { name: "Anwiankwanta", regionCode: "06", districtCode: "09" },
    { name: "Anyinam, New Site", regionCode: "06", districtCode: "09" },
    { name: "Apaaso", regionCode: "06", districtCode: "09" },
    { name: "Apire", regionCode: "06", districtCode: "09" },
    { name: "Apramang, New Site", regionCode: "06", districtCode: "09" },
    { name: "Aputuogya", regionCode: "06", districtCode: "09" },
    { name: "Asaago", regionCode: "06", districtCode: "09" },
    { name: "Asafo", regionCode: "06", districtCode: "09" },
    { name: "Asawase", regionCode: "06", districtCode: "09" },
    { name: "Asisiriwa", regionCode: "06", districtCode: "09" },
    { name: "Asokwa, Komfo Badukrom", regionCode: "06", districtCode: "09" },
    { name: "Atasomanso", regionCode: "06", districtCode: "09" },
    { name: "Atobiase", regionCode: "06", districtCode: "09" },
    { name: "Atonsu", regionCode: "06", districtCode: "09" },
    { name: "Atonsu Aprabon", regionCode: "06", districtCode: "09" },
    { name: "Atonsu -Bokro", regionCode: "06", districtCode: "09" },
    { name: "Atonsu High Tension", regionCode: "06", districtCode: "09" },
    { name: "Atonsu Kuwait", regionCode: "06", districtCode: "09" },
    { name: "Atonsu S Line", regionCode: "06", districtCode: "09" },
    { name: "Atonsu, Aprabo", regionCode: "06", districtCode: "09" },
    { name: "Atonsu, Bokro", regionCode: "06", districtCode: "09" },
    { name: "Atonsu, Dompoase", regionCode: "06", districtCode: "09" },
    { name: "Atonsu, Fabi", regionCode: "06", districtCode: "09" },
    { name: "Atonsu, High Tension", regionCode: "06", districtCode: "09" },
    { name: "Atonsu, Kotokuom Ext", regionCode: "06", districtCode: "09" },
    { name: "Atonsu, Oti", regionCode: "06", districtCode: "09" },
    { name: "Awhiaa", regionCode: "06", districtCode: "09" },
    { name: "Bebu", regionCode: "06", districtCode: "09" },
    { name: "Bekwai", regionCode: "06", districtCode: "09" },
    { name: "Bekwai Township", regionCode: "06", districtCode: "09" },
    { name: "Beposo", regionCode: "06", districtCode: "09" },
    { name: "Brofoyedu", regionCode: "06", districtCode: "09" },
    { name: "Daaban", regionCode: "06", districtCode: "09" },
    { name: "Daban, Ahodwo", regionCode: "06", districtCode: "09" },
    { name: "Daban, New Site", regionCode: "06", districtCode: "09" },
    { name: "Daban, Patuda", regionCode: "06", districtCode: "09" },
    { name: "Dakodwom", regionCode: "06", districtCode: "09" },
    { name: "Danyame", regionCode: "06", districtCode: "09" },
    { name: "Darko", regionCode: "06", districtCode: "09" },
    { name: "Dompoase", regionCode: "06", districtCode: "09" },
    { name: "Esereso", regionCode: "06", districtCode: "09" },
    { name: "Esereso Kotokuom Ext.", regionCode: "06", districtCode: "09" },
    { name: "Fankenebra", regionCode: "06", districtCode: "09" },
    { name: "Feyiase", regionCode: "06", districtCode: "09" },
    { name: "Feyiase Akoyem", regionCode: "06", districtCode: "09" },
    { name: "Feyiase Aputuogya", regionCode: "06", districtCode: "09" },
    { name: "Heman New Site", regionCode: "06", districtCode: "09" },
    { name: "Homabenase", regionCode: "06", districtCode: "09" },
    { name: "Huntado", regionCode: "06", districtCode: "09" },
    { name: "Jachie", regionCode: "06", districtCode: "09" },
    { name: "Kaase", regionCode: "06", districtCode: "09" },
    { name: "Kaase- Ahinsan", regionCode: "06", districtCode: "09" },
    { name: "Kaase, Angola", regionCode: "06", districtCode: "09" },
    { name: "Kaase, Mayanka", regionCode: "06", districtCode: "09" },
    { name: "Kaase, STP", regionCode: "06", districtCode: "09" },
    { name: "Kegyase", regionCode: "06", districtCode: "09" },
    { name: "Kentinkyire", regionCode: "06", districtCode: "09" },
    { name: "Kokoben", regionCode: "06", districtCode: "09" },
    { name: "Kokofu", regionCode: "06", districtCode: "09" },
    { name: "Konkori", regionCode: "06", districtCode: "09" },
    { name: "Konkromoase, New Site", regionCode: "06", districtCode: "09" },
    { name: "Kotwi", regionCode: "06", districtCode: "09" },
    { name: "Krofrom", regionCode: "06", districtCode: "09" },
    { name: "Kuntenase", regionCode: "06", districtCode: "09" },
    { name: "Kuwait", regionCode: "06", districtCode: "09" },
    { name: "Kwadaso Agric", regionCode: "06", districtCode: "09" },
    { name: "Kwadaso Edwenase", regionCode: "06", districtCode: "09" },
    { name: "Kwadaso Estate", regionCode: "06", districtCode: "09" },
    { name: "Kwadaso Market", regionCode: "06", districtCode: "09" },
    { name: "Kwadaso Peters", regionCode: "06", districtCode: "09" },
    { name: "Kwanwoma", regionCode: "06", districtCode: "09" },
    { name: "Kwaso", regionCode: "06", districtCode: "09" },
    { name: "Nhyiaeso", regionCode: "06", districtCode: "09" },
    { name: "Nkoransa", regionCode: "06", districtCode: "09" },
    { name: "Ntinanako", regionCode: "06", districtCode: "09" },
    { name: "Nwamase", regionCode: "06", districtCode: "09" },
    { name: "Nzema", regionCode: "06", districtCode: "09" },
    { name: "Odaso", regionCode: "06", districtCode: "09" },
    { name: "Odeneho Kwadaso", regionCode: "06", districtCode: "09" },
    { name: "Old Asokwa", regionCode: "06", districtCode: "09" },
    { name: "Pakyi #1", regionCode: "06", districtCode: "09" },
    { name: "Pakyi #2", regionCode: "06", districtCode: "09" },
    { name: "Patasi", regionCode: "06", districtCode: "09" },
    { name: "Sabin Kroffrom", regionCode: "06", districtCode: "09" },
    { name: "Santasi", regionCode: "06", districtCode: "09" },
    { name: "Santasi, New Site", regionCode: "06", districtCode: "09" },
    { name: "Sawua Awiom", regionCode: "06", districtCode: "09" },
    { name: "Sokoban", regionCode: "06", districtCode: "09" },
    { name: "Sokoban Ampayoo", regionCode: "06", districtCode: "09" },
    { name: "Sokoban Krofrom", regionCode: "06", districtCode: "09" },
    { name: "Sokoban, Ahodwo", regionCode: "06", districtCode: "09" },
    { name: "Sokoban, Near Wood Village", regionCode: "06", districtCode: "09" },
    { name: "Sokoban, Wood Village", regionCode: "06", districtCode: "09" },
    { name: "South Suntreso", regionCode: "06", districtCode: "09" },
    { name: "Trede", regionCode: "06", districtCode: "09" },
    { name: "TUC", regionCode: "06", districtCode: "09" },
    { name: "Undefined Area Bekwai", regionCode: "06", districtCode: "09" },
    { name: "Undefined Area Danyame", regionCode: "06", districtCode: "09" }
  ],
  "06-11": [
    { name: "Abinkyi Market", regionCode: "06", districtCode: "11" },
    { name: "Aboabokese", regionCode: "06", districtCode: "11" },
    { name: "Aburaso", regionCode: "06", districtCode: "11" },
    { name: "Adiebeba", regionCode: "06", districtCode: "11" },
    { name: "Adiebeba, Adiembra", regionCode: "06", districtCode: "11" },
    { name: "Adum", regionCode: "06", districtCode: "11" },
    { name: "Adum Railways", regionCode: "06", districtCode: "11" },
    { name: "Adum/Kejetia", regionCode: "06", districtCode: "11" },
    { name: "Adum/Ridge", regionCode: "06", districtCode: "11" },
    { name: "Adwaase", regionCode: "06", districtCode: "11" },
    { name: "Afrancho, Odumasi", regionCode: "06", districtCode: "11" },
    { name: "Ahinsan, Angola", regionCode: "06", districtCode: "11" },
    { name: "Ahodwo", regionCode: "06", districtCode: "11" },
    { name: "Ahodwo, Adiembra", regionCode: "06", districtCode: "11" },
    { name: "Ampabame #2", regionCode: "06", districtCode: "11" },
    { name: "Ampatia", regionCode: "06", districtCode: "11" },
    { name: "Ampayoo", regionCode: "06", districtCode: "11" },
    { name: "Anwomaso Station", regionCode: "06", districtCode: "11" },
    { name: "Anyinam, New Site", regionCode: "06", districtCode: "11" },
    { name: "Apaaso", regionCode: "06", districtCode: "11" },
    { name: "Apire", regionCode: "06", districtCode: "11" },
    { name: "Apramang, New Site", regionCode: "06", districtCode: "11" },
    { name: "Asaago", regionCode: "06", districtCode: "11" },
    { name: "Asafo", regionCode: "06", districtCode: "11" },
    { name: "Asokwa, Komfo Badukrom", regionCode: "06", districtCode: "11" },
    { name: "Atasomanso", regionCode: "06", districtCode: "11" },
    { name: "Atonsu", regionCode: "06", districtCode: "11" },
    { name: "Atonsu, Aprabo", regionCode: "06", districtCode: "11" },
    { name: "Atonsu, Bokro", regionCode: "06", districtCode: "11" },
    { name: "Atonsu, Dompoase", regionCode: "06", districtCode: "11" },
    { name: "Atonsu, Fabi", regionCode: "06", districtCode: "11" },
    { name: "Atonsu, High Tension", regionCode: "06", districtCode: "11" },
    { name: "Atonsu, Kotokuom Ext", regionCode: "06", districtCode: "11" },
    { name: "Atonsu, Kuwait", regionCode: "06", districtCode: "11" },
    { name: "Atonsu, Oti", regionCode: "06", districtCode: "11" },
    { name: "Atonsu, S-Line", regionCode: "06", districtCode: "11" },
    { name: "Bebu", regionCode: "06", districtCode: "11" },
    { name: "Bekwame", regionCode: "06", districtCode: "11" },
    { name: "Daban", regionCode: "06", districtCode: "11" },
    { name: "Daban, Ahodwo", regionCode: "06", districtCode: "11" },
    { name: "Daban, New Site", regionCode: "06", districtCode: "11" },
    { name: "Daban, Patuda", regionCode: "06", districtCode: "11" },
    { name: "Dakodwom", regionCode: "06", districtCode: "11" },
    { name: "Danyame", regionCode: "06", districtCode: "11" },
    { name: "Danyame Business Centre", regionCode: "06", districtCode: "11" },
    { name: "Esaase", regionCode: "06", districtCode: "11" },
    { name: "Fankenebra", regionCode: "06", districtCode: "11" },
    { name: "Heman New Site", regionCode: "06", districtCode: "11" },
    { name: "Kaase", regionCode: "06", districtCode: "11" },
    { name: "Kaase, Ahinsan", regionCode: "06", districtCode: "11" },
    { name: "Kaase, Angola", regionCode: "06", districtCode: "11" },
    { name: "Kaase, Mayanka", regionCode: "06", districtCode: "11" },
    { name: "Kaase, STP", regionCode: "06", districtCode: "11" },
    { name: "Kegyase", regionCode: "06", districtCode: "11" },
    { name: "Kejetia", regionCode: "06", districtCode: "11" },
    { name: "Koforidua", regionCode: "06", districtCode: "11" },
    { name: "Kokoben", regionCode: "06", districtCode: "11" },
    { name: "Konkromoase", regionCode: "06", districtCode: "11" },
    { name: "Kotwi", regionCode: "06", districtCode: "11" },
    { name: "Kromoase", regionCode: "06", districtCode: "11" },
    { name: "Kuwait", regionCode: "06", districtCode: "11" },
    { name: "Kwadaso Agric", regionCode: "06", districtCode: "11" },
    { name: "Kwadaso Edwenase", regionCode: "06", districtCode: "11" },
    { name: "Kwadaso Estate", regionCode: "06", districtCode: "11" },
    { name: "Kwadaso Estate,Sofoline", regionCode: "06", districtCode: "11" },
    { name: "Kwadaso Market", regionCode: "06", districtCode: "11" },
    { name: "Kwadaso Peters", regionCode: "06", districtCode: "11" },
    { name: "Kwapra New Site No. 1", regionCode: "06", districtCode: "11" },
    { name: "Nhiaeso", regionCode: "06", districtCode: "11" },
    { name: "Nhyiaeso", regionCode: "06", districtCode: "11" },
    { name: "Nkoransa", regionCode: "06", districtCode: "11" },
    { name: "Nwamase", regionCode: "06", districtCode: "11" },
    { name: "Nzema", regionCode: "06", districtCode: "11" },
    { name: "Odeneho Kwadaso", regionCode: "06", districtCode: "11" },
    { name: "Odeneho Kwadaso, Owass", regionCode: "06", districtCode: "11" },
    { name: "Old Asokwa", regionCode: "06", districtCode: "11" },
    { name: "Pakyi #2", regionCode: "06", districtCode: "11" },
    { name: "Patasi", regionCode: "06", districtCode: "11" },
    { name: "Sabin Kroffrom", regionCode: "06", districtCode: "11" },
    { name: "Santasi", regionCode: "06", districtCode: "11" },
    { name: "Santasi, Aboaso", regionCode: "06", districtCode: "11" },
    { name: "Santasi, New Site", regionCode: "06", districtCode: "11" },
    { name: "Santasi, St. Hubert", regionCode: "06", districtCode: "11" },
    { name: "Sokoban", regionCode: "06", districtCode: "11" },
    { name: "Sokoban, Ahodwo", regionCode: "06", districtCode: "11" },
    { name: "Sokoban, Near Wood Village", regionCode: "06", districtCode: "11" },
    { name: "Sokoban, Wood Village", regionCode: "06", districtCode: "11" },
    { name: "South Suntreso", regionCode: "06", districtCode: "11" },
    { name: "Trede", regionCode: "06", districtCode: "11" },
    { name: "TUC", regionCode: "06", districtCode: "11" }
  ],
  "06-12": [
    { name: "Abinkyi Market", regionCode: "06", districtCode: "12" },
    { name: "Aboabokese", regionCode: "06", districtCode: "12" },
    { name: "Aburaso", regionCode: "06", districtCode: "12" },
    { name: "Adiebeba", regionCode: "06", districtCode: "12" },
    { name: "Adiebeba, Adiembra", regionCode: "06", districtCode: "12" },
    { name: "Adum", regionCode: "06", districtCode: "12" },
    { name: "Adum Railways", regionCode: "06", districtCode: "12" },
    { name: "Adum/Kejetia", regionCode: "06", districtCode: "12" },
    { name: "Adum/Ridge", regionCode: "06", districtCode: "12" },
    { name: "Adumasa", regionCode: "06", districtCode: "12" },
    { name: "Adwaase", regionCode: "06", districtCode: "12" },
    { name: "Afrancho, Odumasi", regionCode: "06", districtCode: "12" },
    { name: "Afratia", regionCode: "06", districtCode: "12" },
    { name: "Agric", regionCode: "06", districtCode: "12" },
    { name: "Ahinsan, Angola", regionCode: "06", districtCode: "12" },
    { name: "Ahodwo", regionCode: "06", districtCode: "12" },
    { name: "Ahodwo, Adiembra", regionCode: "06", districtCode: "12" },
    { name: "Ampabame #1, New Site", regionCode: "06", districtCode: "12" },
    { name: "Ampabame #2", regionCode: "06", districtCode: "12" },
    { name: "Ampabame No 1", regionCode: "06", districtCode: "12" },
    { name: "Ampatia", regionCode: "06", districtCode: "12" },
    { name: "Ampatia /Kokoben", regionCode: "06", districtCode: "12" },
    { name: "Ampayoo", regionCode: "06", districtCode: "12" },
    { name: "Anyinam, New Site", regionCode: "06", districtCode: "12" },
    { name: "Apaaso", regionCode: "06", districtCode: "12" },
    { name: "Apampatia", regionCode: "06", districtCode: "12" },
    { name: "Apire", regionCode: "06", districtCode: "12" },
    { name: "Apramang, New Site", regionCode: "06", districtCode: "12" },
    { name: "Apreku", regionCode: "06", districtCode: "12" },
    { name: "Asaago", regionCode: "06", districtCode: "12" },
    { name: "Asafo", regionCode: "06", districtCode: "12" },
    { name: "Asokwa, Komfo Badukrom", regionCode: "06", districtCode: "12" },
    { name: "Asuoyeboah", regionCode: "06", districtCode: "12" },
    { name: "Atasomanso", regionCode: "06", districtCode: "12" },
    { name: "Atonsu", regionCode: "06", districtCode: "12" },
    { name: "Atonsu -Bokro", regionCode: "06", districtCode: "12" },
    { name: "Atonsu, Aprabo", regionCode: "06", districtCode: "12" },
    { name: "Atonsu, Bokro", regionCode: "06", districtCode: "12" },
    { name: "Atonsu, Dompoase", regionCode: "06", districtCode: "12" },
    { name: "Atonsu, Fabi", regionCode: "06", districtCode: "12" },
    { name: "Atonsu, High Tension", regionCode: "06", districtCode: "12" },
    { name: "Atonsu, Kotokuom Ext", regionCode: "06", districtCode: "12" },
    { name: "Atonsu, Kuwait", regionCode: "06", districtCode: "12" },
    { name: "Atonsu, Oti", regionCode: "06", districtCode: "12" },
    { name: "Atonsu, S-Line", regionCode: "06", districtCode: "12" },
    { name: "Bebu", regionCode: "06", districtCode: "12" },
    { name: "Bedase", regionCode: "06", districtCode: "12" },
    { name: "Bekwame", regionCode: "06", districtCode: "12" },
    { name: "Brofoyedu", regionCode: "06", districtCode: "12" },
    { name: "Chiransa", regionCode: "06", districtCode: "12" },
    { name: "Daaban", regionCode: "06", districtCode: "12" },
    { name: "Daban, Ahodwo", regionCode: "06", districtCode: "12" },
    { name: "Daban, New Site", regionCode: "06", districtCode: "12" },
    { name: "Daban, Patuda", regionCode: "06", districtCode: "12" },
    { name: "Dakodwom", regionCode: "06", districtCode: "12" },
    { name: "Danyame", regionCode: "06", districtCode: "12" },
    { name: "Darko", regionCode: "06", districtCode: "12" },
    { name: "Diekrom", regionCode: "06", districtCode: "12" },
    { name: "Dompoase", regionCode: "06", districtCode: "12" },
    { name: "Duropam", regionCode: "06", districtCode: "12" },
    { name: "Essreso", regionCode: "06", districtCode: "12" },
    { name: "Fankenebra", regionCode: "06", districtCode: "12" },
    { name: "Heman New Site", regionCode: "06", districtCode: "12" },
    { name: "Hemang", regionCode: "06", districtCode: "12" },
    { name: "Kaase", regionCode: "06", districtCode: "12" },
    { name: "Kaase, Angola", regionCode: "06", districtCode: "12" },
    { name: "Kaase, Stp", regionCode: "06", districtCode: "12" },
    { name: "Kegyase", regionCode: "06", districtCode: "12" },
    { name: "Kejetia", regionCode: "06", districtCode: "12" },
    { name: "Kentinkyire", regionCode: "06", districtCode: "12" },
    { name: "Kokoben", regionCode: "06", districtCode: "12" },
    { name: "Konkori", regionCode: "06", districtCode: "12" },
    { name: "Konkromoase", regionCode: "06", districtCode: "12" },
    { name: "Konkromoase, New Site", regionCode: "06", districtCode: "12" },
    { name: "Kotwi", regionCode: "06", districtCode: "12" },
    { name: "Krofrom", regionCode: "06", districtCode: "12" },
    { name: "Kromoase", regionCode: "06", districtCode: "12" },
    { name: "Kwadaso Agric", regionCode: "06", districtCode: "12" },
    { name: "Kwadaso Edwenase", regionCode: "06", districtCode: "12" },
    { name: "Kwadaso Estate", regionCode: "06", districtCode: "12" },
    { name: "Kwadaso Estate,Sofoline", regionCode: "06", districtCode: "12" },
    { name: "Kwadaso Market", regionCode: "06", districtCode: "12" },
    { name: "Kwadaso Peters", regionCode: "06", districtCode: "12" },
    { name: "Kwanwoma", regionCode: "06", districtCode: "12" },
    { name: "Kyekyewere", regionCode: "06", districtCode: "12" },
    { name: "Kyekyewere, Habitat", regionCode: "06", districtCode: "12" },
    { name: "Mpatase", regionCode: "06", districtCode: "12" },
    { name: "New Adwampong", regionCode: "06", districtCode: "12" },
    { name: "Nhiaeso", regionCode: "06", districtCode: "12" },
    { name: "Nkoransa", regionCode: "06", districtCode: "12" },
    { name: "Nwamase", regionCode: "06", districtCode: "12" },
    { name: "Nzema", regionCode: "06", districtCode: "12" },
    { name: "Odeneho Kwadaso", regionCode: "06", districtCode: "12" },
    { name: "Odeneho Kwadaso, Owass", regionCode: "06", districtCode: "12" },
    { name: "Odumasi", regionCode: "06", districtCode: "12" },
    { name: "Old Asokwa", regionCode: "06", districtCode: "12" },
    { name: "Paa", regionCode: "06", districtCode: "12" },
    { name: "Pakyi No 1", regionCode: "06", districtCode: "12" },
    { name: "Pakyi No 2", regionCode: "06", districtCode: "12" },
    { name: "Patasi", regionCode: "06", districtCode: "12" },
    { name: "Sabin Kroffrom", regionCode: "06", districtCode: "12" },
    { name: "Sabin-Akrofrom/Trede", regionCode: "06", districtCode: "12" },
    { name: "Santasi", regionCode: "06", districtCode: "12" },
    { name: "Santasi, Aboaso", regionCode: "06", districtCode: "12" },
    { name: "Santasi, Kegyase", regionCode: "06", districtCode: "12" },
    { name: "Santasi, New Site", regionCode: "06", districtCode: "12" },
    { name: "Santasi, St. Hubert", regionCode: "06", districtCode: "12" },
    { name: "Sokoban", regionCode: "06", districtCode: "12" },
    { name: "Sokoban, Ahodwo", regionCode: "06", districtCode: "12" },
    { name: "Sokoban, Near Wood Village", regionCode: "06", districtCode: "12" },
    { name: "Sokoban, Wood Village", regionCode: "06", districtCode: "12" },
    { name: "South Suntreso", regionCode: "06", districtCode: "12" },
    { name: "Suame", regionCode: "06", districtCode: "12" },
    { name: "Takyimang", regionCode: "06", districtCode: "12" },
    { name: "Trede", regionCode: "06", districtCode: "12" },
    { name: "TUC", regionCode: "06", districtCode: "12" },
    { name: "Twinduase", regionCode: "06", districtCode: "12" }
  ],

  "07-08": [
    { districtCode: "08", regionCode: "07", name: "Airport Ridge" },
    { districtCode: "08", regionCode: "07", name: "Amanful" },
    { districtCode: "08", regionCode: "07", name: "Beach Road" },
    { districtCode: "08", regionCode: "07", name: "Chapel Hill" },
    { districtCode: "08", regionCode: "07", name: "Collins Avenue" },
    { districtCode: "08", regionCode: "07", name: "Esikafoabentem (No. 1, 2, & 3)" },
    { districtCode: "08", regionCode: "07", name: "Lagos Town" },
    { districtCode: "08", regionCode: "07", name: "Market Circle (Central Business District)" },
    { districtCode: "08", regionCode: "07", name: "New Takoradi" },
    { districtCode: "08", regionCode: "07", name: "Poasi" },
    { districtCode: "08", regionCode: "07", name: "Windy Ridge" },
    { districtCode: "08", regionCode: "07", name: "Anaji" },
    { districtCode: "08", regionCode: "07", name: "Apollo" },
    { districtCode: "08", regionCode: "07", name: "Apremdo" },
    { districtCode: "08", regionCode: "07", name: "Assakae" },
    { districtCode: "08", regionCode: "07", name: "Bankyease" },
    { districtCode: "08", regionCode: "07", name: "Effia" },
    { districtCode: "08", regionCode: "07", name: "Effiakuma" },
    { districtCode: "08", regionCode: "07", name: "Kwesimintsim (The Municipal Capital)" },
    { districtCode: "08", regionCode: "07", name: "Mpatado" },
    { districtCode: "08", regionCode: "07", name: "Sabina Estate" },
    { districtCode: "08", regionCode: "07", name: "Tanokrom (East & West)" },
    { districtCode: "08", regionCode: "07", name: "Whindo" },
    { districtCode: "08", regionCode: "07", name: "Adiembra" },
    { districtCode: "08", regionCode: "07", name: "Bakado" },
    { districtCode: "08", regionCode: "07", name: "Ekuase" },
    { districtCode: "08", regionCode: "07", name: "Essikado" },
    { districtCode: "08", regionCode: "07", name: "Fijai" },
    { districtCode: "08", regionCode: "07", name: "Ketan" },
    { districtCode: "08", regionCode: "07", name: "Kojokrom" },
    { districtCode: "08", regionCode: "07", name: "Kweikuma" },
    { districtCode: "08", regionCode: "07", name: "Nkontompo" },
    { districtCode: "08", regionCode: "07", name: "Sekondi Ridge" }
  ],

  "08-01": [
    { name: "Abeadze", regionCode: "08", districtCode: "01" },
    { name: "Aboom", regionCode: "08", districtCode: "01" },
    { name: "Aboransa", regionCode: "08", districtCode: "01" },
    { name: "Abotar", regionCode: "08", districtCode: "01" },
    { name: "Abowinim", regionCode: "08", districtCode: "01" },
    { name: "Abreshia", regionCode: "08", districtCode: "01" },
    { name: "Abrobeano", regionCode: "08", districtCode: "01" },
    { name: "Abukrom Junction", regionCode: "08", districtCode: "01" },
    { name: "Abura", regionCode: "08", districtCode: "01" },
    { name: "Abura Ahunde", regionCode: "08", districtCode: "01" },
    { name: "Acquahkrom", regionCode: "08", districtCode: "01" },
    { name: "Adisadel", regionCode: "08", districtCode: "01" },
    { name: "Agya Nkwanta", regionCode: "08", districtCode: "01" },
    { name: "Ahenkrom", regionCode: "08", districtCode: "01" },
    { name: "Ahuntem", regionCode: "08", districtCode: "01" },
    { name: "Akaikrom", regionCode: "08", districtCode: "01" },
    { name: "Akokokrom", regionCode: "08", districtCode: "01" },
    { name: "Akwakrom", regionCode: "08", districtCode: "01" },
    { name: "Akyim", regionCode: "08", districtCode: "01" },
    { name: "Akyinim", regionCode: "08", districtCode: "01" },
    { name: "Amaful", regionCode: "08", districtCode: "01" },
    { name: "Amisano", regionCode: "08", districtCode: "01" },
    { name: "Amomoma", regionCode: "08", districtCode: "01" },
    { name: "Amosima", regionCode: "08", districtCode: "01" },
    { name: "Anhwiom", regionCode: "08", districtCode: "01" },
    { name: "Anhwiom Jnc", regionCode: "08", districtCode: "01" },
    { name: "Anhwiom Kumasi", regionCode: "08", districtCode: "01" },
    { name: "Ankaful", regionCode: "08", districtCode: "01" },
    { name: "Antado", regionCode: "08", districtCode: "01" },
    { name: "Antseambua", regionCode: "08", districtCode: "01" },
    { name: "Apaakrom", regionCode: "08", districtCode: "01" },
    { name: "Apenkwakrom", regionCode: "08", districtCode: "01" },
    { name: "Apewsika", regionCode: "08", districtCode: "01" },
    { name: "Appiahkrom", regionCode: "08", districtCode: "01" },
    { name: "Appiako", regionCode: "08", districtCode: "01" },
    { name: "Asebufokrom", regionCode: "08", districtCode: "01" },
    { name: "Asonadze", regionCode: "08", districtCode: "01" },
    { name: "Ataabadze", regionCode: "08", districtCode: "01" },
    { name: "Atonkwa", regionCode: "08", districtCode: "01" },
    { name: "Awunafokrom", regionCode: "08", districtCode: "01" },
    { name: "Ayensudo", regionCode: "08", districtCode: "01" },
    { name: "Baidukrom", regionCode: "08", districtCode: "01" },
    { name: "Bando", regionCode: "08", districtCode: "01" },
    { name: "Benyadze", regionCode: "08", districtCode: "01" },
    { name: "Besease", regionCode: "08", districtCode: "01" },
    { name: "Bonkus", regionCode: "08", districtCode: "01" },
    { name: "Brafoyaw", regionCode: "08", districtCode: "01" },
    { name: "Breman", regionCode: "08", districtCode: "01" },
    { name: "Brofoyedur", regionCode: "08", districtCode: "01" },
    { name: "Bronyimibima", regionCode: "08", districtCode: "01" },
    { name: "Daber", regionCode: "08", districtCode: "01" },
    { name: "Dakyebebahobiom", regionCode: "08", districtCode: "01" },
    { name: "Dankwakrom", regionCode: "08", districtCode: "01" },
    { name: "Dompoase", regionCode: "08", districtCode: "01" },
    { name: "Donkorkrom", regionCode: "08", districtCode: "01" },
    { name: "Duakro", regionCode: "08", districtCode: "01" },
    { name: "Dumtu", regionCode: "08", districtCode: "01" },
    { name: "Dutch Komenda", regionCode: "08", districtCode: "01" },
    { name: "Edukrom", regionCode: "08", districtCode: "01" },
    { name: "Efutu", regionCode: "08", districtCode: "01" },
    { name: "Efutu Kokwaado", regionCode: "08", districtCode: "01" },
    { name: "Efutu Mampong", regionCode: "08", districtCode: "01" },
    { name: "Eguafo", regionCode: "08", districtCode: "01" },
    { name: "Egyeikrom", regionCode: "08", districtCode: "01" },
    { name: "Ekon", regionCode: "08", districtCode: "01" },
    { name: "Elmina", regionCode: "08", districtCode: "01" },
    { name: "Esaaman", regionCode: "08", districtCode: "01" },
    { name: "Esien", regionCode: "08", districtCode: "01" },
    { name: "Essandokrom", regionCode: "08", districtCode: "01" },
    { name: "Esuaso(Asuaso)", regionCode: "08", districtCode: "01" },
    { name: "Esuekyir", regionCode: "08", districtCode: "01" },
    { name: "Eture", regionCode: "08", districtCode: "01" },
    { name: "Eyifuah", regionCode: "08", districtCode: "01" },
    { name: "Greenhill", regionCode: "08", districtCode: "01" },
    { name: "Junkwa Krobo", regionCode: "08", districtCode: "01" },
    { name: "Kafodzidzi", regionCode: "08", districtCode: "01" },
    { name: "Kakumdo", regionCode: "08", districtCode: "01" },
    { name: "Kingsway", regionCode: "08", districtCode: "01" },
    { name: "Kissi", regionCode: "08", districtCode: "01" },
    { name: "Kojokrobo", regionCode: "08", districtCode: "01" },
    { name: "Kojokrom", regionCode: "08", districtCode: "01" },
    { name: "Kokorde", regionCode: "08", districtCode: "01" },
    { name: "Kokowado", regionCode: "08", districtCode: "01" },
    { name: "Kokwado", regionCode: "08", districtCode: "01" },
    { name: "Komenda", regionCode: "08", districtCode: "01" },
    { name: "Komfokrom", regionCode: "08", districtCode: "01" },
    { name: "Kotokuraba", regionCode: "08", districtCode: "01" },
    { name: "Krofofordo", regionCode: "08", districtCode: "01" },
    { name: "Kroforfordo", regionCode: "08", districtCode: "01" },
    { name: "Kwabasa", regionCode: "08", districtCode: "01" },
    { name: "Kwahinkrom", regionCode: "08", districtCode: "01" },
    { name: "Kwameta", regionCode: "08", districtCode: "01" },
    { name: "Kwaprow", regionCode: "08", districtCode: "01" },
    { name: "Kwasi Adu", regionCode: "08", districtCode: "01" },
    { name: "Kwayefi", regionCode: "08", districtCode: "01" },
    { name: "Kweikrom", regionCode: "08", districtCode: "01" },
    { name: "Kyease", regionCode: "08", districtCode: "01" },
    { name: "Mfantsipim", regionCode: "08", districtCode: "01" },
    { name: "Moree", regionCode: "08", districtCode: "01" },
    { name: "Mpeasem", regionCode: "08", districtCode: "01" },
    { name: "Munsukwa", regionCode: "08", districtCode: "01" },
    { name: "Nkahyia", regionCode: "08", districtCode: "01" },
    { name: "Nkanfoa", regionCode: "08", districtCode: "01" },
    { name: "Nkontrodo", regionCode: "08", districtCode: "01" },
    { name: "Nsadwe", regionCode: "08", districtCode: "01" },
    { name: "Ntiamoah/Antseamuah", regionCode: "08", districtCode: "01" },
    { name: "Nyinase", regionCode: "08", districtCode: "01" },
    { name: "Obenkrom", regionCode: "08", districtCode: "01" },
    { name: "Obratwawo", regionCode: "08", districtCode: "01" },
    { name: "Odumasi", regionCode: "08", districtCode: "01" },
    { name: "Oframsi", regionCode: "08", districtCode: "01" },
    { name: "Ola", regionCode: "08", districtCode: "01" },
    { name: "Omanpado", regionCode: "08", districtCode: "01" },
    { name: "Onsonyameye", regionCode: "08", districtCode: "01" },
    { name: "Park", regionCode: "08", districtCode: "01" },
    { name: "Pedu", regionCode: "08", districtCode: "01" },
    { name: "Peshie", regionCode: "08", districtCode: "01" },
    { name: "Ponkrom", regionCode: "08", districtCode: "01" },
    { name: "Powano", regionCode: "08", districtCode: "01" },
    { name: "Saafa", regionCode: "08", districtCode: "01" },
    { name: "Saman", regionCode: "08", districtCode: "01" },
    { name: "Sefwi Awona", regionCode: "08", districtCode: "01" },
    { name: "Seweraga", regionCode: "08", districtCode: "01" },
    { name: "Simiw", regionCode: "08", districtCode: "01" },
    { name: "Siwdu", regionCode: "08", districtCode: "01" },
    { name: "Thompsonkrom", regionCode: "08", districtCode: "01" },
    { name: "Tsetsekasum No. 2", regionCode: "08", districtCode: "01" },
    { name: "Waynato", regionCode: "08", districtCode: "01" },
    { name: "Wiomah", regionCode: "08", districtCode: "01" },
    { name: "Worabeba", regionCode: "08", districtCode: "01" },
    { name: "Yamoransa", regionCode: "08", districtCode: "01" },
    { name: "Yawsekyikrom", regionCode: "08", districtCode: "01" }
  ],
  "08-02": [
    { name: "Abaka Nkwanta", regionCode: "08", districtCode: "02" },
    { name: "Abasa", regionCode: "08", districtCode: "02" },
    { name: "Abekuase", regionCode: "08", districtCode: "02" },
    { name: "Aboabo", regionCode: "08", districtCode: "02" },
    { name: "Abodom", regionCode: "08", districtCode: "02" },
    { name: "Abodwese", regionCode: "08", districtCode: "02" },
    { name: "Abora", regionCode: "08", districtCode: "02" },
    { name: "Aburi", regionCode: "08", districtCode: "02" },
    { name: "Achiase", regionCode: "08", districtCode: "02" },
    { name: "Adaboe", regionCode: "08", districtCode: "02" },
    { name: "Adeade", regionCode: "08", districtCode: "02" },
    { name: "Adiyaa", regionCode: "08", districtCode: "02" },
    { name: "Adjetey Camp", regionCode: "08", districtCode: "02" },
    { name: "Adugyaa", regionCode: "08", districtCode: "02" },
    { name: "Adukrom", regionCode: "08", districtCode: "02" },
    { name: "Afiaso", regionCode: "08", districtCode: "02" },
    { name: "Afiefiso", regionCode: "08", districtCode: "02" },
    { name: "Afosua", regionCode: "08", districtCode: "02" },
    { name: "Agona", regionCode: "08", districtCode: "02" },
    { name: "Akotosu", regionCode: "08", districtCode: "02" },
    { name: "Akotosu/Dabenamewohen", regionCode: "08", districtCode: "02" },
    { name: "Akwaayaw", regionCode: "08", districtCode: "02" },
    { name: "Akwaboso", regionCode: "08", districtCode: "02" },
    { name: "Akwakrom", regionCode: "08", districtCode: "02" },
    { name: "Amanhyia", regionCode: "08", districtCode: "02" },
    { name: "Ameyaw", regionCode: "08", districtCode: "02" },
    { name: "Amoafo", regionCode: "08", districtCode: "02" },
    { name: "Amoaman", regionCode: "08", districtCode: "02" },
    { name: "Amobaka", regionCode: "08", districtCode: "02" },
    { name: "Ampabena", regionCode: "08", districtCode: "02" },
    { name: "Ananekrom", regionCode: "08", districtCode: "02" },
    { name: "Anhwiaso", regionCode: "08", districtCode: "02" },
    { name: "Anthony", regionCode: "08", districtCode: "02" },
    { name: "Anto", regionCode: "08", districtCode: "02" },
    { name: "Antwikwaa", regionCode: "08", districtCode: "02" },
    { name: "Anwiam", regionCode: "08", districtCode: "02" },
    { name: "Anwiawa", regionCode: "08", districtCode: "02" },
    { name: "Aponapon", regionCode: "08", districtCode: "02" },
    { name: "Aponsaso", regionCode: "08", districtCode: "02" },
    { name: "Aponsaso #1", regionCode: "08", districtCode: "02" },
    { name: "Aponsaso #2", regionCode: "08", districtCode: "02" },
    { name: "Aponsaso #3", regionCode: "08", districtCode: "02" },
    { name: "Asaman", regionCode: "08", districtCode: "02" },
    { name: "Asemanso", regionCode: "08", districtCode: "02" },
    { name: "Asemasa", regionCode: "08", districtCode: "02" },
    { name: "Asensu Shed", regionCode: "08", districtCode: "02" },
    { name: "Asma Camp", regionCode: "08", districtCode: "02" },
    { name: "Asukeseakyi", regionCode: "08", districtCode: "02" },
    { name: "Ateaso", regionCode: "08", districtCode: "02" },
    { name: "Atobiase", regionCode: "08", districtCode: "02" },
    { name: "Atresu", regionCode: "08", districtCode: "02" },
    { name: "Atwereboana", regionCode: "08", districtCode: "02" },
    { name: "Ayaase", regionCode: "08", districtCode: "02" },
    { name: "Ayebiahwe", regionCode: "08", districtCode: "02" },
    { name: "Baakondzidzi", regionCode: "08", districtCode: "02" },
    { name: "Badoa No.1", regionCode: "08", districtCode: "02" },
    { name: "Badoa No.2", regionCode: "08", districtCode: "02" },
    { name: "Bedanagya Akotosu", regionCode: "08", districtCode: "02" },
    { name: "Bedaniagya", regionCode: "08", districtCode: "02" },
    { name: "Bediako", regionCode: "08", districtCode: "02" },
    { name: "Bekawopa", regionCode: "08", districtCode: "02" },
    { name: "Benuye", regionCode: "08", districtCode: "02" },
    { name: "Bepoben", regionCode: "08", districtCode: "02" },
    { name: "Besease", regionCode: "08", districtCode: "02" },
    { name: "Beseasi", regionCode: "08", districtCode: "02" },
    { name: "Betenase", regionCode: "08", districtCode: "02" },
    { name: "Bethlehem", regionCode: "08", districtCode: "02" },
    { name: "Bimpogya", regionCode: "08", districtCode: "02" },
    { name: "Bobi", regionCode: "08", districtCode: "02" },
    { name: "Bremang", regionCode: "08", districtCode: "02" },
    { name: "Brofoyedur", regionCode: "08", districtCode: "02" },
    { name: "Buaben Camp", regionCode: "08", districtCode: "02" },
    { name: "Buaben No2", regionCode: "08", districtCode: "02" },
    { name: "Buabin No.1", regionCode: "08", districtCode: "02" },
    { name: "Bukrusu", regionCode: "08", districtCode: "02" },
    { name: "Camp", regionCode: "08", districtCode: "02" },
    { name: "Cocoashed", regionCode: "08", districtCode: "02" },
    { name: "Damang", regionCode: "08", districtCode: "02" },
    { name: "Dankwakrom", regionCode: "08", districtCode: "02" },
    { name: "Datano", regionCode: "08", districtCode: "02" },
    { name: "Denyase", regionCode: "08", districtCode: "02" },
    { name: "Dokodoko", regionCode: "08", districtCode: "02" },
    { name: "Domama", regionCode: "08", districtCode: "02" },
    { name: "Dominase", regionCode: "08", districtCode: "02" },
    { name: "Dwen Daa Ma", regionCode: "08", districtCode: "02" },
    { name: "Ehyire", regionCode: "08", districtCode: "02" },
    { name: "Esienkyen", regionCode: "08", districtCode: "02" },
    { name: "Esikessuekesekyr", regionCode: "08", districtCode: "02" },
    { name: "Ewu Da Ho Akotoso", regionCode: "08", districtCode: "02" },
    { name: "Fawomaaye", regionCode: "08", districtCode: "02" },
    { name: "Fobinso", regionCode: "08", districtCode: "02" },
    { name: "Fosu", regionCode: "08", districtCode: "02" },
    { name: "Gyampokrom", regionCode: "08", districtCode: "02" },
    { name: "Hemaso", regionCode: "08", districtCode: "02" },
    { name: "Imbraim", regionCode: "08", districtCode: "02" },
    { name: "Jameso Nkwanta", regionCode: "08", districtCode: "02" },
    { name: "Jukwa Krobo", regionCode: "08", districtCode: "02" },
    { name: "Kakyerenyansa", regionCode: "08", districtCode: "02" },
    { name: "Kayefi", regionCode: "08", districtCode: "02" },
    { name: "Kayireku", regionCode: "08", districtCode: "02" },
    { name: "Keteba", regionCode: "08", districtCode: "02" },
    { name: "Kofi Saa", regionCode: "08", districtCode: "02" },
    { name: "Kotokye", regionCode: "08", districtCode: "02" },
    { name: "Kroanam", regionCode: "08", districtCode: "02" },
    { name: "Kwaku Du", regionCode: "08", districtCode: "02" },
    { name: "Kwaku Krom", regionCode: "08", districtCode: "02" },
    { name: "Kwame Alert", regionCode: "08", districtCode: "02" },
    { name: "Kwamoano/Armahkrom", regionCode: "08", districtCode: "02" },
    { name: "Kwankyemaso/Anam", regionCode: "08", districtCode: "02" },
    { name: "Kwayikrom", regionCode: "08", districtCode: "02" },
    { name: "Kweku Dadze", regionCode: "08", districtCode: "02" },
    { name: "Kwesi Sum", regionCode: "08", districtCode: "02" },
    { name: "Kyebi", regionCode: "08", districtCode: "02" },
    { name: "Kyireayowa", regionCode: "08", districtCode: "02" },
    { name: "Kyirekum", regionCode: "08", districtCode: "02" },
    { name: "Last Stop", regionCode: "08", districtCode: "02" },
    { name: "Ma Wo Ho Ndwo Akotoso", regionCode: "08", districtCode: "02" },
    { name: "Mame Sorfo", regionCode: "08", districtCode: "02" },
    { name: "Mampoma", regionCode: "08", districtCode: "02" },
    { name: "Mangoase", regionCode: "08", districtCode: "02" },
    { name: "Mbaa- Abaasa", regionCode: "08", districtCode: "02" },
    { name: "Mbaaniaye", regionCode: "08", districtCode: "02" },
    { name: "Meretweso", regionCode: "08", districtCode: "02" },
    { name: "Miawoani", regionCode: "08", districtCode: "02" },
    { name: "Mile 33 Junction", regionCode: "08", districtCode: "02" },
    { name: "Mile 33 Town (Akweikrom)", regionCode: "08", districtCode: "02" },
    { name: "Mile 34", regionCode: "08", districtCode: "02" },
    { name: "Minta", regionCode: "08", districtCode: "02" },
    { name: "Mintaso", regionCode: "08", districtCode: "02" },
    { name: "Mmba Mpehia", regionCode: "08", districtCode: "02" },
    { name: "Morkwa", regionCode: "08", districtCode: "02" },
    { name: "Moseaso", regionCode: "08", districtCode: "02" },
    { name: "Mpeasem", regionCode: "08", districtCode: "02" },
    { name: "Nkohunuhu", regionCode: "08", districtCode: "02" },
    { name: "Nkroful", regionCode: "08", districtCode: "02" },
    { name: "Nkromua", regionCode: "08", districtCode: "02" },
    { name: "Noah Junction", regionCode: "08", districtCode: "02" },
    { name: "Nsuaem", regionCode: "08", districtCode: "02" },
    { name: "Nsutem", regionCode: "08", districtCode: "02" },
    { name: "Ntom", regionCode: "08", districtCode: "02" },
    { name: "Nuamakrom", regionCode: "08", districtCode: "02" },
    { name: "Nwieso", regionCode: "08", districtCode: "02" },
    { name: "Nyameani", regionCode: "08", districtCode: "02" },
    { name: "Nyamebebyere", regionCode: "08", districtCode: "02" },
    { name: "Nyamebekyere", regionCode: "08", districtCode: "02" },
    { name: "Nyamebekyere Ahinkro", regionCode: "08", districtCode: "02" },
    { name: "Nyamebeyere", regionCode: "08", districtCode: "02" },
    { name: "Nyamendae", regionCode: "08", districtCode: "02" },
    { name: "Nyankumasi", regionCode: "08", districtCode: "02" },
    { name: "Nyinabontoa", regionCode: "08", districtCode: "02" },
    { name: "Nyinawusu", regionCode: "08", districtCode: "02" },
    { name: "Ologo", regionCode: "08", districtCode: "02" },
    { name: "Onyame Ye Adom", regionCode: "08", districtCode: "02" },
    { name: "Oppong", regionCode: "08", districtCode: "02" },
    { name: "Opponso", regionCode: "08", districtCode: "02" },
    { name: "Oseikrom", regionCode: "08", districtCode: "02" },
    { name: "Osenasgya", regionCode: "08", districtCode: "02" },
    { name: "Oseneso", regionCode: "08", districtCode: "02" },
    { name: "Otukrom", regionCode: "08", districtCode: "02" },
    { name: "Otweabesa", regionCode: "08", districtCode: "02" },
    { name: "Otwekrom", regionCode: "08", districtCode: "02" },
    { name: "Owumpesika", regionCode: "08", districtCode: "02" },
    { name: "Owuominamu", regionCode: "08", districtCode: "02" },
    { name: "Paulkrom", regionCode: "08", districtCode: "02" },
    { name: "Pepekrom", regionCode: "08", districtCode: "02" },
    { name: "Prewodie", regionCode: "08", districtCode: "02" },
    { name: "Saponso", regionCode: "08", districtCode: "02" },
    { name: "Sekyere Obuase", regionCode: "08", districtCode: "02" },
    { name: "Soldierkrom", regionCode: "08", districtCode: "02" },
    { name: "Somnyame Kodu", regionCode: "08", districtCode: "02" },
    { name: "Somnyamekodor", regionCode: "08", districtCode: "02" },
    { name: "Suamire", regionCode: "08", districtCode: "02" },
    { name: "Subin", regionCode: "08", districtCode: "02" },
    { name: "Subrisu", regionCode: "08", districtCode: "02" },
    { name: "Suyhen", regionCode: "08", districtCode: "02" },
    { name: "Tawiah Nkwanta", regionCode: "08", districtCode: "02" },
    { name: "Taylor", regionCode: "08", districtCode: "02" },
    { name: "Tekyemso", regionCode: "08", districtCode: "02" },
    { name: "Tongor", regionCode: "08", districtCode: "02" },
    { name: "Tosen", regionCode: "08", districtCode: "02" },
    { name: "Treposo", regionCode: "08", districtCode: "02" },
    { name: "Tufoe", regionCode: "08", districtCode: "02" },
    { name: "Tweapease", regionCode: "08", districtCode: "02" },
    { name: "Twifo No. 2", regionCode: "08", districtCode: "02" },
    { name: "Twifo Sebenso", regionCode: "08", districtCode: "02" },
    { name: "Wamaso", regionCode: "08", districtCode: "02" },
    { name: "Wampam", regionCode: "08", districtCode: "02" },
    { name: "Wassa Obuase", regionCode: "08", districtCode: "02" },
    { name: "Yadena", regionCode: "08", districtCode: "02" },
    { name: "Yagyemah", regionCode: "08", districtCode: "02" },
    { name: "Ywifo Nyenasi", regionCode: "08", districtCode: "02" }
  ],
  "08-03": [
    { name: "Abaase", regionCode: "08", districtCode: "03" },
    { name: "Abaase 2", regionCode: "08", districtCode: "03" },
    { name: "Abas", regionCode: "08", districtCode: "03" },
    { name: "Abease", regionCode: "08", districtCode: "03" },
    { name: "Aben", regionCode: "08", districtCode: "03" },
    { name: "Aboabo Camp", regionCode: "08", districtCode: "03" },
    { name: "Abodwese", regionCode: "08", districtCode: "03" },
    { name: "Abodweseso", regionCode: "08", districtCode: "03" },
    { name: "Abotareye", regionCode: "08", districtCode: "03" },
    { name: "Adabo", regionCode: "08", districtCode: "03" },
    { name: "Adadientem No.1", regionCode: "08", districtCode: "03" },
    { name: "Adadientem No.2", regionCode: "08", districtCode: "03" },
    { name: "Adadientem No.3", regionCode: "08", districtCode: "03" },
    { name: "Adeambra", regionCode: "08", districtCode: "03" },
    { name: "Adukwaku", regionCode: "08", districtCode: "03" },
    { name: "Adze Ne Woze", regionCode: "08", districtCode: "03" },
    { name: "Ahasowodze", regionCode: "08", districtCode: "03" },
    { name: "Ahuntem", regionCode: "08", districtCode: "03" },
    { name: "Akonfodi", regionCode: "08", districtCode: "03" },
    { name: "Akropong", regionCode: "08", districtCode: "03" },
    { name: "Akropong Odumase", regionCode: "08", districtCode: "03" },
    { name: "Akumeni", regionCode: "08", districtCode: "03" },
    { name: "Akwanhyiam", regionCode: "08", districtCode: "03" },
    { name: "Akwetey", regionCode: "08", districtCode: "03" },
    { name: "Akwetey Beposo", regionCode: "08", districtCode: "03" },
    { name: "Akwetey Nkwantanan", regionCode: "08", districtCode: "03" },
    { name: "Akyeano", regionCode: "08", districtCode: "03" },
    { name: "Amamete (Larteh)", regionCode: "08", districtCode: "03" },
    { name: "Amarh Camp", regionCode: "08", districtCode: "03" },
    { name: "Amoabeng", regionCode: "08", districtCode: "03" },
    { name: "Amoanim", regionCode: "08", districtCode: "03" },
    { name: "Amoati", regionCode: "08", districtCode: "03" },
    { name: "Anhwiase", regionCode: "08", districtCode: "03" },
    { name: "Anhwiase Nkwanta", regionCode: "08", districtCode: "03" },
    { name: "Aniakragya", regionCode: "08", districtCode: "03" },
    { name: "Ankaa", regionCode: "08", districtCode: "03" },
    { name: "Ankaful", regionCode: "08", districtCode: "03" },
    { name: "Anto Abasa", regionCode: "08", districtCode: "03" },
    { name: "Appiahkrom", regionCode: "08", districtCode: "03" },
    { name: "Asaibrim", regionCode: "08", districtCode: "03" },
    { name: "Asaman", regionCode: "08", districtCode: "03" },
    { name: "Asan", regionCode: "08", districtCode: "03" },
    { name: "Asanso", regionCode: "08", districtCode: "03" },
    { name: "Asartoase", regionCode: "08", districtCode: "03" },
    { name: "Asempaneye", regionCode: "08", districtCode: "03" },
    { name: "Asibirim", regionCode: "08", districtCode: "03" },
    { name: "Asorefie", regionCode: "08", districtCode: "03" },
    { name: "Assin Breku", regionCode: "08", districtCode: "03" },
    { name: "Assin Damtsekrom", regionCode: "08", districtCode: "03" },
    { name: "Assin Nyamebebu", regionCode: "08", districtCode: "03" },
    { name: "Assin Ongwa", regionCode: "08", districtCode: "03" },
    { name: "Asuoankomaso", regionCode: "08", districtCode: "03" },
    { name: "Atia Labadi", regionCode: "08", districtCode: "03" },
    { name: "Attah Panyin", regionCode: "08", districtCode: "03" },
    { name: "Atwereboana", regionCode: "08", districtCode: "03" },
    { name: "Awisam", regionCode: "08", districtCode: "03" },
    { name: "Ayaase", regionCode: "08", districtCode: "03" },
    { name: "Ayigbefuom", regionCode: "08", districtCode: "03" },
    { name: "Ayigebfuom", regionCode: "08", districtCode: "03" },
    { name: "Baifikrom", regionCode: "08", districtCode: "03" },
    { name: "Baki/Lamtey", regionCode: "08", districtCode: "03" },
    { name: "Bankyease", regionCode: "08", districtCode: "03" },
    { name: "Banyin", regionCode: "08", districtCode: "03" },
    { name: "Bedeidua", regionCode: "08", districtCode: "03" },
    { name: "Besease No.2", regionCode: "08", districtCode: "03" },
    { name: "Besedurasi", regionCode: "08", districtCode: "03" },
    { name: "Betwase", regionCode: "08", districtCode: "03" },
    { name: "Beyeeden", regionCode: "08", districtCode: "03" },
    { name: "Bobakokrowa", regionCode: "08", districtCode: "03" },
    { name: "Borkai/Lamptey", regionCode: "08", districtCode: "03" },
    { name: "Breku Ninkyiso", regionCode: "08", districtCode: "03" },
    { name: "Bresiako", regionCode: "08", districtCode: "03" },
    { name: "Brisco Camp", regionCode: "08", districtCode: "03" },
    { name: "Cee Camp", regionCode: "08", districtCode: "03" },
    { name: "Cocoa Research", regionCode: "08", districtCode: "03" },
    { name: "Cocoa Station", regionCode: "08", districtCode: "03" },
    { name: "Dansame", regionCode: "08", districtCode: "03" },
    { name: "Densekrom", regionCode: "08", districtCode: "03" },
    { name: "Densekrom No. 2", regionCode: "08", districtCode: "03" },
    { name: "Dii Bolase", regionCode: "08", districtCode: "03" },
    { name: "Dominase", regionCode: "08", districtCode: "03" },
    { name: "Donkorkrom", regionCode: "08", districtCode: "03" },
    { name: "Dosi", regionCode: "08", districtCode: "03" },
    { name: "Duofo", regionCode: "08", districtCode: "03" },
    { name: "Dwenase", regionCode: "08", districtCode: "03" },
    { name: "Dwenedaama", regionCode: "08", districtCode: "03" },
    { name: "Endwa", regionCode: "08", districtCode: "03" },
    { name: "Fanti", regionCode: "08", districtCode: "03" },
    { name: "Fawomanye", regionCode: "08", districtCode: "03" },
    { name: "Fosu Bantama", regionCode: "08", districtCode: "03" },
    { name: "Fosu Dunkwa", regionCode: "08", districtCode: "03" },
    { name: "Framase 1", regionCode: "08", districtCode: "03" },
    { name: "Framase 2", regionCode: "08", districtCode: "03" },
    { name: "Frame No.3 Nyamebekyere", regionCode: "08", districtCode: "03" },
    { name: "Ganan", regionCode: "08", districtCode: "03" },
    { name: "Gangan", regionCode: "08", districtCode: "03" },
    { name: "Gyahdaze", regionCode: "08", districtCode: "03" },
    { name: "Gyinabodie", regionCode: "08", districtCode: "03" },
    { name: "Haruna", regionCode: "08", districtCode: "03" },
    { name: "Hasowodze", regionCode: "08", districtCode: "03" },
    { name: "Homaho N.T", regionCode: "08", districtCode: "03" },
    { name: "Homaho Nkwanta", regionCode: "08", districtCode: "03" },
    { name: "Homaho O.T", regionCode: "08", districtCode: "03" },
    { name: "Jakai", regionCode: "08", districtCode: "03" },
    { name: "Jerusalem", regionCode: "08", districtCode: "03" },
    { name: "Jerusalem (Ankaa #2)", regionCode: "08", districtCode: "03" },
    { name: "Kano", regionCode: "08", districtCode: "03" },
    { name: "Kasim", regionCode: "08", districtCode: "03" },
    { name: "Kedadwen Village", regionCode: "08", districtCode: "03" },
    { name: "Kofitaam", regionCode: "08", districtCode: "03" },
    { name: "Konaboe/Gangan", regionCode: "08", districtCode: "03" },
    { name: "Kotobaabi", regionCode: "08", districtCode: "03" },
    { name: "Kramokrom", regionCode: "08", districtCode: "03" },
    { name: "Krobo Bangalow", regionCode: "08", districtCode: "03" },
    { name: "Krofoforso", regionCode: "08", districtCode: "03" },
    { name: "Krokoso", regionCode: "08", districtCode: "03" },
    { name: "Kukari/Forson", regionCode: "08", districtCode: "03" },
    { name: "Kushia", regionCode: "08", districtCode: "03" },
    { name: "Kwafokrpm", regionCode: "08", districtCode: "03" },
    { name: "Kwakurom", regionCode: "08", districtCode: "03" },
    { name: "Kwame Amoabeng", regionCode: "08", districtCode: "03" },
    { name: "Kwame Ankra", regionCode: "08", districtCode: "03" },
    { name: "Kwame Attah", regionCode: "08", districtCode: "03" },
    { name: "Kwansakrom", regionCode: "08", districtCode: "03" },
    { name: "Kwasiadu/Afenase", regionCode: "08", districtCode: "03" },
    { name: "Kweku Addo", regionCode: "08", districtCode: "03" },
    { name: "Kyeikrom", regionCode: "08", districtCode: "03" },
    { name: "Mankata 1", regionCode: "08", districtCode: "03" },
    { name: "Mankata 2", regionCode: "08", districtCode: "03" },
    { name: "Manpong", regionCode: "08", districtCode: "03" },
    { name: "Mawoniha", regionCode: "08", districtCode: "03" },
    { name: "Mesomagor", regionCode: "08", districtCode: "03" },
    { name: "Mesrenyame", regionCode: "08", districtCode: "03" },
    { name: "Mpease", regionCode: "08", districtCode: "03" },
    { name: "Mpeasem", regionCode: "08", districtCode: "03" },
    { name: "Mpenteboa", regionCode: "08", districtCode: "03" },
    { name: "Nduaso", regionCode: "08", districtCode: "03" },
    { name: "Nigo Asorefie", regionCode: "08", districtCode: "03" },
    { name: "Nipa Hia Moa", regionCode: "08", districtCode: "03" },
    { name: "Nkranfo", regionCode: "08", districtCode: "03" },
    { name: "Nkransafuom", regionCode: "08", districtCode: "03" },
    { name: "Nkukuasa", regionCode: "08", districtCode: "03" },
    { name: "Norkroma", regionCode: "08", districtCode: "03" },
    { name: "Nsene", regionCode: "08", districtCode: "03" },
    { name: "Ntowkrom", regionCode: "08", districtCode: "03" },
    { name: "Nuanua Agave", regionCode: "08", districtCode: "03" },
    { name: "Nuanua Bonso", regionCode: "08", districtCode: "03" },
    { name: "Nuanua Krobo", regionCode: "08", districtCode: "03" },
    { name: "Nuanua Shed", regionCode: "08", districtCode: "03" },
    { name: "Nyamebekyere", regionCode: "08", districtCode: "03" },
    { name: "Nyamebekyere 1", regionCode: "08", districtCode: "03" },
    { name: "Nyamebekyere 2", regionCode: "08", districtCode: "03" },
    { name: "Nyamebekyere(Framase)", regionCode: "08", districtCode: "03" },
    { name: "Nyamebeyere", regionCode: "08", districtCode: "03" },
    { name: "Nyamekye", regionCode: "08", districtCode: "03" },
    { name: "Nyameyedur", regionCode: "08", districtCode: "03" },
    { name: "Nyamtse", regionCode: "08", districtCode: "03" },
    { name: "Nyardoam", regionCode: "08", districtCode: "03" },
    { name: "Obirikweku", regionCode: "08", districtCode: "03" },
    { name: "Obirikweku No. 2", regionCode: "08", districtCode: "03" },
    { name: "Obrawomiem", regionCode: "08", districtCode: "03" },
    { name: "Obrayeko", regionCode: "08", districtCode: "03" },
    { name: "Obrikweku", regionCode: "08", districtCode: "03" },
    { name: "Ochiso", regionCode: "08", districtCode: "03" },
    { name: "Odumase Adiembra", regionCode: "08", districtCode: "03" },
    { name: "Oduomenim", regionCode: "08", districtCode: "03" },
    { name: "Otabil Nkwanta", regionCode: "08", districtCode: "03" },
    { name: "Otabilkrom", regionCode: "08", districtCode: "03" },
    { name: "Pra Agave", regionCode: "08", districtCode: "03" },
    { name: "Pra Ayensu", regionCode: "08", districtCode: "03" },
    { name: "Sabema", regionCode: "08", districtCode: "03" },
    { name: "Sargent 1", regionCode: "08", districtCode: "03" },
    { name: "Sarrgent 2", regionCode: "08", districtCode: "03" },
    { name: "Seichem Agave", regionCode: "08", districtCode: "03" },
    { name: "Seidukrom", regionCode: "08", districtCode: "03" },
    { name: "Sekan Bodua", regionCode: "08", districtCode: "03" },
    { name: "Seseko", regionCode: "08", districtCode: "03" },
    { name: "Simpa", regionCode: "08", districtCode: "03" },
    { name: "Subinso", regionCode: "08", districtCode: "03" },
    { name: "Subriso", regionCode: "08", districtCode: "03" },
    { name: "Swedru Akwapim", regionCode: "08", districtCode: "03" },
    { name: "Taankwa", regionCode: "08", districtCode: "03" },
    { name: "Tabil", regionCode: "08", districtCode: "03" },
    { name: "Tatare Nkwanta", regionCode: "08", districtCode: "03" },
    { name: "Teacher Amoah", regionCode: "08", districtCode: "03" },
    { name: "Techiman", regionCode: "08", districtCode: "03" },
    { name: "Tehenete", regionCode: "08", districtCode: "03" },
    { name: "Togo", regionCode: "08", districtCode: "03" },
    { name: "Tomfokrom", regionCode: "08", districtCode: "03" },
    { name: "Tutuda", regionCode: "08", districtCode: "03" },
    { name: "Twumasi", regionCode: "08", districtCode: "03" },
    { name: "Wawase", regionCode: "08", districtCode: "03" },
    { name: "Wawase #2", regionCode: "08", districtCode: "03" },
    { name: "Worakese", regionCode: "08", districtCode: "03" },
    { name: "Worakese Camp", regionCode: "08", districtCode: "03" },
    { name: "Worakese Station", regionCode: "08", districtCode: "03" },
    { name: "Yanney Camp", regionCode: "08", districtCode: "03" },
    { name: "Yaw Attah", regionCode: "08", districtCode: "03" },
    { name: "Yaw Boamah", regionCode: "08", districtCode: "03" },
    { name: "Yaw Samankrom", regionCode: "08", districtCode: "03" },
    { name: "Zamboli", regionCode: "08", districtCode: "03" }
  ],
  "08-04": [
    { name: "Abaasa", regionCode: "08", districtCode: "04" },
    { name: "Abamkrom", regionCode: "08", districtCode: "04" },
    { name: "Abankrom", regionCode: "08", districtCode: "04" },
    { name: "Aboase", regionCode: "08", districtCode: "04" },
    { name: "Abompi", regionCode: "08", districtCode: "04" },
    { name: "Abontse", regionCode: "08", districtCode: "04" },
    { name: "Abura Ahomfi", regionCode: "08", districtCode: "04" },
    { name: "Abura Ahunde", regionCode: "08", districtCode: "04" },
    { name: "Abura Akotsia Boomu", regionCode: "08", districtCode: "04" },
    { name: "Abura Akotsia Kokodo", regionCode: "08", districtCode: "04" },
    { name: "Abura Betingua", regionCode: "08", districtCode: "04" },
    { name: "Abura Gyabankrom", regionCode: "08", districtCode: "04" },
    { name: "Abura Kankabum", regionCode: "08", districtCode: "04" },
    { name: "Abura Odumase", regionCode: "08", districtCode: "04" },
    { name: "Abura Papagya", regionCode: "08", districtCode: "04" },
    { name: "Achiase", regionCode: "08", districtCode: "04" },
    { name: "Adambo", regionCode: "08", districtCode: "04" },
    { name: "Adoagyir", regionCode: "08", districtCode: "04" },
    { name: "Afafa", regionCode: "08", districtCode: "04" },
    { name: "Agyirefa", regionCode: "08", districtCode: "04" },
    { name: "Ahenhrom", regionCode: "08", districtCode: "04" },
    { name: "Akokokrom", regionCode: "08", districtCode: "04" },
    { name: "Akonoma", regionCode: "08", districtCode: "04" },
    { name: "Akowa", regionCode: "08", districtCode: "04" },
    { name: "Aminsakrom Ekorful", regionCode: "08", districtCode: "04" },
    { name: "Amisakrom Ekroful", regionCode: "08", districtCode: "04" },
    { name: "Amprefu", regionCode: "08", districtCode: "04" },
    { name: "Aniakragya", regionCode: "08", districtCode: "04" },
    { name: "Anokye", regionCode: "08", districtCode: "04" },
    { name: "Anomabo Esuekyir", regionCode: "08", districtCode: "04" },
    { name: "Anomansa", regionCode: "08", districtCode: "04" },
    { name: "Antsaadze", regionCode: "08", districtCode: "04" },
    { name: "Apaakrom", regionCode: "08", districtCode: "04" },
    { name: "Apenkwakrom", regionCode: "08", districtCode: "04" },
    { name: "Aponapondo", regionCode: "08", districtCode: "04" },
    { name: "Asamase", regionCode: "08", districtCode: "04" },
    { name: "Asebu Akroful", regionCode: "08", districtCode: "04" },
    { name: "Asebu Fawomanye", regionCode: "08", districtCode: "04" },
    { name: "Asebufokrom", regionCode: "08", districtCode: "04" },
    { name: "Asebupatase", regionCode: "08", districtCode: "04" },
    { name: "Aseibu Patase", regionCode: "08", districtCode: "04" },
    { name: "Asekyerebedzi", regionCode: "08", districtCode: "04" },
    { name: "Asomdwee", regionCode: "08", districtCode: "04" },
    { name: "Assin Afaw", regionCode: "08", districtCode: "04" },
    { name: "Assin Beposo", regionCode: "08", districtCode: "04" },
    { name: "Assin Saamang", regionCode: "08", districtCode: "04" },
    { name: "Awunafokrom", regionCode: "08", districtCode: "04" },
    { name: "Baidukrom", regionCode: "08", districtCode: "04" },
    { name: "Bosomadze", regionCode: "08", districtCode: "04" },
    { name: "Bosomadze No.1", regionCode: "08", districtCode: "04" },
    { name: "Bosomadze No.2 /Mountains", regionCode: "08", districtCode: "04" },
    { name: "Brebia", regionCode: "08", districtCode: "04" },
    { name: "Brenyi", regionCode: "08", districtCode: "04" },
    { name: "Brofoyedur", regionCode: "08", districtCode: "04" },
    { name: "Buranamoa", regionCode: "08", districtCode: "04" },
    { name: "Daman", regionCode: "08", districtCode: "04" },
    { name: "Duadze", regionCode: "08", districtCode: "04" },
    { name: "Dunkwa", regionCode: "08", districtCode: "04" },
    { name: "Dunkwa Hospital Area", regionCode: "08", districtCode: "04" },
    { name: "Dunkwa Kojoabem", regionCode: "08", districtCode: "04" },
    { name: "Dwendamba", regionCode: "08", districtCode: "04" },
    { name: "Edukuma", regionCode: "08", districtCode: "04" },
    { name: "Eduma", regionCode: "08", districtCode: "04" },
    { name: "Edumanu Onyapa", regionCode: "08", districtCode: "04" },
    { name: "Edumanu/Onyapa", regionCode: "08", districtCode: "04" },
    { name: "Edzimor", regionCode: "08", districtCode: "04" },
    { name: "Efutuakwa", regionCode: "08", districtCode: "04" },
    { name: "Egyirifa", regionCode: "08", districtCode: "04" },
    { name: "Ekroful", regionCode: "08", districtCode: "04" },
    { name: "Ekumafi Dunkwa", regionCode: "08", districtCode: "04" },
    { name: "Ekumfi Abaka", regionCode: "08", districtCode: "04" },
    { name: "Ekumfi Buadu Kwaah", regionCode: "08", districtCode: "04" },
    { name: "Ekumfi Kotokwaa", regionCode: "08", districtCode: "04" },
    { name: "Ekumfi Potwaben", regionCode: "08", districtCode: "04" },
    { name: "Ekumfi Sarkwa", regionCode: "08", districtCode: "04" },
    { name: "Ekunfi Abaka", regionCode: "08", districtCode: "04" },
    { name: "Ekunfi Dunkwa", regionCode: "08", districtCode: "04" },
    { name: "Engow", regionCode: "08", districtCode: "04" },
    { name: "Eshiro", regionCode: "08", districtCode: "04" },
    { name: "Esiakrom", regionCode: "08", districtCode: "04" },
    { name: "Esiamotan", regionCode: "08", districtCode: "04" },
    { name: "Esiamutan", regionCode: "08", districtCode: "04" },
    { name: "Esien", regionCode: "08", districtCode: "04" },
    { name: "Essaman", regionCode: "08", districtCode: "04" },
    { name: "Essandokrom", regionCode: "08", districtCode: "04" },
    { name: "Esuaso(Asuaso)", regionCode: "08", districtCode: "04" },
    { name: "Ewoyaa", regionCode: "08", districtCode: "04" },
    { name: "Fortwekrom", regionCode: "08", districtCode: "04" },
    { name: "Fortwekrom 1", regionCode: "08", districtCode: "04" },
    { name: "Fortwekrom 2", regionCode: "08", districtCode: "04" },
    { name: "Gyandokrom", regionCode: "08", districtCode: "04" },
    { name: "Gyenkuma", regionCode: "08", districtCode: "04" },
    { name: "Jakai", regionCode: "08", districtCode: "04" },
    { name: "Jedu", regionCode: "08", districtCode: "04" },
    { name: "Jerusalem, Madina & Anamwodo", regionCode: "08", districtCode: "04" },
    { name: "Kadeogya 1", regionCode: "08", districtCode: "04" },
    { name: "Kakraka", regionCode: "08", districtCode: "04" },
    { name: "Kamkamkrom", regionCode: "08", districtCode: "04" },
    { name: "Kankamkrom", regionCode: "08", districtCode: "04" },
    { name: "Kankansi", regionCode: "08", districtCode: "04" },
    { name: "Kawansire", regionCode: "08", districtCode: "04" },
    { name: "Kojo Aben", regionCode: "08", districtCode: "04" },
    { name: "Kokoado", regionCode: "08", districtCode: "04" },
    { name: "Kokorade", regionCode: "08", districtCode: "04" },
    { name: "Korado", regionCode: "08", districtCode: "04" },
    { name: "Krakyekrom", regionCode: "08", districtCode: "04" },
    { name: "Krampakrom", regionCode: "08", districtCode: "04" },
    { name: "Kroforfordo", regionCode: "08", districtCode: "04" },
    { name: "Kwadoegya Newsite", regionCode: "08", districtCode: "04" },
    { name: "Kwasi Ammakrom", regionCode: "08", districtCode: "04" },
    { name: "Kwasi Armah", regionCode: "08", districtCode: "04" },
    { name: "Kwekutu", regionCode: "08", districtCode: "04" },
    { name: "Kyekyere", regionCode: "08", districtCode: "04" },
    { name: "Mahami", regionCode: "08", districtCode: "04" },
    { name: "Mmiensa", regionCode: "08", districtCode: "04" },
    { name: "Musunkwa", regionCode: "08", districtCode: "04" },
    { name: "New Kwadoagya 1", regionCode: "08", districtCode: "04" },
    { name: "Nkander", regionCode: "08", districtCode: "04" },
    { name: "Nkwantanan", regionCode: "08", districtCode: "04" },
    { name: "Nsaadze", regionCode: "08", districtCode: "04" },
    { name: "Nyamebekyere", regionCode: "08", districtCode: "04" },
    { name: "Nyamegyeme", regionCode: "08", districtCode: "04" },
    { name: "Obenekrom", regionCode: "08", districtCode: "04" },
    { name: "Obidam", regionCode: "08", districtCode: "04" },
    { name: "Obinim", regionCode: "08", districtCode: "04" },
    { name: "Obokor", regionCode: "08", districtCode: "04" },
    { name: "Obontsir", regionCode: "08", districtCode: "04" },
    { name: "Obratwawo", regionCode: "08", districtCode: "04" },
    { name: "Obukor", regionCode: "08", districtCode: "04" },
    { name: "Odonkwa", regionCode: "08", districtCode: "04" },
    { name: "Odumano Abeadze", regionCode: "08", districtCode: "04" },
    { name: "Odumasi", regionCode: "08", districtCode: "04" },
    { name: "Oframsi", regionCode: "08", districtCode: "04" },
    { name: "Ogoekrom", regionCode: "08", districtCode: "04" },
    { name: "Oguaakuma", regionCode: "08", districtCode: "04" },
    { name: "Ohennekwa", regionCode: "08", districtCode: "04" },
    { name: "Okweisikrom", regionCode: "08", districtCode: "04" },
    { name: "Okyiriku", regionCode: "08", districtCode: "04" },
    { name: "Omanpado", regionCode: "08", districtCode: "04" },
    { name: "Onsonyameye", regionCode: "08", districtCode: "04" },
    { name: "Opem", regionCode: "08", districtCode: "04" },
    { name: "Ouadze", regionCode: "08", districtCode: "04" },
    { name: "Owofa", regionCode: "08", districtCode: "04" },
    { name: "Owuyam", regionCode: "08", districtCode: "04" },
    { name: "Owuyaw Ekunfi", regionCode: "08", districtCode: "04" },
    { name: "Pebi", regionCode: "08", districtCode: "04" },
    { name: "Saafa", regionCode: "08", districtCode: "04" },
    { name: "Saafa 3", regionCode: "08", districtCode: "04" },
    { name: "Saafa Bebianeha", regionCode: "08", districtCode: "04" },
    { name: "Sekyere", regionCode: "08", districtCode: "04" },
    { name: "Sorodoso", regionCode: "08", districtCode: "04" },
    { name: "Techiman", regionCode: "08", districtCode: "04" },
    { name: "Thompsonkrom", regionCode: "08", districtCode: "04" },
    { name: "Towoboase", regionCode: "08", districtCode: "04" },
    { name: "Towobuase", regionCode: "08", districtCode: "04" },
    { name: "Tsetsekasom", regionCode: "08", districtCode: "04" },
    { name: "Tsetsekasum", regionCode: "08", districtCode: "04" },
    { name: "Tsetsekasum No.2", regionCode: "08", districtCode: "04" },
    { name: "Tsetsi", regionCode: "08", districtCode: "04" },
    { name: "Tuafo", regionCode: "08", districtCode: "04" },
    { name: "Waakrom", regionCode: "08", districtCode: "04" },
    { name: "Yawsekyirom", regionCode: "08", districtCode: "04" }
  ],
  "08-05": [
    { name: "Abeadze", regionCode: "08", districtCode: "05" },
    { name: "Abekah", regionCode: "08", districtCode: "05" },
    { name: "Aborafua", regionCode: "08", districtCode: "05" },
    { name: "Afosu", regionCode: "08", districtCode: "05" },
    { name: "Ahamakramua", regionCode: "08", districtCode: "05" },
    { name: "Ajumako Osedzi", regionCode: "08", districtCode: "05" },
    { name: "Akotogua", regionCode: "08", districtCode: "05" },
    { name: "Amoanda", regionCode: "08", districtCode: "05" },
    { name: "Amoanda No.1", regionCode: "08", districtCode: "05" },
    { name: "Amoanda No.2", regionCode: "08", districtCode: "05" },
    { name: "Atakorase", regionCode: "08", districtCode: "05" },
    { name: "Attakurase", regionCode: "08", districtCode: "05" },
    { name: "Aworodo", regionCode: "08", districtCode: "05" },
    { name: "Bekoso", regionCode: "08", districtCode: "05" },
    { name: "Bewura", regionCode: "08", districtCode: "05" },
    { name: "Bibianeha", regionCode: "08", districtCode: "05" },
    { name: "Bobeberedan", regionCode: "08", districtCode: "05" },
    { name: "Bordenkwaa", regionCode: "08", districtCode: "05" },
    { name: "Breman Anyinasu", regionCode: "08", districtCode: "05" },
    { name: "Breman Boso", regionCode: "08", districtCode: "05" },
    { name: "Breman Fawomanye", regionCode: "08", districtCode: "05" },
    { name: "Budukrom", regionCode: "08", districtCode: "05" },
    { name: "Budukwaa", regionCode: "08", districtCode: "05" },
    { name: "Denkyedua", regionCode: "08", districtCode: "05" },
    { name: "Dwenadze", regionCode: "08", districtCode: "05" },
    { name: "Edumaim", regionCode: "08", districtCode: "05" },
    { name: "Eduokrom", regionCode: "08", districtCode: "05" },
    { name: "Edwumaim", regionCode: "08", districtCode: "05" },
    { name: "Ekukrom", regionCode: "08", districtCode: "05" },
    { name: "Ekwamase", regionCode: "08", districtCode: "05" },
    { name: "Enan", regionCode: "08", districtCode: "05" },
    { name: "Entumbil", regionCode: "08", districtCode: "05" },
    { name: "Enyan Denkyira", regionCode: "08", districtCode: "05" },
    { name: "Esaadze", regionCode: "08", districtCode: "05" },
    { name: "Esaaman", regionCode: "08", districtCode: "05" },
    { name: "Esti Fawomanya", regionCode: "08", districtCode: "05" },
    { name: "Etsi Atwereboanda", regionCode: "08", districtCode: "05" },
    { name: "Etsi Enyinasu", regionCode: "08", districtCode: "05" },
    { name: "Etsi Nkatsim", regionCode: "08", districtCode: "05" },
    { name: "Etsi Sunkwaa", regionCode: "08", districtCode: "05" },
    { name: "Fomena", regionCode: "08", districtCode: "05" },
    { name: "Kokoado", regionCode: "08", districtCode: "05" },
    { name: "Kokwaado", regionCode: "08", districtCode: "05" },
    { name: "Kwakokwa", regionCode: "08", districtCode: "05" },
    { name: "Kwanyako", regionCode: "08", districtCode: "05" },
    { name: "Kwanyako Abeadze", regionCode: "08", districtCode: "05" },
    { name: "Kwekukwaa", regionCode: "08", districtCode: "05" },
    { name: "Kwesi Gyan No.1", regionCode: "08", districtCode: "05" },
    { name: "Kwesi Gyan No.2", regionCode: "08", districtCode: "05" },
    { name: "Kyebil", regionCode: "08", districtCode: "05" },
    { name: "Mesrenyame", regionCode: "08", districtCode: "05" },
    { name: "Nkrumahakurase", regionCode: "08", districtCode: "05" },
    { name: "Nkwantakesedo", regionCode: "08", districtCode: "05" },
    { name: "Nkwantanan", regionCode: "08", districtCode: "05" },
    { name: "Nsawadze", regionCode: "08", districtCode: "05" },
    { name: "Oboame", regionCode: "08", districtCode: "05" },
    { name: "Obontser", regionCode: "08", districtCode: "05" },
    { name: "Oboom", regionCode: "08", districtCode: "05" },
    { name: "Obrawogum", regionCode: "08", districtCode: "05" },
    { name: "Obrawogum Junction", regionCode: "08", districtCode: "05" },
    { name: "Ochiso", regionCode: "08", districtCode: "05" },
    { name: "Ogoeokrom", regionCode: "08", districtCode: "05" },
    { name: "Ohyira", regionCode: "08", districtCode: "05" },
    { name: "Okokodo", regionCode: "08", districtCode: "05" },
    { name: "Okuadze", regionCode: "08", districtCode: "05" },
    { name: "Okwahu", regionCode: "08", districtCode: "05" },
    { name: "Opepease", regionCode: "08", districtCode: "05" },
    { name: "Solomon", regionCode: "08", districtCode: "05" }
  ],
  "08-06": [
    { name: "Abekese/Abayaakes", regionCode: "08", districtCode: "06" },
    { name: "Abekuase", regionCode: "08", districtCode: "06" },
    { name: "Abuakua", regionCode: "08", districtCode: "06" },
    { name: "Adendan", regionCode: "08", districtCode: "06" },
    { name: "Adousia", regionCode: "08", districtCode: "06" },
    { name: "Adukwaa", regionCode: "08", districtCode: "06" },
    { name: "Adumanu", regionCode: "08", districtCode: "06" },
    { name: "Affumkwaa", regionCode: "08", districtCode: "06" },
    { name: "Afofosu", regionCode: "08", districtCode: "06" },
    { name: "Agona Nkum", regionCode: "08", districtCode: "06" },
    { name: "Agowase", regionCode: "08", districtCode: "06" },
    { name: "Ahomadonko", regionCode: "08", districtCode: "06" },
    { name: "Amambeteno No.1", regionCode: "08", districtCode: "06" },
    { name: "Amannor Krom", regionCode: "08", districtCode: "06" },
    { name: "Anibrenye", regionCode: "08", districtCode: "06" },
    { name: "Ankaase", regionCode: "08", districtCode: "06" },
    { name: "Asebiem", regionCode: "08", districtCode: "06" },
    { name: "Asempaneye", regionCode: "08", districtCode: "06" },
    { name: "Asorefum", regionCode: "08", districtCode: "06" },
    { name: "Asumjuekrom", regionCode: "08", districtCode: "06" },
    { name: "Asuoku", regionCode: "08", districtCode: "06" },
    { name: "Attuduada", regionCode: "08", districtCode: "06" },
    { name: "Awusem", regionCode: "08", districtCode: "06" },
    { name: "Awusikwa", regionCode: "08", districtCode: "06" },
    { name: "Ayewaso", regionCode: "08", districtCode: "06" },
    { name: "Bepokokoo", regionCode: "08", districtCode: "06" },
    { name: "Beponta", regionCode: "08", districtCode: "06" },
    { name: "Bomenkwata", regionCode: "08", districtCode: "06" },
    { name: "Brakwaeshiem", regionCode: "08", districtCode: "06" },
    { name: "Breman Anhwiam", regionCode: "08", districtCode: "06" },
    { name: "Breman Besease", regionCode: "08", districtCode: "06" },
    { name: "Breman Worakesi", regionCode: "08", districtCode: "06" },
    { name: "Camp C", regionCode: "08", districtCode: "06" },
    { name: "Dawuranpong", regionCode: "08", districtCode: "06" },
    { name: "Diabene", regionCode: "08", districtCode: "06" },
    { name: "Domeabra", regionCode: "08", districtCode: "06" },
    { name: "Dorkunukwata", regionCode: "08", districtCode: "06" },
    { name: "Dwendamba", regionCode: "08", districtCode: "06" },
    { name: "Ehiehu", regionCode: "08", districtCode: "06" },
    { name: "Ekurakese Supuano", regionCode: "08", districtCode: "06" },
    { name: "Essuman Gwira", regionCode: "08", districtCode: "06" },
    { name: "Fankyeneko", regionCode: "08", districtCode: "06" },
    { name: "Kawanopado", regionCode: "08", districtCode: "06" },
    { name: "Kojokuma", regionCode: "08", districtCode: "06" },
    { name: "Kokowado", regionCode: "08", districtCode: "06" },
    { name: "Kwaku-Bua", regionCode: "08", districtCode: "06" },
    { name: "Kwame Ego", regionCode: "08", districtCode: "06" },
    { name: "Kwanan Kwaa", regionCode: "08", districtCode: "06" },
    { name: "Kwekuninsin", regionCode: "08", districtCode: "06" },
    { name: "Kyiraka", regionCode: "08", districtCode: "06" },
    { name: "Manhugu", regionCode: "08", districtCode: "06" },
    { name: "Mpakyem", regionCode: "08", districtCode: "06" },
    { name: "Nankese", regionCode: "08", districtCode: "06" },
    { name: "Nkubem", regionCode: "08", districtCode: "06" },
    { name: "Nkukrom", regionCode: "08", districtCode: "06" },
    { name: "Nsuasa", regionCode: "08", districtCode: "06" },
    { name: "Nsuasa No.1", regionCode: "08", districtCode: "06" },
    { name: "Nyamento Nkom", regionCode: "08", districtCode: "06" },
    { name: "Nyansakyere", regionCode: "08", districtCode: "06" },
    { name: "Obosomasi", regionCode: "08", districtCode: "06" },
    { name: "Odumkweku", regionCode: "08", districtCode: "06" },
    { name: "Ofabir-Bekuase", regionCode: "08", districtCode: "06" },
    { name: "Ogunase", regionCode: "08", districtCode: "06" },
    { name: "Ohiahyeda", regionCode: "08", districtCode: "06" },
    { name: "Ohrabo", regionCode: "08", districtCode: "06" },
    { name: "Otabilkwaa", regionCode: "08", districtCode: "06" },
    { name: "Petukyer", regionCode: "08", districtCode: "06" },
    { name: "Saviour Town", regionCode: "08", districtCode: "06" },
    { name: "Sowotuom", regionCode: "08", districtCode: "06" },
    { name: "Suponso", regionCode: "08", districtCode: "06" },
    { name: "Towoboase", regionCode: "08", districtCode: "06" },
    { name: "Tweredua", regionCode: "08", districtCode: "06" },
    { name: "Wansabriampa", regionCode: "08", districtCode: "06" },
    { name: "Wanyato", regionCode: "08", districtCode: "06" },
    { name: "Yukuwa", regionCode: "08", districtCode: "06" }
  ],
  "08-07": [
    { name: "Abankwaim", regionCode: "08", districtCode: "07" },
    { name: "Aboano", regionCode: "08", districtCode: "07" },
    { name: "Aburafoa", regionCode: "08", districtCode: "07" },
    { name: "Achiase", regionCode: "08", districtCode: "07" },
    { name: "Adukore/Agyakofi", regionCode: "08", districtCode: "07" },
    { name: "Agona Abodom", regionCode: "08", districtCode: "07" },
    { name: "Agona Mensakrom", regionCode: "08", districtCode: "07" },
    { name: "Agona Nyarkrom", regionCode: "08", districtCode: "07" },
    { name: "Ahenkwaa", regionCode: "08", districtCode: "07" },
    { name: "Akoransa", regionCode: "08", districtCode: "07" },
    { name: "Akropong", regionCode: "08", districtCode: "07" },
    { name: "Akurafufuw", regionCode: "08", districtCode: "07" },
    { name: "Akwaku", regionCode: "08", districtCode: "07" },
    { name: "Amanful", regionCode: "08", districtCode: "07" },
    { name: "Anhwiaa Fitaa", regionCode: "08", districtCode: "07" },
    { name: "Appiakrom Debiso", regionCode: "08", districtCode: "07" },
    { name: "Asamoakrom", regionCode: "08", districtCode: "07" },
    { name: "Asarekwa", regionCode: "08", districtCode: "07" },
    { name: "Assin", regionCode: "08", districtCode: "07" },
    { name: "Awutu Bontreso", regionCode: "08", districtCode: "07" },
    { name: "Bewadze", regionCode: "08", districtCode: "07" },
    { name: "Bosompa", regionCode: "08", districtCode: "07" },
    { name: "Brahabekumi", regionCode: "08", districtCode: "07" },
    { name: "Brofoyedur", regionCode: "08", districtCode: "07" },
    { name: "Brofuyedru", regionCode: "08", districtCode: "07" },
    { name: "Dabanyin", regionCode: "08", districtCode: "07" },
    { name: "Dunkwa", regionCode: "08", districtCode: "07" },
    { name: "Duoto", regionCode: "08", districtCode: "07" },
    { name: "Edukrom", regionCode: "08", districtCode: "07" },
    { name: "Esusu", regionCode: "08", districtCode: "07" },
    { name: "Fanti Bawjiase", regionCode: "08", districtCode: "07" },
    { name: "Gomoa Akwamu", regionCode: "08", districtCode: "07" },
    { name: "Gomoa Dahom", regionCode: "08", districtCode: "07" },
    { name: "Gomoa Obiri", regionCode: "08", districtCode: "07" },
    { name: "Gomoa Obuasi", regionCode: "08", districtCode: "07" },
    { name: "Gomoa Whida", regionCode: "08", districtCode: "07" },
    { name: "Gyaman", regionCode: "08", districtCode: "07" },
    { name: "Idankrom", regionCode: "08", districtCode: "07" },
    { name: "Kenyanko", regionCode: "08", districtCode: "07" },
    { name: "Kodwo Abo", regionCode: "08", districtCode: "07" },
    { name: "Kofi Tabilkwaa", regionCode: "08", districtCode: "07" },
    { name: "Kofinkum", regionCode: "08", districtCode: "07" },
    { name: "Kokoado", regionCode: "08", districtCode: "07" },
    { name: "Kokofu", regionCode: "08", districtCode: "07" },
    { name: "Kwabena Mensakwaa", regionCode: "08", districtCode: "07" },
    { name: "Kwame Agyir", regionCode: "08", districtCode: "07" },
    { name: "Kwansakrom", regionCode: "08", districtCode: "07" },
    { name: "Kwasi Amokwa", regionCode: "08", districtCode: "07" },
    { name: "Kwasi Amonabu", regionCode: "08", districtCode: "07" },
    { name: "Kwesitwikwaa", regionCode: "08", districtCode: "07" },
    { name: "Kyekyewere", regionCode: "08", districtCode: "07" },
    { name: "Lome", regionCode: "08", districtCode: "07" },
    { name: "Mankessim", regionCode: "08", districtCode: "07" },
    { name: "Mensahkwaa", regionCode: "08", districtCode: "07" },
    { name: "Mfantseman", regionCode: "08", districtCode: "07" },
    { name: "Namanwura", regionCode: "08", districtCode: "07" },
    { name: "Nkranfo", regionCode: "08", districtCode: "07" },
    { name: "Nkwanta Eshiem", regionCode: "08", districtCode: "07" },
    { name: "Nkwanta Nando", regionCode: "08", districtCode: "07" },
    { name: "North Wawase", regionCode: "08", districtCode: "07" },
    { name: "Nsonan", regionCode: "08", districtCode: "07" },
    { name: "Obonyambo", regionCode: "08", districtCode: "07" },
    { name: "Obosomasi", regionCode: "08", districtCode: "07" },
    { name: "Obuasi", regionCode: "08", districtCode: "07" },
    { name: "Odina", regionCode: "08", districtCode: "07" },
    { name: "Odumasi", regionCode: "08", districtCode: "07" },
    { name: "Oguaa", regionCode: "08", districtCode: "07" },
    { name: "Ohiawoanwu", regionCode: "08", districtCode: "07" },
    { name: "Okaikrom", regionCode: "08", districtCode: "07" },
    { name: "Otabilkrom", regionCode: "08", districtCode: "07" },
    { name: "Otabilkwaa", regionCode: "08", districtCode: "07" },
    { name: "Otsenkorang", regionCode: "08", districtCode: "07" },
    { name: "Otuakwa", regionCode: "08", districtCode: "07" },
    { name: "Somanya", regionCode: "08", districtCode: "07" },
    { name: "Tachiman", regionCode: "08", districtCode: "07" },
    { name: "Tarkwa", regionCode: "08", districtCode: "07" },
    { name: "Wawase", regionCode: "08", districtCode: "07" }
  ],
  "08-08": [
    { name: "Abemkwem", regionCode: "08", districtCode: "08" },
    { name: "Abonsa", regionCode: "08", districtCode: "08" },
    { name: "Acquahkrom", regionCode: "08", districtCode: "08" },
    { name: "Adabra", regionCode: "08", districtCode: "08" },
    { name: "Aduafokwa", regionCode: "08", districtCode: "08" },
    { name: "Akoley", regionCode: "08", districtCode: "08" },
    { name: "Akosua Village", regionCode: "08", districtCode: "08" },
    { name: "Akrampa", regionCode: "08", districtCode: "08" },
    { name: "Anamba", regionCode: "08", districtCode: "08" },
    { name: "Anapansu", regionCode: "08", districtCode: "08" },
    { name: "Anim Akubrifa", regionCode: "08", districtCode: "08" },
    { name: "Asafar Ewe Community", regionCode: "08", districtCode: "08" },
    { name: "Atekyedo", regionCode: "08", districtCode: "08" },
    { name: "Atekyedo Gyahadze", regionCode: "08", districtCode: "08" },
    { name: "Awushie Tettey", regionCode: "08", districtCode: "08" },
    { name: "Ayanful", regionCode: "08", districtCode: "08" },
    { name: "Ayirensu", regionCode: "08", districtCode: "08" },
    { name: "Bankyase", regionCode: "08", districtCode: "08" },
    { name: "Bawunum", regionCode: "08", districtCode: "08" },
    { name: "Bokor", regionCode: "08", districtCode: "08" },
    { name: "Buadukwaa", regionCode: "08", districtCode: "08" },
    { name: "Budatta Junction", regionCode: "08", districtCode: "08" },
    { name: "Ekumfi Edumfa Ewe Comm No.1", regionCode: "08", districtCode: "08" },
    { name: "Ekumfi Edumfa Ewe Comm No.2", regionCode: "08", districtCode: "08" },
    { name: "Esiamotan", regionCode: "08", districtCode: "08" },
    { name: "Esiwkwa", regionCode: "08", districtCode: "08" },
    { name: "Fantiamoa", regionCode: "08", districtCode: "08" },
    { name: "Gomoa Adzintem", regionCode: "08", districtCode: "08" },
    { name: "Gomoa Amoanda", regionCode: "08", districtCode: "08" },
    { name: "Gomoa Assin", regionCode: "08", districtCode: "08" },
    { name: "Gomoa Awombrew", regionCode: "08", districtCode: "08" },
    { name: "Gomoa Dahom", regionCode: "08", districtCode: "08" },
    { name: "Gomoa Esikuma", regionCode: "08", districtCode: "08" },
    { name: "Gomoa Gyankrom #1", regionCode: "08", districtCode: "08" },
    { name: "Gomoa Gyankrom #2", regionCode: "08", districtCode: "08" },
    { name: "Gomoa Kwamekwaa", regionCode: "08", districtCode: "08" },
    { name: "Gomoa Panfokrom", regionCode: "08", districtCode: "08" },
    { name: "Gomoa Tekyeam", regionCode: "08", districtCode: "08" },
    { name: "Gyagyenadze Community Hospital", regionCode: "08", districtCode: "08" },
    { name: "Gyagyenase", regionCode: "08", districtCode: "08" },
    { name: "Gyahaadze", regionCode: "08", districtCode: "08" },
    { name: "Gyahaadze West", regionCode: "08", districtCode: "08" },
    { name: "Gyangyandze", regionCode: "08", districtCode: "08" },
    { name: "Immuna Ewe Community", regionCode: "08", districtCode: "08" },
    { name: "Katakure Ewe Community", regionCode: "08", districtCode: "08" },
    { name: "Kofi Ahor", regionCode: "08", districtCode: "08" },
    { name: "Kope Area", regionCode: "08", districtCode: "08" },
    { name: "Kristo Asafo", regionCode: "08", districtCode: "08" },
    { name: "Kwame Adwer", regionCode: "08", districtCode: "08" },
    { name: "Kwao Kurabie", regionCode: "08", districtCode: "08" },
    { name: "Kwashie Amadu", regionCode: "08", districtCode: "08" },
    { name: "Kwobonadzi", regionCode: "08", districtCode: "08" },
    { name: "Larbi", regionCode: "08", districtCode: "08" },
    { name: "Mamfe #1", regionCode: "08", districtCode: "08" },
    { name: "Mamfe #2", regionCode: "08", districtCode: "08" },
    { name: "Mamfe #3", regionCode: "08", districtCode: "08" },
    { name: "Mempengyegye", regionCode: "08", districtCode: "08" },
    { name: "New Ateitu", regionCode: "08", districtCode: "08" },
    { name: "New Winneba", regionCode: "08", districtCode: "08" },
    { name: "Nfadwen", regionCode: "08", districtCode: "08" },
    { name: "Nkwadu", regionCode: "08", districtCode: "08" },
    { name: "Nsuaem", regionCode: "08", districtCode: "08" },
    { name: "Nsuekyir", regionCode: "08", districtCode: "08" },
    { name: "Nyamebekyere", regionCode: "08", districtCode: "08" },
    { name: "Odambo", regionCode: "08", districtCode: "08" },
    { name: "Odambo Junction", regionCode: "08", districtCode: "08" },
    { name: "Ojobi", regionCode: "08", districtCode: "08" },
    { name: "Okyrekrom", regionCode: "08", districtCode: "08" },
    { name: "Olefreku", regionCode: "08", districtCode: "08" },
    { name: "Olotum", regionCode: "08", districtCode: "08" },
    { name: "Onyadze", regionCode: "08", districtCode: "08" },
    { name: "Osubonpanyin", regionCode: "08", districtCode: "08" },
    { name: "Owofa", regionCode: "08", districtCode: "08" },
    { name: "Postin", regionCode: "08", districtCode: "08" },
    { name: "Quaye", regionCode: "08", districtCode: "08" },
    { name: "Rafiki Satellite Village Gyahaadze", regionCode: "08", districtCode: "08" },
    { name: "Saakwaa", regionCode: "08", districtCode: "08" },
    { name: "Samsamso #1", regionCode: "08", districtCode: "08" },
    { name: "Samsamso #2", regionCode: "08", districtCode: "08" },
    { name: "Signboard", regionCode: "08", districtCode: "08" },
    { name: "Teteoko-Akura", regionCode: "08", districtCode: "08" },
    { name: "Warabeba", regionCode: "08", districtCode: "08" }
  ],
  "08-09": [
    { name: "Aberful", regionCode: "08", districtCode: "09" },
    { name: "Aboakyiwowe", regionCode: "08", districtCode: "09" },
    { name: "Abonsa", regionCode: "08", districtCode: "09" },
    { name: "Abrekum", regionCode: "08", districtCode: "09" },
    { name: "Adawukwaa", regionCode: "08", districtCode: "09" },
    { name: "Adoko", regionCode: "08", districtCode: "09" },
    { name: "Afianko Akora", regionCode: "08", districtCode: "09" },
    { name: "Ahentia", regionCode: "08", districtCode: "09" },
    { name: "Ahumtem", regionCode: "08", districtCode: "09" },
    { name: "Akoley", regionCode: "08", districtCode: "09" },
    { name: "Akonisi", regionCode: "08", districtCode: "09" },
    { name: "Akoo Nisi", regionCode: "08", districtCode: "09" },
    { name: "Akrampa", regionCode: "08", districtCode: "09" },
    { name: "Akrumatoyem", regionCode: "08", districtCode: "09" },
    { name: "Amadua", regionCode: "08", districtCode: "09" },
    { name: "Ankamase", regionCode: "08", districtCode: "09" },
    { name: "Aponkyiakura", regionCode: "08", districtCode: "09" },
    { name: "Awushie Tettey", regionCode: "08", districtCode: "09" },
    { name: "Ayensuako", regionCode: "08", districtCode: "09" },
    { name: "Bantama", regionCode: "08", districtCode: "09" },
    { name: "Bontrase", regionCode: "08", districtCode: "09" },
    { name: "Botoku", regionCode: "08", districtCode: "09" },
    { name: "Brofoyedu/Kofi Wettey", regionCode: "08", districtCode: "09" },
    { name: "Buduburam", regionCode: "08", districtCode: "09" },
    { name: "Choechoe", regionCode: "08", districtCode: "09" },
    { name: "Dankwa", regionCode: "08", districtCode: "09" },
    { name: "Dasum", regionCode: "08", districtCode: "09" },
    { name: "Ehuntem", regionCode: "08", districtCode: "09" },
    { name: "Fetteh Kakraba", regionCode: "08", districtCode: "09" },
    { name: "Fianko", regionCode: "08", districtCode: "09" },
    { name: "Gyatekrom", regionCode: "08", districtCode: "09" },
    { name: "Hasowodze", regionCode: "08", districtCode: "09" },
    { name: "Jei Krodua", regionCode: "08", districtCode: "09" },
    { name: "Kasapa", regionCode: "08", districtCode: "09" },
    { name: "Kasoa Cp", regionCode: "08", districtCode: "09" },
    { name: "Kawanopaado", regionCode: "08", districtCode: "09" },
    { name: "Kemono", regionCode: "08", districtCode: "09" },
    { name: "Kofi Ansah/Oframase", regionCode: "08", districtCode: "09" },
    { name: "Kojo Ashong", regionCode: "08", districtCode: "09" },
    { name: "Kope Area", regionCode: "08", districtCode: "09" },
    { name: "Krispol City", regionCode: "08", districtCode: "09" },
    { name: "Kwaman No.1", regionCode: "08", districtCode: "09" },
    { name: "Kwaman No.2", regionCode: "08", districtCode: "09" },
    { name: "Kwame Kwei", regionCode: "08", districtCode: "09" },
    { name: "Kwame Wettey", regionCode: "08", districtCode: "09" },
    { name: "Kwao Amoako", regionCode: "08", districtCode: "09" },
    { name: "Kwao Bondzi #2", regionCode: "08", districtCode: "09" },
    { name: "Kwao Kurabie", regionCode: "08", districtCode: "09" },
    { name: "Kwashi Abbey", regionCode: "08", districtCode: "09" },
    { name: "Kwashie Abbey", regionCode: "08", districtCode: "09" },
    { name: "Kwashie Amadu", regionCode: "08", districtCode: "09" },
    { name: "Kwata Akropong", regionCode: "08", districtCode: "09" },
    { name: "Kweku Ansah", regionCode: "08", districtCode: "09" },
    { name: "Kwobonadzi", regionCode: "08", districtCode: "09" },
    { name: "Larbi", regionCode: "08", districtCode: "09" },
    { name: "Mayenda", regionCode: "08", districtCode: "09" },
    { name: "Mempengyegye", regionCode: "08", districtCode: "09" },
    { name: "Mensakwaa", regionCode: "08", districtCode: "09" },
    { name: "Mfafo", regionCode: "08", districtCode: "09" },
    { name: "Millenium City", regionCode: "08", districtCode: "09" },
    { name: "Mmofrakrom", regionCode: "08", districtCode: "09" },
    { name: "Nkwantanan", regionCode: "08", districtCode: "09" },
    { name: "Nsiakrom", regionCode: "08", districtCode: "09" },
    { name: "Nyanyano", regionCode: "08", districtCode: "09" },
    { name: "Nyanyano Kakraba", regionCode: "08", districtCode: "09" },
    { name: "Nyarkokwa", regionCode: "08", districtCode: "09" },
    { name: "Obodakaba", regionCode: "08", districtCode: "09" },
    { name: "Obrayeko", regionCode: "08", districtCode: "09" },
    { name: "Ofaankor", regionCode: "08", districtCode: "09" },
    { name: "Ofadaa", regionCode: "08", districtCode: "09" },
    { name: "Ojobi", regionCode: "08", districtCode: "09" },
    { name: "Okwabena", regionCode: "08", districtCode: "09" },
    { name: "Opeikumagyatekrom", regionCode: "08", districtCode: "09" },
    { name: "Oshimpo No.1", regionCode: "08", districtCode: "09" },
    { name: "Oshimpo No.2", regionCode: "08", districtCode: "09" },
    { name: "Otopease", regionCode: "08", districtCode: "09" },
    { name: "Papase", regionCode: "08", districtCode: "09" },
    { name: "Penim", regionCode: "08", districtCode: "09" },
    { name: "Pobie", regionCode: "08", districtCode: "09" },
    { name: "Quaye", regionCode: "08", districtCode: "09" },
    { name: "Sackwakwaa", regionCode: "08", districtCode: "09" },
    { name: "Samsamso #1", regionCode: "08", districtCode: "09" },
    { name: "Samsamso #2", regionCode: "08", districtCode: "09" },
    { name: "Senya Breku", regionCode: "08", districtCode: "09" },
    { name: "Small London", regionCode: "08", districtCode: "09" },
    { name: "Tawia-Kwaa", regionCode: "08", districtCode: "09" },
    { name: "Teteoko-Akura", regionCode: "08", districtCode: "09" }
  ],
  "08-10": [
    { name: "Abakum", regionCode: "08", districtCode: "10" },
    { name: "Adade", regionCode: "08", districtCode: "10" },
    { name: "Agro Farm", regionCode: "08", districtCode: "10" },
    { name: "Agyenkwa", regionCode: "08", districtCode: "10" },
    { name: "Akotsi", regionCode: "08", districtCode: "10" },
    { name: "Akrampa", regionCode: "08", districtCode: "10" },
    { name: "American Down", regionCode: "08", districtCode: "10" },
    { name: "Anapansu", regionCode: "08", districtCode: "10" },
    { name: "Awutu Breku", regionCode: "08", districtCode: "10" },
    { name: "Awutu Senya", regionCode: "08", districtCode: "10" },
    { name: "Bonsoku", regionCode: "08", districtCode: "10" },
    { name: "Brigade", regionCode: "08", districtCode: "10" },
    { name: "Budumburam", regionCode: "08", districtCode: "10" },
    { name: "Cp", regionCode: "08", districtCode: "10" },
    { name: "Dawa", regionCode: "08", districtCode: "10" },
    { name: "Fetteh Kakraba", regionCode: "08", districtCode: "10" },
    { name: "Fifii Pratt", regionCode: "08", districtCode: "10" },
    { name: "Fijae", regionCode: "08", districtCode: "10" },
    { name: "Galilea", regionCode: "08", districtCode: "10" },
    { name: "Gomoa Fetteh", regionCode: "08", districtCode: "10" },
    { name: "Iron City", regionCode: "08", districtCode: "10" },
    { name: "Kakraba", regionCode: "08", districtCode: "10" },
    { name: "Kasoa Town", regionCode: "08", districtCode: "10" },
    { name: "Kojo Oku", regionCode: "08", districtCode: "10" },
    { name: "Kuwait", regionCode: "08", districtCode: "10" },
    { name: "Kwabena Andoh", regionCode: "08", districtCode: "10" },
    { name: "Lamgba", regionCode: "08", districtCode: "10" },
    { name: "Millenium City", regionCode: "08", districtCode: "10" },
    { name: "Nash Academy", regionCode: "08", districtCode: "10" },
    { name: "Nkwantanan", regionCode: "08", districtCode: "10" },
    { name: "Nyame Adom", regionCode: "08", districtCode: "10" },
    { name: "Nyanyano", regionCode: "08", districtCode: "10" },
    { name: "Ojobi", regionCode: "08", districtCode: "10" },
    { name: "Tuba", regionCode: "08", districtCode: "10" },
    { name: "Walantu", regionCode: "08", districtCode: "10" }
  ],

  "09-01": [
    { name: "Abaasa", regionCode: "09", districtCode: "01" },
    { name: "Abekobon No.1", regionCode: "09", districtCode: "01" },
    { name: "Aberewapong", regionCode: "09", districtCode: "01" },
    { name: "Aboaboso", regionCode: "09", districtCode: "01" },
    { name: "Abomsomtweagya", regionCode: "09", districtCode: "01" },
    { name: "Abotanso", regionCode: "09", districtCode: "01" },
    { name: "Abrewankor", regionCode: "09", districtCode: "01" },
    { name: "Abronsase No.1", regionCode: "09", districtCode: "01" },
    { name: "Abronsase No.3(Asuogya-Kokobenom)", regionCode: "09", districtCode: "01" },
    { name: "Abrosase No.2(Tokwae-Asuboi)", regionCode: "09", districtCode: "01" },
    { name: "Achiase", regionCode: "09", districtCode: "01" },
    { name: "Adaeto", regionCode: "09", districtCode: "01" },
    { name: "Adakaruso", regionCode: "09", districtCode: "01" },
    { name: "Adansi", regionCode: "09", districtCode: "01" },
    { name: "Adiemmra", regionCode: "09", districtCode: "01" },
    { name: "Adinkrakrom", regionCode: "09", districtCode: "01" },
    { name: "Adjeikrom", regionCode: "09", districtCode: "01" },
    { name: "Adofokrom No.1", regionCode: "09", districtCode: "01" },
    { name: "Adomfe(Main Town)", regionCode: "09", districtCode: "01" },
    { name: "Adomfe(New Town)", regionCode: "09", districtCode: "01" },
    { name: "Adumasa", regionCode: "09", districtCode: "01" },
    { name: "Adumkurom", regionCode: "09", districtCode: "01" },
    { name: "Afirisere", regionCode: "09", districtCode: "01" },
    { name: "Afoda", regionCode: "09", districtCode: "01" },
    { name: "Agogo ( Kumawu Road)", regionCode: "09", districtCode: "01" },
    { name: "Agogo (From Market To State)", regionCode: "09", districtCode: "01" },
    { name: "Agogo (State)", regionCode: "09", districtCode: "01" },
    { name: "Agogo Zongo", regionCode: "09", districtCode: "01" },
    { name: "Agogo( Dist. Assembly)", regionCode: "09", districtCode: "01" },
    { name: "Agogo(Baah Radu Area)", regionCode: "09", districtCode: "01" },
    { name: "Agogo(From Collins To Ecg Office)", regionCode: "09", districtCode: "01" },
    { name: "Agogo(Nursing Training)", regionCode: "09", districtCode: "01" },
    { name: "Agogo(Purc)", regionCode: "09", districtCode: "01" },
    { name: "Agyeikurom", regionCode: "09", districtCode: "01" },
    { name: "Ahyiayem", regionCode: "09", districtCode: "01" },
    { name: "Ajariago", regionCode: "09", districtCode: "01" },
    { name: "Akrantiebesa", regionCode: "09", districtCode: "01" },
    { name: "Akromah No.2", regionCode: "09", districtCode: "01" },
    { name: "Akronwi", regionCode: "09", districtCode: "01" },
    { name: "Akuakrom $ Banso As", regionCode: "09", districtCode: "01" },
    { name: "Akutuase", regionCode: "09", districtCode: "01" },
    { name: "Akwaatia", regionCode: "09", districtCode: "01" },
    { name: "Amanfrom", regionCode: "09", districtCode: "01" },
    { name: "Amantena", regionCode: "09", districtCode: "01" },
    { name: "Ananekrom", regionCode: "09", districtCode: "01" },
    { name: "Anangro", regionCode: "09", districtCode: "01" },
    { name: "Ankaase", regionCode: "09", districtCode: "01" },
    { name: "Annanie", regionCode: "09", districtCode: "01" },
    { name: "Anyaaso", regionCode: "09", districtCode: "01" },
    { name: "Anyinase", regionCode: "09", districtCode: "01" },
    { name: "Apentubuom", regionCode: "09", districtCode: "01" },
    { name: "Apragya", regionCode: "09", districtCode: "01" },
    { name: "Asankare", regionCode: "09", districtCode: "01" },
    { name: "Asenkyem", regionCode: "09", districtCode: "01" },
    { name: "Asiwa", regionCode: "09", districtCode: "01" },
    { name: "Asom", regionCode: "09", districtCode: "01" },
    { name: "Asubua", regionCode: "09", districtCode: "01" },
    { name: "Atiemo", regionCode: "09", districtCode: "01" },
    { name: "Atobiase", regionCode: "09", districtCode: "01" },
    { name: "Atta Ne Atta", regionCode: "09", districtCode: "01" },
    { name: "Atta-Agyin & Ata Mansa", regionCode: "09", districtCode: "01" },
    { name: "Atunsu Junction", regionCode: "09", districtCode: "01" },
    { name: "Atwidie", regionCode: "09", districtCode: "01" },
    { name: "Baahwiredu", regionCode: "09", districtCode: "01" },
    { name: "Babduaso", regionCode: "09", districtCode: "01" },
    { name: "Bankame", regionCode: "09", districtCode: "01" },
    { name: "Banso", regionCode: "09", districtCode: "01" },
    { name: "Bebome", regionCode: "09", districtCode: "01" },
    { name: "Bebun", regionCode: "09", districtCode: "01" },
    { name: "Bebuso No.1", regionCode: "09", districtCode: "01" },
    { name: "Bebuso No.2", regionCode: "09", districtCode: "01" },
    { name: "Behwe", regionCode: "09", districtCode: "01" },
    { name: "Bibiani", regionCode: "09", districtCode: "01" },
    { name: "Bimma", regionCode: "09", districtCode: "01" },
    { name: "Bomfa", regionCode: "09", districtCode: "01" },
    { name: "Bomiriso", regionCode: "09", districtCode: "01" },
    { name: "Bompata", regionCode: "09", districtCode: "01" },
    { name: "Brantuokrom", regionCode: "09", districtCode: "01" },
    { name: "Breku", regionCode: "09", districtCode: "01" },
    { name: "Breku Camp", regionCode: "09", districtCode: "01" },
    { name: "Brofoyedu", regionCode: "09", districtCode: "01" },
    { name: "By Water", regionCode: "09", districtCode: "01" },
    { name: "Dampong", regionCode: "09", districtCode: "01" },
    { name: "Denmu No.2", regionCode: "09", districtCode: "01" },
    { name: "Densereso", regionCode: "09", districtCode: "01" },
    { name: "Dickson", regionCode: "09", districtCode: "01" },
    { name: "Didipakyie", regionCode: "09", districtCode: "01" },
    { name: "Dome", regionCode: "09", districtCode: "01" },
    { name: "Duase", regionCode: "09", districtCode: "01" },
    { name: "Dukuben", regionCode: "09", districtCode: "01" },
    { name: "Dwendwenase", regionCode: "09", districtCode: "01" },
    { name: "Enumso", regionCode: "09", districtCode: "01" },
    { name: "Esaase", regionCode: "09", districtCode: "01" },
    { name: "Formanso", regionCode: "09", districtCode: "01" },
    { name: "Free Town", regionCode: "09", districtCode: "01" },
    { name: "Gyankobaa", regionCode: "09", districtCode: "01" },
    { name: "Gyidim(Agogo)", regionCode: "09", districtCode: "01" },
    { name: "Habitat (Fittinf Shop Near Rogersco)", regionCode: "09", districtCode: "01" },
    { name: "Habitat (From Kiss Resturant)", regionCode: "09", districtCode: "01" },
    { name: "Habitat (Gas Station)", regionCode: "09", districtCode: "01" },
    { name: "Habitat (Paa Willi International)", regionCode: "09", districtCode: "01" },
    { name: "Habitat New Site", regionCode: "09", districtCode: "01" },
    { name: "Hwidiem", regionCode: "09", districtCode: "01" },
    { name: "Juansa(Rural Bank)", regionCode: "09", districtCode: "01" },
    { name: "Juansa/Water", regionCode: "09", districtCode: "01" },
    { name: "Juaso", regionCode: "09", districtCode: "01" },
    { name: "Juaso Aboabo", regionCode: "09", districtCode: "01" },
    { name: "Juaso(Julan Hotel)", regionCode: "09", districtCode: "01" },
    { name: "Juaso(Nakal Hotel)", regionCode: "09", districtCode: "01" },
    { name: "Juaso(Senior High To Junction)", regionCode: "09", districtCode: "01" },
    { name: "Kansanso", regionCode: "09", districtCode: "01" },
    { name: "Kantanso", regionCode: "09", districtCode: "01" },
    { name: "Kofi Sei", regionCode: "09", districtCode: "01" },
    { name: "Kokoben Praaso", regionCode: "09", districtCode: "01" },
    { name: "Kokobin", regionCode: "09", districtCode: "01" },
    { name: "Kokomba Junction", regionCode: "09", districtCode: "01" },
    { name: "Komeso", regionCode: "09", districtCode: "01" },
    { name: "Konongo", regionCode: "09", districtCode: "01" },
    { name: "Kotei Abresu", regionCode: "09", districtCode: "01" },
    { name: "Kowireso", regionCode: "09", districtCode: "01" },
    { name: "Kpong Praaso", regionCode: "09", districtCode: "01" },
    { name: "Kramokurom", regionCode: "09", districtCode: "01" },
    { name: "Kumeaboi", regionCode: "09", districtCode: "01" },
    { name: "Kurofa", regionCode: "09", districtCode: "01" },
    { name: "Kwabin", regionCode: "09", districtCode: "01" },
    { name: "Kwadwo Adanse", regionCode: "09", districtCode: "01" },
    { name: "Kwakru", regionCode: "09", districtCode: "01" },
    { name: "Kwame Adukrom", regionCode: "09", districtCode: "01" },
    { name: "Kwame Edukrom", regionCode: "09", districtCode: "01" },
    { name: "Kwame Gura", regionCode: "09", districtCode: "01" },
    { name: "Kwanwa", regionCode: "09", districtCode: "01" },
    { name: "Kwaokoko", regionCode: "09", districtCode: "01" },
    { name: "Kwaokurom", regionCode: "09", districtCode: "01" },
    { name: "Kyekyebiase", regionCode: "09", districtCode: "01" },
    { name: "Kyekyewere", regionCode: "09", districtCode: "01" },
    { name: "Kyempo", regionCode: "09", districtCode: "01" },
    { name: "Low Cost", regionCode: "09", districtCode: "01" },
    { name: "Low Cost (Gas Area)", regionCode: "09", districtCode: "01" },
    { name: "Mageda", regionCode: "09", districtCode: "01" },
    { name: "Mamponteng", regionCode: "09", districtCode: "01" },
    { name: "Mankala", regionCode: "09", districtCode: "01" },
    { name: "Mayanka", regionCode: "09", districtCode: "01" },
    { name: "Menamenaso No.1", regionCode: "09", districtCode: "01" },
    { name: "Mensakrom", regionCode: "09", districtCode: "01" },
    { name: "Morso", regionCode: "09", districtCode: "01" },
    { name: "Ningo", regionCode: "09", districtCode: "01" },
    { name: "Nkwanta", regionCode: "09", districtCode: "01" },
    { name: "Nkwantapon", regionCode: "09", districtCode: "01" },
    { name: "Nsonnyameye", regionCode: "09", districtCode: "01" },
    { name: "Nyaboo Patriensa", regionCode: "09", districtCode: "01" },
    { name: "Nyamebekyere", regionCode: "09", districtCode: "01" },
    { name: "Nyamponase", regionCode: "09", districtCode: "01" },
    { name: "Nyiaso", regionCode: "09", districtCode: "01" },
    { name: "Obenimase", regionCode: "09", districtCode: "01" },
    { name: "Obogu", regionCode: "09", districtCode: "01" },
    { name: "Obokro", regionCode: "09", districtCode: "01" },
    { name: "Odifo Wilson", regionCode: "09", districtCode: "01" },
    { name: "Odubi", regionCode: "09", districtCode: "01" },
    { name: "Odumasi", regionCode: "09", districtCode: "01" },
    { name: "Ofoase", regionCode: "09", districtCode: "01" },
    { name: "Ohene Nkwanta", regionCode: "09", districtCode: "01" },
    { name: "Onyemso", regionCode: "09", districtCode: "01" },
    { name: "Oseikrom", regionCode: "09", districtCode: "01" },
    { name: "Otikrom", regionCode: "09", districtCode: "01" },
    { name: "Pataban", regionCode: "09", districtCode: "01" },
    { name: "Patriensa", regionCode: "09", districtCode: "01" },
    { name: "Pekyerekye", regionCode: "09", districtCode: "01" },
    { name: "Perminase", regionCode: "09", districtCode: "01" },
    { name: "Policekurom", regionCode: "09", districtCode: "01" },
    { name: "Praaso", regionCode: "09", districtCode: "01" },
    { name: "Rider Iron & Steel", regionCode: "09", districtCode: "01" },
    { name: "Saabo", regionCode: "09", districtCode: "01" },
    { name: "Sakikrom", regionCode: "09", districtCode: "01" },
    { name: "Sampah", regionCode: "09", districtCode: "01" },
    { name: "Santreso", regionCode: "09", districtCode: "01" },
    { name: "Serebuoso", regionCode: "09", districtCode: "01" },
    { name: "Ssnit", regionCode: "09", districtCode: "01" },
    { name: "Subenesu", regionCode: "09", districtCode: "01" },
    { name: "Subinso", regionCode: "09", districtCode: "01" },
    { name: "Subrisu", regionCode: "09", districtCode: "01" },
    { name: "Tabretuo", regionCode: "09", districtCode: "01" },
    { name: "Takyikurom", regionCode: "09", districtCode: "01" },
    { name: "Telecenter", regionCode: "09", districtCode: "01" },
    { name: "Tema Bonsu", regionCode: "09", districtCode: "01" },
    { name: "Teshie Praso", regionCode: "09", districtCode: "01" },
    { name: "Tetewayo", regionCode: "09", districtCode: "01" },
    { name: "Tinkon", regionCode: "09", districtCode: "01" },
    { name: "Tokwae", regionCode: "09", districtCode: "01" },
    { name: "Tokwae Odumase", regionCode: "09", districtCode: "01" },
    { name: "Wabiri", regionCode: "09", districtCode: "01" },
    { name: "Wenkyi", regionCode: "09", districtCode: "01" },
    { name: "Wioso", regionCode: "09", districtCode: "01" },
    { name: "Yaw Barima No.1", regionCode: "09", districtCode: "01" },
    { name: "Yaw Barima No.2 (Asempanaye)", regionCode: "09", districtCode: "01" },
    { name: "Yaw Sarfo", regionCode: "09", districtCode: "01" },
    { name: "Yawbronyakrom", regionCode: "09", districtCode: "01" },
    { name: "Yawkwe", regionCode: "09", districtCode: "01" },
    { name: "Yawpesa", regionCode: "09", districtCode: "01" },
    { name: "Yeji", regionCode: "09", districtCode: "01" }
  ],
  "09-02": [
    { name: "Abasua", regionCode: "09", districtCode: "02" },
    { name: "Abesewase", regionCode: "09", districtCode: "02" },
    { name: "Abira", regionCode: "09", districtCode: "02" },
    { name: "Abotanso", regionCode: "09", districtCode: "02" },
    { name: "Adawomanse", regionCode: "09", districtCode: "02" },
    { name: "Addokrom", regionCode: "09", districtCode: "02" },
    { name: "Adutwum", regionCode: "09", districtCode: "02" },
    { name: "Afraku", regionCode: "09", districtCode: "02" },
    { name: "Ahodwo", regionCode: "09", districtCode: "02" },
    { name: "Ahwerewa", regionCode: "09", districtCode: "02" },
    { name: "Akrofonso", regionCode: "09", districtCode: "02" },
    { name: "Akrokyere", regionCode: "09", districtCode: "02" },
    { name: "Amape", regionCode: "09", districtCode: "02" },
    { name: "Ananaya", regionCode: "09", districtCode: "02" },
    { name: "Apemso", regionCode: "09", districtCode: "02" },
    { name: "Asekyerewa", regionCode: "09", districtCode: "02" },
    { name: "Asokokor", regionCode: "09", districtCode: "02" },
    { name: "Asokore", regionCode: "09", districtCode: "02" },
    { name: "Attakrom", regionCode: "09", districtCode: "02" },
    { name: "Atwea", regionCode: "09", districtCode: "02" },
    { name: "Awaham", regionCode: "09", districtCode: "02" },
    { name: "Awanya", regionCode: "09", districtCode: "02" },
    { name: "Baman", regionCode: "09", districtCode: "02" },
    { name: "Banko", regionCode: "09", districtCode: "02" },
    { name: "Besoro", regionCode: "09", districtCode: "02" },
    { name: "Boatengkrom", regionCode: "09", districtCode: "02" },
    { name: "Bodomase", regionCode: "09", districtCode: "02" },
    { name: "Bodwease", regionCode: "09", districtCode: "02" },
    { name: "Bomen", regionCode: "09", districtCode: "02" },
    { name: "Bomso", regionCode: "09", districtCode: "02" },
    { name: "Bonwire", regionCode: "09", districtCode: "02" },
    { name: "Bowohomoden", regionCode: "09", districtCode: "02" },
    { name: "Brofoyedru", regionCode: "09", districtCode: "02" },
    { name: "Dadease Akotoso", regionCode: "09", districtCode: "02" },
    { name: "Drobonso", regionCode: "09", districtCode: "02" },
    { name: "Effiduase Town", regionCode: "09", districtCode: "02" },
    { name: "Feyiase", regionCode: "09", districtCode: "02" },
    { name: "Juaben", regionCode: "09", districtCode: "02" },
    { name: "Kokodie", regionCode: "09", districtCode: "02" },
    { name: "Kotei", regionCode: "09", districtCode: "02" },
    { name: "Kumawu", regionCode: "09", districtCode: "02" },
    { name: "Kumawu Wonoo", regionCode: "09", districtCode: "02" },
    { name: "Menam", regionCode: "09", districtCode: "02" },
    { name: "Motokrudua", regionCode: "09", districtCode: "02" },
    { name: "Nkwakwanua", regionCode: "09", districtCode: "02" },
    { name: "Nkwanta", regionCode: "09", districtCode: "02" },
    { name: "Nkyerepoaso", regionCode: "09", districtCode: "02" },
    { name: "Ntumkumso", regionCode: "09", districtCode: "02" },
    { name: "Obanpaninkrom", regionCode: "09", districtCode: "02" },
    { name: "Odoyefe", regionCode: "09", districtCode: "02" },
    { name: "Ofoase", regionCode: "09", districtCode: "02" },
    { name: "Ogua", regionCode: "09", districtCode: "02" },
    { name: "Okaikrom", regionCode: "09", districtCode: "02" },
    { name: "Oyoko", regionCode: "09", districtCode: "02" },
    { name: "Sakra Wonoo", regionCode: "09", districtCode: "02" },
    { name: "Sekyere", regionCode: "09", districtCode: "02" },
    { name: "Seniagya", regionCode: "09", districtCode: "02" },
    { name: "Senkyi", regionCode: "09", districtCode: "02" },
    { name: "Temante", regionCode: "09", districtCode: "02" },
    { name: "Wioso", regionCode: "09", districtCode: "02" },
    { name: "Woraso", regionCode: "09", districtCode: "02" },
    { name: "Wuraponso", regionCode: "09", districtCode: "02" },
    { name: "Yaw Nkrumah", regionCode: "09", districtCode: "02" }
  ],
  "09-03": [
    { name: "Abonkosu", regionCode: "09", districtCode: "03" },
    { name: "Abrakaso", regionCode: "09", districtCode: "03" },
    { name: "Abrukutuao", regionCode: "09", districtCode: "03" },
    { name: "Adweeho", regionCode: "09", districtCode: "03" },
    { name: "Afamanso", regionCode: "09", districtCode: "03" },
    { name: "Aframso", regionCode: "09", districtCode: "03" },
    { name: "Agona", regionCode: "09", districtCode: "03" },
    { name: "Akrofonso", regionCode: "09", districtCode: "03" },
    { name: "Akyease", regionCode: "09", districtCode: "03" },
    { name: "Amanase", regionCode: "09", districtCode: "03" },
    { name: "Amoaman", regionCode: "09", districtCode: "03" },
    { name: "Anansu", regionCode: "09", districtCode: "03" },
    { name: "Ankamadua", regionCode: "09", districtCode: "03" },
    { name: "Apaah", regionCode: "09", districtCode: "03" },
    { name: "Asaam", regionCode: "09", districtCode: "03" },
    { name: "Asamang", regionCode: "09", districtCode: "03" },
    { name: "Asuafu", regionCode: "09", districtCode: "03" },
    { name: "Atonsu", regionCode: "09", districtCode: "03" },
    { name: "Bedomase", regionCode: "09", districtCode: "03" },
    { name: "Benim", regionCode: "09", districtCode: "03" },
    { name: "Bepoase", regionCode: "09", districtCode: "03" },
    { name: "Beposo", regionCode: "09", districtCode: "03" },
    { name: "Bimma", regionCode: "09", districtCode: "03" },
    { name: "Bipoa", regionCode: "09", districtCode: "03" },
    { name: "Boanim", regionCode: "09", districtCode: "03" },
    { name: "Bonkron", regionCode: "09", districtCode: "03" },
    { name: "Bosofour", regionCode: "09", districtCode: "03" },
    { name: "Bresua Bofoyedru", regionCode: "09", districtCode: "03" },
    { name: "Daaho", regionCode: "09", districtCode: "03" },
    { name: "Daban Mentukwa", regionCode: "09", districtCode: "03" },
    { name: "Dadease", regionCode: "09", districtCode: "03" },
    { name: "Dawu", regionCode: "09", districtCode: "03" },
    { name: "Dida Amangoase", regionCode: "09", districtCode: "03" },
    { name: "Dome", regionCode: "09", districtCode: "03" },
    { name: "Domeabra", regionCode: "09", districtCode: "03" },
    { name: "Funifuni", regionCode: "09", districtCode: "03" },
    { name: "Hiamankyene", regionCode: "09", districtCode: "03" },
    { name: "Hwediem", regionCode: "09", districtCode: "03" },
    { name: "Jaduako", regionCode: "09", districtCode: "03" },
    { name: "Jamase", regionCode: "09", districtCode: "03" },
    { name: "Jetiase", regionCode: "09", districtCode: "03" },
    { name: "Kyebi", regionCode: "09", districtCode: "03" },
    { name: "Ko 0fori", regionCode: "09", districtCode: "03" },
    { name: "Koffikrom Ndobesu", regionCode: "09", districtCode: "03" },
    { name: "Kofiase", regionCode: "09", districtCode: "03" },
    { name: "Kokoteasua", regionCode: "09", districtCode: "03" },
    { name: "Kona", regionCode: "09", districtCode: "03" },
    { name: "Krobo", regionCode: "09", districtCode: "03" },
    { name: "Kruwi", regionCode: "09", districtCode: "03" },
    { name: "Kwamang", regionCode: "09", districtCode: "03" },
    { name: "Kyekyebon", regionCode: "09", districtCode: "03" },
    { name: "Kyekyewere", regionCode: "09", districtCode: "03" },
    { name: "Kyeremfaso", regionCode: "09", districtCode: "03" },
    { name: "Mampong", regionCode: "09", districtCode: "03" },
    { name: "Mmoso", regionCode: "09", districtCode: "03" },
    { name: "Monteasua", regionCode: "09", districtCode: "03" },
    { name: "Mpantuase", regionCode: "09", districtCode: "03" },
    { name: "Mprim", regionCode: "09", districtCode: "03" },
    { name: "New Daamang", regionCode: "09", districtCode: "03" },
    { name: "Nintin", regionCode: "09", districtCode: "03" },
    { name: "Nkwabrim", regionCode: "09", districtCode: "03" },
    { name: "Nnaama", regionCode: "09", districtCode: "03" },
    { name: "Nsuase", regionCode: "09", districtCode: "03" },
    { name: "Nsuta", regionCode: "09", districtCode: "03" },
    { name: "Nwaadan", regionCode: "09", districtCode: "03" },
    { name: "Nyinampong", regionCode: "09", districtCode: "03" },
    { name: "Ohemaa Dida", regionCode: "09", districtCode: "03" },
    { name: "Okrakrom", regionCode: "09", districtCode: "03" },
    { name: "Old Daamang", regionCode: "09", districtCode: "03" },
    { name: "Pepease", regionCode: "09", districtCode: "03" },
    { name: "P.S.K", regionCode: "09", districtCode: "03" },
    { name: "Penteng", regionCode: "09", districtCode: "03" },
    { name: "Tabre", regionCode: "09", districtCode: "03" },
    { name: "Tadeaso", regionCode: "09", districtCode: "03" },
    { name: "Tano Odumase", regionCode: "09", districtCode: "03" },
    { name: "Tatafroso", regionCode: "09", districtCode: "03" },
    { name: "Wiamoase", regionCode: "09", districtCode: "03" },
    { name: "Yonso", regionCode: "09", districtCode: "03" }
  ],
  "09-05": [
    { name: "1st Station", regionCode: "09", districtCode: "05" },
    { name: "2nd Station", regionCode: "09", districtCode: "05" },
    { name: "360 Pharmacy", regionCode: "09", districtCode: "05" },
    { name: "Abaawa Ruth", regionCode: "09", districtCode: "05" },
    { name: "Acheamfour", regionCode: "09", districtCode: "05" },
    { name: "Adehye Market", regionCode: "09", districtCode: "05" },
    { name: "Adompom", regionCode: "09", districtCode: "05" },
    { name: "Agye Boat", regionCode: "09", districtCode: "05" },
    { name: "Airport", regionCode: "09", districtCode: "05" },
    { name: "Akwasi Oppong", regionCode: "09", districtCode: "05" },
    { name: "Alarbar", regionCode: "09", districtCode: "05" },
    { name: "Ashante New-Town", regionCode: "09", districtCode: "05" },
    { name: "Buokrom", regionCode: "09", districtCode: "05" },
    { name: "Buokrom Estate", regionCode: "09", districtCode: "05" },
    { name: "Central Market", regionCode: "09", districtCode: "05" },
    { name: "CITA Printing Press", regionCode: "09", districtCode: "05" },
    { name: "CPC", regionCode: "09", districtCode: "05" },
    { name: "CTI", regionCode: "09", districtCode: "05" },
    { name: "Dichemso", regionCode: "09", districtCode: "05" },
    { name: "Down Town", regionCode: "09", districtCode: "05" },
    { name: "Dr. Mensah", regionCode: "09", districtCode: "05" },
    { name: "E-Line", regionCode: "09", districtCode: "05" },
    { name: "F-Line", regionCode: "09", districtCode: "05" },
    { name: "K.O", regionCode: "09", districtCode: "05" },
    { name: "Krofrom", regionCode: "09", districtCode: "05" },
    { name: "Manhyia", regionCode: "09", districtCode: "05" },
    { name: "Mmbrom", regionCode: "09", districtCode: "05" },
    { name: "Moshie Zongo", regionCode: "09", districtCode: "05" },
    { name: "Okess", regionCode: "09", districtCode: "05" },
    { name: "Plaza", regionCode: "09", districtCode: "05" },
    { name: "Roman Hill", regionCode: "09", districtCode: "05" },
    { name: "Sepe", regionCode: "09", districtCode: "05" },
    { name: "Serwaa Nyarko SHS", regionCode: "09", districtCode: "05" },
    { name: "Tafo 3 Miles", regionCode: "09", districtCode: "05" },
    { name: "Tafo 4 Miles", regionCode: "09", districtCode: "05" },
    { name: "Tafo 45", regionCode: "09", districtCode: "05" },
    { name: "Tafo Ahenebronmu", regionCode: "09", districtCode: "05" },
    { name: "Tafo Estates", regionCode: "09", districtCode: "05" },
    { name: "Tafo Hospital", regionCode: "09", districtCode: "05" },
    { name: "Tafo New Road", regionCode: "09", districtCode: "05" },
    { name: "Tafo Nhyiaeso", regionCode: "09", districtCode: "05" },
    { name: "Tafo Zongo", regionCode: "09", districtCode: "05" },
    { name: "Wesco", regionCode: "09", districtCode: "05" },
    { name: "Yenyawso", regionCode: "09", districtCode: "05" }
  ],
  "09-06": [
    { name: "Abirem", regionCode: "09", districtCode: "06" },
    { name: "Aboabo/Oforikrom", regionCode: "09", districtCode: "06" },
    { name: "Achiase", regionCode: "09", districtCode: "06" },
    { name: "Adarko Jachie", regionCode: "09", districtCode: "06" },
    { name: "Adeisena", regionCode: "09", districtCode: "06" },
    { name: "Adukrom/Sawaba", regionCode: "09", districtCode: "06" },
    { name: "Adwumam", regionCode: "09", districtCode: "06" },
    { name: "Afful Nkwanta", regionCode: "09", districtCode: "06" },
    { name: "Akokoamong", regionCode: "09", districtCode: "06" },
    { name: "Akwatia Line", regionCode: "09", districtCode: "06" },
    { name: "Antoa", regionCode: "09", districtCode: "06" },
    { name: "Antoa/Achiase", regionCode: "09", districtCode: "06" },
    { name: "Apirade", regionCode: "09", districtCode: "06" },
    { name: "Asabi", regionCode: "09", districtCode: "06" },
    { name: "Asawasi", regionCode: "09", districtCode: "06" },
    { name: "Asokore Mampong", regionCode: "09", districtCode: "06" },
    { name: "Ayigya", regionCode: "09", districtCode: "06" },
    { name: "Ayigya Maxima", regionCode: "09", districtCode: "06" },
    { name: "Baworo", regionCode: "09", districtCode: "06" },
    { name: "Bompata", regionCode: "09", districtCode: "06" },
    { name: "Bosore", regionCode: "09", districtCode: "06" },
    { name: "Buabai", regionCode: "09", districtCode: "06" },
    { name: "Dote", regionCode: "09", districtCode: "06" },
    { name: "Duase", regionCode: "09", districtCode: "06" },
    { name: "Duase N/S", regionCode: "09", districtCode: "06" },
    { name: "Ekyem", regionCode: "09", districtCode: "06" },
    { name: "Fumesua", regionCode: "09", districtCode: "06" },
    { name: "Kentinkrono", regionCode: "09", districtCode: "06" },
    { name: "Kenyase", regionCode: "09", districtCode: "06" },
    { name: "Ktu/Asafo", regionCode: "09", districtCode: "06" },
    { name: "Kwamo", regionCode: "09", districtCode: "06" },
    { name: "Mesewam", regionCode: "09", districtCode: "06" },
    { name: "Nsenie", regionCode: "09", districtCode: "06" },
    { name: "Nwamase", regionCode: "09", districtCode: "06" },
    { name: "Okyerekrom", regionCode: "09", districtCode: "06" },
    { name: "Parkoso", regionCode: "09", districtCode: "06" },
    { name: "Sawaba", regionCode: "09", districtCode: "06" },
    { name: "Sepe", regionCode: "09", districtCode: "06" },
    { name: "Sisirase", regionCode: "09", districtCode: "06" },
    { name: "Tikrom", regionCode: "09", districtCode: "06" },
    { name: "Yalewa", regionCode: "09", districtCode: "06" }
  ],
  "09-07": [
    { name: "Aboaso", regionCode: "09", districtCode: "07" },
    { name: "Abrade", regionCode: "09", districtCode: "07" },
    { name: "Adabraka", regionCode: "09", districtCode: "07" },
    { name: "Adubinso", regionCode: "09", districtCode: "07" },
    { name: "Adubinso Besease", regionCode: "09", districtCode: "07" },
    { name: "Adubinso Bia", regionCode: "09", districtCode: "07" },
    { name: "Adwumakase Kese", regionCode: "09", districtCode: "07" },
    { name: "Adwumam", regionCode: "09", districtCode: "07" },
    { name: "Ahwia", regionCode: "09", districtCode: "07" },
    { name: "Akitibombo", regionCode: "09", districtCode: "07" },
    { name: "Akosua", regionCode: "09", districtCode: "07" },
    { name: "Ankaase", regionCode: "09", districtCode: "07" },
    { name: "Asenua", regionCode: "09", districtCode: "07" },
    { name: "Asonomaso Nkwanta", regionCode: "09", districtCode: "07" },
    { name: "Atimatim", regionCode: "09", districtCode: "07" },
    { name: "Bampenase", regionCode: "09", districtCode: "07" },
    { name: "Bomfa", regionCode: "09", districtCode: "07" },
    { name: "Bremang Ucg", regionCode: "09", districtCode: "07" },
    { name: "Bremang Ugc", regionCode: "09", districtCode: "07" },
    { name: "Buokrom", regionCode: "09", districtCode: "07" },
    { name: "Buokrom South Africa", regionCode: "09", districtCode: "07" },
    { name: "Daboya", regionCode: "09", districtCode: "07" },
    { name: "Duase", regionCode: "09", districtCode: "07" },
    { name: "Dumakwai", regionCode: "09", districtCode: "07" },
    { name: "Dumanafo", regionCode: "09", districtCode: "07" },
    { name: "Ebom Bomfa", regionCode: "09", districtCode: "07" },
    { name: "Edwinase", regionCode: "09", districtCode: "07" },
    { name: "Ejuratia", regionCode: "09", districtCode: "07" },
    { name: "Essen", regionCode: "09", districtCode: "07" },
    { name: "Fawoade", regionCode: "09", districtCode: "07" },
    { name: "Hemang", regionCode: "09", districtCode: "07" },
    { name: "Kasaam", regionCode: "09", districtCode: "07" },
    { name: "Komire", regionCode: "09", districtCode: "07" },
    { name: "Kwapra", regionCode: "09", districtCode: "07" },
    { name: "Maase", regionCode: "09", districtCode: "07" },
    { name: "Mamponteng", regionCode: "09", districtCode: "07" },
    { name: "Mamponteng Achaiase", regionCode: "09", districtCode: "07" },
    { name: "Mamponteng Korea", regionCode: "09", districtCode: "07" },
    { name: "Medoma", regionCode: "09", districtCode: "07" },
    { name: "Medoma 80", regionCode: "09", districtCode: "07" },
    { name: "Mpobi", regionCode: "09", districtCode: "07" },
    { name: "Nana Appiah", regionCode: "09", districtCode: "07" },
    { name: "Nantan", regionCode: "09", districtCode: "07" },
    { name: "Ntonso", regionCode: "09", districtCode: "07" },
    { name: "Old Asonomaso", regionCode: "09", districtCode: "07" },
    { name: "Overseas", regionCode: "09", districtCode: "07" },
    { name: "Pankrono", regionCode: "09", districtCode: "07" },
    { name: "Quary", regionCode: "09", districtCode: "07" },
    { name: "Sarfo", regionCode: "09", districtCode: "07" },
    { name: "Swedru", regionCode: "09", districtCode: "07" },
    { name: "Taabuom", regionCode: "09", districtCode: "07" },
    { name: "Tewobaabi", regionCode: "09", districtCode: "07" },
    { name: "Truba", regionCode: "09", districtCode: "07" },
    { name: "Wadie Adwumakase", regionCode: "09", districtCode: "07" },
    { name: "Yasore", regionCode: "09", districtCode: "07" }
  ],
  "09-08": [
    { name: "Abankrom", regionCode: "09", districtCode: "08" },
    { name: "Abenase", regionCode: "09", districtCode: "08" },
    { name: "Achiaakrom", regionCode: "09", districtCode: "08" },
    { name: "Achinakrom", regionCode: "09", districtCode: "08" },
    { name: "Adadeantem", regionCode: "09", districtCode: "08" },
    { name: "Adakojachie", regionCode: "09", districtCode: "08" },
    { name: "Ampabame", regionCode: "09", districtCode: "08" },
    { name: "Anwomaso", regionCode: "09", districtCode: "08" },
    { name: "Apromase", regionCode: "09", districtCode: "08" },
    { name: "Asaman", regionCode: "09", districtCode: "08" },
    { name: "Asawase", regionCode: "09", districtCode: "08" },
    { name: "Asotwe", regionCode: "09", districtCode: "08" },
    { name: "Asotwe Bomfa", regionCode: "09", districtCode: "08" },
    { name: "Atia", regionCode: "09", districtCode: "08" },
    { name: "Besease", regionCode: "09", districtCode: "08" },
    { name: "Besease New Site", regionCode: "09", districtCode: "08" },
    { name: "Boamadumase", regionCode: "09", districtCode: "08" },
    { name: "Boankra", regionCode: "09", districtCode: "08" },
    { name: "Bronikrom", regionCode: "09", districtCode: "08" },
    { name: "Deduako", regionCode: "09", districtCode: "08" },
    { name: "Domeabra", regionCode: "09", districtCode: "08" },
    { name: "Donaso", regionCode: "09", districtCode: "08" },
    { name: "Donyina", regionCode: "09", districtCode: "08" },
    { name: "Duampompo", regionCode: "09", districtCode: "08" },
    { name: "Edwenease", regionCode: "09", districtCode: "08" },
    { name: "Ejisu", regionCode: "09", districtCode: "08" },
    { name: "Ejisu New Town", regionCode: "09", districtCode: "08" },
    { name: "Ejisu Old Town", regionCode: "09", districtCode: "08" },
    { name: "Ejisu Sectech", regionCode: "09", districtCode: "08" },
    { name: "Ejisuman", regionCode: "09", districtCode: "08" },
    { name: "Esienimpon", regionCode: "09", districtCode: "08" },
    { name: "Fumesua", regionCode: "09", districtCode: "08" },
    { name: "Hwereso", regionCode: "09", districtCode: "08" },
    { name: "Jamase", regionCode: "09", districtCode: "08" },
    { name: "Jinapee", regionCode: "09", districtCode: "08" },
    { name: "Kelebi", regionCode: "09", districtCode: "08" },
    { name: "Krapa", regionCode: "09", districtCode: "08" },
    { name: "Krapa No.1", regionCode: "09", districtCode: "08" },
    { name: "Krapa No2", regionCode: "09", districtCode: "08" },
    { name: "Kubease", regionCode: "09", districtCode: "08" },
    { name: "Kwamo", regionCode: "09", districtCode: "08" },
    { name: "Kwamo Scoe Board", regionCode: "09", districtCode: "08" },
    { name: "Kwaso", regionCode: "09", districtCode: "08" },
    { name: "Menhyia", regionCode: "09", districtCode: "08" },
    { name: "New Koforidua", regionCode: "09", districtCode: "08" },
    { name: "Nkokurabom", regionCode: "09", districtCode: "08" },
    { name: "Nobewam", regionCode: "09", districtCode: "08" },
    { name: "Nobewam Bomfa", regionCode: "09", districtCode: "08" },
    { name: "Odahu", regionCode: "09", districtCode: "08" },
    { name: "Okorase", regionCode: "09", districtCode: "08" },
    { name: "Onwe", regionCode: "09", districtCode: "08" },
    { name: "Sarpeh", regionCode: "09", districtCode: "08" },
    { name: "Sekyere", regionCode: "09", districtCode: "08" },
    { name: "Serwaakuraa", regionCode: "09", districtCode: "08" },
    { name: "Timeabu", regionCode: "09", districtCode: "08" }
  ],

  "10-01": [
    { name: "Upper Denkyira East", regionCode: "10", districtCode: "01" }
  ],
  "10-02": [
    { name: "Adansi North (Fomena)", regionCode: "10", districtCode: "02" },
    { name: "Obuasi East", regionCode: "10", districtCode: "02" },
    { name: "Obuasi Municipal", regionCode: "10", districtCode: "02" },
    { name: "Amansie Central", regionCode: "10", districtCode: "02" },
  ],
  "10-03": [
    { name: "Bekwai Municipal", regionCode: "10", districtCode: "03" },
    { name: "Bosome Freho", regionCode: "10", districtCode: "03" },
    { name: "Bosomtwe", regionCode: "10", districtCode: "03" },
    { name: "Amansie Central", regionCode: "10", districtCode: "03" },
  ],
  "10-04": [
    { name: "Asokwa Municipal", regionCode: "10", districtCode: "04" }
  ],
  "10-08": [
    { name: "Adansi Akrofuom", regionCode: "10", districtCode: "08" },
    { name: "Adansi South", regionCode: "10", districtCode: "08" },
  ],
  "10-10": [
    { name: "Amansie South", regionCode: "10", districtCode: "10" },
    { name: "Amansie West", regionCode: "10", districtCode: "10" },
    { name: "Atwima Kwanwoma", regionCode: "10", districtCode: "10" },
    { name: "Atwima Mponua", regionCode: "10", districtCode: "10" },
  ],
}

 
export const Communities =
  lodash.flatMap(
    lodash.values(DistrictCodeCommunityMap)
  )